(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[522],{

/***/ 39232:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 1158:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37667);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
function a(t){return t&&t.__esModule&&Object.prototype.hasOwnProperty.call(t,"default")?t.default:t}function c(t,r){return t(r={exports:{}},r.exports),r.exports}var u=c(function(t){t.exports=function(t){if(Array.isArray(t))return t},t.exports.default=t.exports,t.exports.__esModule=!0});a(u);var s=c(function(t){t.exports=function(t,r){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(t)){var e=[],n=!0,o=!1,i=void 0;try{for(var a,c=t[Symbol.iterator]();!(n=(a=c.next()).done)&&(e.push(a.value),!r||e.length!==r);n=!0);}catch(t){o=!0,i=t}finally{try{n||null==c.return||c.return()}finally{if(o)throw i}}return e}},t.exports.default=t.exports,t.exports.__esModule=!0});a(s);var l=c(function(t){t.exports=function(t,r){(null==r||r>t.length)&&(r=t.length);for(var e=0,n=new Array(r);e<r;e++)n[e]=t[e];return n},t.exports.default=t.exports,t.exports.__esModule=!0});a(l);var f=c(function(t){t.exports=function(t,r){if(t){if("string"==typeof t)return l(t,r);var e=Object.prototype.toString.call(t).slice(8,-1);return"Object"===e&&t.constructor&&(e=t.constructor.name),"Map"===e||"Set"===e?Array.from(t):"Arguments"===e||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e)?l(t,r):void 0}},t.exports.default=t.exports,t.exports.__esModule=!0});a(f);var h=c(function(t){t.exports=function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")},t.exports.default=t.exports,t.exports.__esModule=!0});a(h);var p=a(c(function(t){t.exports=function(t,r){return u(t)||s(t,r)||f(t,r)||h()},t.exports.default=t.exports,t.exports.__esModule=!0})),d=a(c(function(t){function r(t,r,e,n,o,i,a){try{var c=t[i](a),u=c.value}catch(t){return void e(t)}c.done?r(u):Promise.resolve(u).then(n,o)}t.exports=function(t){return function(){var e=this,n=arguments;return new Promise(function(o,i){var a=t.apply(e,n);function c(t){r(a,o,i,c,u,"next",t)}function u(t){r(a,o,i,c,u,"throw",t)}c(void 0)})}},t.exports.default=t.exports,t.exports.__esModule=!0})),v=c(function(t){var r=function(t){var r,e=Object.prototype,n=e.hasOwnProperty,o="function"==typeof Symbol?Symbol:{},i=o.iterator||"@@iterator",a=o.asyncIterator||"@@asyncIterator",c=o.toStringTag||"@@toStringTag";function u(t,r,e){return Object.defineProperty(t,r,{value:e,enumerable:!0,configurable:!0,writable:!0}),t[r]}try{u({},"")}catch(t){u=function(t,r,e){return t[r]=e}}function s(t,r,e,n){var o=r&&r.prototype instanceof y?r:y,i=Object.create(o.prototype),a=new O(n||[]);return i._invoke=function(t,r,e){var n=f;return function(o,i){if(n===p)throw new Error("Generator is already running");if(n===d){if("throw"===o)throw i;return I()}for(e.method=o,e.arg=i;;){var a=e.delegate;if(a){var c=j(a,e);if(c){if(c===v)continue;return c}}if("next"===e.method)e.sent=e._sent=e.arg;else if("throw"===e.method){if(n===f)throw n=d,e.arg;e.dispatchException(e.arg)}else"return"===e.method&&e.abrupt("return",e.arg);n=p;var u=l(t,r,e);if("normal"===u.type){if(n=e.done?d:h,u.arg===v)continue;return{value:u.arg,done:e.done}}"throw"===u.type&&(n=d,e.method="throw",e.arg=u.arg)}}}(t,e,a),i}function l(t,r,e){try{return{type:"normal",arg:t.call(r,e)}}catch(t){return{type:"throw",arg:t}}}t.wrap=s;var f="suspendedStart",h="suspendedYield",p="executing",d="completed",v={};function y(){}function m(){}function g(){}var w={};w[i]=function(){return this};var x=Object.getPrototypeOf,b=x&&x(x(T([])));b&&b!==e&&n.call(b,i)&&(w=b);var _=g.prototype=y.prototype=Object.create(w);function L(t){["next","throw","return"].forEach(function(r){u(t,r,function(t){return this._invoke(r,t)})})}function E(t,r){var e;this._invoke=function(o,i){function a(){return new r(function(e,a){!function e(o,i,a,c){var u=l(t[o],t,i);if("throw"!==u.type){var s=u.arg,f=s.value;return f&&"object"==typeof f&&n.call(f,"__await")?r.resolve(f.__await).then(function(t){e("next",t,a,c)},function(t){e("throw",t,a,c)}):r.resolve(f).then(function(t){s.value=t,a(s)},function(t){return e("throw",t,a,c)})}c(u.arg)}(o,i,e,a)})}return e=e?e.then(a,a):a()}}function j(t,e){var n=t.iterator[e.method];if(n===r){if(e.delegate=null,"throw"===e.method){if(t.iterator.return&&(e.method="return",e.arg=r,j(t,e),"throw"===e.method))return v;e.method="throw",e.arg=new TypeError("The iterator does not provide a 'throw' method")}return v}var o=l(n,t.iterator,e.arg);if("throw"===o.type)return e.method="throw",e.arg=o.arg,e.delegate=null,v;var i=o.arg;return i?i.done?(e[t.resultName]=i.value,e.next=t.nextLoc,"return"!==e.method&&(e.method="next",e.arg=r),e.delegate=null,v):i:(e.method="throw",e.arg=new TypeError("iterator result is not an object"),e.delegate=null,v)}function S(t){var r={tryLoc:t[0]};1 in t&&(r.catchLoc=t[1]),2 in t&&(r.finallyLoc=t[2],r.afterLoc=t[3]),this.tryEntries.push(r)}function M(t){var r=t.completion||{};r.type="normal",delete r.arg,t.completion=r}function O(t){this.tryEntries=[{tryLoc:"root"}],t.forEach(S,this),this.reset(!0)}function T(t){if(t){var e=t[i];if(e)return e.call(t);if("function"==typeof t.next)return t;if(!isNaN(t.length)){var o=-1,a=function e(){for(;++o<t.length;)if(n.call(t,o))return e.value=t[o],e.done=!1,e;return e.value=r,e.done=!0,e};return a.next=a}}return{next:I}}function I(){return{value:r,done:!0}}return m.prototype=_.constructor=g,g.constructor=m,m.displayName=u(g,c,"GeneratorFunction"),t.isGeneratorFunction=function(t){var r="function"==typeof t&&t.constructor;return!!r&&(r===m||"GeneratorFunction"===(r.displayName||r.name))},t.mark=function(t){return Object.setPrototypeOf?Object.setPrototypeOf(t,g):(t.__proto__=g,u(t,c,"GeneratorFunction")),t.prototype=Object.create(_),t},t.awrap=function(t){return{__await:t}},L(E.prototype),E.prototype[a]=function(){return this},t.AsyncIterator=E,t.async=function(r,e,n,o,i){void 0===i&&(i=Promise);var a=new E(s(r,e,n,o),i);return t.isGeneratorFunction(e)?a:a.next().then(function(t){return t.done?t.value:a.next()})},L(_),u(_,c,"Generator"),_[i]=function(){return this},_.toString=function(){return"[object Generator]"},t.keys=function(t){var r=[];for(var e in t)r.push(e);return r.reverse(),function e(){for(;r.length;){var n=r.pop();if(n in t)return e.value=n,e.done=!1,e}return e.done=!0,e}},t.values=T,O.prototype={constructor:O,reset:function(t){if(this.prev=0,this.next=0,this.sent=this._sent=r,this.done=!1,this.delegate=null,this.method="next",this.arg=r,this.tryEntries.forEach(M),!t)for(var e in this)"t"===e.charAt(0)&&n.call(this,e)&&!isNaN(+e.slice(1))&&(this[e]=r)},stop:function(){this.done=!0;var t=this.tryEntries[0].completion;if("throw"===t.type)throw t.arg;return this.rval},dispatchException:function(t){if(this.done)throw t;var e=this;function o(n,o){return c.type="throw",c.arg=t,e.next=n,o&&(e.method="next",e.arg=r),!!o}for(var i=this.tryEntries.length-1;i>=0;--i){var a=this.tryEntries[i],c=a.completion;if("root"===a.tryLoc)return o("end");if(a.tryLoc<=this.prev){var u=n.call(a,"catchLoc"),s=n.call(a,"finallyLoc");if(u&&s){if(this.prev<a.catchLoc)return o(a.catchLoc,!0);if(this.prev<a.finallyLoc)return o(a.finallyLoc)}else if(u){if(this.prev<a.catchLoc)return o(a.catchLoc,!0)}else{if(!s)throw new Error("try statement without catch or finally");if(this.prev<a.finallyLoc)return o(a.finallyLoc)}}}},abrupt:function(t,r){for(var e=this.tryEntries.length-1;e>=0;--e){var o=this.tryEntries[e];if(o.tryLoc<=this.prev&&n.call(o,"finallyLoc")&&this.prev<o.finallyLoc){var i=o;break}}i&&("break"===t||"continue"===t)&&i.tryLoc<=r&&r<=i.finallyLoc&&(i=null);var a=i?i.completion:{};return a.type=t,a.arg=r,i?(this.method="next",this.next=i.finallyLoc,v):this.complete(a)},complete:function(t,r){if("throw"===t.type)throw t.arg;return"break"===t.type||"continue"===t.type?this.next=t.arg:"return"===t.type?(this.rval=this.arg=t.arg,this.method="return",this.next="end"):"normal"===t.type&&r&&(this.next=r),v},finish:function(t){for(var r=this.tryEntries.length-1;r>=0;--r){var e=this.tryEntries[r];if(e.finallyLoc===t)return this.complete(e.completion,e.afterLoc),M(e),v}},catch:function(t){for(var r=this.tryEntries.length-1;r>=0;--r){var e=this.tryEntries[r];if(e.tryLoc===t){var n=e.completion;if("throw"===n.type){var o=n.arg;M(e)}return o}}throw new Error("illegal catch attempt")},delegateYield:function(t,e,n){return this.delegate={iterator:T(t),resultName:e,nextLoc:n},"next"===this.method&&(this.arg=r),v}},t}(t.exports);try{regeneratorRuntime=r}catch(t){Function("r","regeneratorRuntime = r")(r)}}),y=function(t){return t.status>=200&&t.status<300?Promise.resolve(t):Promise.reject(new Error(t.statusText))},m=function(t){return t.text()};function g(){return(g=d(v.mark(function t(r){return v.wrap(function(t){for(;;)switch(t.prev=t.next){case 0:return t.prev=0,t.next=3,fetch(r).then(y).then(m);case 3:return t.abrupt("return",t.sent);case 6:return t.prev=6,t.t0=t.catch(0),t.abrupt("return",null);case 9:case"end":return t.stop()}},t,null,[[0,6]])}))).apply(this,arguments)}var w=function(){return Boolean("undefined"!=typeof window&&window.document)},x=function(){var t;w()&&("true"===localStorage.getItem("jl-esi-component-debug")&&(t=console).log.apply(t,arguments))},b=function(o){var i=o.html,a=o.wrapperId,c=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null),u=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function(){return function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"",r=document.createElement("div");r.innerHTML=t;for(var e=r.getElementsByTagName("script"),n=[],o=0;o<e.length;o++)n.push(e[o]);var i=n.filter(function(t){switch(t.getAttribute("type")){case"application/javascript":case"text/javascript":case"module":case"":case null:return!0;default:return!1}});return i.forEach(function(t){return t.parentNode.removeChild(t)}),{scripts:i.map(function(t){var r=document.createElement("script");if(t.hasAttributes())for(var e=0;e<t.attributes.length;e+=1){var n=t.attributes[e],o=n.name,i=n.value;r.setAttribute(o,i)}return r.innerHTML=t.innerHTML,r}),htmlWithoutScripts:r.innerHTML}}(i)},[i]),s=u.htmlWithoutScripts,l=u.scripts;return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function(){return l.forEach(function(t){return c.current.appendChild(t)}),function(){l.forEach(function(t){return c.current&&c.current.contains(t)&&c.current.removeChild(t)})}},[l]),react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div",{ref:c,id:a,dangerouslySetInnerHTML:{__html:s}})};/* harmony default export */ __webpack_exports__["Z"] = ((0,react__WEBPACK_IMPORTED_MODULE_0__.memo)(function(e){var o=e.src,a=e.id,c=function(t){var r=t.id,e=t.src,n="";if(e){var o=e.match(/\/?([\w-/]*)/);n="assembly-".concat(o[1],"-").concat(r).replace(/\//g,"-").replace(/-+/g,"-").toLowerCase()}return n}({src:o,id:a}),u=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(o),s=w()?function(t,r){if(t){var e=document.getElementById(t);if(e)return e.querySelector("#".concat(r))?null:e.innerHTML}return null}(c,a):null,l=(0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(s),f=p(l,2),h=f[0],d=f[1],v=(0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(w()),y=p(v,2),m=y[0],_=y[1];return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function(){h&&o===u.current||(x("jl-esi-component: fetching new fragment",{src:o,old_src:u.current}),function(t){return g.apply(this,arguments)}(o).then(function(t){u.current=o,d(t),_(!1)}))},[o]),h&&m?(x("jl-esi-component: client render (no prop changes)",{src:o,id:a}),react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div",{id:c,dangerouslySetInnerHTML:{__html:h},suppressHydrationWarning:!0})):h?(x("jl-esi-component: client render (with prop changes)",{src:o,id:a}),react__WEBPACK_IMPORTED_MODULE_0___default().createElement(b,{wrapperId:c,html:h})):(x("jl-esi-component: server render (should not see this)",{src:o,id:a}),react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div",{id:c,dangerouslySetInnerHTML:{__html:'<esi:include id="'.concat(a,'" ').concat(o?' src="'.concat(o,'"'):""," />")}}))}));
//# sourceMappingURL=index.esm.js.map


/***/ }),

/***/ 46760:
/***/ (function(__unused_webpack_module, exports) {

(function(global,factory){ true?factory(exports):0})(this,(function(exports){"use strict";var getCookieValue=function(cookieName,cookies){if(typeof cookies==="object"){return cookies[cookieName]}if(typeof document==="object"){var match=document.cookie.match(new RegExp("(^| )"+cookieName+"=([^;]+)"));if(match)return match[2]}};var cookiePrefix="JOHNLEWIS_ENSIGHTEN_PRIVACY_";var storageCanBeSet=function(cookieGroup,cookies){if(typeof cookieGroup==="undefined"){throw new Error('pecr-util: Expected a cookie group to be supplied, e.g. "Functional"')}if(typeof document==="undefined"&&typeof cookies==="undefined"){throw new Error("pecr-util: When running on the server you need to supply an object of cookies from the request")}return getCookieValue(cookiePrefix+cookieGroup,cookies)==="1"};exports.cookiePrefix=cookiePrefix;exports.storageCanBeSet=storageCanBeSet;Object.defineProperty(exports,"__esModule",{value:true})}));

/***/ }),

/***/ 79742:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),

/***/ 48764:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(79742)
var ieee754 = __webpack_require__(80645)
var customInspectSymbol =
  (typeof Symbol === 'function' && typeof Symbol['for'] === 'function') // eslint-disable-line dot-notation
    ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
    : null

exports.lW = Buffer
__webpack_unused_export__ = SlowBuffer
exports.h2 = 50

var K_MAX_LENGTH = 0x7fffffff
__webpack_unused_export__ = K_MAX_LENGTH

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */
Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()

if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
    typeof console.error === 'function') {
  console.error(
    'This browser lacks typed array (Uint8Array) support which is required by ' +
    '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
  )
}

function typedArraySupport () {
  // Can typed array instances can be augmented?
  try {
    var arr = new Uint8Array(1)
    var proto = { foo: function () { return 42 } }
    Object.setPrototypeOf(proto, Uint8Array.prototype)
    Object.setPrototypeOf(arr, proto)
    return arr.foo() === 42
  } catch (e) {
    return false
  }
}

Object.defineProperty(Buffer.prototype, 'parent', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.buffer
  }
})

Object.defineProperty(Buffer.prototype, 'offset', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.byteOffset
  }
})

function createBuffer (length) {
  if (length > K_MAX_LENGTH) {
    throw new RangeError('The value "' + length + '" is invalid for option "size"')
  }
  // Return an augmented `Uint8Array` instance
  var buf = new Uint8Array(length)
  Object.setPrototypeOf(buf, Buffer.prototype)
  return buf
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new TypeError(
        'The "string" argument must be of type string. Received type number'
      )
    }
    return allocUnsafe(arg)
  }
  return from(arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

function from (value, encodingOrOffset, length) {
  if (typeof value === 'string') {
    return fromString(value, encodingOrOffset)
  }

  if (ArrayBuffer.isView(value)) {
    return fromArrayView(value)
  }

  if (value == null) {
    throw new TypeError(
      'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
      'or Array-like Object. Received type ' + (typeof value)
    )
  }

  if (isInstance(value, ArrayBuffer) ||
      (value && isInstance(value.buffer, ArrayBuffer))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof SharedArrayBuffer !== 'undefined' &&
      (isInstance(value, SharedArrayBuffer) ||
      (value && isInstance(value.buffer, SharedArrayBuffer)))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof value === 'number') {
    throw new TypeError(
      'The "value" argument must not be of type number. Received type number'
    )
  }

  var valueOf = value.valueOf && value.valueOf()
  if (valueOf != null && valueOf !== value) {
    return Buffer.from(valueOf, encodingOrOffset, length)
  }

  var b = fromObject(value)
  if (b) return b

  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
      typeof value[Symbol.toPrimitive] === 'function') {
    return Buffer.from(
      value[Symbol.toPrimitive]('string'), encodingOrOffset, length
    )
  }

  throw new TypeError(
    'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
    'or Array-like Object. Received type ' + (typeof value)
  )
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(value, encodingOrOffset, length)
}

// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype)
Object.setPrototypeOf(Buffer, Uint8Array)

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be of type number')
  } else if (size < 0) {
    throw new RangeError('The value "' + size + '" is invalid for option "size"')
  }
}

function alloc (size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(size).fill(fill, encoding)
      : createBuffer(size).fill(fill)
  }
  return createBuffer(size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(size, fill, encoding)
}

function allocUnsafe (size) {
  assertSize(size)
  return createBuffer(size < 0 ? 0 : checked(size) | 0)
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(size)
}

function fromString (string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('Unknown encoding: ' + encoding)
  }

  var length = byteLength(string, encoding) | 0
  var buf = createBuffer(length)

  var actual = buf.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual)
  }

  return buf
}

function fromArrayLike (array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  var buf = createBuffer(length)
  for (var i = 0; i < length; i += 1) {
    buf[i] = array[i] & 255
  }
  return buf
}

function fromArrayView (arrayView) {
  if (isInstance(arrayView, Uint8Array)) {
    var copy = new Uint8Array(arrayView)
    return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength)
  }
  return fromArrayLike(arrayView)
}

function fromArrayBuffer (array, byteOffset, length) {
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('"offset" is outside of buffer bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('"length" is outside of buffer bounds')
  }

  var buf
  if (byteOffset === undefined && length === undefined) {
    buf = new Uint8Array(array)
  } else if (length === undefined) {
    buf = new Uint8Array(array, byteOffset)
  } else {
    buf = new Uint8Array(array, byteOffset, length)
  }

  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(buf, Buffer.prototype)

  return buf
}

function fromObject (obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    var buf = createBuffer(len)

    if (buf.length === 0) {
      return buf
    }

    obj.copy(buf, 0, 0, len)
    return buf
  }

  if (obj.length !== undefined) {
    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
      return createBuffer(0)
    }
    return fromArrayLike(obj)
  }

  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
    return fromArrayLike(obj.data)
  }
}

function checked (length) {
  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= K_MAX_LENGTH) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return b != null && b._isBuffer === true &&
    b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
}

Buffer.compare = function compare (a, b) {
  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength)
  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength)
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError(
      'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
    )
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!Array.isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (isInstance(buf, Uint8Array)) {
      if (pos + buf.length > buffer.length) {
        Buffer.from(buf).copy(buffer, pos)
      } else {
        Uint8Array.prototype.set.call(
          buffer,
          buf,
          pos
        )
      }
    } else if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    } else {
      buf.copy(buffer, pos)
    }
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    throw new TypeError(
      'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
      'Received type ' + typeof string
    )
  }

  var len = string.length
  var mustMatch = (arguments.length > 2 && arguments[2] === true)
  if (!mustMatch && len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) {
          return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
        }
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.toLocaleString = Buffer.prototype.toString

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.h2
  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim()
  if (this.length > max) str += ' ... '
  return '<Buffer ' + str + '>'
}
if (customInspectSymbol) {
  Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (isInstance(target, Uint8Array)) {
    target = Buffer.from(target, target.offset, target.byteLength)
  }
  if (!Buffer.isBuffer(target)) {
    throw new TypeError(
      'The "target" argument must be one of type Buffer or Uint8Array. ' +
      'Received type ' + (typeof target)
    )
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset // Coerce to Number.
  if (numberIsNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  var strLen = string.length

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (numberIsNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset >>> 0
    if (isFinite(length)) {
      length = length >>> 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
      case 'latin1':
      case 'binary':
        return asciiWrite(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF)
      ? 4
      : (firstByte > 0xDF)
          ? 3
          : (firstByte > 0xBF)
              ? 2
              : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += hexSliceLookupTable[buf[i]]
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
  for (var i = 0; i < bytes.length - 1; i += 2) {
    res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256))
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf = this.subarray(start, end)
  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(newBuf, Buffer.prototype)

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUintLE =
Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUintBE =
Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUint8 =
Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUint16LE =
Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUint16BE =
Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUint32LE =
Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUint32BE =
Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUintLE =
Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUintBE =
Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUint8 =
Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeUint16LE =
Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeUint16BE =
Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeUint32LE =
Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset + 3] = (value >>> 24)
  this[offset + 2] = (value >>> 16)
  this[offset + 1] = (value >>> 8)
  this[offset] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeUint32BE =
Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  this[offset + 2] = (value >>> 16)
  this[offset + 3] = (value >>> 24)
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start

  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
    // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end)
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, end),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if ((encoding === 'utf8' && code < 128) ||
          encoding === 'latin1') {
        // Fast path: If `val` fits into a single byte, use that numeric value.
        val = code
      }
    }
  } else if (typeof val === 'number') {
    val = val & 255
  } else if (typeof val === 'boolean') {
    val = Number(val)
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : Buffer.from(val, encoding)
    var len = bytes.length
    if (len === 0) {
      throw new TypeError('The value "' + val +
        '" is invalid for argument "value"')
    }
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node takes equal signs as end of the Base64 encoding
  str = str.split('=')[0]
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = str.trim().replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance (obj, type) {
  return obj instanceof type ||
    (obj != null && obj.constructor != null && obj.constructor.name != null &&
      obj.constructor.name === type.name)
}
function numberIsNaN (obj) {
  // For IE11 support
  return obj !== obj // eslint-disable-line no-self-compare
}

// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var hexSliceLookupTable = (function () {
  var alphabet = '0123456789abcdef'
  var table = new Array(256)
  for (var i = 0; i < 16; ++i) {
    var i16 = i * 16
    for (var j = 0; j < 16; ++j) {
      table[i16 + j] = alphabet[i] + alphabet[j]
    }
  }
  return table
})()


/***/ }),

/***/ 21924:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(10492);

var callBind = __webpack_require__(55559);

var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));

module.exports = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBind(intrinsic);
	}
	return intrinsic;
};


/***/ }),

/***/ 55559:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(58612);
var GetIntrinsic = __webpack_require__(10492);

var $apply = GetIntrinsic('%Function.prototype.apply%');
var $call = GetIntrinsic('%Function.prototype.call%');
var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
var $max = GetIntrinsic('%Math.max%');

if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = null;
	}
}

module.exports = function callBind(originalFunction) {
	var func = $reflectApply(bind, $call, arguments);
	if ($gOPD && $defineProperty) {
		var desc = $gOPD(func, 'length');
		if (desc.configurable) {
			// original length, plus the receiver, minus any additional arguments (after the receiver)
			$defineProperty(
				func,
				'length',
				{ value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) }
			);
		}
	}
	return func;
};

var applyBind = function applyBind() {
	return $reflectApply(bind, $apply, arguments);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}


/***/ }),

/***/ 10492:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var undefined;

var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError = TypeError;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(38626)();

var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': RangeError,
	'%ReferenceError%': ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__(58612);
var hasOwn = __webpack_require__(17642);
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};


/***/ }),

/***/ 38626:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__(19305);

module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};


/***/ }),

/***/ 19305:
/***/ (function(module) {

"use strict";


/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),

/***/ 59435:
/***/ (function(module) {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var w = d * 7;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isFinite(val)) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'weeks':
    case 'week':
    case 'w':
      return n * w;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  var msAbs = Math.abs(ms);
  if (msAbs >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (msAbs >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (msAbs >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (msAbs >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  var msAbs = Math.abs(ms);
  if (msAbs >= d) {
    return plural(ms, msAbs, d, 'day');
  }
  if (msAbs >= h) {
    return plural(ms, msAbs, h, 'hour');
  }
  if (msAbs >= m) {
    return plural(ms, msAbs, m, 'minute');
  }
  if (msAbs >= s) {
    return plural(ms, msAbs, s, 'second');
  }
  return ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, msAbs, n, name) {
  var isPlural = msAbs >= n * 1.5;
  return Math.round(ms / n) + ' ' + name + (isPlural ? 's' : '');
}


/***/ }),

/***/ 11227:
/***/ (function(module, exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(34155);
/* eslint-env browser */

/**
 * This is the web browser implementation of `debug()`.
 */

exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = localstorage();
exports.destroy = (() => {
	let warned = false;

	return () => {
		if (!warned) {
			warned = true;
			console.warn('Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.');
		}
	};
})();

/**
 * Colors.
 */

exports.colors = [
	'#0000CC',
	'#0000FF',
	'#0033CC',
	'#0033FF',
	'#0066CC',
	'#0066FF',
	'#0099CC',
	'#0099FF',
	'#00CC00',
	'#00CC33',
	'#00CC66',
	'#00CC99',
	'#00CCCC',
	'#00CCFF',
	'#3300CC',
	'#3300FF',
	'#3333CC',
	'#3333FF',
	'#3366CC',
	'#3366FF',
	'#3399CC',
	'#3399FF',
	'#33CC00',
	'#33CC33',
	'#33CC66',
	'#33CC99',
	'#33CCCC',
	'#33CCFF',
	'#6600CC',
	'#6600FF',
	'#6633CC',
	'#6633FF',
	'#66CC00',
	'#66CC33',
	'#9900CC',
	'#9900FF',
	'#9933CC',
	'#9933FF',
	'#99CC00',
	'#99CC33',
	'#CC0000',
	'#CC0033',
	'#CC0066',
	'#CC0099',
	'#CC00CC',
	'#CC00FF',
	'#CC3300',
	'#CC3333',
	'#CC3366',
	'#CC3399',
	'#CC33CC',
	'#CC33FF',
	'#CC6600',
	'#CC6633',
	'#CC9900',
	'#CC9933',
	'#CCCC00',
	'#CCCC33',
	'#FF0000',
	'#FF0033',
	'#FF0066',
	'#FF0099',
	'#FF00CC',
	'#FF00FF',
	'#FF3300',
	'#FF3333',
	'#FF3366',
	'#FF3399',
	'#FF33CC',
	'#FF33FF',
	'#FF6600',
	'#FF6633',
	'#FF9900',
	'#FF9933',
	'#FFCC00',
	'#FFCC33'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

// eslint-disable-next-line complexity
function useColors() {
	// NB: In an Electron preload script, document will be defined but not fully
	// initialized. Since we know we're in Chrome, we'll just detect this case
	// explicitly
	if (typeof window !== 'undefined' && window.process && (window.process.type === 'renderer' || window.process.__nwjs)) {
		return true;
	}

	// Internet Explorer and Edge do not support colors.
	if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
		return false;
	}

	// Is webkit? http://stackoverflow.com/a/16459606/376773
	// document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
	return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
		// Is firebug? http://stackoverflow.com/a/398120/376773
		(typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
		// Is firefox >= v31?
		// https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
		(typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
		// Double check webkit in userAgent just in case we are in a worker
		(typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}

/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
	args[0] = (this.useColors ? '%c' : '') +
		this.namespace +
		(this.useColors ? ' %c' : ' ') +
		args[0] +
		(this.useColors ? '%c ' : ' ') +
		'+' + module.exports.humanize(this.diff);

	if (!this.useColors) {
		return;
	}

	const c = 'color: ' + this.color;
	args.splice(1, 0, c, 'color: inherit');

	// The final "%c" is somewhat tricky, because there could be other
	// arguments passed either before or after the %c, so we need to
	// figure out the correct index to insert the CSS into
	let index = 0;
	let lastC = 0;
	args[0].replace(/%[a-zA-Z%]/g, match => {
		if (match === '%%') {
			return;
		}
		index++;
		if (match === '%c') {
			// We only are interested in the *last* %c
			// (the user may have provided their own)
			lastC = index;
		}
	});

	args.splice(lastC, 0, c);
}

/**
 * Invokes `console.debug()` when available.
 * No-op when `console.debug` is not a "function".
 * If `console.debug` is not available, falls back
 * to `console.log`.
 *
 * @api public
 */
exports.log = console.debug || console.log || (() => {});

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */
function save(namespaces) {
	try {
		if (namespaces) {
			exports.storage.setItem('debug', namespaces);
		} else {
			exports.storage.removeItem('debug');
		}
	} catch (error) {
		// Swallow
		// XXX (@Qix-) should we be logging these?
	}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */
function load() {
	let r;
	try {
		r = exports.storage.getItem('debug');
	} catch (error) {
		// Swallow
		// XXX (@Qix-) should we be logging these?
	}

	// If debug isn't set in LS, and we're in Electron, try to load $DEBUG
	if (!r && typeof process !== 'undefined' && 'env' in process) {
		r = process.env.DEBUG;
	}

	return r;
}

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
	try {
		// TVMLKit (Apple TV JS Runtime) does not have a window object, just localStorage in the global context
		// The Browser also has localStorage in the global context.
		return localStorage;
	} catch (error) {
		// Swallow
		// XXX (@Qix-) should we be logging these?
	}
}

module.exports = __webpack_require__(82447)(exports);

const {formatters} = module.exports;

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

formatters.j = function (v) {
	try {
		return JSON.stringify(v);
	} catch (error) {
		return '[UnexpectedJSONParseError]: ' + error.message;
	}
};


/***/ }),

/***/ 82447:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 */

function setup(env) {
	createDebug.debug = createDebug;
	createDebug.default = createDebug;
	createDebug.coerce = coerce;
	createDebug.disable = disable;
	createDebug.enable = enable;
	createDebug.enabled = enabled;
	createDebug.humanize = __webpack_require__(59435);
	createDebug.destroy = destroy;

	Object.keys(env).forEach(key => {
		createDebug[key] = env[key];
	});

	/**
	* The currently active debug mode names, and names to skip.
	*/

	createDebug.names = [];
	createDebug.skips = [];

	/**
	* Map of special "%n" handling functions, for the debug "format" argument.
	*
	* Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	*/
	createDebug.formatters = {};

	/**
	* Selects a color for a debug namespace
	* @param {String} namespace The namespace string for the debug instance to be colored
	* @return {Number|String} An ANSI color code for the given namespace
	* @api private
	*/
	function selectColor(namespace) {
		let hash = 0;

		for (let i = 0; i < namespace.length; i++) {
			hash = ((hash << 5) - hash) + namespace.charCodeAt(i);
			hash |= 0; // Convert to 32bit integer
		}

		return createDebug.colors[Math.abs(hash) % createDebug.colors.length];
	}
	createDebug.selectColor = selectColor;

	/**
	* Create a debugger with the given `namespace`.
	*
	* @param {String} namespace
	* @return {Function}
	* @api public
	*/
	function createDebug(namespace) {
		let prevTime;
		let enableOverride = null;
		let namespacesCache;
		let enabledCache;

		function debug(...args) {
			// Disabled?
			if (!debug.enabled) {
				return;
			}

			const self = debug;

			// Set `diff` timestamp
			const curr = Number(new Date());
			const ms = curr - (prevTime || curr);
			self.diff = ms;
			self.prev = prevTime;
			self.curr = curr;
			prevTime = curr;

			args[0] = createDebug.coerce(args[0]);

			if (typeof args[0] !== 'string') {
				// Anything else let's inspect with %O
				args.unshift('%O');
			}

			// Apply any `formatters` transformations
			let index = 0;
			args[0] = args[0].replace(/%([a-zA-Z%])/g, (match, format) => {
				// If we encounter an escaped % then don't increase the array index
				if (match === '%%') {
					return '%';
				}
				index++;
				const formatter = createDebug.formatters[format];
				if (typeof formatter === 'function') {
					const val = args[index];
					match = formatter.call(self, val);

					// Now we need to remove `args[index]` since it's inlined in the `format`
					args.splice(index, 1);
					index--;
				}
				return match;
			});

			// Apply env-specific formatting (colors, etc.)
			createDebug.formatArgs.call(self, args);

			const logFn = self.log || createDebug.log;
			logFn.apply(self, args);
		}

		debug.namespace = namespace;
		debug.useColors = createDebug.useColors();
		debug.color = createDebug.selectColor(namespace);
		debug.extend = extend;
		debug.destroy = createDebug.destroy; // XXX Temporary. Will be removed in the next major release.

		Object.defineProperty(debug, 'enabled', {
			enumerable: true,
			configurable: false,
			get: () => {
				if (enableOverride !== null) {
					return enableOverride;
				}
				if (namespacesCache !== createDebug.namespaces) {
					namespacesCache = createDebug.namespaces;
					enabledCache = createDebug.enabled(namespace);
				}

				return enabledCache;
			},
			set: v => {
				enableOverride = v;
			}
		});

		// Env-specific initialization logic for debug instances
		if (typeof createDebug.init === 'function') {
			createDebug.init(debug);
		}

		return debug;
	}

	function extend(namespace, delimiter) {
		const newDebug = createDebug(this.namespace + (typeof delimiter === 'undefined' ? ':' : delimiter) + namespace);
		newDebug.log = this.log;
		return newDebug;
	}

	/**
	* Enables a debug mode by namespaces. This can include modes
	* separated by a colon and wildcards.
	*
	* @param {String} namespaces
	* @api public
	*/
	function enable(namespaces) {
		createDebug.save(namespaces);
		createDebug.namespaces = namespaces;

		createDebug.names = [];
		createDebug.skips = [];

		let i;
		const split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
		const len = split.length;

		for (i = 0; i < len; i++) {
			if (!split[i]) {
				// ignore empty strings
				continue;
			}

			namespaces = split[i].replace(/\*/g, '.*?');

			if (namespaces[0] === '-') {
				createDebug.skips.push(new RegExp('^' + namespaces.slice(1) + '$'));
			} else {
				createDebug.names.push(new RegExp('^' + namespaces + '$'));
			}
		}
	}

	/**
	* Disable debug output.
	*
	* @return {String} namespaces
	* @api public
	*/
	function disable() {
		const namespaces = [
			...createDebug.names.map(toNamespace),
			...createDebug.skips.map(toNamespace).map(namespace => '-' + namespace)
		].join(',');
		createDebug.enable('');
		return namespaces;
	}

	/**
	* Returns true if the given mode name is enabled, false otherwise.
	*
	* @param {String} name
	* @return {Boolean}
	* @api public
	*/
	function enabled(name) {
		if (name[name.length - 1] === '*') {
			return true;
		}

		let i;
		let len;

		for (i = 0, len = createDebug.skips.length; i < len; i++) {
			if (createDebug.skips[i].test(name)) {
				return false;
			}
		}

		for (i = 0, len = createDebug.names.length; i < len; i++) {
			if (createDebug.names[i].test(name)) {
				return true;
			}
		}

		return false;
	}

	/**
	* Convert regexp to namespace
	*
	* @param {RegExp} regxep
	* @return {String} namespace
	* @api private
	*/
	function toNamespace(regexp) {
		return regexp.toString()
			.substring(2, regexp.toString().length - 2)
			.replace(/\.\*\?$/, '*');
	}

	/**
	* Coerce `val`.
	*
	* @param {Mixed} val
	* @return {Mixed}
	* @api private
	*/
	function coerce(val) {
		if (val instanceof Error) {
			return val.stack || val.message;
		}
		return val;
	}

	/**
	* XXX DO NOT USE. This is a temporary stub function.
	* XXX It WILL be removed in the next major release.
	*/
	function destroy() {
		console.warn('Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.');
	}

	createDebug.enable(createDebug.load());

	return createDebug;
}

module.exports = setup;


/***/ }),

/***/ 9996:
/***/ (function(module) {

"use strict";


var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, options) {
	return (options.clone !== false && options.isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, options)
		: value
}

function defaultArrayMerge(target, source, options) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, options)
	})
}

function getMergeFunction(key, options) {
	if (!options.customMerge) {
		return deepmerge
	}
	var customMerge = options.customMerge(key);
	return typeof customMerge === 'function' ? customMerge : deepmerge
}

function getEnumerableOwnPropertySymbols(target) {
	return Object.getOwnPropertySymbols
		? Object.getOwnPropertySymbols(target).filter(function(symbol) {
			return Object.propertyIsEnumerable.call(target, symbol)
		})
		: []
}

function getKeys(target) {
	return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target))
}

function propertyIsOnObject(object, property) {
	try {
		return property in object
	} catch(_) {
		return false
	}
}

// Protects from prototype poisoning and unexpected merging up the prototype chain.
function propertyIsUnsafe(target, key) {
	return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
		&& !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
			&& Object.propertyIsEnumerable.call(target, key)) // and also unsafe if they're nonenumerable.
}

function mergeObject(target, source, options) {
	var destination = {};
	if (options.isMergeableObject(target)) {
		getKeys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
		});
	}
	getKeys(source).forEach(function(key) {
		if (propertyIsUnsafe(target, key)) {
			return
		}

		if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
			destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
		} else {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
		}
	});
	return destination
}

function deepmerge(target, source, options) {
	options = options || {};
	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	options.isMergeableObject = options.isMergeableObject || isMergeableObject;
	// cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
	// implementations can use it. The caller may not replace it.
	options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;

	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, options)
	} else if (sourceIsArray) {
		return options.arrayMerge(target, source, options)
	} else {
		return mergeObject(target, source, options)
	}
}

deepmerge.all = function deepmergeAll(array, options) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, options)
	}, {})
};

var deepmerge_1 = deepmerge;

module.exports = deepmerge_1;


/***/ }),

/***/ 58875:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return ExecutionEnvironment;
		}).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}

}());


/***/ }),

/***/ 17648:
/***/ (function(module) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = '[object Function]';

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),

/***/ 58612:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(17648);

module.exports = Function.prototype.bind || implementation;


/***/ }),

/***/ 17642:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(58612);

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ }),

/***/ 80645:
/***/ (function(__unused_webpack_module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ 18552:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),

/***/ 1989:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var hashClear = __webpack_require__(51789),
    hashDelete = __webpack_require__(80401),
    hashGet = __webpack_require__(57667),
    hashHas = __webpack_require__(21327),
    hashSet = __webpack_require__(81866);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),

/***/ 38407:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var listCacheClear = __webpack_require__(27040),
    listCacheDelete = __webpack_require__(14125),
    listCacheGet = __webpack_require__(82117),
    listCacheHas = __webpack_require__(67518),
    listCacheSet = __webpack_require__(54705);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),

/***/ 57071:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),

/***/ 83369:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(24785),
    mapCacheDelete = __webpack_require__(11285),
    mapCacheGet = __webpack_require__(96000),
    mapCacheHas = __webpack_require__(49916),
    mapCacheSet = __webpack_require__(95265);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),

/***/ 53818:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),

/***/ 58525:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),

/***/ 46384:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(38407),
    stackClear = __webpack_require__(37465),
    stackDelete = __webpack_require__(63779),
    stackGet = __webpack_require__(67599),
    stackHas = __webpack_require__(44758),
    stackSet = __webpack_require__(34309);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),

/***/ 62705:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(55639);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ 11149:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(55639);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),

/***/ 70577:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),

/***/ 96874:
/***/ (function(module) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),

/***/ 77412:
/***/ (function(module) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),

/***/ 34963:
/***/ (function(module) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),

/***/ 14636:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTimes = __webpack_require__(22545),
    isArguments = __webpack_require__(35694),
    isArray = __webpack_require__(1469),
    isBuffer = __webpack_require__(44144),
    isIndex = __webpack_require__(65776),
    isTypedArray = __webpack_require__(36719);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),

/***/ 29932:
/***/ (function(module) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),

/***/ 62488:
/***/ (function(module) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),

/***/ 34865:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(89465),
    eq = __webpack_require__(77813);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),

/***/ 18470:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var eq = __webpack_require__(77813);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),

/***/ 44037:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(98363),
    keys = __webpack_require__(3674);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),

/***/ 63886:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(98363),
    keysIn = __webpack_require__(81704);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),

/***/ 89465:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var defineProperty = __webpack_require__(38777);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),

/***/ 85990:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(46384),
    arrayEach = __webpack_require__(77412),
    assignValue = __webpack_require__(34865),
    baseAssign = __webpack_require__(44037),
    baseAssignIn = __webpack_require__(63886),
    cloneBuffer = __webpack_require__(64626),
    copyArray = __webpack_require__(278),
    copySymbols = __webpack_require__(18805),
    copySymbolsIn = __webpack_require__(1911),
    getAllKeys = __webpack_require__(58234),
    getAllKeysIn = __webpack_require__(46904),
    getTag = __webpack_require__(64160),
    initCloneArray = __webpack_require__(43824),
    initCloneByTag = __webpack_require__(29148),
    initCloneObject = __webpack_require__(38517),
    isArray = __webpack_require__(1469),
    isBuffer = __webpack_require__(44144),
    isMap = __webpack_require__(56688),
    isObject = __webpack_require__(13218),
    isSet = __webpack_require__(72928),
    keys = __webpack_require__(3674),
    keysIn = __webpack_require__(81704);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),

/***/ 3118:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(13218);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),

/***/ 21078:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(62488),
    isFlattenable = __webpack_require__(37285);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),

/***/ 97786:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(71811),
    toKey = __webpack_require__(40327);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),

/***/ 68866:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(62488),
    isArray = __webpack_require__(1469);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),

/***/ 44239:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705),
    getRawTag = __webpack_require__(89607),
    objectToString = __webpack_require__(2333);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ 9454:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),

/***/ 25588:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getTag = __webpack_require__(64160),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;


/***/ }),

/***/ 28458:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(23560),
    isMasked = __webpack_require__(15346),
    isObject = __webpack_require__(13218),
    toSource = __webpack_require__(80346);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),

/***/ 29221:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getTag = __webpack_require__(64160),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;


/***/ }),

/***/ 38749:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isLength = __webpack_require__(41780),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),

/***/ 280:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPrototype = __webpack_require__(25726),
    nativeKeys = __webpack_require__(86916);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),

/***/ 10313:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(13218),
    isPrototype = __webpack_require__(25726),
    nativeKeysIn = __webpack_require__(33498);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),

/***/ 56560:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var constant = __webpack_require__(75703),
    defineProperty = __webpack_require__(38777),
    identity = __webpack_require__(6557);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),

/***/ 14259:
/***/ (function(module) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),

/***/ 22545:
/***/ (function(module) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ 48969:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayMap = __webpack_require__(29932);

/**
 * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
 * of key-value pairs for `object` corresponding to the property names of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the key-value pairs.
 */
function baseToPairs(object, props) {
  return arrayMap(props, function(key) {
    return [key, object[key]];
  });
}

module.exports = baseToPairs;


/***/ }),

/***/ 80531:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705),
    arrayMap = __webpack_require__(29932),
    isArray = __webpack_require__(1469),
    isSymbol = __webpack_require__(33448);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),

/***/ 27561:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(67990);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),

/***/ 7518:
/***/ (function(module) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ 57406:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(71811),
    last = __webpack_require__(10928),
    parent = __webpack_require__(40292),
    toKey = __webpack_require__(40327);

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

module.exports = baseUnset;


/***/ }),

/***/ 71811:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(1469),
    isKey = __webpack_require__(15403),
    stringToPath = __webpack_require__(55514),
    toString = __webpack_require__(79833);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),

/***/ 74318:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Uint8Array = __webpack_require__(11149);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),

/***/ 64626:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(55639);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;


/***/ }),

/***/ 57157:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(74318);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),

/***/ 93147:
/***/ (function(module) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),

/***/ 40419:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),

/***/ 77133:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(74318);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),

/***/ 278:
/***/ (function(module) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),

/***/ 98363:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assignValue = __webpack_require__(34865),
    baseAssignValue = __webpack_require__(89465);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),

/***/ 18805:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(98363),
    getSymbols = __webpack_require__(99551);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),

/***/ 1911:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(98363),
    getSymbolsIn = __webpack_require__(51442);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),

/***/ 14429:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(55639);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),

/***/ 13866:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseToPairs = __webpack_require__(48969),
    getTag = __webpack_require__(64160),
    mapToArray = __webpack_require__(68776),
    setToPairs = __webpack_require__(99294);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/**
 * Creates a `_.toPairs` or `_.toPairsIn` function.
 *
 * @private
 * @param {Function} keysFunc The function to get the keys of a given object.
 * @returns {Function} Returns the new pairs function.
 */
function createToPairs(keysFunc) {
  return function(object) {
    var tag = getTag(object);
    if (tag == mapTag) {
      return mapToArray(object);
    }
    if (tag == setTag) {
      return setToPairs(object);
    }
    return baseToPairs(object, keysFunc(object));
  };
}

module.exports = createToPairs;


/***/ }),

/***/ 60696:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPlainObject = __webpack_require__(68630);

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject(value) ? undefined : value;
}

module.exports = customOmitClone;


/***/ }),

/***/ 38777:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),

/***/ 99021:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var flatten = __webpack_require__(85564),
    overRest = __webpack_require__(45357),
    setToString = __webpack_require__(30061);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),

/***/ 31957:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

module.exports = freeGlobal;


/***/ }),

/***/ 58234:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(68866),
    getSymbols = __webpack_require__(99551),
    keys = __webpack_require__(3674);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),

/***/ 46904:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(68866),
    getSymbolsIn = __webpack_require__(51442),
    keysIn = __webpack_require__(81704);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),

/***/ 45050:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isKeyable = __webpack_require__(37019);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),

/***/ 10852:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsNative = __webpack_require__(28458),
    getValue = __webpack_require__(47801);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),

/***/ 85924:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var overArg = __webpack_require__(5569);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),

/***/ 89607:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ 99551:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayFilter = __webpack_require__(34963),
    stubArray = __webpack_require__(70479);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),

/***/ 51442:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(62488),
    getPrototype = __webpack_require__(85924),
    getSymbols = __webpack_require__(99551),
    stubArray = __webpack_require__(70479);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),

/***/ 64160:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DataView = __webpack_require__(18552),
    Map = __webpack_require__(57071),
    Promise = __webpack_require__(53818),
    Set = __webpack_require__(58525),
    WeakMap = __webpack_require__(70577),
    baseGetTag = __webpack_require__(44239),
    toSource = __webpack_require__(80346);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),

/***/ 47801:
/***/ (function(module) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),

/***/ 51789:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(94536);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),

/***/ 80401:
/***/ (function(module) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),

/***/ 57667:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(94536);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),

/***/ 21327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(94536);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),

/***/ 81866:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(94536);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),

/***/ 43824:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),

/***/ 29148:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(74318),
    cloneDataView = __webpack_require__(57157),
    cloneRegExp = __webpack_require__(93147),
    cloneSymbol = __webpack_require__(40419),
    cloneTypedArray = __webpack_require__(77133);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),

/***/ 38517:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseCreate = __webpack_require__(3118),
    getPrototype = __webpack_require__(85924),
    isPrototype = __webpack_require__(25726);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),

/***/ 37285:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705),
    isArguments = __webpack_require__(35694),
    isArray = __webpack_require__(1469);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),

/***/ 65776:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ 15403:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(1469),
    isSymbol = __webpack_require__(33448);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),

/***/ 37019:
/***/ (function(module) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),

/***/ 15346:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var coreJsData = __webpack_require__(14429);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),

/***/ 25726:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),

/***/ 27040:
/***/ (function(module) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),

/***/ 14125:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(18470);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),

/***/ 82117:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(18470);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),

/***/ 67518:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(18470);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),

/***/ 54705:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(18470);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),

/***/ 24785:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Hash = __webpack_require__(1989),
    ListCache = __webpack_require__(38407),
    Map = __webpack_require__(57071);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),

/***/ 11285:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(45050);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),

/***/ 96000:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(45050);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),

/***/ 49916:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(45050);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),

/***/ 95265:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(45050);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),

/***/ 68776:
/***/ (function(module) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),

/***/ 24523:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoize = __webpack_require__(88306);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),

/***/ 94536:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),

/***/ 86916:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var overArg = __webpack_require__(5569);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ 33498:
/***/ (function(module) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),

/***/ 31167:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var freeGlobal = __webpack_require__(31957);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;


/***/ }),

/***/ 2333:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ 5569:
/***/ (function(module) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ 45357:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var apply = __webpack_require__(96874);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),

/***/ 40292:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(97786),
    baseSlice = __webpack_require__(14259);

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

module.exports = parent;


/***/ }),

/***/ 55639:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var freeGlobal = __webpack_require__(31957);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ 99294:
/***/ (function(module) {

/**
 * Converts `set` to its value-value pairs.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the value-value pairs.
 */
function setToPairs(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = [value, value];
  });
  return result;
}

module.exports = setToPairs;


/***/ }),

/***/ 30061:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseSetToString = __webpack_require__(56560),
    shortOut = __webpack_require__(21275);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),

/***/ 21275:
/***/ (function(module) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),

/***/ 37465:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(38407);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),

/***/ 63779:
/***/ (function(module) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),

/***/ 67599:
/***/ (function(module) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),

/***/ 44758:
/***/ (function(module) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),

/***/ 34309:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(38407),
    Map = __webpack_require__(57071),
    MapCache = __webpack_require__(83369);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),

/***/ 55514:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(24523);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),

/***/ 40327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isSymbol = __webpack_require__(33448);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),

/***/ 80346:
/***/ (function(module) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),

/***/ 67990:
/***/ (function(module) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),

/***/ 75703:
/***/ (function(module) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),

/***/ 23279:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(13218),
    now = __webpack_require__(7771),
    toNumber = __webpack_require__(14841);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),

/***/ 77813:
/***/ (function(module) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ 85564:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFlatten = __webpack_require__(21078);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),

/***/ 27361:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(97786);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),

/***/ 6557:
/***/ (function(module) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ 35694:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(9454),
    isObjectLike = __webpack_require__(37005);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),

/***/ 1469:
/***/ (function(module) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ 98612:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(23560),
    isLength = __webpack_require__(41780);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ 44144:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(55639),
    stubFalse = __webpack_require__(95062);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;


/***/ }),

/***/ 67191:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObjectLike = __webpack_require__(37005),
    isPlainObject = __webpack_require__(68630);

/**
 * Checks if `value` is likely a DOM element.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
 * @example
 *
 * _.isElement(document.body);
 * // => true
 *
 * _.isElement('<body>');
 * // => false
 */
function isElement(value) {
  return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
}

module.exports = isElement;


/***/ }),

/***/ 41609:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseKeys = __webpack_require__(280),
    getTag = __webpack_require__(64160),
    isArguments = __webpack_require__(35694),
    isArray = __webpack_require__(1469),
    isArrayLike = __webpack_require__(98612),
    isBuffer = __webpack_require__(44144),
    isPrototype = __webpack_require__(25726),
    isTypedArray = __webpack_require__(36719);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

module.exports = isEmpty;


/***/ }),

/***/ 97398:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(55639);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsFinite = root.isFinite;

/**
 * Checks if `value` is a finite primitive number.
 *
 * **Note:** This method is based on
 * [`Number.isFinite`](https://mdn.io/Number/isFinite).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
 * @example
 *
 * _.isFinite(3);
 * // => true
 *
 * _.isFinite(Number.MIN_VALUE);
 * // => true
 *
 * _.isFinite(Infinity);
 * // => false
 *
 * _.isFinite('3');
 * // => false
 */
function isFinite(value) {
  return typeof value == 'number' && nativeIsFinite(value);
}

module.exports = isFinite;


/***/ }),

/***/ 23560:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isObject = __webpack_require__(13218);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ 41780:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ 56688:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsMap = __webpack_require__(25588),
    baseUnary = __webpack_require__(7518),
    nodeUtil = __webpack_require__(31167);

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;


/***/ }),

/***/ 13218:
/***/ (function(module) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ 37005:
/***/ (function(module) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ 68630:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    getPrototype = __webpack_require__(85924),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),

/***/ 72928:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsSet = __webpack_require__(29221),
    baseUnary = __webpack_require__(7518),
    nodeUtil = __webpack_require__(31167);

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;


/***/ }),

/***/ 47037:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isArray = __webpack_require__(1469),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),

/***/ 33448:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),

/***/ 36719:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(38749),
    baseUnary = __webpack_require__(7518),
    nodeUtil = __webpack_require__(31167);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),

/***/ 3674:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(14636),
    baseKeys = __webpack_require__(280),
    isArrayLike = __webpack_require__(98612);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),

/***/ 81704:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(14636),
    baseKeysIn = __webpack_require__(10313),
    isArrayLike = __webpack_require__(98612);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),

/***/ 10928:
/***/ (function(module) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),

/***/ 88306:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(83369);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),

/***/ 7771:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(55639);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),

/***/ 57557:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayMap = __webpack_require__(29932),
    baseClone = __webpack_require__(85990),
    baseUnset = __webpack_require__(57406),
    castPath = __webpack_require__(71811),
    copyObject = __webpack_require__(98363),
    customOmitClone = __webpack_require__(60696),
    flatRest = __webpack_require__(99021),
    getAllKeysIn = __webpack_require__(46904);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function(path) {
    path = castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});

module.exports = omit;


/***/ }),

/***/ 70479:
/***/ (function(module) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),

/***/ 95062:
/***/ (function(module) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ 14841:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTrim = __webpack_require__(27561),
    isObject = __webpack_require__(13218),
    isSymbol = __webpack_require__(33448);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ 93220:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createToPairs = __webpack_require__(13866),
    keys = __webpack_require__(3674);

/**
 * Creates an array of own enumerable string keyed-value pairs for `object`
 * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
 * entries are returned.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias entries
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the key-value pairs.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.toPairs(new Foo);
 * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
 */
var toPairs = createToPairs(keys);

module.exports = toPairs;


/***/ }),

/***/ 79833:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseToString = __webpack_require__(80531);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),

/***/ 30845:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var safeIsNaN = Number.isNaN ||
    function ponyfill(value) {
        return typeof value === 'number' && value !== value;
    };
function isEqual(first, second) {
    if (first === second) {
        return true;
    }
    if (safeIsNaN(first) && safeIsNaN(second)) {
        return true;
    }
    return false;
}
function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) {
        return false;
    }
    for (var i = 0; i < newInputs.length; i++) {
        if (!isEqual(newInputs[i], lastInputs[i])) {
            return false;
        }
    }
    return true;
}

function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) { isEqual = areInputsEqual; }
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            newArgs[_i] = arguments[_i];
        }
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
            return lastResult;
        }
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}

/* harmony default export */ __webpack_exports__["Z"] = (memoizeOne);


/***/ }),

/***/ 11752:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(36616)


/***/ }),

/***/ 44019:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.getDomainLocale = getDomainLocale;
var basePath = (/* unused pure expression or super */ null && ( false || ''));

function getDomainLocale(path, locale, locales, domainLocales) {
  if (false) { var finalLocale, proto, domain, target, detectDomainLocale, normalizeLocalePath; } else {
    return false;
  }
}

if ((typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) && typeof exports["default"].__esModule === 'undefined') {
  Object.defineProperty(exports["default"], '__esModule', {
    value: true
  });
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 7942:
/***/ (function(module, exports, __webpack_require__) {

"client";
"use strict";

var _slicedToArray = __webpack_require__(85696);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);

var _object_without_properties_loose = (__webpack_require__(17273)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(37667));

var _router = __webpack_require__(64957);

var _addLocale = __webpack_require__(57995);

var _routerContext = __webpack_require__(30647);

var _appRouterContext = __webpack_require__(51992);

var _useIntersection = __webpack_require__(90639);

var _getDomainLocale = __webpack_require__(44019);

var _addBasePath = __webpack_require__(70227);

'client';
var prefetched = {};

function prefetch(router, href, as, options) {
  if ( false || !router) return;
  if (!(0, _router).isLocalURL(href)) return; // Prefetch the JSON page if asked (only in the client)
  // We need to handle a prefetch error here since we may be
  // loading with priority which can reject but we don't
  // want to force navigation since this is only a prefetch

  Promise.resolve(router.prefetch(href, as, options))["catch"](function (err) {
    if (false) {}
  });
  var curLocale = options && typeof options.locale !== 'undefined' ? options.locale : router && router.locale; // Join on an invalid URI character

  prefetched[href + '%' + as + (curLocale ? '%' + curLocale : '')] = true;
}

function isModifiedEvent(event) {
  var target = event.currentTarget.target;
  return target && target !== '_self' || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}

function linkClicked(e, router, href, as, replace, shallow, scroll, locale, isAppRouter, prefetchEnabled) {
  var nodeName = e.currentTarget.nodeName; // anchors inside an svg have a lowercase nodeName

  var isAnchorNodeName = nodeName.toUpperCase() === 'A';

  if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
    // ignore click for browser’s default behavior
    return;
  }

  e.preventDefault();

  var navigate = function navigate() {
    // If the router is an NextRouter instance it will have `beforePopState`
    if ('beforePopState' in router) {
      router[replace ? 'replace' : 'push'](href, as, {
        shallow: shallow,
        locale: locale,
        scroll: scroll
      });
    } else {
      // If `beforePopState` doesn't exist on the router it's the AppRouter.
      var method = replace ? 'replace' : 'push';
      router[method](href, {
        forceOptimisticNavigation: !prefetchEnabled
      });
    }
  };

  if (isAppRouter) {
    // @ts-expect-error startTransition exists.
    _react["default"].startTransition(navigate);
  } else {
    navigate();
  }
}

var Link = /*#__PURE__*/_react["default"].forwardRef(function LinkComponent(props, forwardedRef) {
  if (false) { var hasWarned, optionalProps, optionalPropsGuard, requiredProps, requiredPropsGuard, createPropError; }

  var children;

  var hrefProp = props.href,
      asProp = props.as,
      childrenProp = props.children,
      prefetchProp = props.prefetch,
      passHref = props.passHref,
      replace = props.replace,
      shallow = props.shallow,
      scroll = props.scroll,
      locale = props.locale,
      _onClick = props.onClick,
      _onMouseEnter = props.onMouseEnter,
      _onTouchStart = props.onTouchStart,
      _props$legacyBehavior = props.legacyBehavior,
      legacyBehavior = _props$legacyBehavior === void 0 ? Boolean(false) !== true : _props$legacyBehavior,
      restProps = _object_without_properties_loose(props, ["href", "as", "children", "prefetch", "passHref", "replace", "shallow", "scroll", "locale", "onClick", "onMouseEnter", "onTouchStart", "legacyBehavior"]);

  children = childrenProp;

  if (legacyBehavior && (typeof children === 'string' || typeof children === 'number')) {
    children = /*#__PURE__*/_react["default"].createElement("a", null, children);
  }

  var p = prefetchProp !== false;

  var router = _react["default"].useContext(_routerContext.RouterContext); // TODO-APP: type error. Remove `as any`


  var appRouter = _react["default"].useContext(_appRouterContext.AppRouterContext);

  if (appRouter) {
    router = appRouter;
  }

  var _react$default$useMem = _react["default"].useMemo(function () {
    var _resolveHref = (0, _router).resolveHref(router, hrefProp, true),
        _resolveHref2 = _slicedToArray(_resolveHref, 2),
        resolvedHref = _resolveHref2[0],
        resolvedAs = _resolveHref2[1];

    return {
      href: resolvedHref,
      as: asProp ? (0, _router).resolveHref(router, asProp) : resolvedAs || resolvedHref
    };
  }, [router, hrefProp, asProp]),
      href = _react$default$useMem.href,
      as = _react$default$useMem.as;

  var previousHref = _react["default"].useRef(href);

  var previousAs = _react["default"].useRef(as); // This will return the first child, if multiple are provided it will throw an error


  var child;

  if (legacyBehavior) {
    if (false) {} else {
      child = _react["default"].Children.only(children);
    }
  }

  var childRef = legacyBehavior ? child && typeof child === 'object' && child.ref : forwardedRef;

  var _useIntersection2 = (0, _useIntersection).useIntersection({
    rootMargin: '200px'
  }),
      _useIntersection3 = _slicedToArray(_useIntersection2, 3),
      setIntersectionRef = _useIntersection3[0],
      isVisible = _useIntersection3[1],
      resetVisible = _useIntersection3[2];

  var setRef = _react["default"].useCallback(function (el) {
    // Before the link getting observed, check if visible state need to be reset
    if (previousAs.current !== as || previousHref.current !== href) {
      resetVisible();
      previousAs.current = as;
      previousHref.current = href;
    }

    setIntersectionRef(el);

    if (childRef) {
      if (typeof childRef === 'function') childRef(el);else if (typeof childRef === 'object') {
        childRef.current = el;
      }
    }
  }, [as, childRef, href, resetVisible, setIntersectionRef]);

  _react["default"].useEffect(function () {
    var shouldPrefetch = isVisible && p && (0, _router).isLocalURL(href);
    var curLocale = typeof locale !== 'undefined' ? locale : router && router.locale;
    var isPrefetched = prefetched[href + '%' + as + (curLocale ? '%' + curLocale : '')];

    if (shouldPrefetch && !isPrefetched) {
      prefetch(router, href, as, {
        locale: curLocale
      });
    }
  }, [as, href, isVisible, locale, p, router]);

  var childProps = {
    ref: setRef,
    onClick: function onClick(e) {
      if (false) {}

      if (!legacyBehavior && typeof _onClick === 'function') {
        _onClick(e);
      }

      if (legacyBehavior && child.props && typeof child.props.onClick === 'function') {
        child.props.onClick(e);
      }

      if (!e.defaultPrevented) {
        linkClicked(e, router, href, as, replace, shallow, scroll, locale, Boolean(appRouter), p);
      }
    },
    onMouseEnter: function onMouseEnter(e) {
      if (!legacyBehavior && typeof _onMouseEnter === 'function') {
        _onMouseEnter(e);
      }

      if (legacyBehavior && child.props && typeof child.props.onMouseEnter === 'function') {
        child.props.onMouseEnter(e);
      } // Check for not prefetch disabled in page using appRouter


      if (!(!p && appRouter)) {
        if ((0, _router).isLocalURL(href)) {
          prefetch(router, href, as, {
            priority: true
          });
        }
      }
    },
    onTouchStart: function onTouchStart(e) {
      if (!legacyBehavior && typeof _onTouchStart === 'function') {
        _onTouchStart(e);
      }

      if (legacyBehavior && child.props && typeof child.props.onTouchStart === 'function') {
        child.props.onTouchStart(e);
      } // Check for not prefetch disabled in page using appRouter


      if (!(!p && appRouter)) {
        if ((0, _router).isLocalURL(href)) {
          prefetch(router, href, as, {
            priority: true
          });
        }
      }
    }
  }; // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
  // defined, we specify the current 'href', so that repetition is not needed by the user

  if (!legacyBehavior || passHref || child.type === 'a' && !('href' in child.props)) {
    var curLocale = typeof locale !== 'undefined' ? locale : router && router.locale; // we only render domain locales if we are currently on a domain locale
    // so that locale links are still visitable in development/preview envs

    var localeDomain = router && router.isLocaleDomain && (0, _getDomainLocale).getDomainLocale(as, curLocale, router.locales, router.domainLocales);
    childProps.href = localeDomain || (0, _addBasePath).addBasePath((0, _addLocale).addLocale(as, curLocale, router && router.defaultLocale));
  }

  return legacyBehavior ? /*#__PURE__*/_react["default"].cloneElement(child, childProps) : /*#__PURE__*/_react["default"].createElement("a", Object.assign({}, restProps, childProps), children);
});

var _default = Link;
exports["default"] = _default;

if ((typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) && typeof exports["default"].__esModule === 'undefined') {
  Object.defineProperty(exports["default"], '__esModule', {
    value: true
  });
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 90639:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = __webpack_require__(85696);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.useIntersection = useIntersection;

var _react = __webpack_require__(37667);

var _requestIdleCallback = __webpack_require__(26286);

var hasIntersectionObserver = typeof IntersectionObserver === 'function';
var observers = new Map();
var idList = [];

function createObserver(options) {
  var id = {
    root: options.root || null,
    margin: options.rootMargin || ''
  };
  var existing = idList.find(function (obj) {
    return obj.root === id.root && obj.margin === id.margin;
  });
  var instance;

  if (existing) {
    instance = observers.get(existing);

    if (instance) {
      return instance;
    }
  }

  var elements = new Map();
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var callback = elements.get(entry.target);
      var isVisible = entry.isIntersecting || entry.intersectionRatio > 0;

      if (callback && isVisible) {
        callback(isVisible);
      }
    });
  }, options);
  instance = {
    id: id,
    observer: observer,
    elements: elements
  };
  idList.push(id);
  observers.set(id, instance);
  return instance;
}

function observe(element, callback, options) {
  var _createObserver = createObserver(options),
      id = _createObserver.id,
      observer = _createObserver.observer,
      elements = _createObserver.elements;

  elements.set(element, callback);
  observer.observe(element);
  return function unobserve() {
    elements["delete"](element);
    observer.unobserve(element); // Destroy observer when there's nothing left to watch:

    if (elements.size === 0) {
      observer.disconnect();
      observers["delete"](id);
      var index = idList.findIndex(function (obj) {
        return obj.root === id.root && obj.margin === id.margin;
      });

      if (index > -1) {
        idList.splice(index, 1);
      }
    }
  };
}

function useIntersection(_ref) {
  var rootRef = _ref.rootRef,
      rootMargin = _ref.rootMargin,
      disabled = _ref.disabled;
  var isDisabled = disabled || !hasIntersectionObserver;

  var _useState = (0, _react).useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var _useState3 = (0, _react).useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      element = _useState4[0],
      setElement = _useState4[1];

  (0, _react).useEffect(function () {
    if (hasIntersectionObserver) {
      if (isDisabled || visible) return;

      if (element && element.tagName) {
        var unobserve = observe(element, function (isVisible) {
          return isVisible && setVisible(isVisible);
        }, {
          root: rootRef == null ? void 0 : rootRef.current,
          rootMargin: rootMargin
        });
        return unobserve;
      }
    } else {
      if (!visible) {
        var idleCallback = (0, _requestIdleCallback).requestIdleCallback(function () {
          return setVisible(true);
        });
        return function () {
          return (0, _requestIdleCallback).cancelIdleCallback(idleCallback);
        };
      }
    }
  }, [element, isDisabled, rootMargin, rootRef, visible]);
  var resetVisible = (0, _react).useCallback(function () {
    setVisible(false);
  }, []);
  return [setElement, visible, resetVisible];
}

if ((typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) && typeof exports["default"].__esModule === 'undefined') {
  Object.defineProperty(exports["default"], '__esModule', {
    value: true
  });
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 51992:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.TemplateContext = exports.GlobalLayoutRouterContext = exports.LayoutRouterContext = exports.AppRouterContext = void 0;

var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(37667));

var AppRouterContext = _react["default"].createContext(null);

exports.AppRouterContext = AppRouterContext;

var LayoutRouterContext = _react["default"].createContext(null);

exports.LayoutRouterContext = LayoutRouterContext;

var GlobalLayoutRouterContext = _react["default"].createContext(null);

exports.GlobalLayoutRouterContext = GlobalLayoutRouterContext;

var TemplateContext = _react["default"].createContext(null);

exports.TemplateContext = TemplateContext;

if (false) {}

/***/ }),

/***/ 73579:
/***/ (function(module, exports, __webpack_require__) {

"client";
"use strict";

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;

var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);

var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(37667));

var _loadable = _interop_require_default(__webpack_require__(23668));

function dynamic(dynamicOptions, options) {
  var loadableFn = _loadable["default"];
  var loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
    // A loading component is not required, so we default it
    loading: function loading(_ref) {
      var error = _ref.error,
          isLoading = _ref.isLoading,
          pastDelay = _ref.pastDelay;
      if (!pastDelay) return null;

      if (false) {}

      return null;
    }
  }; // Support for direct import(), eg: dynamic(import('../hello-world'))
  // Note that this is only kept for the edge case where someone is passing in a promise as first argument
  // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
  // To make sure we don't execute the import without rendering first

  if (dynamicOptions instanceof Promise) {
    loadableOptions.loader = function () {
      return dynamicOptions;
    }; // Support for having import as a function, eg: dynamic(() => import('../hello-world'))

  } else if (typeof dynamicOptions === 'function') {
    loadableOptions.loader = dynamicOptions; // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
  } else if (typeof dynamicOptions === 'object') {
    loadableOptions = _extends({}, loadableOptions, dynamicOptions);
  } // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})


  loadableOptions = _extends({}, loadableOptions, options); // Error if Fizz rendering is not enabled and `suspense` option is set to true

  if (false) {}

  if (loadableOptions.suspense) {
    if (false) {}

    delete loadableOptions.ssr;
    delete loadableOptions.loading;
  } // coming from build/babel/plugins/react-loadable-plugin.js


  if (loadableOptions.loadableGenerated) {
    loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
    delete loadableOptions.loadableGenerated;
  } // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
  // skip `ssr` for suspense mode and opt-in React.lazy directly


  if (typeof loadableOptions.ssr === 'boolean' && !loadableOptions.suspense) {
    if (!loadableOptions.ssr) {
      delete loadableOptions.ssr;
      return noSSR(loadableFn, loadableOptions);
    }

    delete loadableOptions.ssr;
  }

  return loadableFn(loadableOptions);
}

'client';
var isServerSide = false;

function noSSR(LoadableInitializer, loadableOptions) {
  // Removing webpack and modules means react-loadable won't try preloading
  delete loadableOptions.webpack;
  delete loadableOptions.modules; // This check is necessary to prevent react-loadable from initializing on the server

  if (!isServerSide) {
    return LoadableInitializer(loadableOptions);
  }

  var Loading = loadableOptions.loading; // This will only be rendered on the server side

  return function () {
    return /*#__PURE__*/_react["default"].createElement(Loading, {
      error: null,
      isLoading: true,
      pastDelay: false,
      timedOut: false
    });
  };
}

if ((typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) && typeof exports["default"].__esModule === 'undefined') {
  Object.defineProperty(exports["default"], '__esModule', {
    value: true
  });
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 3982:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.LoadableContext = void 0;

var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(37667));

var LoadableContext = _react["default"].createContext(null);

exports.LoadableContext = LoadableContext;

if (false) {}

/***/ }),

/***/ 23668:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _classCallCheck = __webpack_require__(33227);

var _createClass = __webpack_require__(88361);

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);

var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(37667));

var _loadableContext = __webpack_require__(3982);

var _ref =  true ? __webpack_require__(37667) : 0,
    useSyncExternalStore = _ref.useSyncExternalStore;

var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;

function load(loader) {
  var promise = loader();
  var state = {
    loading: true,
    loaded: null,
    error: null
  };
  state.promise = promise.then(function (loaded) {
    state.loading = false;
    state.loaded = loaded;
    return loaded;
  })["catch"](function (err) {
    state.loading = false;
    state.error = err;
    throw err;
  });
  return state;
}

function resolve(obj) {
  return obj && obj.__esModule ? obj["default"] : obj;
}

function createLoadableComponent(loadFn, options) {
  var opts = Object.assign({
    loader: null,
    loading: null,
    delay: 200,
    timeout: null,
    webpack: null,
    modules: null,
    suspense: false
  }, options);

  if (opts.suspense) {
    opts.lazy = _react["default"].lazy(opts.loader);
  }
  /** @type LoadableSubscription */


  var subscription = null;

  function init() {
    if (!subscription) {
      var sub = new LoadableSubscription(loadFn, opts);
      subscription = {
        getCurrentValue: sub.getCurrentValue.bind(sub),
        subscribe: sub.subscribe.bind(sub),
        retry: sub.retry.bind(sub),
        promise: sub.promise.bind(sub)
      };
    }

    return subscription.promise();
  } // Server only


  if (false) {} // Client only


  if (!initialized && true) {
    // require.resolveWeak check is needed for environments that don't have it available like Jest
    var moduleIds = opts.webpack && "function" === 'function' ? opts.webpack() : opts.modules;

    if (moduleIds) {
      READY_INITIALIZERS.push(function (ids) {
        var _iterator = _createForOfIteratorHelper(moduleIds),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var moduleId = _step.value;

            if (ids.indexOf(moduleId) !== -1) {
              return init();
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
    }
  }

  function useLoadableModule() {
    init();

    var context = _react["default"].useContext(_loadableContext.LoadableContext);

    if (context && Array.isArray(opts.modules)) {
      opts.modules.forEach(function (moduleName) {
        context(moduleName);
      });
    }
  }

  function LoadableImpl(props, ref) {
    useLoadableModule();
    var state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);

    _react["default"].useImperativeHandle(ref, function () {
      return {
        retry: subscription.retry
      };
    }, []);

    return _react["default"].useMemo(function () {
      if (state.loading || state.error) {
        return _react["default"].createElement(opts.loading, {
          isLoading: state.loading,
          pastDelay: state.pastDelay,
          timedOut: state.timedOut,
          error: state.error,
          retry: subscription.retry
        });
      } else if (state.loaded) {
        return _react["default"].createElement(resolve(state.loaded), props);
      } else {
        return null;
      }
    }, [props, state]);
  }

  function LazyImpl(props, ref) {
    useLoadableModule();
    return _react["default"].createElement(opts.lazy, _extends({}, props, {
      ref: ref
    }));
  }

  var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;

  LoadableComponent.preload = function () {
    return init();
  };

  LoadableComponent.displayName = 'LoadableComponent';
  return _react["default"].forwardRef(LoadableComponent);
}

var LoadableSubscription = /*#__PURE__*/function () {
  function LoadableSubscription(loadFn, opts) {
    _classCallCheck(this, LoadableSubscription);

    this._loadFn = loadFn;
    this._opts = opts;
    this._callbacks = new Set();
    this._delay = null;
    this._timeout = null;
    this.retry();
  }

  _createClass(LoadableSubscription, [{
    key: "promise",
    value: function promise() {
      return this._res.promise;
    }
  }, {
    key: "retry",
    value: function retry() {
      var _this = this;

      this._clearTimeouts();

      this._res = this._loadFn(this._opts.loader);
      this._state = {
        pastDelay: false,
        timedOut: false
      };
      var res = this._res,
          opts = this._opts;

      if (res.loading) {
        if (typeof opts.delay === 'number') {
          if (opts.delay === 0) {
            this._state.pastDelay = true;
          } else {
            this._delay = setTimeout(function () {
              _this._update({
                pastDelay: true
              });
            }, opts.delay);
          }
        }

        if (typeof opts.timeout === 'number') {
          this._timeout = setTimeout(function () {
            _this._update({
              timedOut: true
            });
          }, opts.timeout);
        }
      }

      this._res.promise.then(function () {
        _this._update({});

        _this._clearTimeouts();
      })["catch"](function (_err) {
        _this._update({});

        _this._clearTimeouts();
      });

      this._update({});
    }
  }, {
    key: "_update",
    value: function _update(partial) {
      this._state = _extends({}, this._state, {
        error: this._res.error,
        loaded: this._res.loaded,
        loading: this._res.loading
      }, partial);

      this._callbacks.forEach(function (callback) {
        return callback();
      });
    }
  }, {
    key: "_clearTimeouts",
    value: function _clearTimeouts() {
      clearTimeout(this._delay);
      clearTimeout(this._timeout);
    }
  }, {
    key: "getCurrentValue",
    value: function getCurrentValue() {
      return this._state;
    }
  }, {
    key: "subscribe",
    value: function subscribe(callback) {
      var _this2 = this;

      this._callbacks.add(callback);

      return function () {
        _this2._callbacks["delete"](callback);
      };
    }
  }]);

  return LoadableSubscription;
}();

function Loadable(opts) {
  return createLoadableComponent(load, opts);
}

function flushInitializers(initializers, ids) {
  var promises = [];

  while (initializers.length) {
    var init = initializers.pop();
    promises.push(init(ids));
  }

  return Promise.all(promises).then(function () {
    if (initializers.length) {
      return flushInitializers(initializers, ids);
    }
  });
}

Loadable.preloadAll = function () {
  return new Promise(function (resolveInitializers, reject) {
    flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
  });
};

Loadable.preloadReady = function () {
  var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return new Promise(function (resolvePreload) {
    var res = function res() {
      initialized = true;
      return resolvePreload();
    }; // We always will resolve, errors should be handled within loading UIs.


    flushInitializers(READY_INITIALIZERS, ids).then(res, res);
  });
};

if (true) {
  window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}

var _default = Loadable;
exports["default"] = _default;

/***/ }),

/***/ 53171:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var _react = _interopRequireWildcard(__webpack_require__(37667));

var _ChevronDown32PxOutlined = _interopRequireDefault(__webpack_require__(20372));

var _ChevronDown24PxOutlined = _interopRequireDefault(__webpack_require__(35119));

var _propTypes = _interopRequireDefault(__webpack_require__(45697));

var _classnames = _interopRequireDefault(__webpack_require__(39232));

var _accordionModule = _interopRequireDefault(__webpack_require__(26996));

var _jsxRuntime = __webpack_require__(85893);

var _excluded = ["label", "children", "className", "animated", "animationDuration", "onStateChange", "size", "instanceName", "responsive"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
      t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}

function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };

  var t = _getRequireWildcardCache(r);

  if (t && t.has(e)) return t.get(e);
  var n = {
    __proto__: null
  },
      a = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var u in e) {
    if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }

  return n["default"] = e, t && t.set(e, n), n;
}

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");

  return "symbol" == _typeof(i) ? i : i + "";
}

function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];

  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return ("string" === r ? String : Number)(t);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];

  if (null != t) {
    var e,
        n,
        i,
        u,
        a = [],
        f = !0,
        o = !1;

    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) {
        ;
      }
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }

    return a;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var propTypes = {
  /** Text (or markup) to show as the title for this accordion */
  label: _propTypes["default"].node.isRequired,

  /** Contents of the accordion */
  children: _propTypes["default"].node.isRequired,

  /** Animate the toggling of the accordion if true */
  animated: _propTypes["default"].bool,

  /** Customise animation duration */
  animationDuration: _propTypes["default"].number,

  /** Callback to run on open or close */
  onStateChange: _propTypes["default"].func,

  /** Set the accordion size */
  size: _propTypes["default"].oneOf(['S', 'M', 'L']),

  /** Specific namespace for open/close events */
  instanceName: _propTypes["default"].string,

  /** Class name for styling */
  className: _propTypes["default"].string,

  /** Override for size that instead adds responsive size */
  responsive: _propTypes["default"].bool
};

var Accordion = function Accordion(_ref) {
  var label = _ref.label,
      children = _ref.children,
      className = _ref.className,
      _ref$animated = _ref.animated,
      animated = _ref$animated === void 0 ? false : _ref$animated,
      _ref$animationDuratio = _ref.animationDuration,
      animationDuration = _ref$animationDuratio === void 0 ? 400 : _ref$animationDuratio,
      _ref$onStateChange = _ref.onStateChange,
      onStateChange = _ref$onStateChange === void 0 ? function () {} : _ref$onStateChange,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'L' : _ref$size,
      instanceName = _ref.instanceName,
      _ref$responsive = _ref.responsive,
      responsive = _ref$responsive === void 0 ? false : _ref$responsive,
      props = _objectWithoutProperties(_ref, _excluded);

  var detailsRef = (0, _react.useRef)();
  var contentRef = (0, _react.useRef)();
  var summaryRef = (0, _react.useRef)();

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      animation = _useState2[0],
      setAnimation = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isClosing = _useState4[0],
      setIsClosing = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isExpanding = _useState6[0],
      setIsExpanding = _useState6[1];

  var _useState7 = (0, _react.useState)(animated),
      _useState8 = _slicedToArray(_useState7, 2),
      isAnimated = _useState8[0],
      setIsAnimated = _useState8[1];

  var animationOptions = {
    duration: animationDuration,
    easing: 'ease-out'
  };
  var handleAnimatedFinished = (0, _react.useCallback)(function (open) {
    var $detail = detailsRef.current;

    if ($detail) {
      $detail.open = open;
      setAnimation(null);
      setIsClosing(false);
      setIsExpanding(false);
      $detail.style.height = '';
      $detail.style.overflow = '';
    }
  }, []);
  var expand = (0, _react.useCallback)(function () {
    var $detail = detailsRef.current;
    var $content = contentRef.current;
    setIsExpanding(true);
    var startHeight = "".concat($detail.offsetHeight, "px");
    var endHeight = "".concat($detail.offsetHeight + $content.offsetHeight, "px");

    if (animation) {
      animation.cancel();
    }

    var runningAnimation = $detail.animate({
      height: [startHeight, endHeight]
    }, animationOptions);
    setAnimation(runningAnimation);

    runningAnimation.onfinish = function () {
      return handleAnimatedFinished(true);
    };

    runningAnimation.oncancel = function () {
      return setIsExpanding(false);
    };
  }, [animation, handleAnimatedFinished]);
  var shrink = (0, _react.useCallback)(function () {
    var $detail = detailsRef.current;
    var $summary = summaryRef.current;
    setIsClosing(true);
    var startHeight = "".concat($detail.offsetHeight, "px");
    var endHeight = "".concat($summary.offsetHeight, "px");

    if (animation) {
      animation.cancel();
    }

    var runningAnimation = $detail.animate({
      height: [startHeight, endHeight]
    }, animationOptions);
    setAnimation(runningAnimation);

    runningAnimation.onfinish = function () {
      return handleAnimatedFinished(false);
    };

    runningAnimation.oncancel = function () {
      return setIsClosing(false);
    };
  }, [animation, handleAnimatedFinished]);
  var open = (0, _react.useCallback)(function () {
    var $detail = detailsRef.current;
    $detail.style.height = "".concat($detail.offsetHeight, "px");
    $detail.open = true;
    window.requestAnimationFrame(function () {
      return expand();
    });
  }, [expand]);
  var handleClick = (0, _react.useCallback)(function (e) {
    var $detail = detailsRef.current;
    e.preventDefault();
    $detail.style.overflow = 'hidden';

    if (isClosing || !$detail.open) {
      isAnimated ? open() : $detail.open = true;
      onStateChange(true);
    } else if (isExpanding || $detail.open) {
      isAnimated ? shrink() : $detail.open = false;
      onStateChange(false);
    }
  }, [open, shrink, onStateChange, isClosing, isExpanding, isAnimated]);
  var handleCustomEvent = (0, _react.useCallback)(function (event) {
    var _event$detail, _event$detail2;

    var $detail = detailsRef.current;

    if ((event === null || event === void 0 || (_event$detail = event.detail) === null || _event$detail === void 0 ? void 0 : _event$detail.action) === 'open' && (isClosing || !$detail.open)) {
      isAnimated ? open() : $detail.open = true;
      onStateChange(true);
    } else if ((event === null || event === void 0 || (_event$detail2 = event.detail) === null || _event$detail2 === void 0 ? void 0 : _event$detail2.action) === 'close' && (isExpanding || $detail.open)) {
      isAnimated ? shrink() : $detail.open = false;
      onStateChange(false);
    }
  }, [open, shrink, onStateChange, isClosing, isExpanding, isAnimated]);
  (0, _react.useEffect)(function () {
    var $detail = detailsRef.current;

    if ($detail) {
      setIsAnimated(isAnimated && 'animate' in $detail);
    }

    if (instanceName) {
      document.body.addEventListener("jlds:accordion:".concat(instanceName), handleCustomEvent);
      return function () {
        document.body.removeEventListener("jlds:accordion:".concat(instanceName), handleCustomEvent);
      };
    }
  }, [instanceName, handleCustomEvent, isAnimated]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("details", _objectSpread(_objectSpread({
    ref: detailsRef,
    className: (0, _classnames["default"])(_accordionModule["default"]['c-accordion'], className, _defineProperty(_defineProperty(_defineProperty({}, _accordionModule["default"]['c-accordion--small-size'], size === 'S' && !responsive), _accordionModule["default"]['c-accordion--medium-size'], size === 'M' && !responsive), _accordionModule["default"]['c-accordion--responsive-size'], responsive)),
    "data-testid": "accordion:details"
  }, props), {}, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("summary", {
      ref: summaryRef,
      onClick: handleClick,
      role: "button",
      tabIndex: "0",
      className: (0, _classnames["default"])(_accordionModule["default"]['c-accordion__label'], _defineProperty(_defineProperty(_defineProperty({}, _accordionModule["default"]['c-accordion__label--medium-size'], size === 'M' && !responsive), _accordionModule["default"]['c-accordion__label--small-size'], size === 'S' && !responsive), _accordionModule["default"]['c-accordion__label--responsive-size'], responsive)),
      children: [label, /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: (0, _classnames["default"])(_accordionModule["default"]['c-accordion__chevron'], _defineProperty(_defineProperty(_defineProperty({}, _accordionModule["default"]['c-accordion__chevron--medium-size'], size === 'M' && !responsive), _accordionModule["default"]['c-accordion__chevron--small-size'], size === 'S' && !responsive), _accordionModule["default"]['c-accordion__chevron--responsive-size'], responsive)),
        children: responsive ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ChevronDown24PxOutlined["default"], {
            className: _accordionModule["default"]['c-accordion--small-icon']
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChevronDown32PxOutlined["default"], {
            className: _accordionModule["default"]['c-accordion--large-icon']
          })]
        }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [size === 'S' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChevronDown24PxOutlined["default"], {}), size === 'M' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChevronDown24PxOutlined["default"], {}), size === 'L' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChevronDown32PxOutlined["default"], {})]
        })
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _accordionModule["default"]['c-accordion__content'],
      ref: contentRef,
      children: children
    })]
  }));
};

Accordion.propTypes = propTypes;

var _default = exports.Z = /*#__PURE__*/(0, _react.memo)(Accordion);

/***/ }),

/***/ 87979:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(37667));

var _classnames2 = _interopRequireDefault(__webpack_require__(39232));

var _propTypes = _interopRequireDefault(__webpack_require__(45697));

var _Button = __webpack_require__(73087);

var _addToBasketUtils = __webpack_require__(10406);

var _addToBasketButtonModule = _interopRequireDefault(__webpack_require__(39435));

var _jsxRuntime = __webpack_require__(85893);

var _excluded = ["sendToBasket", "onBeforeAdd", "onSuccess", "onError", "shortCtaText", "className", "forceLoading", "isRoundel", "title", "variantId", "skuId", "quantity", "clientId", "path", "customText", "hasHeaderBasketCountEvent", "hasScreenReaderAnnouncement"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");

  return "symbol" == _typeof(i) ? i : i + "";
}

function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];

  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return ("string" === r ? String : Number)(t);
}

function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
      t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}

function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };

  var t = _getRequireWildcardCache(r);

  if (t && t.has(e)) return t.get(e);
  var n = {
    __proto__: null
  },
      a = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var u in e) {
    if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }

  return n["default"] = e, t && t.set(e, n), n;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];

  if (null != t) {
    var e,
        n,
        i,
        u,
        a = [],
        f = !0,
        o = !1;

    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) {
        ;
      }
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }

    return a;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var STATE_ACTIVE = 'ACTIVE';
var STATE_ADDING = 'ADDING';
var STATE_SUCCESS = 'SUCCESS';
var STATE_TEXT = {
  ACTIVE: 'Add to your basket',
  ADDING: 'Adding to your basket',
  SUCCESS: 'Added to your basket'
};
var STATE_TEXT_SHORT = {
  ACTIVE: 'Add to basket',
  ADDING: 'Adding to basket',
  SUCCESS: 'Added to basket'
};

var AddToBasketButton = function AddToBasketButton(_ref) {
  var _ref$sendToBasket = _ref.sendToBasket,
      sendToBasket = _ref$sendToBasket === void 0 ? function (_, opts) {
    return (0, _addToBasketUtils.addToBasketRequest)(opts);
  } : _ref$sendToBasket,
      _ref$onBeforeAdd = _ref.onBeforeAdd,
      onBeforeAdd = _ref$onBeforeAdd === void 0 ? function () {
    return Promise.resolve();
  } : _ref$onBeforeAdd,
      _ref$onSuccess = _ref.onSuccess,
      onSuccess = _ref$onSuccess === void 0 ? undefined : _ref$onSuccess,
      _ref$onError = _ref.onError,
      onError = _ref$onError === void 0 ? undefined : _ref$onError,
      _ref$shortCtaText = _ref.shortCtaText,
      shortCtaText = _ref$shortCtaText === void 0 ? false : _ref$shortCtaText,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$forceLoading = _ref.forceLoading,
      forceLoading = _ref$forceLoading === void 0 ? false : _ref$forceLoading,
      _ref$isRoundel = _ref.isRoundel,
      isRoundel = _ref$isRoundel === void 0 ? false : _ref$isRoundel,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title,
      _ref$variantId = _ref.variantId,
      variantId = _ref$variantId === void 0 ? undefined : _ref$variantId,
      _ref$skuId = _ref.skuId,
      skuId = _ref$skuId === void 0 ? undefined : _ref$skuId,
      _ref$quantity = _ref.quantity,
      quantity = _ref$quantity === void 0 ? 1 : _ref$quantity,
      _ref$clientId = _ref.clientId,
      clientId = _ref$clientId === void 0 ? undefined : _ref$clientId,
      _ref$path = _ref.path,
      path = _ref$path === void 0 ? '/basket/items' : _ref$path,
      _ref$customText = _ref.customText,
      customText = _ref$customText === void 0 ? undefined : _ref$customText,
      _ref$hasHeaderBasketC = _ref.hasHeaderBasketCountEvent,
      hasHeaderBasketCountEvent = _ref$hasHeaderBasketC === void 0 ? true : _ref$hasHeaderBasketC,
      _ref$hasScreenReaderA = _ref.hasScreenReaderAnnouncement,
      hasScreenReaderAnnouncement = _ref$hasScreenReaderA === void 0 ? true : _ref$hasScreenReaderA,
      rest = _objectWithoutProperties(_ref, _excluded);

  var TEXT = shortCtaText ? STATE_TEXT_SHORT : STATE_TEXT;

  var _useState = (0, _react.useState)(STATE_ACTIVE),
      _useState2 = _slicedToArray(_useState, 2),
      addToBasketState = _useState2[0],
      setAddToBasketState = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = _slicedToArray(_useState3, 2),
      addToBasketErrors = _useState4[0],
      setAddToBasketErrors = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = _slicedToArray(_useState5, 2),
      screenReaderAnnouncement = _useState6[0],
      setScreenReaderAnnouncement = _useState6[1];

  var handleErrors = function handleErrors() {
    var resJson = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var partialSuccess = arguments.length > 1 ? arguments[1] : undefined;
    return new Promise(function (resolve) {
      if (!resJson.errors || resJson.errors.length === 0) {
        resolve(resJson);
      } else if (onError) {
        onError(resJson, partialSuccess).then(resolve);
      } else {
        Promise.resolve().then(function () {
          return _interopRequireWildcard(__webpack_require__(84618));
        }).then(function (_ref2) {
          var AddToBasketErrors = _ref2.AddToBasketErrors;
          return setAddToBasketErrors( /*#__PURE__*/(0, _jsxRuntime.jsx)(AddToBasketErrors, {
            errors: resJson.errors,
            showAsWarnings: partialSuccess,
            clearAddToBasketErrors: function clearAddToBasketErrors() {
              setAddToBasketErrors(null);
              resolve(resJson);
            }
          }));
        });
      }
    });
  };

  var handleSuccess = function handleSuccess(resJson) {
    if (hasHeaderBasketCountEvent) {
      (0, _addToBasketUtils.updateHeaderBasketCount)();
    }

    if (hasScreenReaderAnnouncement) {
      setScreenReaderAnnouncement("".concat(title, " added to your basket"));
      setTimeout(function () {
        setScreenReaderAnnouncement(null);
      }, 500);
    }

    if (isRoundel) {
      setAddToBasketState(STATE_SUCCESS);
      setTimeout(function () {
        setAddToBasketState(STATE_ACTIVE);
      }, 1500);
    } else {
      setAddToBasketState(STATE_ACTIVE);
    }

    if (onSuccess) {
      onSuccess(resJson);
    }
  };

  var handleClick = function handleClick(event) {
    setAddToBasketState(STATE_ADDING);
    onBeforeAdd(event, {
      variantId: variantId,
      skuId: skuId,
      quantity: quantity,
      clientId: clientId,
      path: path
    }).then(sendToBasket(event, {
      variantId: variantId,
      skuId: skuId,
      quantity: quantity,
      clientId: clientId,
      path: path
    }).then(function () {
      var resJson = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (resJson.errors && resJson.errors.length > 0) {
        Promise.resolve(handleErrors(resJson, true)).then(handleSuccess);
      } else {
        handleSuccess(resJson);
      }
    }, function (resJson) {
      return Promise.resolve(handleErrors(resJson)).then(function () {
        setAddToBasketState(STATE_ACTIVE);
      });
    }));
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Button.PrimaryButton, _objectSpread(_objectSpread({
      onClick: handleClick,
      className: (0, _classnames2["default"])(className, _addToBasketButtonModule["default"]['c-atb-btn'], _addToBasketButtonModule["default"]['joyfully-bold'], _addToBasketButtonModule["default"]['c-atb-btn--joyfully-bold'], _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, _addToBasketButtonModule["default"]['c-atb-btn--roundel'], isRoundel), _addToBasketButtonModule["default"]['c-atb-btn--is-active'], addToBasketState === STATE_ACTIVE), _addToBasketButtonModule["default"]['c-atb-btn--is-adding'], addToBasketState === STATE_ADDING), _addToBasketButtonModule["default"]['c-atb-btn--is-successful'], addToBasketState === STATE_SUCCESS)),
      inverted: isRoundel && [STATE_SUCCESS, STATE_ADDING].includes(addToBasketState),
      submitting: forceLoading || addToBasketState === STATE_ADDING,
      disabled: forceLoading || addToBasketState === STATE_SUCCESS,
      "aria-label": customText || TEXT[addToBasketState]
    }, rest), {}, {
      children: [customText || TEXT['ACTIVE'], /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: _addToBasketButtonModule["default"]['visually-hidden'],
        children: ", ".concat(title)
      })]
    })), addToBasketErrors, screenReaderAnnouncement && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      "aria-live": "assertive",
      role: "status",
      className: _addToBasketButtonModule["default"]['visually-hidden'],
      children: screenReaderAnnouncement
    })]
  });
};

AddToBasketButton.propTypes = {
  /** Class to apply to the button */
  className: _propTypes["default"].string,

  /** Function to be called before sending the ATB request. Should return a promise. */
  onBeforeAdd: _propTypes["default"].func,

  /** Function to be called when add to basket is clicked. Should return a promise containing a list of any errors. */
  sendToBasket: _propTypes["default"].func,

  /** Flag to use short version text for CTA button */
  shortCtaText: _propTypes["default"].bool,

  /** Flag to force show loading state (ATB->QV Lazy loading) */
  forceLoading: _propTypes["default"].bool,

  /** Flag to show roundel button */
  isRoundel: _propTypes["default"].bool,

  /** Product title (used for screen reader text) */
  title: _propTypes["default"].string.isRequired,

  /** Success callback (also handles partial success) */
  onSuccess: _propTypes["default"].func,

  /** Error callback */
  onError: _propTypes["default"].func,

  /** Product variantId */
  variantId: _propTypes["default"].string,

  /** Product skuId */
  skuId: _propTypes["default"].string,

  /** Quantity to add */
  quantity: _propTypes["default"].number,

  /** ClientId for the basket services */
  clientId: _propTypes["default"].string,

  /** Basket endpoint (useful to override for local development) */
  path: _propTypes["default"].string,

  /** Custom text to use in the button */
  customText: _propTypes["default"].string,

  /** Flag to prevent triggering the header basket count event */
  hasHeaderBasketCountEvent: _propTypes["default"].bool,

  /** Flag to prevent screen reader announcements */
  hasScreenReaderAnnouncement: _propTypes["default"].bool
};

var _default = exports["default"] = AddToBasketButton;

/***/ }),

/***/ 84618:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.AddToBasketErrors = void 0;

var _react = _interopRequireDefault(__webpack_require__(37667));

var _propTypes = _interopRequireDefault(__webpack_require__(45697));

var _Message = _interopRequireDefault(__webpack_require__(46701));

var _Modal = _interopRequireDefault(__webpack_require__(86314));

var _jsxRuntime = __webpack_require__(85893);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var AddToBasketErrors = exports.AddToBasketErrors = function AddToBasketErrors(_ref) {
  var errors = _ref.errors,
      clearAddToBasketErrors = _ref.clearAddToBasketErrors,
      showAsWarnings = _ref.showAsWarnings;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal["default"], {
    isOpen: true,
    header: "Something went wrong",
    onClose: clearAddToBasketErrors,
    children: errors.map(function (_ref2) {
      var message = _ref2.message,
          code = _ref2.code;
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Message["default"], {
        title: message,
        type: showAsWarnings ? 'warning' : 'error',
        animation: "shake",
        disableScrollToOnMount: true
      }, code);
    })
  });
};

AddToBasketErrors.propTypes = {
  errors: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    message: _propTypes["default"].string.isRequired,
    code: _propTypes["default"].string.isRequired
  })).isRequired,
  clearAddToBasketErrors: _propTypes["default"].func,
  showAsWarnings: _propTypes["default"].bool
};
AddToBasketErrors.defaultProps = {
  clearAddToBasketErrors: undefined,
  showAsWarnings: false
};

/***/ }),

/***/ 10406:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.updateHeaderBasketCount = exports.authenticate = exports.addToBasketRequest = exports.BASKET_QTY_UPDATED_EVENT = void 0;

var _env = _interopRequireDefault(__webpack_require__(61635));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");

  return "symbol" == _typeof(i) ? i : i + "";
}

function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];

  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return ("string" === r ? String : Number)(t);
}

function _regeneratorRuntime() {
  "use strict";
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */

  _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  };

  var t,
      e = {},
      r = Object.prototype,
      n = r.hasOwnProperty,
      o = Object.defineProperty || function (t, e, r) {
    t[e] = r.value;
  },
      i = "function" == typeof Symbol ? Symbol : {},
      a = i.iterator || "@@iterator",
      c = i.asyncIterator || "@@asyncIterator",
      u = i.toStringTag || "@@toStringTag";

  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }

  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }

  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
        a = Object.create(i.prototype),
        c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }

  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }

  e.wrap = wrap;
  var h = "suspendedStart",
      l = "suspendedYield",
      f = "executing",
      s = "completed",
      y = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
      v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);

  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }

  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);

      if ("throw" !== c.type) {
        var u = c.arg,
            h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }

      a(c.arg);
    }

    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }

        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }

  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw Error("Generator is already running");

      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }

      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;

        if (c) {
          var u = maybeInvokeDelegate(c, n);

          if (u) {
            if (u === y) continue;
            return u;
          }
        }

        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);

        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }

        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }

  function maybeInvokeDelegate(e, r) {
    var n = r.method,
        o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }

  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }

  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }

  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }

  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;

      if (!isNaN(e.length)) {
        var o = -1,
            i = function next() {
          for (; ++o < e.length;) {
            if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
          }

          return next.value = t, next.done = !0, next;
        };

        return i.next = i;
      }
    }

    throw new TypeError(_typeof(e) + " is not iterable");
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
        r = [];

    for (var n in e) {
      r.push(n);
    }

    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }

      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) {
        "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
      }
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;

      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }

      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
            a = i.completion;
        if ("root" === i.tryLoc) return handle("end");

        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
              u = n.call(i, "finallyLoc");

          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];

        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }

      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];

        if (r.tryLoc === t) {
          var n = r.completion;

          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }

          return o;
        }
      }

      throw Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var RequestFailedError = {
  errors: [{
    message: 'There was a problem with your request, please check your network connection and try again. If the problem persists please try again later.',
    code: 'REQUEST_FAILED'
  }]
}; // Returns JWT Token

var authenticate = exports.authenticate = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var _window$auth;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!_env["default"].isClient) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", (_window$auth = window.auth0) === null || _window$auth === void 0 ? void 0 : _window$auth.getTokenIfAuthenticated());

          case 2:
            return _context.abrupt("return", '');

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function authenticate() {
    return _ref.apply(this, arguments);
  };
}();

var addToBasketRequest = exports.addToBasketRequest = function addToBasketRequest(_ref2) {
  var variantId = _ref2.variantId,
      skuId = _ref2.skuId,
      _ref2$quantity = _ref2.quantity,
      quantity = _ref2$quantity === void 0 ? 1 : _ref2$quantity,
      _ref2$clientId = _ref2.clientId,
      clientId = _ref2$clientId === void 0 ? 'mono' : _ref2$clientId,
      _ref2$path = _ref2.path,
      path = _ref2$path === void 0 ? '/basket/items' : _ref2$path;

  if (!variantId) {
    console.error("JL-UI-KIT: addToBasketUtils: No variantId for client ".concat(clientId, " sku ").concat(skuId, " qty ").concat(quantity, " path ").concat(path));
    return Promise.reject(RequestFailedError);
  }

  return authenticate().then(function (authToken) {
    return fetch("".concat(path, "/").concat(variantId), {
      method: 'POST',
      body: JSON.stringify({
        variantId: variantId,
        skuId: skuId,
        quantity: quantity
      }),
      credentials: 'include',
      headers: _objectSpread({
        'x-api-client-id': clientId,
        'Content-Type': 'application/json'
      }, authToken && {
        Authorisation: "Bearer ".concat(authToken)
      })
    }).then(function (res) {
      if (res.ok) {
        return res.json();
      }

      if (res.status !== 404) {
        return res.json().then(function (resJson) {
          return Promise.reject(resJson);
        }, function () {
          return Promise.reject(RequestFailedError);
        });
      }

      return Promise.reject(RequestFailedError);
    }, function () {
      return Promise.reject(RequestFailedError);
    });
  });
};

var BASKET_QTY_UPDATED_EVENT = exports.BASKET_QTY_UPDATED_EVENT = 'jl-events.browser.basketQuantityUpdated';

var updateHeaderBasketCount = exports.updateHeaderBasketCount = function updateHeaderBasketCount() {
  var updateBasketEvent = new CustomEvent(BASKET_QTY_UPDATED_EVENT);
  window.dispatchEvent(updateBasketEvent);
};

/***/ }),

/***/ 70951:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var _react = _interopRequireWildcard(__webpack_require__(37667));

var _classnames3 = _interopRequireDefault(__webpack_require__(39232));

var _debounce = _interopRequireDefault(__webpack_require__(23279));

var _propTypes = _interopRequireDefault(__webpack_require__(45697));

var _Button = __webpack_require__(73087);

var _buttonCarouselModule = _interopRequireDefault(__webpack_require__(64039));

var _buttonsToDisplay = _interopRequireDefault(__webpack_require__(54866));

var _jsxRuntime = __webpack_require__(85893);

var _excluded = ["buttonKey", "buttonUrl", "buttonText", "className"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
      t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}

function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };

  var t = _getRequireWildcardCache(r);

  if (t && t.has(e)) return t.get(e);
  var n = {
    __proto__: null
  },
      a = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var u in e) {
    if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }

  return n["default"] = e, t && t.set(e, n), n;
}

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");

  return "symbol" == _typeof(i) ? i : i + "";
}

function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];

  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return ("string" === r ? String : Number)(t);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];

  if (null != t) {
    var e,
        n,
        i,
        u,
        a = [],
        f = !0,
        o = !1;

    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) {
        ;
      }
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }

    return a;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var propTypes = {
  /** Array of objects containing button properties */
  buttonList: _propTypes["default"].arrayOf(_propTypes["default"].object),
  isCentred: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  ariaLabel: _propTypes["default"].string,
  hasLargeButtons: _propTypes["default"].bool
};
var defaultProps = {
  buttonList: [],
  isCentred: false,
  className: undefined,
  ariaLabel: undefined,
  hasLargeButtons: false
};

var ButtonCarousel = function ButtonCarousel(_ref) {
  var buttonList = _ref.buttonList,
      isCentred = _ref.isCentred,
      className = _ref.className,
      ariaLabel = _ref.ariaLabel,
      hasLargeButtons = _ref.hasLargeButtons;
  var TotalNumberOfButtons = buttonList.length;

  var ref = _react["default"].useRef();

  var _React$useState = _react["default"].useState(true),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isMobile = _React$useState2[0],
      setIsMobile = _React$useState2[1];

  var _React$useState3 = _react["default"].useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      isExpanded = _React$useState4[0],
      setIsExpanded = _React$useState4[1];

  var _React$useState5 = _react["default"].useState(false),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      isReady = _React$useState6[0],
      setIsReady = _React$useState6[1];

  var _React$useState7 = _react["default"].useState(TotalNumberOfButtons),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      numberOfButtonsToShow = _React$useState8[0],
      setNumberOfButtonstoShow = _React$useState8[1];

  var numberHidden = TotalNumberOfButtons - numberOfButtonsToShow;
  var mobileUpper = 768;

  var updateIsMobile = function updateIsMobile() {
    setIsMobile(window.innerWidth < mobileUpper);
  };

  var findNextFocus = function findNextFocus(nextButton) {
    if (ref.current && ref.current.querySelector) {
      ref.current.querySelector("[data-ind=\"".concat(nextButton, "\"]")).focus();
    }
  };

  var updateNumberOfButtonsToShow = function updateNumberOfButtonsToShow() {
    var newButtonsWidths = [];
    var containerWidth = ref.current && ref.current.offsetWidth || 0;
    var anchorTags = ref.current && ref.current.querySelectorAll && ref.current.querySelectorAll('a:not([data-test^="show"]), button:not([data-test^="show"])');

    if (anchorTags) {
      anchorTags.forEach(function (element) {
        if (element) newButtonsWidths.push(element.offsetWidth);
      });
    }

    setNumberOfButtonstoShow((0, _buttonsToDisplay["default"])(newButtonsWidths, containerWidth));
  };

  var handleResize = (0, _debounce["default"])(function () {
    updateIsMobile();
    updateNumberOfButtonsToShow();
  });

  _react["default"].useLayoutEffect(function () {
    updateNumberOfButtonsToShow();
    updateIsMobile();
    setIsReady(true);
    window.addEventListener('resize', handleResize);
    return function () {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  _react["default"].useEffect(function () {
    updateNumberOfButtonsToShow();
  }, [buttonList]);

  _react["default"].useEffect(function () {
    if (isExpanded) {
      findNextFocus(numberOfButtonsToShow);
    } else if (isReady) findNextFocus(0);
  }, [isExpanded]);

  var buttonTag = function buttonTag(button, index) {
    var buttonKey = button.buttonKey,
        buttonUrl = button.buttonUrl,
        buttonText = button.buttonText,
        buttonClass = button.className,
        rest = _objectWithoutProperties(button, _excluded);

    var buttonProps = _objectSpread({
      href: buttonUrl,
      children: buttonText
    }, rest);

    if (!hasLargeButtons) buttonProps.size = 'responsive';
    var isHidden = !isMobile && !isExpanded && index + 1 > numberOfButtonsToShow;
    buttonProps.className = (0, _classnames3["default"])(buttonClass, _buttonCarouselModule["default"].button, _defineProperty(_defineProperty({}, _buttonCarouselModule["default"].hide, isHidden), _buttonCarouselModule["default"]['button--large'], hasLargeButtons));
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.SecondaryButton, _objectSpread({
      "data-ind": index,
      inline: true
    }, buttonProps), buttonKey ? buttonKey : "button".concat(index));
  };

  return buttonList.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    ref: ref,
    "aria-label": ariaLabel || "Group of ".concat(TotalNumberOfButtons, " buttons"),
    className: (0, _classnames3["default"])(className, _buttonCarouselModule["default"].slider, _defineProperty(_defineProperty(_defineProperty({}, _buttonCarouselModule["default"].isCentred, isCentred), _buttonCarouselModule["default"].visibleSlider, isMobile), _buttonCarouselModule["default"].isReady, isReady)),
    children: [buttonList.map(function (button, index) {
      return buttonTag(button, index);
    }), !isMobile && !isExpanded && numberHidden > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.SecondaryButton, {
      className: _buttonCarouselModule["default"].button,
      "data-test": "show-more",
      inline: true,
      "aria-label": "Show ".concat(numberHidden, " more"),
      onClick: function onClick() {
        setIsExpanded(true);
      },
      children: "+ ".concat(numberHidden)
    }), !isMobile && isExpanded && numberHidden > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.SecondaryButton, {
      inline: true,
      "data-test": "show-less",
      className: _buttonCarouselModule["default"].button,
      onClick: function onClick() {
        setIsExpanded(false);
      },
      children: "Show less"
    })]
  });
};

ButtonCarousel.propTypes = propTypes;
ButtonCarousel.defaultProps = defaultProps;

var _default = exports.Z = /*#__PURE__*/(0, _react.memo)(ButtonCarousel);

/***/ }),

/***/ 19822:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.ALPHA_BaseCarousel = void 0;

var react_1 = __importStar(__webpack_require__(37667));

var classnames_1 = __importDefault(__webpack_require__(39232));

var CarouselNavigationButtons_1 = __webpack_require__(55919);

var CarouselList_1 = __webpack_require__(94717);

var BaseCarousel_module_scss_1 = __importDefault(__webpack_require__(51753));
/**
 * Renders a carousel that displays a list of items.
 * @param {string} id - A unique identifier for the carousel.
 * @param {string} ariaLabel - A descriptive label for accessibility.
 * @param {string} [heading] - An optional title for the carousel.
 * @param {ReactElement} children - A ReactElement representing the items in the carousel.
 * @param {number} numberOfItemsToShow - The number of items to display at once in the carousel.
 * @param {boolean} [showVisibleScrollbar] - A boolean indicating whether to display a visible scrollbar.
 * @param {boolean} [showNavigationControls] - A boolean indicating whether to display navigation controls.
 * @returns {ReactElement} A ReactElement representing the carousel component.
 */


var ALPHA_BaseCarousel = function ALPHA_BaseCarousel(_a) {
  var _b;

  var _c;

  var id = _a.id,
      ariaLabel = _a.ariaLabel,
      heading = _a.heading,
      children = _a.children,
      numberOfItemsToShow = _a.numberOfItemsToShow,
      _d = _a.showVisibleScrollbar,
      showVisibleScrollbar = _d === void 0 ? false : _d;
  var items = (_c = react_1["default"].Children) === null || _c === void 0 ? void 0 : _c.toArray(children);
  var numberOfPages = Math.ceil((items === null || items === void 0 ? void 0 : items.length) / numberOfItemsToShow);
  var ulContainerElement = (0, react_1.useRef)(null);

  var _e = (0, react_1.useState)(0),
      currentPage = _e[0],
      setCurrentPage = _e[1];

  var showNavigationControls = (items === null || items === void 0 ? void 0 : items.length) > numberOfItemsToShow;
  (0, react_1.useEffect)(function () {
    var _a;

    var carouselScroller = ulContainerElement === null || ulContainerElement === void 0 ? void 0 : ulContainerElement.current;
    var observer = new IntersectionObserver(function (observations) {
      var _a, _b, _c, _d, _e, _f;

      for (var _i = 0, observations_1 = observations; _i < observations_1.length; _i++) {
        var observation = observations_1[_i];
        (_b = (_a = observation === null || observation === void 0 ? void 0 : observation.target) === null || _a === void 0 ? void 0 : _a.classList) === null || _b === void 0 ? void 0 : _b.toggle('--in-view', observation === null || observation === void 0 ? void 0 : observation.isIntersecting);

        if (observation === null || observation === void 0 ? void 0 : observation.isIntersecting) {
          var currentPageId = +((_c = observation === null || observation === void 0 ? void 0 : observation.target) === null || _c === void 0 ? void 0 : _c.getAttribute('data-pageid'));

          if (currentPageId === numberOfPages - 1) {
            var previousPage = (_d = observation === null || observation === void 0 ? void 0 : observation.target) === null || _d === void 0 ? void 0 : _d.previousElementSibling;
            (_e = previousPage === null || previousPage === void 0 ? void 0 : previousPage.classList) === null || _e === void 0 ? void 0 : _e.remove('--in-view');
          }

          setCurrentPage(+((_f = observation === null || observation === void 0 ? void 0 : observation.target) === null || _f === void 0 ? void 0 : _f.getAttribute('data-pageId')));
        }
      }
    }, {
      root: carouselScroller,
      threshold: 0.8,
      rootMargin: "0% -2% 0% -2%"
    });
    (_a = Array.from(carouselScroller === null || carouselScroller === void 0 ? void 0 : carouselScroller.children)) === null || _a === void 0 ? void 0 : _a.forEach(function (item) {
      observer === null || observer === void 0 ? void 0 : observer.observe(item);
    });
    return function () {
      observer === null || observer === void 0 ? void 0 : observer.unobserve(carouselScroller);
    };
  }, [numberOfPages, currentPage]);

  var goToPage = function goToPage(container, targetElement) {
    var scrollDistance = Math.abs((container === null || container === void 0 ? void 0 : container.offsetLeft) - (targetElement === null || targetElement === void 0 ? void 0 : targetElement.offsetLeft));
    container === null || container === void 0 ? void 0 : container.scrollTo({
      left: scrollDistance,
      behavior: 'smooth'
    });
  };

  var goNext = function goNext() {
    var _a, _b;

    var current = (_a = ulContainerElement === null || ulContainerElement === void 0 ? void 0 : ulContainerElement.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll('.--in-view');
    var next = (_b = current === null || current === void 0 ? void 0 : current[0]) === null || _b === void 0 ? void 0 : _b.nextElementSibling;

    if (next) {
      goToPage(ulContainerElement === null || ulContainerElement === void 0 ? void 0 : ulContainerElement.current, next);
    }
  };

  var goPrevious = function goPrevious() {
    var _a, _b;

    var current = (_a = ulContainerElement === null || ulContainerElement === void 0 ? void 0 : ulContainerElement.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll('.--in-view');
    var next = (_b = current === null || current === void 0 ? void 0 : current[0]) === null || _b === void 0 ? void 0 : _b.previousElementSibling;

    if (next) {
      goToPage(ulContainerElement === null || ulContainerElement === void 0 ? void 0 : ulContainerElement.current, next);
    }
  };

  var goToNextDirection = function goToNextDirection(dir) {
    if (dir === 'right') {
      goNext();
    } else if (dir === 'left') {
      goPrevious();
    }
  };

  return react_1["default"].createElement("section", {
    "aria-label": ariaLabel,
    "aria-roledescription": "Carousel"
  }, react_1["default"].createElement("div", {
    className: (0, classnames_1["default"])(BaseCarousel_module_scss_1["default"].carousel)
  }, react_1["default"].createElement("div", {
    className: (0, classnames_1["default"])(BaseCarousel_module_scss_1["default"]['carousel__header-container'], (_b = {}, _b[BaseCarousel_module_scss_1["default"]['carousel__heading']] = heading, _b))
  }, heading && react_1["default"].createElement("h2", {
    "data-testid": "carousel-heading"
  }, heading), showNavigationControls && react_1["default"].createElement(CarouselNavigationButtons_1.ALPHA_CarouselNavigationButtons, {
    goToNextDirection: goToNextDirection,
    currentPage: currentPage,
    numberOfPages: numberOfPages
  })), react_1["default"].createElement(CarouselList_1.CarouselList, {
    id: id,
    showVisibleScrollbar: showVisibleScrollbar,
    ulContainerElementRef: ulContainerElement,
    items: items
  })));
};

exports.ALPHA_BaseCarousel = ALPHA_BaseCarousel;

/***/ }),

/***/ 64783:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.CarouselItem = void 0;

var react_1 = __importDefault(__webpack_require__(37667));

var classnames_1 = __importDefault(__webpack_require__(39232));

var CarouselItem_module_scss_1 = __importDefault(__webpack_require__(64176));
/**
 * Renders an individual item within a carousel.
 * @param {ReactElement} item - The JSX element representing the item to render.
 * @param {number} index - The index of the item within the carousel.
 * @param {number} itemsCount - The total number of items in the carousel.
 * @param {number} itemNumber - The number representing the position of the item within the carousel (1-indexed).
 * @returns {ReactElement} JSX element representing the carousel item.
 */


var CarouselItem = function CarouselItem(_a) {
  var item = _a.item,
      index = _a.index,
      itemsCount = _a.itemsCount,
      itemNumber = _a.itemNumber;
  return react_1["default"].createElement("div", {
    className: (0, classnames_1["default"])(CarouselItem_module_scss_1["default"].carousel__item),
    "aria-roledescription": "slide",
    "aria-label": "".concat(itemNumber, " of ").concat(itemsCount),
    "data-index": index,
    role: "listitem",
    "data-testid": "item-".concat(itemNumber)
  }, item);
};

exports.CarouselItem = CarouselItem;

/***/ }),

/***/ 94717:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.CarouselList = void 0;

var react_1 = __importDefault(__webpack_require__(37667));

var classnames_1 = __importDefault(__webpack_require__(39232));

var CarouselItem_1 = __webpack_require__(64783);

var CarouselList_module_scss_1 = __importDefault(__webpack_require__(42530));
/**
 * Renders a carousel list component.
 * @param {string} id - The ID of the carousel list.
 * @param {boolean} [showVisibleScrollbar=false] - Whether to show a visible scrollbar.
 * @param {React.RefObject<HTMLDivElement>} ulContainerElementRef - Reference to the container element of the list.
 * @param {HTMLElement[]} items - Array of items to be displayed in the carousel.
 * @returns {JSX.Element} The rendered carousel list component.
 */


var CarouselList = function CarouselList(_a) {
  var _b;

  var id = _a.id,
      _c = _a.showVisibleScrollbar,
      showVisibleScrollbar = _c === void 0 ? false : _c,
      ulContainerElementRef = _a.ulContainerElementRef,
      items = _a.items;
  var pages = items.reduce(function (pagesArray, item, index) {
    var _a;

    var itemObject = {
      item: item,
      itemNumber: index + 1
    };
    var pagesIndex = Math.floor(index / 5);

    if (!(pagesArray === null || pagesArray === void 0 ? void 0 : pagesArray[pagesIndex])) {
      pagesArray[pagesIndex] = [];
    }

    (_a = pagesArray === null || pagesArray === void 0 ? void 0 : pagesArray[pagesIndex]) === null || _a === void 0 ? void 0 : _a.push(itemObject);
    return pagesArray;
  }, []);
  return react_1["default"].createElement("div", {
    className: (0, classnames_1["default"])(CarouselList_module_scss_1["default"]['carousel__items-container'], (_b = {}, _b[CarouselList_module_scss_1["default"].visibleScrollbar] = showVisibleScrollbar, _b)),
    role: "list",
    "data-testid": "carousel-items-container",
    ref: ulContainerElementRef,
    id: id
  }, pages === null || pages === void 0 ? void 0 : pages.map(function (page, index) {
    return react_1["default"].createElement("div", {
      className: (0, classnames_1["default"])(CarouselList_module_scss_1["default"].carousel__page, CarouselList_module_scss_1["default"]["carousel__page--".concat(page === null || page === void 0 ? void 0 : page.length, "-items")]),
      "data-testid": "carousel-page-".concat(index),
      "data-pageid": index,
      key: index
    }, page === null || page === void 0 ? void 0 : page.map(function (itemObject, index) {
      return react_1["default"].createElement(CarouselItem_1.CarouselItem, {
        item: itemObject === null || itemObject === void 0 ? void 0 : itemObject.item,
        index: index,
        key: "contentKey-".concat(index),
        itemsCount: items === null || items === void 0 ? void 0 : items.length,
        itemNumber: itemObject === null || itemObject === void 0 ? void 0 : itemObject.itemNumber
      });
    }));
  }));
};

exports.CarouselList = CarouselList;

/***/ }),

/***/ 55919:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.ALPHA_CarouselNavigationButtons = void 0;

var react_1 = __importDefault(__webpack_require__(37667));

var classnames_1 = __importDefault(__webpack_require__(39232));

var IconButton_1 = __webpack_require__(2909);

var ChevronRight32PxOutlined_1 = __importDefault(__webpack_require__(18610));

var ChevronLeft32PxOutlined_1 = __importDefault(__webpack_require__(4279));

var CarouselNavigationButtons_module_scss_1 = __importDefault(__webpack_require__(74646));
/**
 * Renders the navigation buttons for a carousel.
 * @param {number} numberOfPages - The total number of pages in the carousel.
 * @param {'left' | 'right'} goToNextDirection - Function to navigate to the next page in the specified direction ('left' or 'right').
 * @param {number} currentPage - The index of the current page.
 * @returns {ReactElement} - Rendered navigation buttons component.
 */


var ALPHA_CarouselNavigationButtons = function ALPHA_CarouselNavigationButtons(_a) {
  var goToNextDirection = _a.goToNextDirection,
      numberOfPages = _a.numberOfPages,
      currentPage = _a.currentPage;
  return react_1["default"].createElement("nav", {
    "aria-label": "Carousel Navigation",
    className: (0, classnames_1["default"])(CarouselNavigationButtons_module_scss_1["default"].carousel__navigation),
    "data-testid": "navigation-controls"
  }, react_1["default"].createElement("div", {
    className: (0, classnames_1["default"])(CarouselNavigationButtons_module_scss_1["default"]['carousel__navigation-buttons'])
  }, react_1["default"].createElement(IconButton_1.IconButton, {
    "aria-label": "previous page of items",
    "data-testid": "icon-chevron-left",
    className: (0, classnames_1["default"])(CarouselNavigationButtons_module_scss_1["default"]['carousel__navigation-button--left']),
    IconComponent: ChevronLeft32PxOutlined_1["default"],
    size: "large",
    disabled: currentPage === 0,
    onClick: function onClick() {
      return goToNextDirection('left');
    },
    alt: "previous page"
  }), react_1["default"].createElement(IconButton_1.IconButton, {
    "aria-label": "next page of items",
    "data-testid": "icon-chevron-right",
    className: (0, classnames_1["default"])(CarouselNavigationButtons_module_scss_1["default"]['carousel__navigation-button--right']),
    IconComponent: ChevronRight32PxOutlined_1["default"],
    size: "large",
    disabled: currentPage === numberOfPages - 1,
    onClick: function onClick() {
      return goToNextDirection('right');
    },
    alt: "next page"
  })));
};

exports.ALPHA_CarouselNavigationButtons = ALPHA_CarouselNavigationButtons;

/***/ }),

/***/ 19770:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.ALPHA_ProductCardCarousel = void 0;

var react_1 = __importStar(__webpack_require__(37667));

var BaseCarousel_1 = __webpack_require__(19822);

var classnames_1 = __importDefault(__webpack_require__(39232));

var ProductCardCarousel_module_scss_1 = __importDefault(__webpack_require__(62503));
/**
 * Renders a carousel of product cards
 * @param {string} id - Unique identifier for the carousel
 * @param {string} ariaLabel - Aria label for accessibility
 * @param {string} heading - Heading text for the carousel
 * @param {ReactElement} children - Child elements to be displayed in the carousel
 * @returns {ReactElement} ProductCardCarousel component
 */


var ALPHA_ProductCardCarousel = function ALPHA_ProductCardCarousel(_a) {
  var _b;

  var id = _a.id,
      ariaLabel = _a.ariaLabel,
      heading = _a.heading,
      children = _a.children;

  var _c = (0, react_1.useState)(false),
      isReady = _c[0],
      setIsReady = _c[1];

  (0, react_1.useEffect)(function () {
    if (isReady === false) {
      setIsReady(true);
    }
  }, [isReady]);
  return react_1["default"].createElement("div", {
    "data-testid": "product-card-carousel",
    className: (0, classnames_1["default"])(ProductCardCarousel_module_scss_1["default"]['product-card-carousel'], (_b = {}, _b[ProductCardCarousel_module_scss_1["default"]['product-card-carousel--ready']] = isReady, _b))
  }, react_1["default"].createElement(BaseCarousel_1.ALPHA_BaseCarousel, {
    id: id,
    heading: heading,
    numberOfItemsToShow: 5,
    ariaLabel: ariaLabel
  }, children));
};

exports.ALPHA_ProductCardCarousel = ALPHA_ProductCardCarousel;

/***/ }),

/***/ 4990:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(37667));

var _Option = _interopRequireDefault(__webpack_require__(49826));

var _jsxRuntime = __webpack_require__(85893);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
      t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}

function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };

  var t = _getRequireWildcardCache(r);

  if (t && t.has(e)) return t.get(e);
  var n = {
    __proto__: null
  },
      a = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var u in e) {
    if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }

  return n["default"] = e, t && t.set(e, n), n;
}

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");

  return "symbol" == _typeof(i) ? i : i + "";
}

function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];

  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return ("string" === r ? String : Number)(t);
}

var propTypes = _objectSpread({}, _Option["default"].propTypes);

var defaultProps = _objectSpread({}, _Option["default"].defaultProps);

var Checkbox = function Checkbox(props) {
  var allProps = _objectSpread({}, props);

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Option["default"], _objectSpread({
    type: "checkbox"
  }, allProps));
};

Checkbox.propTypes = propTypes;
Checkbox.defaultProps = defaultProps;

var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(Checkbox);

/***/ }),

/***/ 12562:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(37667));

var _propTypes = _interopRequireDefault(__webpack_require__(45697));

var _classnames = _interopRequireDefault(__webpack_require__(39232));

var _energyRatingModule = _interopRequireDefault(__webpack_require__(95719));

var _jsxRuntime = __webpack_require__(85893);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
      t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}

function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };

  var t = _getRequireWildcardCache(r);

  if (t && t.has(e)) return t.get(e);
  var n = {
    __proto__: null
  },
      a = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var u in e) {
    if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }

  return n["default"] = e, t && t.set(e, n), n;
}

var energyRatingImageFilenames = [{
  assetFilename: 'A.svg',
  hashedAssetFilename: 'A.d0fb5589.svg'
}, {
  assetFilename: 'B.svg',
  hashedAssetFilename: 'B.62c41d3c.svg'
}, {
  assetFilename: 'C.svg',
  hashedAssetFilename: 'C.83a078dd.svg'
}, {
  assetFilename: 'D.svg',
  hashedAssetFilename: 'D.4070790c.svg'
}, {
  assetFilename: 'E.svg',
  hashedAssetFilename: 'E.1654dc64.svg'
}, {
  assetFilename: 'F.svg',
  hashedAssetFilename: 'F.327ae98d.svg'
}, {
  assetFilename: 'G.svg',
  hashedAssetFilename: 'G.a24a9165.svg'
}];
var energyRatingLegacyImageFilenames = [{
  assetFilename: 'A+++.svg',
  hashedAssetFilename: 'A+++.0912f020.svg'
}, {
  assetFilename: 'A++.svg',
  hashedAssetFilename: 'A++.56180987.svg'
}, {
  assetFilename: 'A+.svg',
  hashedAssetFilename: 'A+.e2227015.svg'
}, {
  assetFilename: 'A.svg',
  hashedAssetFilename: 'A.9840c66e.svg'
}, {
  assetFilename: 'B.svg',
  hashedAssetFilename: 'B.3f468c94.svg'
}, {
  assetFilename: 'C.svg',
  hashedAssetFilename: 'C.7afd2f39.svg'
}, {
  assetFilename: 'D.svg',
  hashedAssetFilename: 'D.d9f887af.svg'
}];

function getHashedFilename(_ref) {
  var rating = _ref.rating,
      ratingLegacy = _ref.ratingLegacy;
  var asset = rating ? energyRatingImageFilenames.find(function (_ref2) {
    var assetFilename = _ref2.assetFilename;
    return "".concat(rating, ".svg") === assetFilename;
  }) : energyRatingLegacyImageFilenames.find(function (_ref3) {
    var assetFilename = _ref3.assetFilename;
    return "".concat(ratingLegacy, ".svg") === assetFilename;
  });
  return (asset === null || asset === void 0 ? void 0 : asset.hashedAssetFilename) || name;
}

var ENERGY_RATING_ASSETS_URL = 'https://www.johnlewis.com/static/ui-assets/hashed/images/energy-ratings/';

var EnergyRating = function EnergyRating(_ref4) {
  var _ref4$rating = _ref4.rating,
      rating = _ref4$rating === void 0 ? undefined : _ref4$rating,
      _ref4$ratingLegacy = _ref4.ratingLegacy,
      ratingLegacy = _ref4$ratingLegacy === void 0 ? undefined : _ref4$ratingLegacy,
      _ref4$className = _ref4.className,
      className = _ref4$className === void 0 ? '' : _ref4$className,
      _ref4$hasEnergySideDr = _ref4.hasEnergySideDrawer,
      hasEnergySideDrawer = _ref4$hasEnergySideDr === void 0 ? false : _ref4$hasEnergySideDr,
      _ref4$handleEnergyRat = _ref4.handleEnergyRatingClick,
      handleEnergyRatingClick = _ref4$handleEnergyRat === void 0 ? function () {} : _ref4$handleEnergyRat;
  var availableRating = ['A', 'B', 'C', 'D', 'E', 'F', 'G'];
  var availableRatingLegacy = ['A+++', 'A++', 'A+', 'A', 'B', 'C', 'D'];

  if ((!rating || !availableRating.includes(rating)) && (!ratingLegacy || !availableRatingLegacy.includes(ratingLegacy))) {
    return null;
  }

  var imageUrlSuffix = rating ? '' : 'legacy/';
  var imagePath = "".concat(ENERGY_RATING_ASSETS_URL).concat(imageUrlSuffix).concat(getHashedFilename({
    rating: rating,
    ratingLegacy: ratingLegacy
  }));
  var altTextShort = rating ? "Energy efficiency rating ".concat(rating, " on a scale of A to G") : "Energy efficiency rating ".concat(ratingLegacy, " on a scale of A+++ to D");
  var altTextLong = rating ? "This item is rated ".concat(rating, " for energy efficiency on a scale of A most efficient to G least efficient") : "This item is rated ".concat(ratingLegacy, " for energy efficiency on a scale of A+++ most efficient to D least efficient");
  var energyRating = rating ? rating : ratingLegacy;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: (0, _classnames["default"])(_energyRatingModule["default"]['energy-rating'], className),
    children: hasEnergySideDrawer ? /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
      onClick: function onClick() {
        return handleEnergyRatingClick(altTextLong, energyRating);
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
        "data-testid": "energy-rating",
        title: altTextShort,
        alt: altTextShort,
        src: imagePath
      })
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
      "data-testid": "energy-rating",
      title: altTextShort,
      alt: altTextShort,
      src: imagePath
    })
  });
};

EnergyRating.propTypes = {
  rating: _propTypes["default"].string,
  ratingLegacy: _propTypes["default"].string,
  className: _propTypes["default"].string
};

var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(EnergyRating);

/***/ }),

/***/ 72601:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(37667));

var _propTypes = _interopRequireDefault(__webpack_require__(45697));

var _classnames = _interopRequireDefault(__webpack_require__(39232));

var _loadingSpinnerModule = _interopRequireDefault(__webpack_require__(42397));

var _jsxRuntime = __webpack_require__(85893);

var _excluded = ["centered", "className", "style"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
      t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}

function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };

  var t = _getRequireWildcardCache(r);

  if (t && t.has(e)) return t.get(e);
  var n = {
    __proto__: null
  },
      a = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var u in e) {
    if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }

  return n["default"] = e, t && t.set(e, n), n;
}

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}

  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");

  return "symbol" == _typeof(i) ? i : i + "";
}

function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];

  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return ("string" === r ? String : Number)(t);
} // TODO convert to a functional component in future. Doesn't need to be a class.
// TODO Discussion to understand from the community of how this is being used, specifically around scaling.


var LoadingSpinner = /*#__PURE__*/function (_PureComponent) {
  function LoadingSpinner() {
    _classCallCheck(this, LoadingSpinner);

    return _callSuper(this, LoadingSpinner, arguments);
  }

  _inherits(LoadingSpinner, _PureComponent);

  return _createClass(LoadingSpinner, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          centered = _this$props.centered,
          className = _this$props.className,
          style = _this$props.style,
          rest = _objectWithoutProperties(_this$props, _excluded);

      return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: (0, _classnames["default"])(_loadingSpinnerModule["default"]['c-loading-spinner'], _defineProperty({}, _loadingSpinnerModule["default"]['c-loading-spinner--centered'], centered)),
        "data-test": "spinner-wrapper",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread(_objectSpread({
          className: (0, _classnames["default"])(_loadingSpinnerModule["default"]['c-loading-spinner__spinner'], className),
          style: _objectSpread({}, style)
        }, rest), {}, {
          "data-test": "spinner"
        }))
      });
    }
  }]);
}(_react.PureComponent);

_defineProperty(LoadingSpinner, "propTypes", {
  /** Center the spinner vertically and horizontally within parent */
  centered: _propTypes["default"].bool
});

_defineProperty(LoadingSpinner, "defaultProps", {
  centered: false
});

var _default = exports["default"] = LoadingSpinner;

/***/ }),

/***/ 46701:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(37667));

var _propTypes = _interopRequireDefault(__webpack_require__(45697));

var _classnames = _interopRequireDefault(__webpack_require__(39232));

var _Button = __webpack_require__(73087);

var _staticContentPropCheck = _interopRequireDefault(__webpack_require__(85730));

var _scrollTo = __webpack_require__(41433);

var _errorCodeConstants = _interopRequireDefault(__webpack_require__(15116));

var _messageModule = _interopRequireDefault(__webpack_require__(27527));

var _TickInCircle32PxOutlined = _interopRequireDefault(__webpack_require__(29554));

var _Warning32PxOutlined = _interopRequireDefault(__webpack_require__(41882));

var _Info32PxOutlined = _interopRequireDefault(__webpack_require__(56703));

var _jsxRuntime = __webpack_require__(85893);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
      t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}

function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };

  var t = _getRequireWildcardCache(r);

  if (t && t.has(e)) return t.get(e);
  var n = {
    __proto__: null
  },
      a = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var u in e) {
    if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }

  return n["default"] = e, t && t.set(e, n), n;
}

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}

  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");

  return "symbol" == _typeof(i) ? i : i + "";
}

function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];

  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return ("string" === r ? String : Number)(t);
}

var bodyText = function bodyText(body, isOldMessage, styles) {
  var isNode = /*#__PURE__*/_react["default"].isValidElement(body);

  if (isNode) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      "data-test": isOldMessage ? undefined : 'message-body',
      className: styles['c-message__body'],
      children: body
    });
  }

  if (body) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      "data-test": isOldMessage ? undefined : 'message-body',
      className: styles['c-message__body'],
      children: body
    });
  }

  return null;
};

var displayIcon = function displayIcon(type) {
  switch (type) {
    case 'error':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Warning32PxOutlined["default"], {});

    case 'success':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_TickInCircle32PxOutlined["default"], {});

    case 'warning':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Info32PxOutlined["default"], {});

    case 'info':
    case 'infoInline':
    default:
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Info32PxOutlined["default"], {});
  }
};

var typeStyle = function typeStyle(type) {
  switch (type) {
    case 'error':
    case 'info':
    case 'warning':
    case 'infoInline':
      return "c-message__inner--".concat(type);

    default:
      return 'c-message__inner--info';
  }
};

var Button = function Button(_ref) {
  var buttonLevel = _ref.buttonLevel,
      onClick = _ref.onClick,
      dataTest = _ref.dataTest,
      children = _ref.children;
  var classes = (0, _classnames["default"])(_messageModule["default"]['c-message__button'], _messageModule["default"]["c-message__button--".concat(buttonLevel)]);
  var buttons = {
    primary: _Button.PrimaryButton,
    secondary: _Button.SecondaryButton,
    underlined: _Button.UnderlinedButton,
    tertiary: _Button.TertiaryButton
  };
  var ButtonWithLevel = buttons[buttonLevel] || buttons['underlined'];
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(ButtonWithLevel, {
    onClick: onClick,
    "data-test": dataTest,
    className: classes,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      children: children
    })
  });
};

var Message = /*#__PURE__*/function (_Component) {
  function Message(props) {
    var _this;

    _classCallCheck(this, Message);

    _this = _callSuper(this, Message, [props]);
    _this.state = {
      refreshesArray: [0]
    };
    return _this;
  }

  _inherits(Message, _Component);

  return _createClass(Message, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          type = _this$props.type,
          disableScrollToOnMount = _this$props.disableScrollToOnMount,
          focusOnAlert = _this$props.focusOnAlert,
          code = _this$props.code;

      if (!disableScrollToOnMount && type !== 'info') {
        (0, _scrollTo.scrollToElement)("[data-error=\"".concat(code, "\"]"), focusOnAlert);
      }
    } // https://gitlab.com/JohnLewisPartnership/jl-ui/jl-ui-kit/-/issues/230

  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (this.props.refreshes !== nextProps.refreshes) {
        var arr = this.state.refreshesArray;
        this.setState({
          refreshesArray: arr.concat(nextProps.refreshes)
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props2 = this.props,
          type = _this$props2.type,
          focusOnAlert = _this$props2.focusOnAlert,
          code = _this$props2.code,
          disableScrollToOnUpdate = _this$props2.disableScrollToOnUpdate,
          refreshes = _this$props2.refreshes;
      var hasRefreshesChanged = prevProps.refreshes < refreshes;

      if (!disableScrollToOnUpdate && type !== 'info' && hasRefreshesChanged) {
        (0, _scrollTo.scrollToElement)("[data-error=\"".concat(code, "\"]"), focusOnAlert);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          type = _this$props3.type,
          title = _this$props3.title,
          body = _this$props3.body,
          buttonText = _this$props3.buttonText,
          buttonLevel = _this$props3.buttonLevel,
          onButtonClick = _this$props3.onButtonClick,
          code = _this$props3.code,
          animation = _this$props3.animation,
          dataTest = _this$props3['data-test'],
          className = _this$props3.className,
          id = _this$props3.id,
          formInline = _this$props3.formInline;
      var refreshesArray = this.state.refreshesArray;
      var validationError = code === _errorCodeConstants["default"].CLIENT_FORM_VALIDATION_ERRORS;
      var containerClassName = (0, _classnames["default"])(_messageModule["default"]['c-message'], _defineProperty(_defineProperty(_defineProperty({}, _messageModule["default"]['c-message--inline'], type.toLowerCase().indexOf('inline') !== -1), className, !!className), _messageModule["default"]['c-message--form-inline'], formInline));
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        id: id,
        className: containerClassName,
        children: refreshesArray.map(function (val, index, arr) {
          var isOldMessage = arr.length > 1 && index !== arr.length - 1;
          var props = isOldMessage ? {
            'aria-hidden': true,
            style: {
              display: 'none'
            },
            className: (0, _classnames["default"])(_messageModule["default"]['c-message__inner'], _messageModule["default"][typeStyle(type)])
          } : {
            role: 'alert',
            'data-test': dataTest,
            'data-error': code,
            tabIndex: '-1',
            className: (0, _classnames["default"])(_messageModule["default"]['c-message__inner'], _messageModule["default"][typeStyle(type)], _defineProperty({}, _messageModule["default"]['c-message__horizontalShake'], animation === 'shake'))
          };
          return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread(_objectSpread({}, props), {}, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              className: _messageModule["default"]['c-message__copy-container'],
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                className: (0, _classnames["default"])(_messageModule["default"]['c-message__icon'], _messageModule["default"]['joyfully-bold']),
                children: displayIcon(type)
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
                className: (0, _classnames["default"])(_messageModule["default"]['c-message__title'], _messageModule["default"]['joyfully-bold'], {
                  sessioncamlogerror: type === 'error' && !validationError
                }),
                "data-test": isOldMessage ? undefined : "".concat(dataTest, "-title"),
                children: title
              }), bodyText(body, isOldMessage, _messageModule["default"]), buttonText && /*#__PURE__*/(0, _jsxRuntime.jsx)(Button, {
                buttonLevel: buttonLevel,
                onClick: onButtonClick,
                dataTest: isOldMessage ? undefined : 'message-button',
                children: buttonText
              })]
            })
          }), "message-".concat(val));
        })
      });
    }
  }]);
}(_react.Component);

_defineProperty(Message, "propTypes", {
  /** One of: info, success, error */
  type: _propTypes["default"].string,

  /** Optional error code to show in data-error attribute */
  code: _propTypes["default"].string,

  /** Top-line title for the message */
  title: _staticContentPropCheck["default"].isRequired,

  /** String (or markup) for the body of the message */
  body: _staticContentPropCheck["default"],

  /** Custom class name to be added */
  className: _propTypes["default"].string,

  /** Display a button after the message body with this label */
  buttonText: _staticContentPropCheck["default"],

  /** Display a button after the message body with this style */
  buttonLevel: _propTypes["default"].string,

  /** Display a button after the message body with this action */
  onButtonClick: _propTypes["default"].func,

  /**  */
  refreshes: _propTypes["default"].number,

  /** Option to animate message; only 'shake' supported */
  animation: _propTypes["default"].string,

  /** Capture the browser's focus */
  focusOnAlert: _propTypes["default"].bool,

  /** Do not scroll to message when it is mounted */
  disableScrollToOnMount: _propTypes["default"].bool,

  /** Do not scroll to message when it is updated */
  disableScrollToOnUpdate: _propTypes["default"].bool,

  /** Set an option data-test attribute */
  'data-test': _propTypes["default"].string,

  /** Optional ID attribute for the message container */
  id: _propTypes["default"].string
});

_defineProperty(Message, "defaultProps", {
  type: 'info',
  body: '',
  code: '',
  buttonText: '',
  buttonLevel: 'underlined',
  className: '',
  onButtonClick: function onButtonClick() {},
  refreshes: 0,
  animation: '',
  focusOnAlert: false,
  disableScrollToOnMount: false,
  disableScrollToOnUpdate: false,
  'data-test': 'message',
  id: undefined
});

var _default = exports["default"] = Message;

/***/ }),

/***/ 65576:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Message = void 0;

var react_1 = __importStar(__webpack_require__(37667));

var classnames_1 = __importDefault(__webpack_require__(39232));

var message_module_scss_1 = __importDefault(__webpack_require__(66137));

var getAriaLabel_1 = __webpack_require__(27779);

var Error32PxFilledRed_1 = __importDefault(__webpack_require__(95819));

var Error32PxFilled_1 = __importDefault(__webpack_require__(94734));

var Info32PxFilledBlue_1 = __importDefault(__webpack_require__(23011));

var Info32PxFilled_1 = __importDefault(__webpack_require__(89165));

var TickInCircle32PxFilledGreen_1 = __importDefault(__webpack_require__(94247));

var TickInCircle32PxFilled_1 = __importDefault(__webpack_require__(76570));

var Warning32PxFilledYellow_1 = __importDefault(__webpack_require__(80089));

var Warning32PxFilled_1 = __importDefault(__webpack_require__(52572));

var Button_1 = __webpack_require__(73087);

var Message = function Message(_a) {
  var _b, _c, _d, _e, _f, _g;

  var _h = _a.type,
      type = _h === void 0 ? 'information' : _h,
      title = _a.title,
      body = _a.body,
      className = _a.className,
      buttonText = _a.buttonText,
      buttonProps = _a.buttonProps,
      dataId = _a.dataId,
      dataTest = _a.dataTest,
      role = _a.role,
      whiteBackground = _a.whiteBackground,
      wideTab = _a.wideTab,
      IconComponent = _a.IconComponent;
  var hasTitle = title ? true : false;
  var hasBody = body ? true : false;
  var hasButton = buttonText ? true : false;

  var getIcon = function getIcon(type, IconComponent, isWhiteIcon) {
    switch (type) {
      case 'error':
        return isWhiteIcon ? react_1["default"].createElement(Error32PxFilled_1["default"], {
          title: "Error Icon",
          iconState: "icon-invert"
        }) : react_1["default"].createElement(Error32PxFilledRed_1["default"], {
          title: "Error Icon"
        });

      case 'information':
        return IconComponent ? react_1["default"].createElement(IconComponent, {
          title: "Information Icon",
          iconState: isWhiteIcon ? 'icon-invert' : 'icon-information'
        }) : isWhiteIcon ? react_1["default"].createElement(Info32PxFilled_1["default"], {
          title: "Information Icon",
          iconState: "icon-invert"
        }) : react_1["default"].createElement(Info32PxFilledBlue_1["default"], {
          title: "Information Icon"
        });

      case 'success':
        return isWhiteIcon ? react_1["default"].createElement(TickInCircle32PxFilled_1["default"], {
          title: "Success Icon",
          iconState: "icon-invert"
        }) : react_1["default"].createElement(TickInCircle32PxFilledGreen_1["default"], {
          title: "Success Icon"
        });

      case 'warning':
        return isWhiteIcon ? react_1["default"].createElement(Warning32PxFilled_1["default"], {
          title: "Warning Icon",
          iconState: "icon-invert"
        }) : react_1["default"].createElement(Warning32PxFilledYellow_1["default"], {
          title: "Warning Icon"
        });

      default:
        {
          return isWhiteIcon ? react_1["default"].createElement(Info32PxFilled_1["default"], {
            title: "Information Icon",
            iconState: "icon-invert"
          }) : react_1["default"].createElement(Info32PxFilledBlue_1["default"], {
            title: "Information Icon"
          });
        }
    }
  };

  if (!hasTitle && !hasBody) {
    console.error('A Message must have at least one of title or body assigned to it.');
    return null;
  }

  return react_1["default"].createElement("div", {
    className: (0, classnames_1["default"])(className, message_module_scss_1["default"].message, message_module_scss_1["default"]["message--".concat(type)], (_b = {}, _b[message_module_scss_1["default"]['message--white-background']] = whiteBackground, _b), (_c = {}, _c[message_module_scss_1["default"]['message--wide-tab']] = wideTab, _c), (_d = {}, _d[message_module_scss_1["default"]['message--wide-tab-border']] = wideTab && !hasTitle, _d)),
    "aria-label": (0, getAriaLabel_1.getAriaLabel)("".concat(type)),
    tabIndex: -1,
    "data-id": dataId,
    "data-test": dataTest,
    role: role
  }, hasTitle && react_1["default"].createElement("div", {
    className: (0, classnames_1["default"])(message_module_scss_1["default"].message__icon),
    "aria-hidden": "true"
  }, getIcon(type, IconComponent, wideTab)), react_1["default"].createElement("div", {
    className: (0, classnames_1["default"])(message_module_scss_1["default"].message__content, (_e = {}, _e[message_module_scss_1["default"]['message__content--spacing']] = hasTitle, _e), (_f = {}, _f[message_module_scss_1["default"]['message__content--centre']] = !hasBody, _f))
  }, hasTitle && react_1["default"].createElement("h2", {
    className: (0, classnames_1["default"])(message_module_scss_1["default"].message__title)
  }, title), hasBody && react_1["default"].createElement("div", {
    className: (0, classnames_1["default"])(message_module_scss_1["default"].message__body, (_g = {}, _g[message_module_scss_1["default"]['message__body--spacing']] = hasTitle, _g))
  }, (0, react_1.isValidElement)(body) ? react_1["default"].createElement("div", {
    className: (0, classnames_1["default"])(message_module_scss_1["default"]['message__body-object'])
  }, body) : react_1["default"].createElement("p", {
    className: (0, classnames_1["default"])(message_module_scss_1["default"]['message__body-text'])
  }, body)), hasButton && react_1["default"].createElement(Button_1.UnderlinedButton, __assign({
    className: (0, classnames_1["default"])(message_module_scss_1["default"]['message__body-link'])
  }, buttonProps), buttonText)));
};

exports.Message = Message;

/***/ }),

/***/ 27779:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.getAriaLabel = void 0;
/**
 * Created a title case ARIA label for a message based on its type.
 *
 * @param {string} type - The type of the message.
 * @returns {string} The ARIA label for the message in title case.
 */

var getAriaLabel = function getAriaLabel(type) {
  var _a;

  if (!type) {
    return 'Message';
  }

  var firstCharacter = (_a = type === null || type === void 0 ? void 0 : type.charAt(0)) === null || _a === void 0 ? void 0 : _a.toUpperCase();
  var remainingCharacters = type === null || type === void 0 ? void 0 : type.slice(1);
  return "".concat(firstCharacter).concat(remainingCharacters, " Message");
};

exports.getAriaLabel = getAriaLabel;

/***/ }),

/***/ 86314:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = exports.ModalButtons = void 0;

var _react = _interopRequireWildcard(__webpack_require__(37667));

var _propTypes = _interopRequireDefault(__webpack_require__(45697));

var _reactModal = _interopRequireDefault(__webpack_require__(83253));

var _classnames = _interopRequireDefault(__webpack_require__(39232));

var _env = _interopRequireDefault(__webpack_require__(61635));

var _Close24PxOutlined = _interopRequireDefault(__webpack_require__(88823));

var _noScroll = __webpack_require__(13076);

var _ChevronLeft24PxOutlined = _interopRequireDefault(__webpack_require__(11209));

var _Button = __webpack_require__(73087);

var _staticContentPropCheck = _interopRequireDefault(__webpack_require__(85730));

var _modalModule = _interopRequireDefault(__webpack_require__(95582));

var _jsxRuntime = __webpack_require__(85893);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
      t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}

function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };

  var t = _getRequireWildcardCache(r);

  if (t && t.has(e)) return t.get(e);
  var n = {
    __proto__: null
  },
      a = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var u in e) {
    if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }

  return n["default"] = e, t && t.set(e, n), n;
}

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}

  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");

  return "symbol" == _typeof(i) ? i : i + "";
}

function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];

  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return ("string" === r ? String : Number)(t);
} // jl-ui-kit


var logWarning = function logWarning(message) {
  if (_env["default"].isClientNonProd) {
    // eslint-disable-next-line no-console
    console.warn("%cJL-UI-KIT: Warning\n  Modal: ".concat(message), 'color: red;');
  }
};

var Modal = /*#__PURE__*/function (_Component) {
  function Modal(props) {
    var _this;

    _classCallCheck(this, Modal);

    _this = _callSuper(this, Modal, [props]);

    _defineProperty(_this, "onCloseClick", function () {
      _this.closeModal();
    });

    _defineProperty(_this, "onReactModalRequestClose", function () {
      _this.closeModal();
    });

    _defineProperty(_this, "onReactModalAfterOpen", function () {
      (0, _noScroll.setNoScroll)(true);
    });

    _defineProperty(_this, "onBackClick", function () {
      var _this$props = _this.props,
          disableControls = _this$props.disableControls,
          onBack = _this$props.onBack;

      if (!disableControls) {
        _this.keepFocusWithinModal();

        onBack();
      }
    });

    _defineProperty(_this, "keepFocusWithinModal", function () {
      var content = _this.contentRef;

      if (content && content.focus) {
        content.focus();
      }
    });

    if (_env["default"].isClient) {
      var rootId = 'page-root';

      if (document.getElementById(rootId) && document.getElementById(rootId) !== document.body) {
        _reactModal["default"].setAppElement("#".concat(rootId));
      }

      document.documentElement.setAttribute('data-modal', 'false');
    }

    _this.state = {
      isOpen: _this.props.isOpen
    };
    return _this;
  } // https://gitlab.com/JohnLewisPartnership/jl-ui/jl-ui-kit/-/issues/231


  _inherits(Modal, _Component);

  return _createClass(Modal, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      this.setState({
        isOpen: nextProps.isOpen
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var isOpen = this.props.isOpen;

      if (prevProps.isOpen && !isOpen) {
        (0, _noScroll.setNoScroll)(false);
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var rootId = 'page-root';

      if (document.getElementById(rootId) && document.getElementById(rootId) !== document.body) {
        _reactModal["default"].setAppElement("#".concat(rootId));
      } else {
        throw new Error('JLDS_ERROR_01: Missing page-root ID: The main container for the page level application is missing the required id="page-root" attribute: For more info please visit => https://prod-jl-design-system-storybook.design-system.prod.jl-digital.net/?path=/docs/errors-jlds-error-01--docs');
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      (0, _noScroll.setNoScroll)(false);
    }
  }, {
    key: "closeModal",
    value: function closeModal() {
      var _this$props2 = this.props,
          disableControls = _this$props2.disableControls,
          onClose = _this$props2.onClose;
      var isOpen = this.state.isOpen;

      if (isOpen && !disableControls) {
        this.setState({
          isOpen: false
        });
        (0, _noScroll.setNoScroll)(false);
        onClose();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          className = _this$props3.className,
          children = _this$props3.children,
          header = _this$props3.header,
          headerButtonAction = _this$props3.headerButtonAction,
          headerButtonText = _this$props3.headerButtonText,
          headerChildren = _this$props3.headerChildren,
          headerCount = _this$props3.headerCount,
          fullscreen = _this$props3.fullscreen,
          a11yHeader = _this$props3.a11yHeader,
          forceFullHeight = _this$props3.forceFullHeight,
          closeButtonText = _this$props3.closeButtonText,
          backButtonText = _this$props3.backButtonText,
          hideCloseButton = _this$props3.hideCloseButton,
          shouldCloseOnOverlayClick = _this$props3.shouldCloseOnOverlayClick,
          shouldCloseOnEsc = _this$props3.shouldCloseOnEsc,
          showBackButton = _this$props3.showBackButton,
          large = _this$props3.large,
          headerStyleModifier = _this$props3.headerStyleModifier,
          scrollId = _this$props3.scrollId,
          disableControls = _this$props3.disableControls,
          hasPadding = _this$props3.hasPadding,
          headerTitleClassName = _this$props3.headerTitleClassName,
          headerButtonClassName = _this$props3.headerButtonClassName,
          headerChildrenClassName = _this$props3.headerChildrenClassName,
          closeButtonClassName = _this$props3.closeButtonClassName,
          modalChildrenClassName = _this$props3.modalChildrenClassName;
      var isOpen = this.state.isOpen;
      /*
        From: http://reactcommunity.org/react-modal/accessibility/#aria
        You should use the contentLabel prop to provide a label for the modal
        content (via aria-label) if there is no visible label on the screen.
        If the modal is already labeled with visible text, you should specify
        the element including the label with the aria-labelledby attribute
        using the aria prop
      */

      var contentLabel;
      var aria;

      if (a11yHeader && a11yHeader !== header) {
        contentLabel = a11yHeader;
      } else if (header) {
        aria = {
          labelledby: 'modal-header'
        };
      } else {
        logWarning('you need to supply a "header" or "a11yHeader" prop');
      } // TODO: A11y: icons have no titles, review and revisit.


      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactModal["default"], {
        isOpen: isOpen,
        contentLabel: contentLabel,
        aria: aria,
        onRequestClose: this.onReactModalRequestClose,
        onAfterOpen: this.onReactModalAfterOpen,
        className: {
          base: (0, _classnames["default"])(className, _modalModule["default"].modal, _defineProperty(_defineProperty(_defineProperty({}, _modalModule["default"].large, large && !fullscreen), _modalModule["default"].fullscreen, fullscreen), _modalModule["default"].forceFullHeight, forceFullHeight)),
          afterOpen: _modalModule["default"].modalAfterOpen,
          beforeClose: _modalModule["default"].modalBeforeClose
        },
        overlayClassName: {
          base: _modalModule["default"].overlay,
          afterOpen: _modalModule["default"].overlayAfterOpen,
          beforeClose: _modalModule["default"].overlayBeforeClose
        },
        shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
        shouldCloseOnEsc: shouldCloseOnEsc,
        ariaHideApp: true,
        role: "dialog",
        contentRef: function contentRef(node) {
          _this2.contentRef = node;
        },
        children: [(header || showBackButton) && /*#__PURE__*/(0, _jsxRuntime.jsxs)("header", {
          className: (0, _classnames["default"])(_modalModule["default"].header, headerStyleModifier, _defineProperty({}, _modalModule["default"].fullWidthHeaderText, hideCloseButton && !showBackButton)),
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("h2", {
            className: (0, _classnames["default"])(_modalModule["default"].headerTitle, headerTitleClassName),
            id: "modal-header",
            children: [header, typeof headerCount !== 'undefined' && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              className: (0, _classnames["default"])(_modalModule["default"].headerCount),
              children: headerCount
            }), headerButtonText && headerButtonAction && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.TertiaryButton, {
              className: (0, _classnames["default"])(_modalModule["default"].headerButton, headerButtonClassName),
              small: true,
              onClick: headerButtonAction,
              "data-test": "modal-button-header",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                className: (0, _classnames["default"])(_modalModule["default"].headerButtonText),
                children: headerButtonText
              })
            })]
          }), headerChildren && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: (0, _classnames["default"])(_modalModule["default"].headerChildren, headerChildrenClassName),
            children: headerChildren
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          "aria-live": "polite",
          "data-scroll-container": scrollId,
          className: _modalModule["default"].content,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            "data-test": "modal-children",
            "data-scroll-content": scrollId,
            className: (0, _classnames["default"])(_modalModule["default"].children, modalChildrenClassName, _defineProperty(_defineProperty({}, _modalModule["default"].noHeaderCloseButton, !header && !hideCloseButton && !showBackButton), _modalModule["default"]['children--has-padding'], hasPadding)),
            children: children
          })
        }), showBackButton && /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
          disabled: disableControls,
          className: (0, _classnames["default"])(_modalModule["default"].backButton, _modalModule["default"].button),
          onClick: this.onBackClick,
          "data-test": "modal-button-back",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ChevronLeft24PxOutlined["default"], {}), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: _modalModule["default"].buttonText,
            children: backButtonText
          })]
        }), !hideCloseButton && /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
          disabled: disableControls,
          className: (0, _classnames["default"])(_modalModule["default"].button, _modalModule["default"].closeButton, closeButtonClassName),
          onClick: this.onCloseClick,
          "data-test": "modal-button-close",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Close24PxOutlined["default"], {}), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: _modalModule["default"].buttonText,
            children: closeButtonText
          })]
        })]
      });
    }
  }]);
}(_react.Component); // TODO: Technical debt, component only used in documentation?


_defineProperty(Modal, "propTypes", {
  /** The content to render inside modal */
  children: _propTypes["default"].node.isRequired,

  /** Optional root class name */
  className: _propTypes["default"].string,

  /** show || hide modal */
  isOpen: _propTypes["default"].bool,

  /** creates a fixed header area at top of modal with your text centered vertically and horizontally */
  header: _staticContentPropCheck["default"],

  /** adds a number in brackets next to the header text */
  headerCount: _propTypes["default"].number,

  /** adds button text string alongside the header */
  headerButtonText: _propTypes["default"].string,

  /** the function to be invoked by the button */
  headerButtonAction: _propTypes["default"].func,

  /** The content to render addition1ally inside header */
  headerChildren: _propTypes["default"].node,

  /** a `class` modifier to override default header styles */
  headerStyleModifier: _propTypes["default"].string,

  /** the text you want voiceover to read out to describe the modal */
  a11yHeader: _staticContentPropCheck["default"],

  /** makes the modal fullscreen */
  fullscreen: _propTypes["default"].bool,

  /** forces modal to occupy full height on smaller screens (1) */
  forceFullHeight: _propTypes["default"].bool,

  /** disables modal closing when set */
  disableControls: _propTypes["default"].bool,

  /** hide the close button */
  hideCloseButton: _propTypes["default"].bool,

  /** close button is just an X icon, this text is used for a11y */
  closeButtonText: _staticContentPropCheck["default"],

  /** back button is just an < icon, this text is used for a11y */
  backButtonText: _staticContentPropCheck["default"],

  /** disable || enable modal closing when overlay background is clicked */
  shouldCloseOnOverlayClick: _propTypes["default"].bool,

  /** disable || enable modal closing when ESC key is clicked */
  shouldCloseOnEsc: _propTypes["default"].bool,

  /** show || hide back button */
  showBackButton: _propTypes["default"].bool,

  /** add data-scroll attributes to the modal content divs to assist use with scrollTo utility */
  scrollId: _propTypes["default"].string,

  /** callback for when close button is clicked */
  onClose: _propTypes["default"].func,

  /** callback for when back button is clicked */
  onBack: _propTypes["default"].func,

  /** increase the max width of the modal */
  large: _propTypes["default"].bool,

  /** add standard padding around modal children */
  hasPadding: _propTypes["default"].bool,

  /** a `class` modifier to override default header title styles */
  headerTitleClassName: _propTypes["default"].string,

  /** a `class` modifier to override default header button styles */
  headerButtonClassName: _propTypes["default"].string,

  /** a `class` modifier to override default header children styles */
  headerChildrenClassName: _propTypes["default"].string,

  /** a `class` modifier to override default close button styles */
  closeButtonClassName: _propTypes["default"].string,

  /** a `class` modifier to override default children styles */
  modalChildrenClassName: _propTypes["default"].string
});

_defineProperty(Modal, "defaultProps", {
  className: undefined,
  isOpen: false,
  header: undefined,
  headerCount: undefined,
  headerButtonText: undefined,
  headerButtonAction: undefined,
  headerChildren: undefined,
  headerStyleModifier: undefined,
  a11yHeader: undefined,
  fullscreen: false,
  forceFullHeight: false,
  disableControls: false,
  hideCloseButton: false,
  closeButtonText: 'Close',
  backButtonText: 'Back',
  scrollId: undefined,
  shouldCloseOnOverlayClick: true,
  shouldCloseOnEsc: true,
  showBackButton: false,
  onClose: function onClose() {
    return logWarning('no-op default implementation of props.onClose() has been called');
  },
  onBack: function onBack() {
    return logWarning('no-op default implementation of props.onBack() has been called');
  },
  large: false,
  hasPadding: true,
  headerTitleClassName: undefined,
  headerButtonClassName: undefined,
  headerChildrenClassName: undefined,
  closeButtonClassName: undefined,
  modalChildrenClassName: undefined
});

var ModalButtons = exports.ModalButtons = function ModalButtons(_ref) {
  var inline = _ref.inline,
      children = _ref.children;

  if (children) {
    children.forEach(function (child) {
      if (child.props.inline) {
        logWarning('ModalButtons has "inline" prop which you should use instead of applying it to the Buttons.');
      }
    });
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: (0, _classnames["default"])(_modalModule["default"].actions, _defineProperty({}, _modalModule["default"]['actions--inline'], inline)),
    children: children
  });
};

var _default = exports["default"] = Modal;

/***/ }),

/***/ 49826:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(37667));

var _propTypes = _interopRequireDefault(__webpack_require__(45697));

var _classnames4 = _interopRequireDefault(__webpack_require__(39232));

var _nanoid = __webpack_require__(78647);

var _optionModule = _interopRequireDefault(__webpack_require__(33155));

var _jsxRuntime = __webpack_require__(85893);

var _excluded = ["isRealFormControl"],
    _excluded2 = ["isRealFormControl"],
    _excluded3 = ["id", "children", "className", "focusOnLabel", "name", "isButton", "isControlled", "label", "checked", "labelClassName", "additionalInfo", "onChange", "type", "inputClassName", "inputWrapperClassName", "ariaLabel", "ariaInvalid", "ariaDescribedBy", "describedById", "submitButton", "primaryLabelClassName", "isRealFormControl", "withContainer", "isBordered"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
      t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}

function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };

  var t = _getRequireWildcardCache(r);

  if (t && t.has(e)) return t.get(e);
  var n = {
    __proto__: null
  },
      a = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var u in e) {
    if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }

  return n["default"] = e, t && t.set(e, n), n;
}

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");

  return "symbol" == _typeof(i) ? i : i + "";
}

function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];

  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return ("string" === r ? String : Number)(t);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var propTypes = {
  /** Id for the input */
  id: _propTypes["default"].string,

  /** Required: name for the checkbox/radio input */
  name: _propTypes["default"].string.isRequired,

  /** Required: text (or markup) to show within the option's label */
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]).isRequired,

  /** The value of the input */
  value: _propTypes["default"].string,

  /** Function to be called when a change event is fired by the input */
  onChange: _propTypes["default"].func,

  /** Checked/selected state of the input */
  checked: _propTypes["default"].bool,

  /** Custom class name to be added */
  className: _propTypes["default"].string,

  /** Custom class name to be added to label element */
  labelClassName: _propTypes["default"].string,

  /** Custom class name to be added to primary label element */
  primaryLabelClassName: _propTypes["default"].string,

  /** Expand focus state outline to wrap whole label */
  focusOnLabel: _propTypes["default"].bool,

  /** Add border, padding and spacing to the whole component */
  isButton: _propTypes["default"].bool,

  /** Uses a controlled component */
  isControlled: _propTypes["default"].bool,

  /** Optional additionalInfo */
  additionalInfo: _propTypes["default"].string,

  /** Optional class name to be added to input element */
  inputClassName: _propTypes["default"].string,

  /** Optional class name to be added to wrapper element */
  inputWrapperClassName: _propTypes["default"].string,

  /** The aria-label attribute to be added to input element */
  ariaLabel: _propTypes["default"].string,

  /** The aria-invalid attribute to be added to input element */
  ariaInvalid: _propTypes["default"].string,

  /** The aria-describedby attribute to be added to input element */
  ariaDescribedBy: _propTypes["default"].string,

  /** Id is related to aria-describedby attribute to be added to label element */
  describedById: _propTypes["default"].string,

  /** Whether to render an actual form control */
  isRealFormControl: _propTypes["default"].bool
};
var defaultProps = {
  id: undefined,
  value: undefined,
  checked: false,
  className: undefined,
  focusOnLabel: false,
  isButton: false,
  isControlled: false,
  labelClassName: undefined,
  primaryLabelClassName: undefined,
  onChange: function onChange() {},
  additionalInfo: undefined,
  name: undefined,
  inputClassName: undefined,
  inputWrapperClassName: undefined,
  ariaLabel: undefined,
  ariaInvalid: undefined,
  ariaDescribedBy: undefined,
  describedById: undefined,
  isRealFormControl: true
};

var Input = function Input(_ref) {
  var isRealFormControl = _ref.isRealFormControl,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  return isRealFormControl ? /*#__PURE__*/(0, _jsxRuntime.jsx)("input", _objectSpread({}, otherProps)) : /*#__PURE__*/(0, _jsxRuntime.jsx)("span", _objectSpread({}, otherProps));
};

var Label = function Label(_ref2) {
  var isRealFormControl = _ref2.isRealFormControl,
      otherProps = _objectWithoutProperties(_ref2, _excluded2);

  return isRealFormControl ?
  /*#__PURE__*/

  /* eslint-disable-next-line jsx-a11y/label-has-associated-control */
  (0, _jsxRuntime.jsx)("label", _objectSpread({}, otherProps)) : /*#__PURE__*/(0, _jsxRuntime.jsx)("span", _objectSpread({}, otherProps));
};

var Option = function Option(props) {
  var id = props.id,
      children = props.children,
      className = props.className,
      focusOnLabel = props.focusOnLabel,
      name = props.name,
      isButton = props.isButton,
      isControlled = props.isControlled,
      label = props.label,
      checked = props.checked,
      labelClassName = props.labelClassName,
      additionalInfo = props.additionalInfo,
      onChange = props.onChange,
      type = props.type,
      inputClassName = props.inputClassName,
      inputWrapperClassName = props.inputWrapperClassName,
      ariaLabel = props.ariaLabel,
      ariaInvalid = props.ariaInvalid,
      ariaDescribedBy = props.ariaDescribedBy,
      describedById = props.describedById,
      submitButton = props.submitButton,
      primaryLabelClassName = props.primaryLabelClassName,
      isRealFormControl = props.isRealFormControl,
      withContainer = props.withContainer,
      isBordered = props.isBordered,
      allOtherProps = _objectWithoutProperties(props, _excluded3);

  var inputId = id || "".concat(name, "_").concat((0, _nanoid.nanoid)(10));
  var checkedStatus = isControlled || !isRealFormControl ? {
    checked: checked
  } : {
    defaultChecked: checked
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: (0, _classnames4["default"])(_optionModule["default"]['c-option'], _optionModule["default"]["c-option--".concat(type)], _optionModule["default"]['joyfully-bold'], className, inputWrapperClassName, _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, _optionModule["default"]['c-option--is-button'], isButton), _optionModule["default"]['c-option--focus-on-label'], focusOnLabel), _optionModule["default"]['c-option--checked'], !isRealFormControl && checkedStatus.checked), _optionModule["default"]['c-option--disabled'], allOtherProps.disabled)),
    "data-testid": "".concat(type, "-").concat(label && label.replace ? label.replace(/\s+/g, '-').toLowerCase() : ''),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Input, _objectSpread(_objectSpread(_objectSpread({
      type: type
    }, allOtherProps), {}, {
      onChange: onChange
    }, checkedStatus), {}, {
      id: inputId,
      name: name,
      className: (0, _classnames4["default"])(_optionModule["default"]['c-option__input'], _optionModule["default"]["c-option__input--".concat(type)], inputClassName, _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, _optionModule["default"]['c-option__input--checked'], !isRealFormControl && checkedStatus.checked), _optionModule["default"]['c-option__input--disabled'], allOtherProps.disabled), _optionModule["default"]['c-option__label--with-container'], withContainer), _optionModule["default"]['c-option__label--is-bordered'], isBordered)),
      "aria-label": ariaLabel,
      "aria-invalid": ariaInvalid,
      "aria-describedby": ariaDescribedBy,
      isRealFormControl: isRealFormControl
    })), /*#__PURE__*/(0, _jsxRuntime.jsxs)(Label, {
      id: describedById,
      htmlFor: inputId,
      className: (0, _classnames4["default"])(_optionModule["default"]['c-option__label'], _optionModule["default"]["c-option__label--".concat(type)], labelClassName, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, _optionModule["default"]['c-option__label--with-container'], withContainer), _optionModule["default"]['c-option__label--is-bordered'], isBordered), _optionModule["default"]['c-option__label--with-secondary'], children), _optionModule["default"]['c-option__label--disabled'], allOtherProps.disabled), _optionModule["default"]['c-option__label--checked'], !isRealFormControl && checkedStatus.checked), _optionModule["default"]['c-option__label--focus-on-label'], focusOnLabel)),
      isRealFormControl: isRealFormControl,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: (0, _classnames4["default"])(_optionModule["default"]['c-option__primary-label'], primaryLabelClassName),
        children: [label, additionalInfo && !withContainer && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: (0, _classnames4["default"])(_optionModule["default"]['c-option__primary-label-aside']),
          children: additionalInfo
        })]
      }), additionalInfo && withContainer && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: (0, _classnames4["default"])([_optionModule["default"]['c-option__primary-label--with-container']]),
        children: additionalInfo
      }), children && isButton && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: _optionModule["default"]['c-option__secondary-label'],
        children: children
      })]
    })]
  });
};

Option.propTypes = propTypes;
Option.defaultProps = defaultProps;

var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(Option);

/***/ }),

/***/ 20775:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.NowWasPrice = void 0;

var _react = _interopRequireDefault(__webpack_require__(37667));

var _classnames4 = _interopRequireDefault(__webpack_require__(39232));

var _priceModule = _interopRequireDefault(__webpack_require__(35594));

var _generateNowWasAriaLabel = __webpack_require__(16744);

var _getPriceOrRange = __webpack_require__(15917);

var _jsxRuntime = __webpack_require__(85893);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");

  return "symbol" == _typeof(i) ? i : i + "";
}

function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];

  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return ("string" === r ? String : Number)(t);
}

var NowWasPrice = exports.NowWasPrice = function NowWasPrice(_ref) {
  var className = _ref.className,
      dataTestPrefix = _ref.dataTestPrefix,
      _ref$price = _ref.price,
      was = _ref$price.was,
      then1 = _ref$price.then1,
      then2 = _ref$price.then2,
      now = _ref$price.now,
      pricePrefix = _ref.pricePrefix,
      priceSuffix = _ref.priceSuffix,
      usageContext = _ref.usageContext,
      showPriceReduction = _ref.showPriceReduction,
      unitPriceWording = _ref.unitPriceWording,
      isAnyday = _ref.isAnyday,
      isProductCard = _ref.isProductCard,
      isQuickView = _ref.isQuickView,
      reducedPrice = _ref.reducedPrice;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
    className: (0, _classnames4["default"])(className, _priceModule["default"]['price'], _priceModule["default"]['price--reduced'], _priceModule["default"]["price--context-".concat(usageContext)], _defineProperty({}, _priceModule["default"]['price--anyday'], isAnyday)),
    "data-test": dataTestPrefix ? "".concat(dataTestPrefix, "-price") : 'price',
    "aria-label": (0, _generateNowWasAriaLabel.generateNowWasAriaLabel)(was, then1, then2, now, pricePrefix, priceSuffix),
    children: [now && /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
      className: (0, _classnames4["default"])(_priceModule["default"]['price__now'], _defineProperty({}, _priceModule["default"]['price__right-padding'], isQuickView)),
      "data-test": dataTestPrefix ? "".concat(dataTestPrefix, "-price-now") : 'price-now',
      role: "presentation",
      children: [pricePrefix && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: (0, _classnames4["default"])(_priceModule["default"]['price__prefix']),
          children: pricePrefix
        }), ' ']
      }), (0, _getPriceOrRange.getPriceOrRange)(now), priceSuffix && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [' ', /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: (0, _classnames4["default"])(_priceModule["default"]['price__suffix']),
          children: priceSuffix
        })]
      })]
    }), [was, then1, then2].map(function (previousPrice, index) {
      return previousPrice && [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: (0, _classnames4["default"])(_priceModule["default"]['price__prev'], _defineProperty({}, _priceModule["default"]['price__right-padding'], isQuickView)),
        "data-test": dataTestPrefix ? "".concat(dataTestPrefix, "-price-prev") : 'price-prev',
        role: "presentation",
        children: (0, _getPriceOrRange.getPriceOrRange)(previousPrice)
      }, "".concat(index < 1 ? 'was' : 'then', "Value").concat(previousPrice.from || previousPrice))];
    }), unitPriceWording && !isProductCard ? /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: (0, _classnames4["default"])(_priceModule["default"]['price__unit-price'], _priceModule["default"]["price__unit-price-".concat(usageContext)]),
      "aria-label": unitPriceWording,
      children: unitPriceWording
    }) : null, showPriceReduction && reducedPrice && /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
      className: (0, _classnames4["default"])(_priceModule["default"]['price__reduction']),
      "data-test": dataTestPrefix ? "".concat(dataTestPrefix, "-price-reduction") : 'price-reduction',
      "aria-label": "Save ".concat(reducedPrice),
      children: ["Save ", reducedPrice]
    })]
  });
};

/***/ }),

/***/ 73850:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(37667));

var _propTypes = _interopRequireDefault(__webpack_require__(45697));

var _classnames2 = _interopRequireDefault(__webpack_require__(39232));

var _brands = __webpack_require__(70);

var _calculatePriceReduction = _interopRequireDefault(__webpack_require__(570));

var _createUnitPriceString = _interopRequireDefault(__webpack_require__(90554));

var _priceModule = _interopRequireDefault(__webpack_require__(35594));

var _getPriceOrRange = __webpack_require__(15917);

var _generateAriaLabel = __webpack_require__(5153);

var _WasNowPrice = __webpack_require__(61032);

var _NowWasPrice = __webpack_require__(20775);

var _jsxRuntime = __webpack_require__(85893);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
      t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}

function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };

  var t = _getRequireWildcardCache(r);

  if (t && t.has(e)) return t.get(e);
  var n = {
    __proto__: null
  },
      a = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var u in e) {
    if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }

  return n["default"] = e, t && t.set(e, n), n;
}

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");

  return "symbol" == _typeof(i) ? i : i + "";
}

function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];

  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return ("string" === r ? String : Number)(t);
}

var Price = function Price(_ref) {
  var brand = _ref.brand,
      className = _ref.className,
      dataTestPrefix = _ref.dataTestPrefix,
      _ref$price = _ref.price,
      was = _ref$price.was,
      then1 = _ref$price.then1,
      then2 = _ref$price.then2,
      now = _ref$price.now,
      pricePrefix = _ref.pricePrefix,
      priceSuffix = _ref.priceSuffix,
      unitPriceInfo = _ref.unitPriceInfo,
      usageContext = _ref.usageContext,
      _ref$showPriceReducti = _ref.showPriceReduction,
      showPriceReduction = _ref$showPriceReducti === void 0 ? false : _ref$showPriceReducti,
      _ref$isNowWas = _ref.isNowWas,
      isNowWas = _ref$isNowWas === void 0 ? false : _ref$isNowWas;
  var unitPriceWording = (0, _createUnitPriceString["default"])(unitPriceInfo);
  var isAnyday = (0, _brands.isAnydayBrand)(brand);
  var isProductCard = Boolean(usageContext === 'product-card');
  var isQuickView = Boolean(usageContext === 'quick-view');

  if (!now) {
    return null;
  }

  var reducedPrice = showPriceReduction ? (0, _calculatePriceReduction["default"])({
    was: was,
    now: now
  }) : null;
  var priceSuffixText = !isProductCard ? priceSuffix : null;

  if (was) {
    if (isNowWas) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_NowWasPrice.NowWasPrice, {
        className: className,
        dataTestPrefix: dataTestPrefix,
        price: {
          was: was,
          then1: then1,
          then2: then2,
          now: now
        },
        pricePrefix: pricePrefix,
        priceSuffix: priceSuffixText,
        usageContext: usageContext,
        showPriceReduction: showPriceReduction,
        unitPriceWording: unitPriceWording,
        isAnyday: isAnyday,
        isProductCard: isProductCard,
        isQuickView: isQuickView,
        reducedPrice: reducedPrice
      });
    } else {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_WasNowPrice.WasNowPrice, {
        className: className,
        dataTestPrefix: dataTestPrefix,
        price: {
          was: was,
          then1: then1,
          then2: then2,
          now: now
        },
        pricePrefix: pricePrefix,
        priceSuffix: priceSuffixText,
        usageContext: usageContext,
        showPriceReduction: showPriceReduction,
        unitPriceWording: unitPriceWording,
        isAnyday: isAnyday,
        isProductCard: isProductCard,
        isQuickView: isQuickView,
        reducedPrice: reducedPrice
      });
    }
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
    className: (0, _classnames2["default"])(className, _priceModule["default"]['price'], _priceModule["default"]["price--context-".concat(usageContext)], _defineProperty({}, _priceModule["default"]["price--anyday"], isAnyday)),
    "data-test": dataTestPrefix ? "".concat(dataTestPrefix, "-price") : 'price',
    "aria-label": (0, _generateAriaLabel.generateAriaLabel)(undefined, undefined, undefined, now, pricePrefix, priceSuffixText),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
      className: (0, _classnames2["default"])(_priceModule["default"]['price__now']),
      "data-test": dataTestPrefix ? "".concat(dataTestPrefix, "-price-now") : 'price-now',
      role: "presentation",
      children: [pricePrefix && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: (0, _classnames2["default"])(_priceModule["default"]['price__prefix']),
          children: pricePrefix
        }), ' ']
      }), (0, _getPriceOrRange.getPriceOrRange)(now), priceSuffixText && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [' ', /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: (0, _classnames2["default"])(_priceModule["default"]['price__suffix']),
          children: priceSuffixText
        })]
      })]
    }), unitPriceWording && !isProductCard ? /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: (0, _classnames2["default"])(_priceModule["default"]['price__unit-price'], _priceModule["default"]["price__unit-price-".concat(usageContext)]),
      "aria-label": unitPriceWording,
      children: unitPriceWording
    }) : null]
  });
};

Price.defaultProps = {
  brand: null,
  className: null,
  dataTestPrefix: null,
  price: {},
  pricePrefix: null,
  priceSuffix: null,
  unitPriceInfo: null,
  usageContext: 'product-card',
  showPriceReduction: false
};
Price.propTypes = {
  brand: _propTypes["default"].string,
  className: _propTypes["default"].string,
  dataTestPrefix: _propTypes["default"].string,
  price: _propTypes["default"].shape({
    was: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].shape({
      from: _propTypes["default"].string,
      to: _propTypes["default"].string
    })]),
    then1: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].shape({
      from: _propTypes["default"].string,
      to: _propTypes["default"].string
    })]),
    then2: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].shape({
      from: _propTypes["default"].string,
      to: _propTypes["default"].string
    })]),
    now: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].shape({
      from: _propTypes["default"].string,
      to: _propTypes["default"].string
    })])
  }),
  pricePrefix: _propTypes["default"].string,

  /** Suffix text for the price - not displayed when usageContext is 'product-card' */
  priceSuffix: _propTypes["default"].string,
  unitPriceInfo: _propTypes["default"].shape({
    pricePerUnit: _propTypes["default"].shape({
      currency: _propTypes["default"].string,
      price: _propTypes["default"].number
    }),
    unit: _propTypes["default"].shape({
      measure: _propTypes["default"].string,
      quantity: _propTypes["default"].number
    })
  }),
  usageContext: _propTypes["default"].oneOf(['product-card', 'quick-view', 'pdp']),
  showPriceReduction: _propTypes["default"].bool
};

var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(Price);

/***/ }),

/***/ 61032:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.WasNowPrice = void 0;

var _react = _interopRequireDefault(__webpack_require__(37667));

var _classnames4 = _interopRequireDefault(__webpack_require__(39232));

var _priceModule = _interopRequireDefault(__webpack_require__(35594));

var _generateAriaLabel = __webpack_require__(5153);

var _getPriceOrRange = __webpack_require__(15917);

var _jsxRuntime = __webpack_require__(85893);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");

  return "symbol" == _typeof(i) ? i : i + "";
}

function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];

  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return ("string" === r ? String : Number)(t);
}

var WasNowPrice = exports.WasNowPrice = function WasNowPrice(_ref) {
  var className = _ref.className,
      dataTestPrefix = _ref.dataTestPrefix,
      _ref$price = _ref.price,
      was = _ref$price.was,
      then1 = _ref$price.then1,
      then2 = _ref$price.then2,
      now = _ref$price.now,
      pricePrefix = _ref.pricePrefix,
      priceSuffix = _ref.priceSuffix,
      usageContext = _ref.usageContext,
      showPriceReduction = _ref.showPriceReduction,
      unitPriceWording = _ref.unitPriceWording,
      isAnyday = _ref.isAnyday,
      isProductCard = _ref.isProductCard,
      isQuickView = _ref.isQuickView,
      reducedPrice = _ref.reducedPrice;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
    className: (0, _classnames4["default"])(className, _priceModule["default"]['price'], _priceModule["default"]['price--reduced'], _priceModule["default"]["price--context-".concat(usageContext)], _defineProperty({}, _priceModule["default"]['price--anyday'], isAnyday)),
    "data-test": dataTestPrefix ? "".concat(dataTestPrefix, "-price") : 'price',
    "aria-label": (0, _generateAriaLabel.generateAriaLabel)(was, then1, then2, now, pricePrefix, priceSuffix),
    children: [[was, then1, then2].map(function (previousPrice, index) {
      return previousPrice && [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: (0, _classnames4["default"])(_priceModule["default"]['price__prev'], _defineProperty({}, _priceModule["default"]['price__right-padding'], isQuickView)),
        "data-test": dataTestPrefix ? "".concat(dataTestPrefix, "-price-prev") : 'price-prev',
        role: "presentation",
        children: (0, _getPriceOrRange.getPriceOrRange)(previousPrice)
      }, "".concat(index < 1 ? 'was' : 'then', "Value").concat(previousPrice.from || previousPrice))];
    }), now && /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
      className: (0, _classnames4["default"])(_priceModule["default"]['price__now'], _defineProperty({}, _priceModule["default"]['price__right-padding'], isQuickView)),
      "data-test": dataTestPrefix ? "".concat(dataTestPrefix, "-price-now") : 'price-now',
      role: "presentation",
      children: [pricePrefix && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: (0, _classnames4["default"])(_priceModule["default"]['price__prefix']),
          children: pricePrefix
        }), ' ']
      }), (0, _getPriceOrRange.getPriceOrRange)(now), priceSuffix && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [' ', /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: (0, _classnames4["default"])(_priceModule["default"]['price__suffix']),
          children: priceSuffix
        })]
      })]
    }), unitPriceWording && !isProductCard ? /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: (0, _classnames4["default"])(_priceModule["default"]['price__unit-price'], _priceModule["default"]["price__unit-price-".concat(usageContext)]),
      "aria-label": unitPriceWording,
      children: unitPriceWording
    }) : null, showPriceReduction && reducedPrice && /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
      className: (0, _classnames4["default"])(_priceModule["default"]['price__reduction']),
      "data-test": dataTestPrefix ? "".concat(dataTestPrefix, "-price-reduction") : 'price-reduction',
      "aria-label": "Save ".concat(reducedPrice),
      children: ["Save ", reducedPrice]
    })]
  });
};

/***/ }),

/***/ 5153:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.generateAriaLabel = void 0;

var _getPriceOrRange = __webpack_require__(15917);
/**
 * Generates an ARIA label string based on the given price values.
 *
 * @param was - The previous price.
 * @param then1 - The first intermediate price.
 * @param then2 - The second intermediate price.
 * @param now - The current price.
 * @param pricePrefix - A prefix for the price.
 * @param priceSuffix - A suffix for the price.
 * @returns The generated ARIA label string.
 */


var generateAriaLabel = exports.generateAriaLabel = function generateAriaLabel(was, then1, then2, now) {
  var pricePrefix = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
  var priceSuffix = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
  var steps = [];
  var wasPrice = (0, _getPriceOrRange.getPriceOrRange)(was);
  var then1Price = (0, _getPriceOrRange.getPriceOrRange)(then1);
  var then2Price = (0, _getPriceOrRange.getPriceOrRange)(then2);
  var nowPrice = (0, _getPriceOrRange.getPriceOrRange)(now);

  if (wasPrice) {
    steps.push("The price was ".concat(wasPrice));
  }

  if (then1Price) {
    steps.push("then ".concat(then1Price));
  }

  if (then2Price) {
    steps.push("then ".concat(then2Price));
  }

  if (nowPrice) {
    var priceText = "".concat(pricePrefix !== null && pricePrefix !== void 0 ? pricePrefix : '', " ").concat(nowPrice, " ").concat(priceSuffix !== null && priceSuffix !== void 0 ? priceSuffix : '').trim();

    if (steps.length === 0) {
      steps.push("The price is ".concat(priceText));
    } else {
      steps.push("now ".concat(priceText));
    }
  }

  return steps.join(', ');
};

/***/ }),

/***/ 16744:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.generateNowWasAriaLabel = void 0;

var _getPriceOrRange = __webpack_require__(15917);
/**
 * Generates an ARIA label string based on the given price values for now was format.
 *
 * @param was - The previous price.
 * @param then1 - The first intermediate price.
 * @param then2 - The second intermediate price.
 * @param now - The current price.
 * @param pricePrefix - A prefix for the price.
 * @param priceSuffix - A suffix for the price.
 * @returns The generated ARIA label string.
 */


var generateNowWasAriaLabel = exports.generateNowWasAriaLabel = function generateNowWasAriaLabel(was, then1, then2, now) {
  var pricePrefix = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
  var priceSuffix = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
  var steps = [];
  var wasPrice = (0, _getPriceOrRange.getPriceOrRange)(was);
  var then1Price = (0, _getPriceOrRange.getPriceOrRange)(then1);
  var then2Price = (0, _getPriceOrRange.getPriceOrRange)(then2);
  var nowPrice = (0, _getPriceOrRange.getPriceOrRange)(now);

  if (nowPrice) {
    var priceText = "".concat(pricePrefix !== null && pricePrefix !== void 0 ? pricePrefix : '', " ").concat(nowPrice, " ").concat(priceSuffix !== null && priceSuffix !== void 0 ? priceSuffix : '').trim();
    steps.push("The price is ".concat(priceText));
  }

  if (then2Price) {
    steps.push("was ".concat(then2Price));
  }

  if (then1Price) {
    if (then2Price) {
      steps.push("".concat(then1Price));
    } else {
      steps.push("was ".concat(then1Price));
    }
  }

  if (wasPrice) {
    steps.push("and originally ".concat(wasPrice));
  }

  return steps.join(', ');
};

/***/ }),

/***/ 15917:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.getPriceOrRange = void 0;

var formatted_price_1 = __importDefault(__webpack_require__(46742));
/**
 * Converts a price value or range to a string representation.
 * @param price - The price value or range.
 * @returns The string representation of the price.
 */


var getPriceOrRange = function getPriceOrRange(price) {
  if (price === null || price === undefined || price === '') {
    return null;
  }

  if (typeof price === 'object') {
    return "".concat((0, formatted_price_1["default"])(price === null || price === void 0 ? void 0 : price.from), " \u2013 ").concat((0, formatted_price_1["default"])(price === null || price === void 0 ? void 0 : price.to));
  } else {
    return (0, formatted_price_1["default"])(price);
  }
};

exports.getPriceOrRange = getPriceOrRange;

/***/ }),

/***/ 83849:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = createCurrencyString;

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");

  return "symbol" == _typeof(i) ? i : i + "";
}

function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];

  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return ("string" === r ? String : Number)(t);
}

function createCurrencyString(pricePerUnit) {
  var currencyString,
      priceString,
      _pricePerUnit = _objectSpread({}, pricePerUnit),
      currency = _pricePerUnit.currency,
      price = _pricePerUnit.price;

  if (price) {
    priceString = parseFloat(price).toFixed(2);
  }

  if (currency === 'GBP' && priceString) {
    currencyString = "\xA3".concat(priceString);
  } else if ((currency === null || currency === void 0 ? void 0 : currency.length) === 1 && priceString) {
    currencyString = "".concat(currency).concat(priceString);
  }

  return currencyString;
}

/***/ }),

/***/ 13518:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = createUnitAmountString;

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");

  return "symbol" == _typeof(i) ? i : i + "";
}

function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];

  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return ("string" === r ? String : Number)(t);
}

function createUnitAmountString(unit) {
  var unitAmountString,
      _unit = _objectSpread({}, unit),
      measure = _unit.measure,
      quantity = _unit.quantity;

  if (measure && quantity) {
    unitAmountString = "".concat(quantity).concat(measure);
  }

  return unitAmountString;
}

/***/ }),

/***/ 90554:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = createUnitPriceString;

var _createCurrencyString = _interopRequireDefault(__webpack_require__(83849));

var _createUnitAmountString = _interopRequireDefault(__webpack_require__(13518));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");

  return "symbol" == _typeof(i) ? i : i + "";
}

function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];

  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return ("string" === r ? String : Number)(t);
}

function createUnitPriceString(unitPriceInfo) {
  var unitPriceString,
      _unitPriceInfo = _objectSpread({}, unitPriceInfo),
      pricePerUnit = _unitPriceInfo.pricePerUnit,
      unit = _unitPriceInfo.unit,
      amount = (0, _createCurrencyString["default"])(pricePerUnit),
      measure = (0, _createUnitAmountString["default"])(unit);

  if (amount && measure) {
    unitPriceString = "".concat(amount, " per ").concat(measure);
  }

  return unitPriceString;
}

/***/ }),

/***/ 58344:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var _react = _interopRequireWildcard(__webpack_require__(37667));

var _propTypes = _interopRequireDefault(__webpack_require__(45697));

var _classnames = _interopRequireDefault(__webpack_require__(39232));

var _productCardDetailedModule = _interopRequireDefault(__webpack_require__(9760));

var _brands = __webpack_require__(70);

var _getProductUrl = _interopRequireDefault(__webpack_require__(84225));

var _cachedBasket = __webpack_require__(45384);

var _useEmailConfirmed = __webpack_require__(28464);

var _AdditionalMessages = _interopRequireDefault(__webpack_require__(80194));

var _Checkbox = _interopRequireDefault(__webpack_require__(4990));

var _CtaButton = __webpack_require__(55396);

var _EnergyRating = _interopRequireDefault(__webpack_require__(12562));

var _Image = _interopRequireDefault(__webpack_require__(21914));

var _PreOrder = _interopRequireDefault(__webpack_require__(88882));

var _Price = _interopRequireDefault(__webpack_require__(73850));

var _ProductCardRating = _interopRequireDefault(__webpack_require__(28291));

var _PromoMessages = _interopRequireDefault(__webpack_require__(52930));

var _Sponsored = _interopRequireDefault(__webpack_require__(40475));

var _Swatches = _interopRequireDefault(__webpack_require__(52117));

var _Title = _interopRequireDefault(__webpack_require__(53845));

var _jsxRuntime = __webpack_require__(85893);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
      t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}

function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };

  var t = _getRequireWildcardCache(r);

  if (t && t.has(e)) return t.get(e);
  var n = {
    __proto__: null
  },
      a = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var u in e) {
    if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }

  return n["default"] = e, t && t.set(e, n), n;
}

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");

  return "symbol" == _typeof(i) ? i : i + "";
}

function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];

  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return ("string" === r ? String : Number)(t);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];

  if (null != t) {
    var e,
        n,
        i,
        u,
        a = [],
        f = !0,
        o = !1;

    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) {
        ;
      }
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }

    return a;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var ALPHA__ProductCardDetailed = function ALPHA__ProductCardDetailed(_ref) {
  var _availability$futureA, _availability$preOrde, _energy$rating, _energy$rating2, _energy$rating3, _availability$futureA2, _availability$preOrde2;

  var product = _ref.product,
      _ref$hasAltImageOnHov = _ref.hasAltImageOnHover,
      hasAltImageOnHover = _ref$hasAltImageOnHov === void 0 ? false : _ref$hasAltImageOnHov,
      _ref$hasEnergySideDra = _ref.hasEnergySideDrawer,
      hasEnergySideDrawer = _ref$hasEnergySideDra === void 0 ? false : _ref$hasEnergySideDra,
      _ref$hasNowWasPricing = _ref.hasNowWasPricing,
      hasNowWasPricing = _ref$hasNowWasPricing === void 0 ? false : _ref$hasNowWasPricing,
      _ref$hasPromoMessageM = _ref.hasPromoMessageModal,
      hasPromoMessageModal = _ref$hasPromoMessageM === void 0 ? false : _ref$hasPromoMessageM,
      _ref$isPromoQuickView = _ref.isPromoQuickViewFlagOn,
      isPromoQuickViewFlagOn = _ref$isPromoQuickView === void 0 ? false : _ref$isPromoQuickView,
      _ref$showPriceReducti = _ref.showPriceReduction,
      showPriceReduction = _ref$showPriceReducti === void 0 ? false : _ref$showPriceReducti,
      _ref$atbProps = _ref.atbProps,
      atbProps = _ref$atbProps === void 0 ? {} : _ref$atbProps,
      _ref$buttonSettings = _ref.buttonSettings,
      buttonSettings = _ref$buttonSettings === void 0 ? {} : _ref$buttonSettings,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$compareProps = _ref.compareProps,
      compareProps = _ref$compareProps === void 0 ? {} : _ref$compareProps,
      _ref$hasCompare = _ref.hasCompare,
      hasCompare = _ref$hasCompare === void 0 ? false : _ref$hasCompare,
      _ref$imageSettings = _ref.imageSettings,
      imageSettings = _ref$imageSettings === void 0 ? {} : _ref$imageSettings,
      _ref$moreInformationC = _ref.moreInformationCustomLabel,
      moreInformationCustomLabel = _ref$moreInformationC === void 0 ? '' : _ref$moreInformationC,
      _ref$pricePrefix = _ref.pricePrefix,
      pricePrefix = _ref$pricePrefix === void 0 ? '' : _ref$pricePrefix,
      _ref$selectedSwatch = _ref.selectedSwatch,
      selectedSwatch = _ref$selectedSwatch === void 0 ? {} : _ref$selectedSwatch,
      _ref$sponsoredTitleEn = _ref.sponsoredTitleEnabled,
      sponsoredTitleEnabled = _ref$sponsoredTitleEn === void 0 ? false : _ref$sponsoredTitleEn,
      _ref$titleHeaderTagLe = _ref.titleHeaderTagLevel,
      titleHeaderTagLevel = _ref$titleHeaderTagLe === void 0 ? undefined : _ref$titleHeaderTagLe,
      _ref$handleClick = _ref.handleClick,
      handleClick = _ref$handleClick === void 0 ? function () {} : _ref$handleClick,
      _ref$handleDisplayPro = _ref.handleDisplayPromoModal,
      handleDisplayPromoModal = _ref$handleDisplayPro === void 0 ? undefined : _ref$handleDisplayPro,
      _ref$handleEnergyRati = _ref.handleEnergyRatingClick,
      handleEnergyRatingClick = _ref$handleEnergyRati === void 0 ? function () {} : _ref$handleEnergyRati,
      _ref$handleQuickAddCl = _ref.handleQuickAddClick,
      handleQuickAddClick = _ref$handleQuickAddCl === void 0 ? undefined : _ref$handleQuickAddCl,
      _ref$handleQuickViewC = _ref.handleQuickViewClick,
      handleQuickViewClick = _ref$handleQuickViewC === void 0 ? function () {} : _ref$handleQuickViewC,
      _ref$handleSwatchClic = _ref.handleSwatchClick,
      handleSwatchClickProp = _ref$handleSwatchClic === void 0 ? undefined : _ref$handleSwatchClic;
  var additionalMessages = product.additionalMessages,
      adId = product.adId,
      alternativeImageUrls = product.alternativeImageUrls,
      availability = product.availability,
      brand = product.brand,
      colorSwatches = product.colorSwatches,
      energy = product.energy,
      id = product.id,
      image = product.image,
      price = product.price,
      _product$promoMessage = product.promoMessages,
      promoMessages = _product$promoMessage === void 0 ? [] : _product$promoMessage,
      rating = product.rating,
      title = product.title,
      url = product.url;
  var hasEmailMeWhenAvailableButton = buttonSettings.hasEmailMeWhenAvailableButton,
      _buttonSettings$hasCt = buttonSettings.hasCtaButton,
      hasCtaButton = _buttonSettings$hasCt === void 0 ? true : _buttonSettings$hasCt;
  var emailConfirmed = (0, _useEmailConfirmed.useEmailConfirmed)(hasEmailMeWhenAvailableButton, id);
  var cachedBasket = (0, _cachedBasket.useCachedBasketData)();
  var isAddedToBasket = cachedBasket.products.some(function (p) {
    return p.productId === id;
  });

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      swatchOverride = _useState2[0],
      setSwatchOverride = _useState2[1];

  var isAnyday = (0, _brands.isAnydayBrand)(brand);
  var productUrl = swatchOverride ? (0, _getProductUrl["default"])(title, id, swatchOverride, adId) : url || (0, _getProductUrl["default"])(title, id, selectedSwatch, adId);

  var getOverrideSwatch = function getOverrideSwatch(e) {
    var override = colorSwatches.find(function (_ref2) {
      var color = _ref2.color;
      return color === e.currentTarget.title || color + ' - Out of stock' === e.currentTarget.title;
    });
    return override;
  };

  var handleSwatchClick = function handleSwatchClick(e) {
    handleSelectedSwatchClick(e);

    if (handleSwatchClickProp) {
      handleSwatchClickProp(e);
    }
  };

  var handleSelectedSwatchClick = function handleSelectedSwatchClick(e) {
    e.preventDefault();
    var override = getOverrideSwatch(e);

    if (override) {
      setSwatchOverride(override);
    }
  };

  var handleEnergyArrowClick = function handleEnergyArrowClick(altText, rating) {
    handleEnergyRatingClick(altText, rating, energy === null || energy === void 0 ? void 0 : energy.label, energy === null || energy === void 0 ? void 0 : energy.informationSheet, adId, id);
  };

  var handleQuickViewIconClick = function handleQuickViewIconClick() {
    var swatchOrder = (colorSwatches || []).map(function (_ref3) {
      var color = _ref3.color;
      return color;
    });
    return Promise.resolve(handleQuickViewClick(id, selectedSwatch.url || (0, _getProductUrl["default"])(title, id, selectedSwatch), swatchOrder, swatchOverride === null || swatchOverride === void 0 ? void 0 : swatchOverride.color, adId));
  };

  var hasPreOrderMessages = (availability === null || availability === void 0 || (_availability$futureA = availability.futureAvailability) === null || _availability$futureA === void 0 ? void 0 : _availability$futureA.availableToOrderFromMessage) || (availability === null || availability === void 0 || (_availability$preOrde = availability.preOrder) === null || _availability$preOrde === void 0 ? void 0 : _availability$preOrde.streetDateMessage);
  var hasMessages = (promoMessages === null || promoMessages === void 0 ? void 0 : promoMessages.length) || (additionalMessages === null || additionalMessages === void 0 ? void 0 : additionalMessages.length) || hasPreOrderMessages;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("article", {
    className: (0, _classnames["default"])(_productCardDetailedModule["default"]['c-product-card-container'], className),
    "data-product-id": id,
    "data-taggstar": "product-card",
    "data-test": "product-card",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: (0, _classnames["default"])(_productCardDetailedModule["default"]['c-product-card'], _defineProperty({}, _productCardDetailedModule["default"]['c-product-card--has-messages'], hasMessages)),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: (0, _classnames["default"])(_productCardDetailedModule["default"]['c-product-card__image-container']),
        "data-test": "product-image-container",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Image["default"], _objectSpread({
          alternativeImageUrls: alternativeImageUrls,
          className: (0, _classnames["default"])(_productCardDetailedModule["default"]['c-product-card__image'], 'product__image'),
          handleClick: handleClick,
          hasAltImageOnHover: hasAltImageOnHover,
          image: image,
          multipleSwatches: colorSwatches && colorSwatches.length > 1,
          selectedSwatch: swatchOverride || selectedSwatch,
          title: title,
          url: productUrl
        }, imageSettings))
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: _productCardDetailedModule["default"]['c-product-card__title-section'],
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: _productCardDetailedModule["default"]['c-product-card__link-container'],
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
            className: _productCardDetailedModule["default"]['c-product-card__link'],
            href: productUrl,
            onClick: handleClick,
            tabIndex: 0,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Title["default"], {
              brand: isAnyday ? 'Anyday' : brand,
              brandPrefix: isAnyday ? 'John Lewis ' : '',
              headerTagLevel: titleHeaderTagLevel,
              isAnyday: isAnyday,
              isBranded: !!brand,
              isUnlimitedLines: true,
              title: title
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Sponsored["default"], {
            hasSponsoredTitle: sponsoredTitleEnabled
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Price["default"], {
            brand: brand,
            className: _productCardDetailedModule["default"]['c-product-card__price'],
            dataTestPrefix: "product-card",
            isNowWas: hasNowWasPricing,
            price: price,
            pricePrefix: pricePrefix,
            showPriceReduction: showPriceReduction
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ProductCardRating["default"], {
            className: _productCardDetailedModule["default"]['c-product-card__rating'],
            rating: rating
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_EnergyRating["default"], {
          className: _productCardDetailedModule["default"].energyRating,
          handleEnergyRatingClick: handleEnergyArrowClick,
          hasEnergySideDrawer: hasEnergySideDrawer,
          rating: energy !== null && energy !== void 0 && (_energy$rating = energy.rating) !== null && _energy$rating !== void 0 && _energy$rating.legacy ? undefined : energy === null || energy === void 0 || (_energy$rating2 = energy.rating) === null || _energy$rating2 === void 0 ? void 0 : _energy$rating2.value,
          ratingLegacy: energy !== null && energy !== void 0 && (_energy$rating3 = energy.rating) !== null && _energy$rating3 !== void 0 && _energy$rating3.legacy ? energy.rating.value : undefined
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Swatches["default"], {
          baseUrl: productUrl,
          className: (0, _classnames["default"])(_productCardDetailedModule["default"]['c-product-card__swatches']),
          handleClick: handleSwatchClick,
          id: id,
          imageLoading: imageSettings.loading,
          selectedSwatch: swatchOverride || selectedSwatch,
          swatches: colorSwatches,
          title: title
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: _productCardDetailedModule["default"]['c-product-card__divider']
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: _productCardDetailedModule["default"]['c-product-card__messages-section'],
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_PromoMessages["default"], {
          handleDisplayModal: handleDisplayPromoModal,
          handleQuickViewClick: handleQuickViewIconClick,
          hasPromoMessageModal: hasPromoMessageModal,
          isPromoQuickViewFlagOn: isPromoQuickViewFlagOn,
          productUrl: productUrl,
          promos: promoMessages,
          title: title,
          wrapperClassName: (0, _classnames["default"])(_productCardDetailedModule["default"]['c-product-card__section-divider'], _productCardDetailedModule["default"]['c-product-card__promo-messages'])
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_PreOrder["default"], {
          className: (0, _classnames["default"])(_productCardDetailedModule["default"]['c-product-card__section-divider']),
          availableToOrder: availability === null || availability === void 0 || (_availability$futureA2 = availability.futureAvailability) === null || _availability$futureA2 === void 0 ? void 0 : _availability$futureA2.availableToOrderFromMessage,
          streetDate: availability === null || availability === void 0 || (_availability$preOrde2 = availability.preOrder) === null || _availability$preOrde2 === void 0 ? void 0 : _availability$preOrde2.streetDateMessage
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_AdditionalMessages["default"], {
          className: (0, _classnames["default"])(_productCardDetailedModule["default"]['c-product-card__section-divider']),
          messages: additionalMessages
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: (0, _classnames["default"])(_productCardDetailedModule["default"]['c-product-card__btn-section']),
        children: [hasCtaButton && /*#__PURE__*/(0, _jsxRuntime.jsx)(_CtaButton.CtaButton, _objectSpread(_objectSpread({}, buttonSettings), {}, {
          atbProps: atbProps,
          className: _productCardDetailedModule["default"]['c-product-card__cta'],
          emailConfirmed: emailConfirmed,
          handleQuickAddClick: handleQuickAddClick,
          handleQuickViewClick: handleQuickViewClick,
          hasShortCtaText: true,
          isAddedToBasket: isAddedToBasket,
          moreInformationCustomLabel: moreInformationCustomLabel,
          product: product,
          productUrl: productUrl,
          selectedSwatch: selectedSwatch,
          swatchOrder: (colorSwatches || []).map(function (_ref4) {
            var color = _ref4.color;
            return color;
          }),
          swatchOverride: swatchOverride
        })), hasCompare && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Checkbox["default"], _objectSpread({
          id: "compare-checkbox-".concat(id),
          className: _productCardDetailedModule["default"]['c-product-card__compare'] // prettier-ignore
          ,
          label: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
            children: ["Compare", /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              className: _productCardDetailedModule["default"]['visuallyHidden'],
              children: "Select for product comparison, ".concat(title)
            })]
          }),
          isControlled: true,
          name: "compare-checkbox-".concat(id)
        }, compareProps))]
      })]
    })
  });
};

ALPHA__ProductCardDetailed.displayName = 'ProductCardDetailed';

var colorSwatchType = _propTypes["default"].shape({
  color: _propTypes["default"].string,
  colorSwatchUrl: _propTypes["default"].string,
  imageUrl: _propTypes["default"].string,
  isAvailable: _propTypes["default"].bool,
  skuId: _propTypes["default"].string,
  url: _propTypes["default"].string
});

ALPHA__ProductCardDetailed.propTypes = {
  product: _propTypes["default"].shape({
    /** Array of additional (non-promo) messages to display */
    additionalMessages: _propTypes["default"].arrayOf(_propTypes["default"].string),

    /** Id of advert if product card is sponsored */
    adId: _propTypes["default"].string,

    /** Indicates if a product is preorderable */
    availability: _propTypes["default"].shape({
      futureAvailability: _propTypes["default"].shape({
        availableToOrderFromMessage: _propTypes["default"].string
      }),
      preOrder: _propTypes["default"].shape({
        streetDateMessage: _propTypes["default"].string
      })
    }),

    /** Brand */
    brand: _propTypes["default"].string,

    /** Colour variants for product (if you want to show them) */
    colorSwatches: _propTypes["default"].arrayOf(colorSwatchType),

    /** Energy rating info */
    energy: _propTypes["default"].shape({
      rating: _propTypes["default"].shape({
        legacy: _propTypes["default"].bool,
        value: _propTypes["default"].string
      }),
      label: _propTypes["default"].string,
      informationSheet: _propTypes["default"].string
    }),

    /** Product ID */
    id: _propTypes["default"].string.isRequired,

    /** Main/default product image */
    image: _propTypes["default"].string.isRequired,

    /** Is this a multisku product */
    isMultiSku: _propTypes["default"].bool,

    /** Pricing object: { was, then1, then2, now } each a string or a range { from, to } */
    price: _propTypes["default"].shape(_Price["default"].propTypes),

    /** Array of promo messages to display */
    promoMessages: _propTypes["default"].arrayOf(_propTypes["default"].string),

    /** Rating summary: { averageRating, reviews } */
    rating: _propTypes["default"].shape(_ProductCardRating["default"].propTypes),

    /** Default SkuId for the product */
    skuId: _propTypes["default"].string,

    /** Product title */
    title: _propTypes["default"].string.isRequired,

    /** Product (default) URL */
    url: _propTypes["default"].string,

    /** default variantId for the product */
    variantId: _propTypes["default"].string
  }).isRequired,

  /** Indicate whether to try to display first alt image when main image hovered over */
  hasAltImageOnHover: _propTypes["default"].bool,

  /** Enable energy side drawer when energy rating is clicked */
  hasEnergySideDrawer: _propTypes["default"].bool,

  /** Indicates whether to show Now Was pricing instead of Was Now */
  hasNowWasPricing: _propTypes["default"].bool,

  /** for experiment: Enable more promo messages to open in a dedicated modal */
  hasPromoMessageModal: _propTypes["default"].bool,

  /** for experiment: Enable more promo messages to open in quick view */
  isPromoQuickViewFlagOn: _propTypes["default"].bool,

  /** Enable display of price reduction */
  showPriceReduction: _propTypes["default"].bool,

  /** Add to basket button props */
  atbProps: _propTypes["default"].shape({
    path: _propTypes["default"].string,
    clientId: _propTypes["default"].string.isRequired,
    onSuccess: _propTypes["default"].func,
    onError: _propTypes["default"].func,
    hasHeaderBasketCountEvent: _propTypes["default"].bool,
    hasScreenReaderAnnouncement: _propTypes["default"].bool
  }),
  buttonSettings: _propTypes["default"].shape({
    /** Enable the email when available button */
    hasEmailMeWhenAvailableButton: _propTypes["default"].bool,

    /** Enable the notify me button for future releases */
    hasNotifyMeButton: _propTypes["default"].bool,

    /** Enable the add to basket button */
    hasAddToBasketButton: _propTypes["default"].bool,

    /** Enable the More Information button for complex products */
    hasMoreInformationButton: _propTypes["default"].bool,

    /** Enable Go to your basket button, if the SKU is in found in the cached_basket cookie */
    hasGoToBasketButton: _propTypes["default"].bool,

    /** Enable We'll be in touch button */
    hasBeInTouchButton: _propTypes["default"].bool,

    /** Enable Out of stock button */
    hasOosButton: _propTypes["default"].bool
  }),

  /** Indicates that the Compare feature is available for this product and localStorage can be used */
  hasCompare: _propTypes["default"].bool,

  /** Compare checkbox props */
  compareProps: _propTypes["default"].shape({
    checked: _propTypes["default"].bool,
    disabled: _propTypes["default"].bool,
    onChange: _propTypes["default"].func
  }),

  /** Image settings for sizing and loading */
  imageSettings: _propTypes["default"].shape({
    /** Set the sizes attribute on the product image */
    sizes: _propTypes["default"].string,

    /** Customize the set of widths for the product image srcSet attribute */
    srcSetWidths: _propTypes["default"].arrayOf(_propTypes["default"].string),

    /** Set a custom aspect ratio for the image */
    aspectRatio: _propTypes["default"].number,

    /** The image loading strategy to use */
    loading: _propTypes["default"].oneOf(['eager', 'lazy'])
  }),

  /** Indicates that product card should show Sponsored */
  sponsoredTitleEnabled: _propTypes["default"].bool,

  /** Custom More Information label overwrite */
  moreInformationCustomLabel: _propTypes["default"].string,

  /** Show additional pricing text */
  pricePrefix: _propTypes["default"].string,

  /** Currently displayed variant: { skuId, color, url, colorSwatchUrl, imageUrl, isAvailable } */
  selectedSwatch: colorSwatchType,

  /** Sets <H(1-6)> tag level for the title */
  titleHeaderTagLevel: _propTypes["default"].number,

  /** Custom event handler fired when clicking on any hyperlink within the card */
  handleClick: _propTypes["default"].func,

  /** Custom event handler fired when displaying promo modal */
  handleDisplayPromoModal: _propTypes["default"].func,

  /** Custom event handler fired when energy rating is clicked */
  handleEnergyRatingClick: _propTypes["default"].func,

  /** Custom event handler fired when quick add is opened */
  handleQuickAddClick: _propTypes["default"].func,

  /** Custom event handler fired when quick view is opened (for view more promo messages)*/
  handleQuickViewClick: _propTypes["default"].func,

  /** Custom event handler fired when clicking on any swatch within the card */
  handleSwatchClick: _propTypes["default"].func
};

var _default = exports.Z = /*#__PURE__*/(0, _react.memo)(ALPHA__ProductCardDetailed);

/***/ }),

/***/ 44021:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Carousel = void 0; // New and temporary carousel component for PLP-277 test

var react_1 = __importStar(__webpack_require__(37667));

var Image_1 = __importDefault(__webpack_require__(21914));

var classnames_1 = __importDefault(__webpack_require__(39232));

var carousel_module_scss_1 = __importDefault(__webpack_require__(9066));

var Carousel = function Carousel(_a) {
  var _b;

  var _c = _a.images,
      images = _c === void 0 ? [] : _c,
      width = _a.width,
      _d = _a.initialSlide,
      initialSlide = _d === void 0 ? 0 : _d,
      _e = _a.currentSlide,
      currentSlide = _e === void 0 ? 0 : _e,
      setCurrentSlide = _a.setCurrentSlide,
      _f = _a.showNavigation,
      showNavigation = _f === void 0 ? false : _f,
      url = _a.url,
      imageSettings = _a.imageSettings;
  var carouselElement = (0, react_1.useRef)(null);

  var _g = (0, react_1.useState)(false),
      isAnimating = _g[0],
      setIsAnimating = _g[1];

  var _h = (0, react_1.useState)(false),
      hasLoaded = _h[0],
      setHasLoaded = _h[1];

  var updateCarouselScroll = (0, react_1.useCallback)(function (targetSlide) {
    var carouselElementCurrent = carouselElement.current;
    if (carouselElementCurrent === null) return;

    if (!isAnimating && carouselElementCurrent.scrollLeft !== targetSlide * width) {
      carouselElementCurrent.scrollTo({
        left: targetSlide * width,
        behavior: 'smooth'
      });
      setCurrentSlide(targetSlide);
      setIsAnimating(true);
    }
  }, [isAnimating, setCurrentSlide, width]);
  (0, react_1.useEffect)(function () {
    var carouselElementCurrent = carouselElement.current; // add event listener for  scrollLeft to reach target

    var handleScroll;

    if (isAnimating) {
      handleScroll = carouselElementCurrent.addEventListener('scroll', function () {
        if (currentSlide === 0 && carouselElementCurrent.scrollLeft > 0) {
          return;
        }

        if (carouselElementCurrent.scrollLeft === currentSlide * width) {
          setIsAnimating(false);
        }
      });
    }

    return function () {
      return carouselElementCurrent.removeEventListener('scroll', handleScroll);
    };
  }, [currentSlide, isAnimating, width]);
  (0, react_1.useEffect)(function () {
    if (initialSlide !== 0) {
      var carouselElementCurrent = carouselElement.current;

      if (initialSlide > 1) {
        carouselElementCurrent.scrollTo({
          left: initialSlide * width
        });
      }

      updateCarouselScroll(initialSlide);
    }

    setHasLoaded(true); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var handlePrevImageClick = (0, react_1.useCallback)(function () {
    if (isAnimating) return;
    var targetSlide;

    if (currentSlide > 0) {
      targetSlide = currentSlide - 1;
    } else {
      targetSlide = images.length - 1;
    }

    updateCarouselScroll(targetSlide);
  }, [isAnimating, currentSlide, updateCarouselScroll, images.length]);
  var handleNextImageClick = (0, react_1.useCallback)(function () {
    if (isAnimating) return;
    var targetSlide;

    if (currentSlide < images.length - 1) {
      targetSlide = currentSlide + 1;
    } else {
      targetSlide = 0;
    }

    updateCarouselScroll(targetSlide);
  }, [isAnimating, currentSlide, images.length, updateCarouselScroll]);
  return react_1["default"].createElement(react_1["default"].Fragment, null, react_1["default"].createElement("ul", {
    "data-testid": "carousel",
    className: (0, classnames_1["default"])(carousel_module_scss_1["default"].Carousel, (_b = {}, _b[carousel_module_scss_1["default"]['Carousel--is-active']] = hasLoaded, _b)),
    style: {
      gridTemplateColumns: "repeat(".concat(images.length, ", 1fr)")
    },
    ref: carouselElement,
    role: "group",
    "aria-label": "carousel"
  }, images.map(function (image, index) {
    return react_1["default"].createElement("li", {
      key: 'carouselimage' + index,
      className: carousel_module_scss_1["default"].Carousel_item,
      style: {
        width: width
      }
    }, react_1["default"].createElement(Image_1["default"], __assign({
      className: (0, classnames_1["default"])(carousel_module_scss_1["default"]['c-product-card__image'], 'product__image'),
      image: image,
      url: url,
      hasLoadingSpinner: "true"
    }, imageSettings)));
  })), showNavigation && react_1["default"].createElement(react_1["default"].Fragment, null, react_1["default"].createElement("button", {
    className: carousel_module_scss_1["default"].Carousel_button__prev,
    "data-testid": "prev-button",
    onClick: handlePrevImageClick
  }, react_1["default"].createElement("span", {
    className: carousel_module_scss_1["default"].Carousel_buttonText
  }, "Previous image")), react_1["default"].createElement("button", {
    className: carousel_module_scss_1["default"].Carousel_button__next,
    "data-testid": "next-button",
    onClick: handleNextImageClick
  }, react_1["default"].createElement("span", {
    className: carousel_module_scss_1["default"].Carousel_buttonText
  }, "Next image"))));
};

exports.Carousel = Carousel;

/***/ }),

/***/ 81118:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var _react = _interopRequireWildcard(__webpack_require__(37667));

var _propTypes = _interopRequireDefault(__webpack_require__(45697));

var _classnames = _interopRequireDefault(__webpack_require__(39232));

var _Image = _interopRequireDefault(__webpack_require__(21914));

var _getProductUrl = _interopRequireDefault(__webpack_require__(84225));

var _Title = _interopRequireDefault(__webpack_require__(53845));

var _Sponsored = _interopRequireDefault(__webpack_require__(40475));

var _Price = _interopRequireDefault(__webpack_require__(73850));

var _ProductCardRating = _interopRequireDefault(__webpack_require__(28291));

var _Swatches = _interopRequireDefault(__webpack_require__(52117));

var _PromoMessages = _interopRequireDefault(__webpack_require__(52930));

var _OutOfStock = _interopRequireDefault(__webpack_require__(34036));

var _productCardModule = _interopRequireDefault(__webpack_require__(33095));

var _shouldShowQuickViewButton = __webpack_require__(45211);

var _QuickViewDrawer = __webpack_require__(24446);

var _cachedBasket = __webpack_require__(45384);

var _IconButton = __webpack_require__(2909);

var _Visible24PxOutlined = __webpack_require__(71227);

var _carousel = __webpack_require__(44021);

var _LoadingSpinner = _interopRequireDefault(__webpack_require__(72601));

var _brands = __webpack_require__(70);

var _useEmailConfirmed = __webpack_require__(28464);

var _useWindowSize2 = __webpack_require__(92667);

var _CtaButton = __webpack_require__(55396);

var _PreOrder = _interopRequireDefault(__webpack_require__(88882));

var _EnergyRating = _interopRequireDefault(__webpack_require__(12562));

var _SocialProofMessage = __webpack_require__(95451);

var _jsxRuntime = __webpack_require__(85893);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
      t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}

function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };

  var t = _getRequireWildcardCache(r);

  if (t && t.has(e)) return t.get(e);
  var n = {
    __proto__: null
  },
      a = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var u in e) {
    if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }

  return n["default"] = e, t && t.set(e, n), n;
}

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");

  return "symbol" == _typeof(i) ? i : i + "";
}

function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];

  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return ("string" === r ? String : Number)(t);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];

  if (null != t) {
    var e,
        n,
        i,
        u,
        a = [],
        f = !0,
        o = !1;

    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) {
        ;
      }
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }

    return a;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var defaultCustomerNotifiableEvents = {
  backInStock: false,
  onRelease: false,
  onPreorderLaunch: false,
  newlyInStock: false
};

var ProductCard = function ProductCard(_ref) {
  var _availability$futureA, _availability$preOrde, _energy$rating, _energy$rating2, _energy$rating3, _energy$rating4, _availability$futureA2, _availability$preOrde2;

  var product = _ref.product,
      _ref$buttonSettings = _ref.buttonSettings,
      buttonSettings = _ref$buttonSettings === void 0 ? {} : _ref$buttonSettings,
      _ref$hasAltImageOnHov = _ref.hasAltImageOnHover,
      hasAltImageOnHover = _ref$hasAltImageOnHov === void 0 ? false : _ref$hasAltImageOnHov,
      _ref$hasBrandedTitle = _ref.hasBrandedTitle,
      hasBrandedTitle = _ref$hasBrandedTitle === void 0 ? false : _ref$hasBrandedTitle,
      _ref$hasEnergySideDra = _ref.hasEnergySideDrawer,
      hasEnergySideDrawer = _ref$hasEnergySideDra === void 0 ? false : _ref$hasEnergySideDra,
      _ref$hasImageCarousel = _ref.hasImageCarousel,
      hasImageCarousel = _ref$hasImageCarousel === void 0 ? false : _ref$hasImageCarousel,
      _ref$hasCarouselAltSt = _ref.hasCarouselAltStart,
      hasCarouselAltStart = _ref$hasCarouselAltSt === void 0 ? false : _ref$hasCarouselAltSt,
      _ref$hasNowWasPricing = _ref.hasNowWasPricing,
      hasNowWasPricing = _ref$hasNowWasPricing === void 0 ? false : _ref$hasNowWasPricing,
      _ref$hasPromoMessageM = _ref.hasPromoMessageModal,
      hasPromoMessageModal = _ref$hasPromoMessageM === void 0 ? false : _ref$hasPromoMessageM,
      _ref$hasShortCtaText = _ref.hasShortCtaText,
      hasShortCtaText = _ref$hasShortCtaText === void 0 ? false : _ref$hasShortCtaText,
      _ref$hasShortlistView = _ref.hasShortlistView,
      hasShortlistView = _ref$hasShortlistView === void 0 ? false : _ref$hasShortlistView,
      _ref$isPromoQuickView = _ref.isPromoQuickViewFlagOn,
      isPromoQuickViewFlagOn = _ref$isPromoQuickView === void 0 ? false : _ref$isPromoQuickView,
      _ref$isQuickViewIcon = _ref.isQuickViewIcon,
      isQuickViewIcon = _ref$isQuickViewIcon === void 0 ? false : _ref$isQuickViewIcon,
      _ref$quickViewBundleL = _ref.quickViewBundleLoading,
      quickViewBundleLoading = _ref$quickViewBundleL === void 0 ? false : _ref$quickViewBundleL,
      _ref$showPriceReducti = _ref.showPriceReduction,
      showPriceReduction = _ref$showPriceReducti === void 0 ? false : _ref$showPriceReducti,
      swatchImpressionsHashValue = _ref.swatchImpressionsHashValue,
      _ref$atbProps = _ref.atbProps,
      atbProps = _ref$atbProps === void 0 ? {} : _ref$atbProps,
      children = _ref.children,
      className = _ref.className,
      extraChildren = _ref.extraChildren,
      _ref$imageSettings = _ref.imageSettings,
      imageSettings = _ref$imageSettings === void 0 ? {} : _ref$imageSettings,
      moreInformationCustomLabel = _ref.moreInformationCustomLabel,
      _ref$pricePrefix = _ref.pricePrefix,
      pricePrefix = _ref$pricePrefix === void 0 ? '' : _ref$pricePrefix,
      _ref$selectedSwatch = _ref.selectedSwatch,
      selectedSwatch = _ref$selectedSwatch === void 0 ? {} : _ref$selectedSwatch,
      _ref$sponsoredTitleEn = _ref.sponsoredTitleEnabled,
      sponsoredTitleEnabled = _ref$sponsoredTitleEn === void 0 ? false : _ref$sponsoredTitleEn,
      titleHeaderTagLevel = _ref.titleHeaderTagLevel,
      _ref$socialProofMessa = _ref.socialProofMessage,
      socialProofMessage = _ref$socialProofMessa === void 0 ? null : _ref$socialProofMessa,
      handleClick = _ref.handleClick,
      handleDisplayPromoModal = _ref.handleDisplayPromoModal,
      handleEnergyRatingClick = _ref.handleEnergyRatingClick,
      handleImageChange = _ref.handleImageChange,
      handleQuickAddClick = _ref.handleQuickAddClick,
      handleQuickViewClick = _ref.handleQuickViewClick,
      handleSwatchClickProp = _ref.handleSwatchClick;

  var adId = product.adId,
      alternativeImageUrls = product.alternativeImageUrls,
      availability = product.availability,
      brand = product.brand,
      colorSwatches = product.colorSwatches,
      _product$customerNoti = product.customerNotifiableEvents,
      _product$customerNoti2 = _product$customerNoti === void 0 ? defaultCustomerNotifiableEvents : _product$customerNoti,
      backInStock = _product$customerNoti2.backInStock,
      onRelease = _product$customerNoti2.onRelease,
      onPreorderLaunch = _product$customerNoti2.onPreorderLaunch,
      newlyInStock = _product$customerNoti2.newlyInStock,
      energy = product.energy,
      id = product.id,
      image = product.image,
      outOfStock = product.outOfStock,
      price = product.price,
      _product$promoMessage = product.promoMessages,
      promoMessages = _product$promoMessage === void 0 ? [] : _product$promoMessage,
      rating = product.rating,
      title = product.title,
      url = product.url;

  var isPreorderBackInStock = Boolean(backInStock && outOfStock);
  var isPreOrderable = Boolean((availability === null || availability === void 0 || (_availability$futureA = availability.futureAvailability) === null || _availability$futureA === void 0 ? void 0 : _availability$futureA.availableToOrderFromMessage) || (availability === null || availability === void 0 || (_availability$preOrde = availability.preOrder) === null || _availability$preOrde === void 0 ? void 0 : _availability$preOrde.streetDateMessage));
  var isFutureRelease = Boolean(isPreorderBackInStock || onRelease || onPreorderLaunch || newlyInStock || isPreOrderable);
  var hasEmailMeWhenAvailableButton = buttonSettings.hasEmailMeWhenAvailableButton,
      _buttonSettings$hasQu = buttonSettings.hasQuickViewButton,
      hasQuickViewButton = _buttonSettings$hasQu === void 0 ? true : _buttonSettings$hasQu,
      _buttonSettings$hasCt = buttonSettings.hasCtaButton,
      hasCtaButton = _buttonSettings$hasCt === void 0 ? true : _buttonSettings$hasCt;
  var emailConfirmed = (0, _useEmailConfirmed.useEmailConfirmed)(hasEmailMeWhenAvailableButton, id);

  var _useWindowSize = (0, _useWindowSize2.useWindowSize)(),
      isMaxMobileSize = _useWindowSize.isMaxMobileSize;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      swatchOverride = _useState2[0],
      setSwatchOverride = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isQvIconLoading = _useState4[0],
      setIsQvIconLoading = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isQvDrawerForcedClosed = _useState6[0],
      setIsQvDrawerForcedClosed = _useState6[1];

  var _useState7 = (0, _react.useState)(null),
      _useState8 = _slicedToArray(_useState7, 2),
      imageHeight = _useState8[0],
      setImageHeight = _useState8[1];

  var _useState9 = (0, _react.useState)(null),
      _useState10 = _slicedToArray(_useState9, 2),
      imageWidth = _useState10[0],
      setImageWidth = _useState10[1]; // PLP-277 temporary carousel state. Can be removed or replaced when /product-card/TEMP-carousel is retired.


  var _useState11 = (0, _react.useState)(0),
      _useState12 = _slicedToArray(_useState11, 2),
      currentCarouselSlide = _useState12[0],
      setCurrentCarouselSlide = _useState12[1];

  var initialSlideNumber = hasCarouselAltStart ? 1 : 0;

  var _useState13 = (0, _react.useState)(initialSlideNumber),
      _useState14 = _slicedToArray(_useState13, 2),
      initialCarouselSlide = _useState14[0],
      setInitialCarouselSlide = _useState14[1];

  var _useState15 = (0, _react.useState)(false),
      _useState16 = _slicedToArray(_useState15, 2),
      showCarousel = _useState16[0],
      setShowCarousel = _useState16[1];

  var _useState17 = (0, _react.useState)(true),
      _useState18 = _slicedToArray(_useState17, 2),
      showCarouselNavigation = _useState18[0],
      setShowCarouselNavigation = _useState18[1];

  var cachedBasket = (0, _cachedBasket.useCachedBasketData)();
  var isAddedToBasket = cachedBasket.products.some(function (p) {
    return p.productId === id;
  });
  var isAnyday = (0, _brands.isAnydayBrand)(brand);
  var isMidTier = (0, _brands.isMidTierBrand)(brand);
  var productCardElement = (0, _react.useRef)();
  var productUrl = swatchOverride ? (0, _getProductUrl["default"])(title, id, swatchOverride, adId) : url || (0, _getProductUrl["default"])(title, id, selectedSwatch, adId);
  var hasCarousel = hasImageCarousel && !isMaxMobileSize && (alternativeImageUrls === null || alternativeImageUrls === void 0 ? void 0 : alternativeImageUrls.length) > 0;
  var hasQuickViewIconButton = (0, _shouldShowQuickViewButton.shouldShowQuickViewButton)(product) && isQuickViewIcon;
  var updateImageSize = (0, _react.useCallback)(function () {
    var _productCardElement$c;

    var elementWidth = (_productCardElement$c = productCardElement.current) === null || _productCardElement$c === void 0 ? void 0 : _productCardElement$c.offsetWidth;
    setImageWidth(elementWidth);
    setImageHeight(elementWidth / 0.75);
  }, [productCardElement, setImageHeight, setImageWidth]);
  (0, _react.useEffect)(function () {
    updateImageSize();
  }, [updateImageSize]);

  var getOverrideSwatch = function getOverrideSwatch(e) {
    var override = colorSwatches.find(function (_ref2) {
      var color = _ref2.color;
      return color === e.currentTarget.title || color + ' - Out of stock' === e.currentTarget.title;
    });
    return override;
  };

  var handleSwatchClick = function handleSwatchClick(e, index) {
    handleSelectedSwatchClick(e);

    if (index > 0) {
      setShowCarousel(false);
    } else {
      setShowCarousel(true);
      setSwatchOverride(null);
    }

    if (handleSwatchClickProp) {
      handleSwatchClickProp(e);
    }
  };

  var handleSelectedSwatchClick = function handleSelectedSwatchClick(e) {
    e.preventDefault();
    var override = getOverrideSwatch(e);

    if (override) {
      setSwatchOverride(override);
      setShowCarousel(false);
      setCurrentCarouselSlide(0);
    }
  };

  var handleEnergyArrowClick = function handleEnergyArrowClick(altText, rating) {
    handleEnergyRatingClick(altText, rating, energy.label, energy.informationSheet, adId, id);
  };

  var handleQuickViewIconClick = function handleQuickViewIconClick(_ref3) {
    var _ref3$shouldScrollToP = _ref3.shouldScrollToPromoMsgs,
        shouldScrollToPromoMsgs = _ref3$shouldScrollToP === void 0 ? false : _ref3$shouldScrollToP;
    setIsQvIconLoading(true);
    var swatchOrder = (colorSwatches || []).map(function (_ref4) {
      var color = _ref4.color;
      return color;
    });
    return Promise.resolve(handleQuickViewClick(id, selectedSwatch.url || (0, _getProductUrl["default"])(title, id, selectedSwatch), swatchOrder, swatchOverride === null || swatchOverride === void 0 ? void 0 : swatchOverride.color, adId, shouldScrollToPromoMsgs)).then(function () {
      setIsQvIconLoading(false);
    });
  };

  var updateMouseState = function updateMouseState(newState) {
    if (showCarousel && newState == false) {
      setInitialCarouselSlide(currentCarouselSlide);
    }

    if (!swatchOverride) {
      setShowCarousel(newState);
    }
  };

  _react["default"].useLayoutEffect(function () {
    window.addEventListener('resize', updateImageSize);
    return function () {
      window.removeEventListener('resize', updateImageSize);
    };
  }, [updateImageSize]);

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("article", {
    ref: productCardElement,
    className: (0, _classnames["default"])(_productCardModule["default"]['c-product-card'], className),
    "data-product-id": id,
    "data-taggstar": "product-card",
    "data-test": "product-card",
    onMouseEnter: function onMouseEnter() {
      updateMouseState(true);
    },
    onMouseLeave: function onMouseLeave() {
      updateMouseState(false);
    },
    children: [socialProofMessage && /*#__PURE__*/(0, _jsxRuntime.jsx)(_SocialProofMessage.SocialProofMessage, {
      message: socialProofMessage
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: (0, _classnames["default"])(_productCardModule["default"]['c-product-card__image-container'], _defineProperty({}, _productCardModule["default"]['c-product-card__image-container--hasCarousel'], hasCarousel)),
      "data-test": "product-image-container",
      children: [hasCarousel && showCarousel && /*#__PURE__*/(0, _jsxRuntime.jsx)(_carousel.Carousel, {
        width: imageWidth,
        height: imageHeight,
        images: [image].concat(_toConsumableArray(alternativeImageUrls)),
        currentSlide: currentCarouselSlide,
        initialSlide: initialCarouselSlide,
        setShowNavigation: setShowCarouselNavigation,
        setCurrentSlide: setCurrentCarouselSlide,
        showNavigation: showCarouselNavigation,
        handleClick: handleClick,
        url: productUrl,
        imageSettings: imageSettings
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Image["default"], _objectSpread({
        className: (0, _classnames["default"])(_productCardModule["default"]['c-product-card__image'], 'product__image'),
        style: {
          width: imageWidth,
          height: imageHeight
        },
        alternativeImageUrls: alternativeImageUrls,
        handleClick: handleClick,
        image: image,
        hasAltImageOnHover: hasAltImageOnHover,
        multipleSwatches: colorSwatches && colorSwatches.length > 1,
        selectedSwatch: swatchOverride || selectedSwatch,
        title: title,
        url: productUrl
      }, imageSettings)), hasQuickViewIconButton && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: _productCardModule["default"]['c-cta-buttons__right'],
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton.IconButton, {
          ariaLabel: "Quick view for ".concat(title),
          className: _productCardModule["default"]['c-cta-buttons--quick-view'],
          "data-test": "icon-quick-view-button",
          IconComponent: _Visible24PxOutlined.Visible24PxOutlinedIcon,
          onClick: handleQuickViewIconClick,
          size: "small",
          submitting: isQvIconLoading || quickViewBundleLoading,
          title: "Quick view"
        })
      }), hasQuickViewButton && !isAddedToBasket && !isQuickViewIcon && /*#__PURE__*/(0, _jsxRuntime.jsx)(_QuickViewDrawer.QuickViewDrawer, {
        className: (0, _classnames["default"])(_productCardModule["default"]['c-product-card__hover-drawer'], _defineProperty({}, _productCardModule["default"]['c-product-card__hover-drawer__force-close'], isQvDrawerForcedClosed)),
        onClick: handleQuickViewClick,
        product: product,
        quickViewBundleLoading: quickViewBundleLoading,
        selectedSwatch: selectedSwatch,
        swatchOrder: (colorSwatches || []).map(function (_ref5) {
          var color = _ref5.color;
          return color;
        }),
        swatchOverride: swatchOverride
      })]
    }), hasCtaButton && /*#__PURE__*/(0, _jsxRuntime.jsx)(_CtaButton.CtaButton, _objectSpread(_objectSpread({}, buttonSettings), {}, {
      atbProps: atbProps,
      className: _productCardModule["default"]['c-product-card__cta'],
      emailConfirmed: emailConfirmed,
      handleQuickAddClick: handleQuickAddClick,
      handleQuickViewClick: handleQuickViewClick,
      hasShortCtaText: hasShortCtaText,
      isAddedToBasket: isAddedToBasket,
      moreInformationCustomLabel: moreInformationCustomLabel,
      product: product,
      productUrl: productUrl,
      quickViewBundleLoading: quickViewBundleLoading,
      selectedSwatch: selectedSwatch,
      showViewOptions: hasShortlistView,
      swatchOrder: (colorSwatches || []).map(function (_ref6) {
        var color = _ref6.color;
        return color;
      }),
      swatchOverride: swatchOverride
    })), extraChildren && /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
      children: extraChildren
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: _productCardModule["default"]['c-product-card__product-details'],
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
        className: _productCardModule["default"]['c-product-card__link'],
        href: productUrl,
        onClick: handleClick,
        tabIndex: 0,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: (0, _classnames["default"])(_productCardModule["default"]['c-product-card__title'], _defineProperty(_defineProperty({}, _productCardModule["default"]['brand-promise-anyday'], isAnyday), _productCardModule["default"]['brand-promise-mid-tier'], isMidTier)),
          "data-test": "product-title",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Title["default"], {
            brand: isAnyday ? 'Anyday' : brand,
            brandPrefix: isAnyday ? 'John Lewis ' : '',
            headerTagLevel: titleHeaderTagLevel,
            isAnyday: isAnyday,
            isBranded: brand && hasBrandedTitle,
            selectedSwatch: swatchOverride || selectedSwatch,
            title: title
          })
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Sponsored["default"], {
        className: _productCardModule["default"]['c-product-card__sponsored'],
        hasSponsoredTitle: sponsoredTitleEnabled
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Price["default"], {
        brand: brand,
        className: _productCardModule["default"]['c-product-card__section'],
        dataTestPrefix: "product-card",
        isNowWas: hasNowWasPricing,
        price: price,
        pricePrefix: pricePrefix,
        showPriceReduction: showPriceReduction
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ProductCardRating["default"], {
        className: _productCardModule["default"]['c-product-card__section'],
        rating: rating
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_EnergyRating["default"], {
      className: (0, _classnames["default"])(_productCardModule["default"]['c-product-card__section'], _productCardModule["default"].energyRating, _defineProperty({}, _productCardModule["default"].legacy, energy === null || energy === void 0 || (_energy$rating = energy.rating) === null || _energy$rating === void 0 ? void 0 : _energy$rating.legacy)),
      handleEnergyRatingClick: handleEnergyArrowClick,
      hasEnergySideDrawer: hasEnergySideDrawer,
      rating: energy !== null && energy !== void 0 && (_energy$rating2 = energy.rating) !== null && _energy$rating2 !== void 0 && _energy$rating2.legacy ? undefined : energy === null || energy === void 0 || (_energy$rating3 = energy.rating) === null || _energy$rating3 === void 0 ? void 0 : _energy$rating3.value,
      ratingLegacy: energy !== null && energy !== void 0 && (_energy$rating4 = energy.rating) !== null && _energy$rating4 !== void 0 && _energy$rating4.legacy ? energy.rating.value : undefined
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Swatches["default"], {
      baseUrl: productUrl,
      className: _productCardModule["default"]['c-product-card__section'],
      handleClick: handleSwatchClick,
      id: id,
      imageLoading: imageSettings.loading,
      selectedSwatch: swatchOverride || selectedSwatch,
      setIsQvDrawerForcedClosed: setIsQvDrawerForcedClosed,
      swatches: colorSwatches,
      swatchImpressionsHashValue: swatchImpressionsHashValue,
      title: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_PromoMessages["default"], {
      handleDisplayModal: handleDisplayPromoModal,
      handleQuickViewClick: handleQuickViewIconClick,
      hasPromoMessageModal: hasPromoMessageModal,
      hasViewMoreLink: hasShortlistView,
      isPromoQuickViewFlagOn: isPromoQuickViewFlagOn,
      productUrl: productUrl,
      promos: promoMessages,
      title: title,
      wrapperClassName: _productCardModule["default"]['c-product-card__section']
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_PreOrder["default"], {
      availableToOrder: availability === null || availability === void 0 || (_availability$futureA2 = availability.futureAvailability) === null || _availability$futureA2 === void 0 ? void 0 : _availability$futureA2.availableToOrderFromMessage,
      className: _productCardModule["default"]['c-product-card__section'],
      streetDate: availability === null || availability === void 0 || (_availability$preOrde2 = availability.preOrder) === null || _availability$preOrde2 === void 0 ? void 0 : _availability$preOrde2.streetDateMessage
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_OutOfStock["default"], {
      className: (0, _classnames["default"])([_productCardModule["default"]['c-product-card__section']]),
      isFutureRelease: isFutureRelease,
      outOfStock: outOfStock
    }), _react["default"].Children.map(children, function (child) {
      if (child) return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: _productCardModule["default"]['c-product-card__section'],
        "data-test": "product-card-child-item",
        children: child
      });
      return null;
    })]
  });
};

ProductCard.displayName = 'ProductCard';

var colorSwatchType = _propTypes["default"].shape({
  color: _propTypes["default"].string,
  basicColor: _propTypes["default"].string,
  colorSwatchUrl: _propTypes["default"].string,
  imageUrl: _propTypes["default"].string,
  isAvailable: _propTypes["default"].bool,
  skuId: _propTypes["default"].string,
  id: _propTypes["default"].string,
  isColorOfDefaultVariant: _propTypes["default"].bool,
  url: _propTypes["default"].string
});

ProductCard.propTypes = {
  /** Product data */
  product: _propTypes["default"].shape({
    /** Colour variants for product (if you want to show them) */
    colorSwatches: _propTypes["default"].arrayOf(colorSwatchType),

    /** Is the product in store only (eg knives) */
    isInStoreOnly: _propTypes["default"].bool,

    /** Product ID */
    id: _propTypes["default"].string.isRequired,

    /** Main/default product image */
    image: _propTypes["default"].string.isRequired,

    /** Is the product out of stock */
    outOfStock: _propTypes["default"].bool,

    /** Pricing object: { was, then1, then2, now } each a string or a range { from, to } */
    price: _propTypes["default"].shape(_Price["default"].propTypes),

    /** Array of promo messages to display */
    promoMessages: _propTypes["default"].arrayOf(_propTypes["default"].string),

    /** Rating summary: { averageRating, reviews } */
    rating: _propTypes["default"].shape(_ProductCardRating["default"].propTypes),

    /** Product title */
    title: _propTypes["default"].string.isRequired,

    /** Product (default) URL */
    url: _propTypes["default"].string,

    /** Alternative product images */
    alternativeImageUrls: _propTypes["default"].arrayOf(_propTypes["default"].string),

    /** Default SkuId for the product */
    skuId: _propTypes["default"].string,

    /** default variantId for the product */
    variantId: _propTypes["default"].string,

    /** Indicates if a product is a future release */
    customerNotifiableEvents: _propTypes["default"].shape({
      backInStock: _propTypes["default"].bool,
      onRelease: _propTypes["default"].bool,
      onPreorderLaunch: _propTypes["default"].bool,
      newlyInStock: _propTypes["default"].bool
    }),

    /** Indicates if a product is preorderable */
    availability: _propTypes["default"].shape({
      futureAvailability: _propTypes["default"].shape({
        availableToOrderFromMessage: _propTypes["default"].string
      }),
      preOrder: _propTypes["default"].shape({
        streetDateMessage: _propTypes["default"].string
      })
    }),

    /** Is this a multisku product */
    isMultiSku: _propTypes["default"].bool,
    type: _propTypes["default"].string,
    isMadeToMeasure: _propTypes["default"].bool,
    isFabricByLength: _propTypes["default"].bool
  }).isRequired,

  /** Currently displayed variant: { skuId, color, url, colorSwatchUrl, imageUrl, isAvailable } */
  selectedSwatch: colorSwatchType,
  buttonSettings: _propTypes["default"].shape({
    /** Enable the quickview button */
    hasQuickViewButton: _propTypes["default"].bool,

    /** Enable the email when available button */
    hasEmailMeWhenAvailableButton: _propTypes["default"].bool,

    /** Enable the notify me button for future releases */
    hasNotifyMeButton: _propTypes["default"].bool,

    /** Enable the add to basket button */
    hasAddToBasketButton: _propTypes["default"].bool,

    /** Enable the More Information button for complex products */
    hasMoreInformationButton: _propTypes["default"].bool,

    /** Enable Go to your basket button, if the SKU is in found in the cached_basket cookie */
    hasGoToBasketButton: _propTypes["default"].bool,

    /** Enable We'll be in touch button */
    hasBeInTouchButton: _propTypes["default"].bool,

    /** Enable Out of stock button */
    hasOosButton: _propTypes["default"].bool
  }),

  /** Custom More Information label overwrite */
  moreInformationCustomLabel: _propTypes["default"].string,

  /** Custom event handler fired when clicking on any hyperlink within the card */
  handleClick: _propTypes["default"].func,

  /** Optional flag to use short CTA texts */
  hasShortCtaText: _propTypes["default"].bool,

  /** Optional flag to use in shortlist modal view */
  hasShortlistView: _propTypes["default"].bool,

  /** Optional property to render Social Proof Message */
  socialProofMessage: _propTypes["default"].string,
  handleQuickViewClick: _propTypes["default"].func,

  /** Section to pass extra child content */
  extraChildren: _propTypes["default"].node,

  /** Show additional pricing text */
  pricePrefix: _propTypes["default"].string,

  /** Image settings for sizing and loading */
  imageSettings: _propTypes["default"].shape({
    /** Set the sizes attribute on the product image */
    sizes: _propTypes["default"].string,

    /** Customize the set of widths for the product image srcSet attribute */
    srcSetWidths: _propTypes["default"].arrayOf(_propTypes["default"].string),

    /** Set a custom aspect ratio for the image */
    aspectRatio: _propTypes["default"].number,

    /** The image loading strategy to use */
    loading: _propTypes["default"].oneOf(['eager', 'lazy'])
  }),

  /** Add to basket button props */
  atbProps: _propTypes["default"].shape({
    path: _propTypes["default"].string,
    clientId: _propTypes["default"].string.isRequired,
    onSuccess: _propTypes["default"].func,
    onError: _propTypes["default"].func,
    hasHeaderBasketCountEvent: _propTypes["default"].bool,
    hasScreenReaderAnnouncement: _propTypes["default"].bool
  }),

  /** Indicates that product card should show Sponsored */
  sponsoredTitleEnabled: _propTypes["default"].bool,

  /** Custom event handler fired when clicking on any swatch within the card */
  handleSwatchClick: _propTypes["default"].func,

  /** QuickView bundle is being lazy loaded */
  quickViewBundleLoading: _propTypes["default"].bool,

  /** Indicate whether to try to display first alt image when main image hovered over */
  hasAltImageOnHover: _propTypes["default"].bool,

  /** Displays QV icon */
  isQuickViewIcon: _propTypes["default"].bool,

  /** Displays QV when View more offers button pressed */
  isPromoQuickViewFlagOn: _propTypes["default"].bool,

  /** Custom event handler fired when displaying promo modal */
  handleDisplayPromoModal: _propTypes["default"].func,
  swatchImpressionsHashValue: _propTypes["default"].string,

  /** Sets <H(1-6)> tag level for the title */
  titleHeaderTagLevel: _propTypes["default"].number,

  /** Indicates whether to show Now Was pricing instead of Was Now */
  hasNowWasPricing: _propTypes["default"].bool
};

var _default = exports.Z = /*#__PURE__*/(0, _react.memo)(ProductCard);

/***/ }),

/***/ 80194:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(37667));

var _propTypes = _interopRequireDefault(__webpack_require__(45697));

var _classnames = _interopRequireDefault(__webpack_require__(39232));

var _additionalMessagesModule = _interopRequireDefault(__webpack_require__(76267));

var _jsxRuntime = __webpack_require__(85893);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
      t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}

function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };

  var t = _getRequireWildcardCache(r);

  if (t && t.has(e)) return t.get(e);
  var n = {
    __proto__: null
  },
      a = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var u in e) {
    if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }

  return n["default"] = e, t && t.set(e, n), n;
}

var AdditionalMessages = function AdditionalMessages(_ref) {
  var _ref$messages = _ref.messages,
      messages = _ref$messages === void 0 ? [] : _ref$messages,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? undefined : _ref$className;

  if (!messages || !messages.length) {
    return null;
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: (0, _classnames["default"])(className),
    "data-test": "additional-messages",
    children: messages.map(function (message) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        className: (0, _classnames["default"])(_additionalMessagesModule["default"]['additional-message']),
        children: message
      }, message);
    })
  });
};

AdditionalMessages.propTypes = {
  messages: _propTypes["default"].arrayOf(_propTypes["default"].string),
  className: _propTypes["default"].string
};

var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(AdditionalMessages);

/***/ }),

/***/ 55396:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.CtaButton = void 0;

var _react = _interopRequireWildcard(__webpack_require__(37667));

var _Button = __webpack_require__(73087);

var _AddToBasketButton = _interopRequireDefault(__webpack_require__(87979));

var _classnames = _interopRequireDefault(__webpack_require__(39232));

var _getProductUrl = _interopRequireDefault(__webpack_require__(84225));

var _OpenMiniBasket = __webpack_require__(11217);

var _basket = __webpack_require__(16088);

var _ctaButtonModule = _interopRequireDefault(__webpack_require__(40656));

var _displayLogic = __webpack_require__(28303);

var _jsxRuntime = __webpack_require__(85893);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
      t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}

function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };

  var t = _getRequireWildcardCache(r);

  if (t && t.has(e)) return t.get(e);
  var n = {
    __proto__: null
  },
      a = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var u in e) {
    if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }

  return n["default"] = e, t && t.set(e, n), n;
}

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");

  return "symbol" == _typeof(i) ? i : i + "";
}

function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];

  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return ("string" === r ? String : Number)(t);
}

function _regeneratorRuntime() {
  "use strict";
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */

  _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  };

  var t,
      e = {},
      r = Object.prototype,
      n = r.hasOwnProperty,
      o = Object.defineProperty || function (t, e, r) {
    t[e] = r.value;
  },
      i = "function" == typeof Symbol ? Symbol : {},
      a = i.iterator || "@@iterator",
      c = i.asyncIterator || "@@asyncIterator",
      u = i.toStringTag || "@@toStringTag";

  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }

  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }

  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
        a = Object.create(i.prototype),
        c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }

  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }

  e.wrap = wrap;
  var h = "suspendedStart",
      l = "suspendedYield",
      f = "executing",
      s = "completed",
      y = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
      v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);

  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }

  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);

      if ("throw" !== c.type) {
        var u = c.arg,
            h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }

      a(c.arg);
    }

    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }

        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }

  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw Error("Generator is already running");

      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }

      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;

        if (c) {
          var u = maybeInvokeDelegate(c, n);

          if (u) {
            if (u === y) continue;
            return u;
          }
        }

        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);

        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }

        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }

  function maybeInvokeDelegate(e, r) {
    var n = r.method,
        o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }

  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }

  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }

  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }

  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;

      if (!isNaN(e.length)) {
        var o = -1,
            i = function next() {
          for (; ++o < e.length;) {
            if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
          }

          return next.value = t, next.done = !0, next;
        };

        return i.next = i;
      }
    }

    throw new TypeError(_typeof(e) + " is not iterable");
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
        r = [];

    for (var n in e) {
      r.push(n);
    }

    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }

      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) {
        "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
      }
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;

      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }

      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
            a = i.completion;
        if ("root" === i.tryLoc) return handle("end");

        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
              u = n.call(i, "finallyLoc");

          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];

        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }

      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];

        if (r.tryLoc === t) {
          var n = r.completion;

          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }

          return o;
        }
      }

      throw Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];

  if (null != t) {
    var e,
        n,
        i,
        u,
        a = [],
        f = !0,
        o = !1;

    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) {
        ;
      }
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }

    return a;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var CtaButton = exports.CtaButton = function CtaButton(_ref) {
  var product = _ref.product,
      className = _ref.className,
      _ref$hasAddToBasketBu = _ref.hasAddToBasketButton,
      hasAddToBasketButton = _ref$hasAddToBasketBu === void 0 ? true : _ref$hasAddToBasketBu,
      _ref$hasEmailMeWhenAv = _ref.hasEmailMeWhenAvailableButton,
      hasEmailMeWhenAvailableButton = _ref$hasEmailMeWhenAv === void 0 ? true : _ref$hasEmailMeWhenAv,
      _ref$hasMoreInformati = _ref.hasMoreInformationButton,
      hasMoreInformationButton = _ref$hasMoreInformati === void 0 ? true : _ref$hasMoreInformati,
      _ref$hasInStoreOnlyBu = _ref.hasInStoreOnlyButton,
      hasInStoreOnlyButton = _ref$hasInStoreOnlyBu === void 0 ? true : _ref$hasInStoreOnlyBu,
      _ref$hasOosButton = _ref.hasOosButton,
      hasOosButton = _ref$hasOosButton === void 0 ? true : _ref$hasOosButton,
      _ref$hasGoToBasketBut = _ref.hasGoToBasketButton,
      hasGoToBasketButton = _ref$hasGoToBasketBut === void 0 ? true : _ref$hasGoToBasketBut,
      emailConfirmed = _ref.emailConfirmed,
      isAddedToBasket = _ref.isAddedToBasket,
      moreInformationCustomLabel = _ref.moreInformationCustomLabel,
      productUrl = _ref.productUrl,
      hasShortCtaText = _ref.hasShortCtaText,
      handleQuickViewClick = _ref.handleQuickViewClick,
      handleQuickAddClick = _ref.handleQuickAddClick,
      selectedSwatch = _ref.selectedSwatch,
      isListViewOn = _ref.isListViewOn,
      _ref$atbProps = _ref.atbProps,
      atbProps = _ref$atbProps === void 0 ? {} : _ref$atbProps,
      swatchOrder = _ref.swatchOrder,
      swatchOverride = _ref.swatchOverride,
      _ref$quickViewBundleL = _ref.quickViewBundleLoading,
      quickViewBundleLoading = _ref$quickViewBundleL === void 0 ? false : _ref$quickViewBundleL,
      _ref$showViewOptions = _ref.showViewOptions,
      showViewOptions = _ref$showViewOptions === void 0 ? false : _ref$showViewOptions;
  var title = product.title,
      id = product.id,
      skuId = product.skuId,
      variantId = product.variantId,
      isMultiSku = product.isMultiSku,
      adId = product.adId;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  var btnSize = isListViewOn ? 'regular' : 'small';
  var moreInformationLabel = moreInformationCustomLabel ? moreInformationCustomLabel : (product === null || product === void 0 ? void 0 : product.type) === 'productSet' ? 'View range' : 'More information';

  var handleMultiSkuSelection = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setIsLoading(true);
              _context.next = 3;
              return Promise.resolve(window.innerWidth < 768 && handleQuickAddClick ? handleQuickAddClick(id, productUrl, swatchOrder, swatchOverride === null || swatchOverride === void 0 ? void 0 : swatchOverride.color, adId) : handleQuickViewClick(id, selectedSwatch.url || (0, _getProductUrl["default"])(title, id, selectedSwatch), swatchOrder, swatchOverride === null || swatchOverride === void 0 ? void 0 : swatchOverride.color, adId));

            case 3:
              setIsLoading(false);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleMultiSkuSelection() {
      return _ref2.apply(this, arguments);
    };
  }();

  if ((0, _displayLogic.shouldShowViewOptionsButton)(product, showViewOptions)) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Button.SecondaryButton, {
      "data-test": "component-view-option-button",
      className: (0, _classnames["default"])(className, _ctaButtonModule["default"]['cta-button'], _defineProperty({}, _ctaButtonModule["default"]['cta-button--list-view'], isListViewOn)),
      tag: "a",
      href: productUrl,
      submitting: isLoading,
      disabled: isLoading,
      size: btnSize,
      children: ["View options", /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: _ctaButtonModule["default"]['visually-hidden'],
        children: ", ".concat(title)
      })]
    }, "view-options");
  }

  if ((0, _displayLogic.shouldShowInStoreOnly)(product, hasInStoreOnlyButton)) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.PrimaryButton, {
      "data-test": "In Store Only Button",
      className: (0, _classnames["default"])(className, _ctaButtonModule["default"]['cta-button'], _defineProperty({}, _ctaButtonModule["default"]['cta-button--list-view'], isListViewOn)),
      disabled: true,
      tag: "a",
      href: productUrl,
      size: btnSize,
      children: "In-store only"
    }, "in-store-only");
  }

  if ((0, _displayLogic.shouldShowPermanentOOSButton)(product, hasOosButton)) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.PrimaryButton, {
      "data-test": "Out Of Stock Button",
      className: (0, _classnames["default"])(className, _ctaButtonModule["default"]['cta-button'], _defineProperty({}, _ctaButtonModule["default"]['cta-button--list-view'], isListViewOn)),
      disabled: true,
      tag: "a",
      href: productUrl,
      size: btnSize,
      children: "Out of stock"
    }, "oos");
  }

  if ((0, _displayLogic.shouldShowEmwbisButton)(product, hasEmailMeWhenAvailableButton) && !emailConfirmed) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Button.SecondaryButton, {
      "data-test": "component-email-bis-button",
      className: (0, _classnames["default"])(className, _ctaButtonModule["default"]['cta-button'], _defineProperty({}, _ctaButtonModule["default"]['cta-button--list-view'], isListViewOn)),
      onClick: handleMultiSkuSelection,
      submitting: isLoading,
      disabled: isLoading,
      size: btnSize,
      children: ["Email when available", /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: _ctaButtonModule["default"]['visually-hidden'],
        children: ", ".concat(title)
      })]
    }, "email-me");
  }

  if ((0, _displayLogic.shouldShowEmwbisButton)(product, hasEmailMeWhenAvailableButton) && emailConfirmed) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.SecondaryButton, {
      "data-test": "We will be in touch Button",
      className: (0, _classnames["default"])(className, _ctaButtonModule["default"]['cta-button'], _defineProperty({}, _ctaButtonModule["default"]['cta-button--list-view'], isListViewOn)),
      tag: "a",
      href: productUrl,
      size: btnSize,
      children: "We'll be in touch"
    }, "well-be-in-touch");
  }

  if ((0, _displayLogic.shouldShowAddToBasketButton)(product, hasAddToBasketButton) && (!isAddedToBasket || (0, _basket.isBasketPageType)())) {
    return /*#__PURE__*/(0, _react.createElement)(_AddToBasketButton["default"], _objectSpread(_objectSpread({}, atbProps), {}, {
      shortCtaText: hasShortCtaText,
      title: title,
      variantId: variantId,
      skuId: skuId,
      "data-test": atbProps['data-test'] || isMultiSku ? 'multi sku add to basket' : 'add to basket',
      sendToBasket: isMultiSku ? handleMultiSkuSelection : atbProps.sendToBasket,
      className: (0, _classnames["default"])(className, _ctaButtonModule["default"]['cta-button'], _defineProperty({}, _ctaButtonModule["default"]['cta-button--list-view'], isListViewOn)),
      forceLoading: isLoading || isMultiSku && quickViewBundleLoading,
      size: btnSize,
      hasHeaderBasketCountEvent: !isMultiSku,
      key: "atb"
    }));
  }

  if ((0, _displayLogic.shouldShowAddToBasketButton)(product, hasAddToBasketButton) && isAddedToBasket && hasGoToBasketButton && !(0, _basket.isBasketPageType)()) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.SecondaryButton, {
      "data-test": "component-go-to-basket-button",
      className: (0, _classnames["default"])(className, _ctaButtonModule["default"]['cta-button'], _defineProperty({}, _ctaButtonModule["default"]['cta-button--list-view'], isListViewOn)),
      onClick: _OpenMiniBasket.openMiniBasket,
      tag: "a",
      href: "/basket",
      size: btnSize,
      children: "Go to".concat(hasShortCtaText ? '' : ' your', " basket")
    }, "gtb");
  }

  if (hasMoreInformationButton) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Button.SecondaryButton, {
      "data-test": "More Information Button",
      className: (0, _classnames["default"])(className, _ctaButtonModule["default"]['cta-button'], _defineProperty({}, _ctaButtonModule["default"]['cta-button--list-view'], isListViewOn)),
      tag: "a",
      href: productUrl,
      size: btnSize,
      children: [moreInformationLabel, /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: _ctaButtonModule["default"]['visually-hidden'],
        children: ", ".concat(title)
      })]
    }, "more-info");
  }

  return null;
};

/***/ }),

/***/ 28303:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.shouldShowViewOptionsButton = exports.shouldShowPermanentOOSButton = exports.shouldShowInStoreOnly = exports.shouldShowEmwbisButton = exports.shouldShowAddToBasketButton = void 0;

var productHasPrice = function productHasPrice(price) {
  return typeof price === 'string' && price !== '' || (price === null || price === void 0 ? void 0 : price.now) != null && Number(price.now) !== 0;
};

var defaultCustomerNotifiableEvents = {
  backInStock: false,
  onRelease: false,
  onPreorderLaunch: false,
  newlyInStock: false
};

var shouldShowAddToBasketButton = exports.shouldShowAddToBasketButton = function shouldShowAddToBasketButton() {
  var _availability$futureA;

  var product = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var hasButton = arguments.length > 1 ? arguments[1] : undefined;

  var outOfStock = product.outOfStock,
      isInStoreOnly = product.isInStoreOnly,
      type = product.type,
      isMadeToMeasure = product.isMadeToMeasure,
      isFabricByLength = product.isFabricByLength,
      price = product.price,
      availability = product.availability,
      _product$customerNoti = product.customerNotifiableEvents,
      _product$customerNoti2 = _product$customerNoti === void 0 ? defaultCustomerNotifiableEvents : _product$customerNoti,
      backInStock = _product$customerNoti2.backInStock,
      onRelease = _product$customerNoti2.onRelease,
      onPreorderLaunch = _product$customerNoti2.onPreorderLaunch,
      newlyInStock = _product$customerNoti2.newlyInStock;

  var isPreorderBackInStock = backInStock && outOfStock;
  var availableToOrderFromMessage = availability === null || availability === void 0 || (_availability$futureA = availability.futureAvailability) === null || _availability$futureA === void 0 ? void 0 : _availability$futureA.availableToOrderFromMessage;
  var isFutureRelease = isPreorderBackInStock || onRelease || onPreorderLaunch || newlyInStock || availableToOrderFromMessage;

  if (isFutureRelease || outOfStock || isInStoreOnly || type === 'asaf' || isMadeToMeasure || type === 'productSet' || type === 'bundle' || isFabricByLength || !productHasPrice(price) || !hasButton) {
    return false;
  }

  return true;
};

var shouldShowEmwbisButton = exports.shouldShowEmwbisButton = function shouldShowEmwbisButton() {
  var product = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var hasButton = arguments.length > 1 ? arguments[1] : undefined;

  var outOfStock = product.outOfStock,
      isInStoreOnly = product.isInStoreOnly,
      _product$customerNoti3 = product.customerNotifiableEvents,
      _product$customerNoti4 = _product$customerNoti3 === void 0 ? defaultCustomerNotifiableEvents : _product$customerNoti3,
      backInStock = _product$customerNoti4.backInStock,
      onRelease = _product$customerNoti4.onRelease,
      onPreorderLaunch = _product$customerNoti4.onPreorderLaunch,
      newlyInStock = _product$customerNoti4.newlyInStock;

  var isPreorderBackInStock = backInStock && outOfStock;

  if ((isPreorderBackInStock || onPreorderLaunch || onRelease || newlyInStock) && !isInStoreOnly && hasButton) {
    return true;
  }

  return false;
};

var shouldShowInStoreOnly = exports.shouldShowInStoreOnly = function shouldShowInStoreOnly() {
  var product = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var hasButton = arguments.length > 1 ? arguments[1] : undefined;
  var isInStoreOnly = product.isInStoreOnly;

  if (isInStoreOnly && hasButton) {
    return true;
  }

  return false;
};

var shouldShowPermanentOOSButton = exports.shouldShowPermanentOOSButton = function shouldShowPermanentOOSButton(product, hasButton) {
  var _availability$futureA2, _availability$preOrde;

  var outOfStock = product.outOfStock,
      isInStoreOnly = product.isInStoreOnly,
      availability = product.availability,
      _product$customerNoti5 = product.customerNotifiableEvents,
      _product$customerNoti6 = _product$customerNoti5 === void 0 ? defaultCustomerNotifiableEvents : _product$customerNoti5,
      _product$customerNoti7 = _product$customerNoti6.backInStock,
      backInStock = _product$customerNoti7 === void 0 ? false : _product$customerNoti7,
      _product$customerNoti8 = _product$customerNoti6.onRelease,
      onRelease = _product$customerNoti8 === void 0 ? false : _product$customerNoti8,
      _product$customerNoti9 = _product$customerNoti6.onPreorderLaunch,
      onPreorderLaunch = _product$customerNoti9 === void 0 ? false : _product$customerNoti9,
      _product$customerNoti10 = _product$customerNoti6.newlyInStock,
      newlyInStock = _product$customerNoti10 === void 0 ? false : _product$customerNoti10;

  var hasNotifiableEvents = backInStock || onRelease || onPreorderLaunch || newlyInStock;
  var isPreOrderable = (availability === null || availability === void 0 || (_availability$futureA2 = availability.futureAvailability) === null || _availability$futureA2 === void 0 ? void 0 : _availability$futureA2.availableToOrderFromMessage) || (availability === null || availability === void 0 || (_availability$preOrde = availability.preOrder) === null || _availability$preOrde === void 0 ? void 0 : _availability$preOrde.streetDateMessage);

  if (outOfStock && !isPreOrderable && !hasNotifiableEvents && !isInStoreOnly && hasButton) {
    return true;
  }

  return false;
};

var shouldShowViewOptionsButton = exports.shouldShowViewOptionsButton = function shouldShowViewOptionsButton() {
  var product = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var showViewOptions = arguments.length > 1 ? arguments[1] : undefined;
  var outOfStock = product.outOfStock,
      isMultiSku = product.isMultiSku,
      isMadeToMeasure = product.isMadeToMeasure,
      isFabricByLength = product.isFabricByLength;

  if ((outOfStock || isMultiSku || isMadeToMeasure || isFabricByLength) && showViewOptions) {
    return true;
  }

  return false;
};

/***/ }),

/***/ 21914:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(37667));

var _classnames = _interopRequireDefault(__webpack_require__(39232));

var _propTypes = _interopRequireDefault(__webpack_require__(45697));

var _isEmpty = _interopRequireDefault(__webpack_require__(41609));

var _scene7UrlParser = __webpack_require__(29997);

var _imageModule = _interopRequireDefault(__webpack_require__(60534));

var _LoadingSpinner = _interopRequireDefault(__webpack_require__(72601));

var _jsxRuntime = __webpack_require__(85893);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
      t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}

function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };

  var t = _getRequireWildcardCache(r);

  if (t && t.has(e)) return t.get(e);
  var n = {
    __proto__: null
  },
      a = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var u in e) {
    if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }

  return n["default"] = e, t && t.set(e, n), n;
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");

  return "symbol" == _typeof(i) ? i : i + "";
}

function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];

  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return ("string" === r ? String : Number)(t);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];

  if (null != t) {
    var e,
        n,
        i,
        u,
        a = [],
        f = !0,
        o = !1;

    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) {
        ;
      }
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }

    return a;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var Image = function Image(_ref) {
  var _ref$alternativeImage = _ref.alternativeImageUrls,
      alternativeImageUrls = _ref$alternativeImage === void 0 ? [] : _ref$alternativeImage,
      _ref$aspectRatio = _ref.aspectRatio,
      aspectRatio = _ref$aspectRatio === void 0 ? 0.75 : _ref$aspectRatio,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? undefined : _ref$className,
      _ref$handleClick = _ref.handleClick,
      handleClick = _ref$handleClick === void 0 ? function () {} : _ref$handleClick,
      _ref$hasAltImageOnHov = _ref.hasAltImageOnHover,
      hasAltImageOnHover = _ref$hasAltImageOnHov === void 0 ? false : _ref$hasAltImageOnHov,
      _ref$image = _ref.image,
      image = _ref$image === void 0 ? '' : _ref$image,
      _ref$imageRef = _ref.imageRef,
      imageRef = _ref$imageRef === void 0 ? undefined : _ref$imageRef,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? 'lazy' : _ref$loading,
      _ref$multipleSwatches = _ref.multipleSwatches,
      multipleSwatches = _ref$multipleSwatches === void 0 ? false : _ref$multipleSwatches,
      _ref$selectedSwatch = _ref.selectedSwatch,
      selectedSwatch = _ref$selectedSwatch === void 0 ? {} : _ref$selectedSwatch,
      _ref$sizes = _ref.sizes,
      sizes = _ref$sizes === void 0 ? '(max-width: 567px) 50vw, (min-width: 568px) and (max-width:768px) 33vw, 20vw' : _ref$sizes,
      _ref$srcSetWidths = _ref.srcSetWidths,
      srcSetWidths = _ref$srcSetWidths === void 0 ? ['160', '320', '540'] : _ref$srcSetWidths,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title,
      _ref$url = _ref.url,
      url = _ref$url === void 0 ? '' : _ref$url,
      _ref$hasLoadingSpinne = _ref.hasLoadingSpinner,
      hasLoadingSpinner = _ref$hasLoadingSpinne === void 0 ? false : _ref$hasLoadingSpinne;
  var imageUrl = multipleSwatches && selectedSwatch !== null && selectedSwatch !== void 0 && selectedSwatch.imageUrl ? selectedSwatch.imageUrl : image;
  var hasAlternativeImages = (alternativeImageUrls === null || alternativeImageUrls === void 0 ? void 0 : alternativeImageUrls.length) > 0 && ((0, _isEmpty["default"])(selectedSwatch) || (selectedSwatch === null || selectedSwatch === void 0 ? void 0 : selectedSwatch.imageUrl) === image);

  var _useState = (0, _react.useState)(true),
      _useState2 = _slicedToArray(_useState, 2),
      showLoadingSpinner = _useState2[0],
      setShowLoadingSpinner = _useState2[1];

  var isAltImageOnHoverEnabled = hasAltImageOnHover && hasAlternativeImages;

  var determineSrcSetArr = function determineSrcSetArr(urlOfImage) {
    return srcSetWidths.map(function (width) {
      return "".concat((0, _scene7UrlParser.setScene7UrlQueryParams)(urlOfImage, {
        wid: width,
        hei: Math.round(width / aspectRatio)
      }), " ").concat(width, "w");
    });
  };

  var srcSetArr = determineSrcSetArr(imageUrl);
  var altImageSrcSetArr = hasAlternativeImages ? determineSrcSetArr(alternativeImageUrls[0]) : [];
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("a", {
    className: (0, _classnames["default"])(_imageModule["default"].imageLink, className),
    href: url,
    tabIndex: "-1",
    "aria-hidden": "true",
    onClick: handleClick,
    children: [hasLoadingSpinner && showLoadingSpinner && /*#__PURE__*/(0, _jsxRuntime.jsx)(_LoadingSpinner["default"], {
      className: _imageModule["default"].loadingSpinner
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
      className: (0, _classnames["default"])(_imageModule["default"].image, _defineProperty({}, _imageModule["default"]['image--isLoading'], hasLoadingSpinner && showLoadingSpinner)),
      width: "250",
      height: Math.round(250 / aspectRatio),
      src: srcSetArr[0].split(' ')[0],
      alt: selectedSwatch !== null && selectedSwatch !== void 0 && selectedSwatch.color ? "".concat(title, ", ").concat(selectedSwatch.color) : title,
      srcSet: srcSetArr.join(', '),
      sizes: sizes,
      ref: imageRef,
      loading: loading,
      "data-test": "product-card-image",
      onLoad: hasLoadingSpinner ? function () {
        setShowLoadingSpinner(false);
      } : null
    }), isAltImageOnHoverEnabled ? /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
      className: (0, _classnames["default"])(_imageModule["default"].altImage),
      width: "250",
      height: Math.round(250 / aspectRatio),
      src: altImageSrcSetArr[0].split(' ')[0],
      alt: selectedSwatch !== null && selectedSwatch !== void 0 && selectedSwatch.color ? "".concat(title, ", ").concat(selectedSwatch.color) : title,
      srcSet: altImageSrcSetArr.join(', '),
      sizes: sizes,
      loading: loading,
      "data-test": "product-card-alt-image"
    }) : null]
  });
};

Image.propTypes = {
  alternativeImageUrls: _propTypes["default"].arrayOf(_propTypes["default"].string),
  aspectRatio: _propTypes["default"].number,
  className: _propTypes["default"].string,
  handleClick: _propTypes["default"].func,
  hasAltImageOnHover: _propTypes["default"].bool,
  image: _propTypes["default"].string,
  loading: _propTypes["default"].oneOf(['eager', 'lazy']),
  multipleSwatches: _propTypes["default"].bool,
  selectedSwatch: _propTypes["default"].shape({
    color: _propTypes["default"].string,
    basicColor: _propTypes["default"].string,
    colorSwatchUrl: _propTypes["default"].string,
    imageUrl: _propTypes["default"].string,
    isAvailable: _propTypes["default"].bool,
    skuId: _propTypes["default"].string,
    id: _propTypes["default"].string,
    isColorOfDefaultVariant: _propTypes["default"].bool,
    url: _propTypes["default"].string
  }),
  sizes: _propTypes["default"].string,
  srcSetWidths: _propTypes["default"].arrayOf(_propTypes["default"].string),
  title: _propTypes["default"].string,
  url: _propTypes["default"].string
};

var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(Image);

/***/ }),

/***/ 34036:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(37667));

var _propTypes = _interopRequireDefault(__webpack_require__(45697));

var _classnames2 = _interopRequireDefault(__webpack_require__(39232));

var _outOfStockModule = _interopRequireDefault(__webpack_require__(98106));

var _jsxRuntime = __webpack_require__(85893);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
      t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}

function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };

  var t = _getRequireWildcardCache(r);

  if (t && t.has(e)) return t.get(e);
  var n = {
    __proto__: null
  },
      a = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var u in e) {
    if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }

  return n["default"] = e, t && t.set(e, n), n;
}

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");

  return "symbol" == _typeof(i) ? i : i + "";
}

function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];

  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return ("string" === r ? String : Number)(t);
}

var OutOfStock = function OutOfStock(_ref) {
  var _ref$outOfStock = _ref.outOfStock,
      outOfStock = _ref$outOfStock === void 0 ? false : _ref$outOfStock,
      _ref$isFutureRelease = _ref.isFutureRelease,
      isFutureRelease = _ref$isFutureRelease === void 0 ? false : _ref$isFutureRelease,
      _ref$isListView = _ref.isListView,
      isListView = _ref$isListView === void 0 ? false : _ref$isListView,
      className = _ref.className;

  if (!outOfStock || isFutureRelease) {
    return null;
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
    "data-test": "out-of-stock",
    className: (0, _classnames2["default"])(className, _outOfStockModule["default"]['out-of-stock'], _defineProperty({}, _outOfStockModule["default"]['out-of-stock--list-view'], isListView)),
    children: "Out of stock"
  });
};

OutOfStock.propTypes = {
  outOfStock: _propTypes["default"].bool,
  isListView: _propTypes["default"].bool,
  isFutureRelease: _propTypes["default"].bool
};

var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(OutOfStock);

/***/ }),

/***/ 88882:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(37667));

var _propTypes = _interopRequireDefault(__webpack_require__(45697));

var _classnames = _interopRequireDefault(__webpack_require__(39232));

var _preOrderModule = _interopRequireDefault(__webpack_require__(46219));

var _jsxRuntime = __webpack_require__(85893);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
      t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}

function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };

  var t = _getRequireWildcardCache(r);

  if (t && t.has(e)) return t.get(e);
  var n = {
    __proto__: null
  },
      a = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var u in e) {
    if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }

  return n["default"] = e, t && t.set(e, n), n;
}

var PreOrder = function PreOrder(_ref) {
  var _ref$availableToOrder = _ref.availableToOrder,
      availableToOrder = _ref$availableToOrder === void 0 ? '' : _ref$availableToOrder,
      _ref$streetDate = _ref.streetDate,
      streetDate = _ref$streetDate === void 0 ? '' : _ref$streetDate,
      className = _ref.className;

  if (!availableToOrder && !streetDate) {
    return null;
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [availableToOrder && /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      "data-test": "availableToOrder-message",
      className: (0, _classnames["default"])(className, _preOrderModule["default"]['pre-order']),
      children: availableToOrder
    }), streetDate && /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      "data-test": "streetDate-message",
      className: (0, _classnames["default"])(className, _preOrderModule["default"]['pre-order']),
      children: streetDate
    })]
  });
};

PreOrder.propTypes = {
  availableToOrder: _propTypes["default"].string,
  streetDate: _propTypes["default"].string,
  classname: _propTypes["default"].string
};

var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(PreOrder);

/***/ }),

/***/ 52930:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(37667));

var _classnames = _interopRequireDefault(__webpack_require__(39232));

var _propTypes = _interopRequireDefault(__webpack_require__(45697));

var _SaleTag24PxFilledRed = _interopRequireDefault(__webpack_require__(24241));

var _promoMessagesModule = _interopRequireDefault(__webpack_require__(69884));

var _jsxRuntime = __webpack_require__(85893);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
      t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}

function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };

  var t = _getRequireWildcardCache(r);

  if (t && t.has(e)) return t.get(e);
  var n = {
    __proto__: null
  },
      a = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var u in e) {
    if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }

  return n["default"] = e, t && t.set(e, n), n;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];

  if (null != t) {
    var e,
        n,
        i,
        u,
        a = [],
        f = !0,
        o = !1;

    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) {
        ;
      }
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }

    return a;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var PromoMessages = function PromoMessages(_ref) {
  var _ref$handleDisplayMod = _ref.handleDisplayModal,
      handleDisplayModal = _ref$handleDisplayMod === void 0 ? undefined : _ref$handleDisplayMod,
      _ref$handleQuickViewC = _ref.handleQuickViewClick,
      handleQuickViewClick = _ref$handleQuickViewC === void 0 ? undefined : _ref$handleQuickViewC,
      _ref$hasPromoMessageM = _ref.hasPromoMessageModal,
      hasPromoMessageModal = _ref$hasPromoMessageM === void 0 ? false : _ref$hasPromoMessageM,
      _ref$isPromoQuickView = _ref.isPromoQuickViewFlagOn,
      isPromoQuickViewFlagOn = _ref$isPromoQuickView === void 0 ? false : _ref$isPromoQuickView,
      productUrl = _ref.productUrl,
      _ref$promos = _ref.promos,
      promos = _ref$promos === void 0 ? [] : _ref$promos,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title,
      _ref$wrapperClassName = _ref.wrapperClassName,
      wrapperClassName = _ref$wrapperClassName === void 0 ? undefined : _ref$wrapperClassName;

  var _useState = (0, _react.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      modalContent = _useState2[0],
      setModalContent = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      isLoading = _useState4[0],
      setIsLoading = _useState4[1];

  if (!promos || !promos.length) {
    return null;
  }

  var hideModal = function hideModal() {
    setModalContent();
    setIsLoading(false);
  };

  var showModal = function showModal() {
    setIsLoading(true);

    if (isPromoQuickViewFlagOn && handleQuickViewClick) {
      handleQuickViewClick({
        shouldScrollToPromoMsgs: true
      }).then(function () {
        setIsLoading(false);
        handleDisplayModal && handleDisplayModal();
      });
    } else {
      Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(5216));
      }).then(function (_ref2) {
        var PromoModal = _ref2.PromoModal;
        setModalContent( /*#__PURE__*/(0, _jsxRuntime.jsx)(PromoModal, {
          onClose: hideModal,
          promos: promos,
          productUrl: productUrl
        }));
        setIsLoading(false);
        handleDisplayModal && handleDisplayModal();
      });
    }
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    "data-test": "product-card-promo-messages",
    className: (0, _classnames["default"])(wrapperClassName),
    children: hasPromoMessageModal && promos.length > 1 ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        "data-test": "product-card-promo-message",
        className: _promoMessagesModule["default"].promo,
        children: promos[0]
      }, promos[0]), /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
        onClick: showModal,
        className: (0, _classnames["default"])(_promoMessagesModule["default"].offers),
        disabled: isLoading,
        "data-test": "product-card-promo-message-button",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: _promoMessagesModule["default"].offerTag,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SaleTag24PxFilledRed["default"], {})
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
          className: (0, _classnames["default"])(_promoMessagesModule["default"].underline),
          children: ["View offers", title && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: _promoMessagesModule["default"].visuallyHidden,
            children: " for ".concat(title)
          })]
        })]
      }), modalContent]
    }) : promos.map(function (promo) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        "data-test": "product-card-promo-message",
        className: _promoMessagesModule["default"].promo,
        children: promo
      }, promo);
    })
  });
};

PromoMessages.propTypes = {
  handleDisplayModal: _propTypes["default"].func,
  handleQuickViewClick: _propTypes["default"].func,
  hasPromoMessageModal: _propTypes["default"].bool,
  isPromoQuickViewFlagOn: _propTypes["default"].bool,
  promos: _propTypes["default"].arrayOf(_propTypes["default"].string),
  title: _propTypes["default"].string,
  wrapperClassName: _propTypes["default"].string
};

var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(PromoMessages);

/***/ }),

/***/ 5216:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.PromoModal = void 0;

var _react = _interopRequireDefault(__webpack_require__(37667));

var _Modal = _interopRequireDefault(__webpack_require__(86314));

var _Button = __webpack_require__(73087);

var _noScroll = __webpack_require__(13076);

var _promoMessagesModule = _interopRequireDefault(__webpack_require__(69884));

var _jsxRuntime = __webpack_require__(85893);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var PromoModal = exports.PromoModal = function PromoModal(_ref) {
  var onClose = _ref.onClose,
      promos = _ref.promos,
      productUrl = _ref.productUrl;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Modal["default"], {
    isOpen: true,
    header: "Offers",
    onClose: onClose,
    className: _promoMessagesModule["default"]['promo__modal'],
    headerTitleClassName: _promoMessagesModule["default"]['promo__modal-title'],
    headerStyleModifier: _promoMessagesModule["default"]['promo__modal-header'],
    closeButtonClassName: _promoMessagesModule["default"]['promo__modal-close'],
    children: [promos.map(function (promo) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        "data-test": "product-card-promo-message",
        className: _promoMessagesModule["default"]['promo--plain'],
        children: promo
      }, promo);
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.UnderlinedButton, {
      href: productUrl,
      tag: "a",
      onClick: function onClick() {
        return (0, _noScroll.setNoScroll)(false);
      },
      children: "View full product information"
    })]
  });
};

/***/ }),

/***/ 24446:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.QuickViewDrawer = void 0;

var _react = _interopRequireWildcard(__webpack_require__(37667));

var _Button = __webpack_require__(73087);

var _classnames = _interopRequireDefault(__webpack_require__(39232));

var _getProductUrl = _interopRequireDefault(__webpack_require__(84225));

var _quickViewDrawerModule = _interopRequireDefault(__webpack_require__(38137));

var _shouldShowQuickViewButton = __webpack_require__(45211);

var _jsxRuntime = __webpack_require__(85893);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
      t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}

function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };

  var t = _getRequireWildcardCache(r);

  if (t && t.has(e)) return t.get(e);
  var n = {
    __proto__: null
  },
      a = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var u in e) {
    if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }

  return n["default"] = e, t && t.set(e, n), n;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];

  if (null != t) {
    var e,
        n,
        i,
        u,
        a = [],
        f = !0,
        o = !1;

    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) {
        ;
      }
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }

    return a;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var QuickViewDrawer = exports.QuickViewDrawer = function QuickViewDrawer(_ref) {
  var product = _ref.product,
      onClick = _ref.onClick,
      selectedSwatch = _ref.selectedSwatch,
      swatchOrder = _ref.swatchOrder,
      swatchOverride = _ref.swatchOverride,
      _ref$quickViewBundleL = _ref.quickViewBundleLoading,
      quickViewBundleLoading = _ref$quickViewBundleL === void 0 ? false : _ref$quickViewBundleL,
      className = _ref.className;
  var title = product.title,
      id = product.id;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var handleClick = function handleClick() {
    setLoading(true);
    return Promise.resolve(onClick(id, selectedSwatch.url || (0, _getProductUrl["default"])(title, id, selectedSwatch), swatchOrder, swatchOverride === null || swatchOverride === void 0 ? void 0 : swatchOverride.color)).then(function () {
      setLoading(false);
    });
  };

  var showQuickView = (0, _shouldShowQuickViewButton.shouldShowQuickViewButton)(product);
  return showQuickView ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    "data-test": "component-hover-drawer",
    className: (0, _classnames["default"])(className, _quickViewDrawerModule["default"]['qv-drawer']),
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Button.SecondaryButton, {
      "data-test": "component-quick-view-button",
      className: (0, _classnames["default"])(_quickViewDrawerModule["default"]['qv-drawer__button']),
      submitting: loading || quickViewBundleLoading,
      onClick: handleClick,
      size: "small",
      children: ["Quick view", /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: _quickViewDrawerModule["default"]['visually-hidden'],
        children: ", ".concat(title)
      })]
    }, "quick-view")
  }) : null;
};

/***/ }),

/***/ 45211:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.shouldShowQuickViewButton = void 0;
var defaultCustomerNotifiableEvents = {
  backInStock: false,
  onRelease: false,
  onPreorderLaunch: false,
  newlyInStock: false
};

var shouldShowQuickViewButton = exports.shouldShowQuickViewButton = function shouldShowQuickViewButton() {
  var product = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var isMadeToMeasure = product.isMadeToMeasure,
      outOfStock = product.outOfStock,
      isInStoreOnly = product.isInStoreOnly,
      type = product.type,
      isFabricByLength = product.isFabricByLength,
      price = product.price,
      _product$customerNoti = product.customerNotifiableEvents,
      _product$customerNoti2 = _product$customerNoti === void 0 ? defaultCustomerNotifiableEvents : _product$customerNoti,
      backInStock = _product$customerNoti2.backInStock,
      onRelease = _product$customerNoti2.onRelease,
      onPreorderLaunch = _product$customerNoti2.onPreorderLaunch,
      newlyInStock = _product$customerNoti2.newlyInStock;

  var isPreorderBackInStock = backInStock && outOfStock;
  var isFutureRelease = isPreorderBackInStock || onRelease || onPreorderLaunch || newlyInStock;
  var productHasPrice = (price === null || price === void 0 ? void 0 : price.now) != null && Number(price.now) !== 0;

  if (isMadeToMeasure || isFutureRelease || outOfStock || isInStoreOnly || type === 'asaf' || type === 'productSet' || type === 'bundle' || isFabricByLength || !productHasPrice) {
    return false;
  }

  return true;
};

/***/ }),

/***/ 28291:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(37667));

var _propTypes = _interopRequireDefault(__webpack_require__(45697));

var _classnames2 = _interopRequireDefault(__webpack_require__(39232));

var _Rating = _interopRequireDefault(__webpack_require__(82775));

var _productCardRatingModule = _interopRequireDefault(__webpack_require__(75355));

var _jsxRuntime = __webpack_require__(85893);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
      t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}

function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };

  var t = _getRequireWildcardCache(r);

  if (t && t.has(e)) return t.get(e);
  var n = {
    __proto__: null
  },
      a = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var u in e) {
    if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }

  return n["default"] = e, t && t.set(e, n), n;
}

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");

  return "symbol" == _typeof(i) ? i : i + "";
}

function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];

  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return ("string" === r ? String : Number)(t);
}

var ProductCardRating = function ProductCardRating(_ref) {
  var _ref$rating = _ref.rating,
      rating = _ref$rating === void 0 ? {} : _ref$rating,
      isListViewOn = _ref.isListViewOn,
      className = _ref.className;
  var reviews = rating.reviews;

  if (!Object.keys(rating).length || !reviews) {
    return '';
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: (0, _classnames2["default"])(_productCardRatingModule["default"].rating, className, _defineProperty({}, _productCardRatingModule["default"]['list-view'], isListViewOn)),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Rating["default"], {
      rating: rating
    })
  });
};

ProductCardRating.defaultProps = {
  rating: {},
  isListViewOn: false
};
ProductCardRating.propTypes = {
  rating: _propTypes["default"].shape({
    averageRating: _propTypes["default"].number,
    reviews: _propTypes["default"].number,
    isListViewOn: _propTypes["default"].bool
  })
};

var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(ProductCardRating);

/***/ }),

/***/ 95451:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.SocialProofMessage = void 0;

var react_1 = __importStar(__webpack_require__(37667));

var classnames_1 = __importDefault(__webpack_require__(39232));

var social_proof_message_module_scss_1 = __importDefault(__webpack_require__(89123));

var renderMessage = function renderMessage(message) {
  return react_1["default"].createElement("div", {
    className: social_proof_message_module_scss_1["default"]['social-proof-message']
  }, message);
};

var SocialProofMessage = function SocialProofMessage(_a) {
  var _b;

  var _c = _a.message,
      message = _c === void 0 ? '' : _c,
      fetchComponent = _a.fetchComponent;

  var _d = (0, react_1.useState)(message ? renderMessage(message) : null),
      Component = _d[0],
      setComponent = _d[1];

  (0, react_1.useEffect)(function () {
    if (message) {
      setComponent(renderMessage(message));
    } else if (fetchComponent) {
      setComponent(fetchComponent());
    }
  }, [message, fetchComponent]);
  return Component && react_1["default"].createElement("div", {
    className: (0, classnames_1["default"])(social_proof_message_module_scss_1["default"]['social-proof-message-container'], (_b = {}, _b[social_proof_message_module_scss_1["default"]['social-proof-message-container__rendered-internally']] = message, _b)),
    "data-test": "jlds-social-proof-messages"
  }, Component);
};

exports.SocialProofMessage = SocialProofMessage;

/***/ }),

/***/ 40475:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(37667));

var _propTypes = _interopRequireDefault(__webpack_require__(45697));

var _classnames = _interopRequireDefault(__webpack_require__(39232));

var _sponsoredModule = _interopRequireDefault(__webpack_require__(86829));

var _jsxRuntime = __webpack_require__(85893);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
      t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}

function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };

  var t = _getRequireWildcardCache(r);

  if (t && t.has(e)) return t.get(e);
  var n = {
    __proto__: null
  },
      a = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var u in e) {
    if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }

  return n["default"] = e, t && t.set(e, n), n;
}

var Sponsored = function Sponsored(_ref) {
  var _ref$hasSponsoredTitl = _ref.hasSponsoredTitle,
      hasSponsoredTitle = _ref$hasSponsoredTitl === void 0 ? false : _ref$hasSponsoredTitl,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className;

  if (!hasSponsoredTitle) {
    return null;
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
    "aria-label": 'Sponsored product',
    className: (0, _classnames["default"])(_sponsoredModule["default"]['sponsored-text'], className),
    "data-test": "sponsored-product-tag",
    children: "Sponsored"
  });
};

Sponsored.propTypes = {
  hasSponsoredTitle: _propTypes["default"].bool,
  className: _propTypes["default"].string
};

var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(Sponsored);

/***/ }),

/***/ 52117:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(37667));

var _debounce = _interopRequireDefault(__webpack_require__(23279));

var _classnames4 = _interopRequireDefault(__webpack_require__(39232));

var _swatchesModule = _interopRequireDefault(__webpack_require__(66981));

var _getProductUrl = _interopRequireDefault(__webpack_require__(84225));

var _scene7UrlParser = __webpack_require__(29997);

var _jsxRuntime = __webpack_require__(85893);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
      t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}

function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };

  var t = _getRequireWildcardCache(r);

  if (t && t.has(e)) return t.get(e);
  var n = {
    __proto__: null
  },
      a = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var u in e) {
    if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }

  return n["default"] = e, t && t.set(e, n), n;
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");

  return "symbol" == _typeof(i) ? i : i + "";
}

function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];

  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return ("string" === r ? String : Number)(t);
}

function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}

  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

var Swatches = /*#__PURE__*/function (_PureComponent) {
  function Swatches() {
    var _this;

    _classCallCheck(this, Swatches);

    _this = _callSuper(this, Swatches);
    _this.state = {
      showMoreAvailable: false
    };
    _this.checkShowMoreAvailable = _this.checkShowMoreAvailable.bind(_this);
    return _this;
  }

  _inherits(Swatches, _PureComponent);

  return _createClass(Swatches, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var swatches = this.props.swatches;

      if (!swatches || !swatches.length || swatches.length === 1) {
        return;
      }

      this.checkShowMoreAvailable();
      window.addEventListener('resize', (0, _debounce["default"])(this.checkShowMoreAvailable, 150));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', (0, _debounce["default"])(this.checkShowMoreAvailable, 150));
    }
  }, {
    key: "checkShowMoreAvailable",
    value: function checkShowMoreAvailable() {
      var swatches = this.props.swatches;

      if (!swatches || !this.swatchList || !this.swatchItem) {
        return;
      }

      var swatchListWidth = this.swatchList.clientWidth;
      var swatchItemWidth = this.swatchItem.clientWidth;
      var maxSwatches = swatchListWidth / swatchItemWidth;
      this.setState({
        showMoreAvailable: swatches.length > maxSwatches
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var showMoreAvailable = this.state.showMoreAvailable;
      var _this$props = this.props,
          swatches = _this$props.swatches,
          title = _this$props.title,
          id = _this$props.id,
          baseUrl = _this$props.baseUrl,
          handleClick = _this$props.handleClick,
          _this$props$imageLoad = _this$props.imageLoading,
          imageLoading = _this$props$imageLoad === void 0 ? 'lazy' : _this$props$imageLoad,
          isListViewOn = _this$props.isListViewOn,
          className = _this$props.className,
          selectedSwatch = _this$props.selectedSwatch,
          swatchImpressionsHashValue = _this$props.swatchImpressionsHashValue;

      if (!swatches || !swatches.length || swatches.length === 1) {
        return '';
      }

      var getSwatchUrl = function getSwatchUrl(title, id, swatch) {
        var swatchUrl = swatch.url || (0, _getProductUrl["default"])(title, id, swatch);
        return swatchImpressionsHashValue ? "".concat(swatchUrl, "#").concat(swatchImpressionsHashValue) : swatchUrl;
      };

      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: (0, _classnames4["default"])(_swatchesModule["default"].swatches, className, _defineProperty({}, _swatchesModule["default"]['list-view'], isListViewOn)),
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: _swatchesModule["default"].visuallyHidden,
          children: "View this product in other colours by selecting one of the following:"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("ul", {
          className: (0, _classnames4["default"])(_swatchesModule["default"].swatchesList, _defineProperty({}, _swatchesModule["default"]['swatchesList--padding-below'], showMoreAvailable)),
          ref: function ref(swatchList) {
            _this2.swatchList = swatchList;
          },
          children: swatches.map(function (swatch, i) {
            return /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
              className: (0, _classnames4["default"])(_swatchesModule["default"].swatchItem, _defineProperty(_defineProperty({}, _swatchesModule["default"].unavailable, !swatch.isAvailable), _swatchesModule["default"]['swatchItem--selected'], (selectedSwatch === null || selectedSwatch === void 0 ? void 0 : selectedSwatch.color) === swatch.color || !(selectedSwatch !== null && selectedSwatch !== void 0 && selectedSwatch.color) && i === 0)),
              ref: function ref(swatchItem) {
                _this2.swatchItem = swatchItem;
              },
              children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
                "data-test": "swatch-button",
                title: "".concat(swatch.color).concat(swatch.isAvailable ? '' : ' - Out of stock'),
                tabIndex: "0",
                onClick: function onClick(event) {
                  return handleClick(event, i);
                },
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                  src: (0, _scene7UrlParser.setScene7UrlQueryParams)(swatch.colorSwatchUrl, {
                    wid: '18',
                    hei: '18',
                    fit: 'crop'
                  }),
                  alt: "".concat(swatch.color, " ").concat(swatch.isAvailable ? '' : ' - Out of stock'),
                  loading: imageLoading
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
                  className: _swatchesModule["default"].visuallyHidden,
                  children: ["This colour is", ' ', swatch.isAvailable ? 'available' : 'unavailable']
                })]
              })
            }, swatch.skuId);
          })
        }), showMoreAvailable ? /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
          className: _swatchesModule["default"].moreColours,
          href: baseUrl || (0, _getProductUrl["default"])(title, id),
          children: "+ More colours available"
        }) : '']
      });
    }
  }]);
}(_react.PureComponent);

var _default = exports["default"] = Swatches;

/***/ }),

/***/ 53845:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(37667));

var _propTypes = _interopRequireDefault(__webpack_require__(45697));

var _classnames8 = _interopRequireDefault(__webpack_require__(39232));

var _titleModule = _interopRequireDefault(__webpack_require__(36730));

var _escapeRegexSpecialChars = __webpack_require__(57610);

var _jsxRuntime = __webpack_require__(85893);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
      t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}

function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };

  var t = _getRequireWildcardCache(r);

  if (t && t.has(e)) return t.get(e);
  var n = {
    __proto__: null
  },
      a = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var u in e) {
    if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }

  return n["default"] = e, t && t.set(e, n), n;
}

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");

  return "symbol" == _typeof(i) ? i : i + "";
}

function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];

  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return ("string" === r ? String : Number)(t);
}

var getTitleWithoutBrand = function getTitleWithoutBrand() {
  var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var brand = arguments.length > 1 ? arguments[1] : undefined;
  var isAnyday = arguments.length > 2 ? arguments[2] : undefined;

  if (!brand || !title) {
    return title;
  }

  return isAnyday ? title.replace(new RegExp(/^anyday john lewis & partners|^john lewis anyday/, 'i'), '').trim() : title.replace(new RegExp("^".concat((0, _escapeRegexSpecialChars.escapeRegexSpecialChars)(brand)), 'i'), '').trim();
};

var Title = function Title(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title,
      brand = _ref.brand,
      _ref$brandPrefix = _ref.brandPrefix,
      brandPrefix = _ref$brandPrefix === void 0 ? '' : _ref$brandPrefix,
      _ref$isListViewOn = _ref.isListViewOn,
      isListViewOn = _ref$isListViewOn === void 0 ? false : _ref$isListViewOn,
      selectedSwatch = _ref.selectedSwatch,
      isBranded = _ref.isBranded,
      isAnyday = _ref.isAnyday,
      _ref$headerTagLevel = _ref.headerTagLevel,
      headerTagLevel = _ref$headerTagLevel === void 0 ? 2 : _ref$headerTagLevel,
      _ref$isUnlimitedLines = _ref.isUnlimitedLines,
      isUnlimitedLines = _ref$isUnlimitedLines === void 0 ? false : _ref$isUnlimitedLines;

  if (!title) {
    return '';
  }

  var isUnbrandedBrand = brand === 'Unbranded';
  var titleWithoutBrand = isUnbrandedBrand ? title : getTitleWithoutBrand(title, brand, isAnyday);
  var HeaderTag = "h".concat(headerTagLevel > 0 && headerTagLevel < 7 ? headerTagLevel : 2);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(HeaderTag, {
    className: _titleModule["default"].title,
    children: [isBranded && !isUnbrandedBrand || isAnyday || brand === 'CHANEL' ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
        className: (0, _classnames8["default"])(_titleModule["default"]['title__brand'], _defineProperty(_defineProperty({}, _titleModule["default"]["title__brand--".concat(brand.toLowerCase())], brand), _titleModule["default"]['title__brand--list-view'], isListViewOn)),
        children: [brandPrefix && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: _titleModule["default"]['title__brandPrefix'],
          children: brandPrefix
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
          children: "".concat(brand, " ")
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: (0, _classnames8["default"])(_titleModule["default"]['title__desc'], _defineProperty({}, _titleModule["default"]['title__desc--three-lines'], !isUnlimitedLines), _defineProperty({}, _titleModule["default"]['title__desc--branded'], isBranded), _defineProperty({}, _titleModule["default"]['title__desc--list-view'], isListViewOn)),
        children: titleWithoutBrand
      })]
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: (0, _classnames8["default"])(_titleModule["default"]['title__desc'], _defineProperty({}, _titleModule["default"]['title__desc--four-lines'], !isUnlimitedLines), _defineProperty({}, _titleModule["default"]['title__desc--branded'], isBranded && isUnbrandedBrand), _defineProperty({}, _titleModule["default"]['title__desc--list-view'], isListViewOn)),
      children: title
    }), (selectedSwatch === null || selectedSwatch === void 0 ? void 0 : selectedSwatch.color) && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: _titleModule["default"]['title__visually-hidden'],
      children: ", ".concat(selectedSwatch.color)
    })]
  });
};

Title.propTypes = {
  title: _propTypes["default"].string,
  isListViewOn: _propTypes["default"].bool,
  brand: _propTypes["default"].string,
  brandPrefix: _propTypes["default"].string,
  isBranded: _propTypes["default"].bool,
  isAnyday: _propTypes["default"].bool,
  headerTagLevel: _propTypes["default"].number,
  isUnlimitedLines: _propTypes["default"].bool
};

var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(Title);

/***/ }),

/***/ 82775:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(37667));

var _propTypes = _interopRequireDefault(__webpack_require__(45697));

var _classnames = _interopRequireDefault(__webpack_require__(39232));

var _ratingModule = _interopRequireDefault(__webpack_require__(74049));

var _StarsRatingSmallSelected = _interopRequireDefault(__webpack_require__(1694));

var _StarsRatingSmallDeSelected = _interopRequireDefault(__webpack_require__(87994));

var _jsxRuntime = __webpack_require__(85893);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
      t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}

function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };

  var t = _getRequireWildcardCache(r);

  if (t && t.has(e)) return t.get(e);
  var n = {
    __proto__: null
  },
      a = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var u in e) {
    if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }

  return n["default"] = e, t && t.set(e, n), n;
}

var Suffix = function Suffix(_ref) {
  var suffixType = _ref.suffixType,
      rating = _ref.rating;
  var averageRating = rating.averageRating,
      reviews = rating.reviews;

  switch (suffixType) {
    case 'none':
      return null;

    case 'ratingAndCount':
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
        className: _ratingModule["default"].fontSmall,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: _ratingModule["default"].visuallyHidden,
          children: "The average rating is"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: _ratingModule["default"].rating,
          children: averageRating
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: _ratingModule["default"].visuallyHidden,
          children: "from"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: _ratingModule["default"].ratingAndCount,
          children: "/"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: _ratingModule["default"].ratingAndCount,
          children: reviews
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: _ratingModule["default"].visuallyHidden,
          children: reviews !== 1 ? 'reviews' : 'review'
        })]
      });

    case 'ratingAndMax':
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: _ratingModule["default"].visuallyHidden,
          children: "The average rating is"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: _ratingModule["default"].rating,
          children: averageRating
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: _ratingModule["default"].visuallyHidden,
          children: "out of"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          "aria-hidden": "true",
          children: "/"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: _ratingModule["default"].ratingAndCount,
          children: "5"
        })]
      });

    case 'reviews':
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: _ratingModule["default"].visuallyHidden,
          children: reviews !== 1 ? 'There are ' : 'There is '
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          "aria-hidden": "true",
          children: "("
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
          className: _ratingModule["default"].reviews,
          children: [reviews, " ", reviews !== 1 ? 'reviews' : 'review']
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          "aria-hidden": "true",
          children: ")"
        })]
      });

    default:
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: _ratingModule["default"].visuallyHidden,
          children: reviews !== 1 ? 'There are ' : 'There is '
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: _ratingModule["default"].reviews,
          children: reviews
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: _ratingModule["default"].visuallyHidden,
          children: reviews !== 1 ? ' reviews' : ' review'
        })]
      });
  }
};

var Rating = function Rating(_ref2) {
  var _ref2$rating = _ref2.rating,
      rating = _ref2$rating === void 0 ? {} : _ref2$rating,
      _ref2$className = _ref2.className,
      className = _ref2$className === void 0 ? '' : _ref2$className,
      suffixType = _ref2.suffixType,
      size = _ref2.size,
      _ref2$ownRating = _ref2.ownRating,
      ownRating = _ref2$ownRating === void 0 ? false : _ref2$ownRating;
  var averageRating = rating.averageRating,
      reviews = rating.reviews;

  if (!Object.keys(rating).length || !reviews) {
    return '';
  }

  var ratingStarsWidth = averageRating * 20;
  var averageRatingParsed = parseFloat(averageRating).toFixed(2);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: (0, _classnames["default"])(_ratingModule["default"].ratings, _ratingModule["default"][size], _ratingModule["default"]['size-joyfully-bold']),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "".concat(_ratingModule["default"].starRatings, " ").concat(className),
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: _ratingModule["default"].starDefault,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_StarsRatingSmallDeSelected["default"], {
            className: (0, _classnames["default"])(_ratingModule["default"].starOutline, _ratingModule["default"]['joyfully-bold']),
            height: 14
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: _ratingModule["default"].starRated,
          style: {
            width: "".concat(ratingStarsWidth, "%")
          },
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_StarsRatingSmallSelected["default"], {
            className: (0, _classnames["default"])(_ratingModule["default"].starFilled, _ratingModule["default"]['joyfully-bold']),
            height: 14
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
            className: _ratingModule["default"].visuallyHidden,
            "data-test": "rating",
            "data-testid": "rating-accessibility",
            children: ["Product review details,", ' ', ownRating ? "you rated this product ".concat(averageRatingParsed, " out of 5 stars.") : "this product has received, on average,".concat(' ', "\n              ", averageRatingParsed, " out of 5 star rating.")]
          })]
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: (0, _classnames["default"])(_ratingModule["default"].suffix, _ratingModule["default"]['suffix-joyfully-bold']),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Suffix, {
          suffixType: suffixType,
          rating: rating
        })
      })]
    })
  });
};

Rating.defaultProps = {
  rating: {},
  className: '',
  suffixType: 'count',
  size: 'small'
};
Rating.propTypes = {
  className: _propTypes["default"].string,
  rating: _propTypes["default"].shape({
    averageRating: _propTypes["default"].number,
    reviews: _propTypes["default"].number
  }),
  size: _propTypes["default"].oneOf(['small', 'large']),
  suffixType: _propTypes["default"].oneOf(['count', 'none', 'ratingAndCount', 'reviews', 'ratingAndMax']),
  ownRating: _propTypes["default"].bool
};
Suffix.defaultProps = {
  rating: {},
  suffixType: 'count'
};
Suffix.propTypes = {
  rating: _propTypes["default"].shape({
    averageRating: _propTypes["default"].number,
    reviews: _propTypes["default"].number
  }),
  suffixType: _propTypes["default"].oneOf(['count', 'none', 'ratingAndCount', 'reviews', 'ratingAndMax'])
};

var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(Rating);

/***/ }),

/***/ 15116:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var errorCodeConstants = {
  RESET_PASSWORD_TOKEN_NOT_VALID: 'token.not.valid',
  SERVER_INTERNAL_ERROR: 'server.internal.error',
  BFF_SERVER_INTERNAL_ERROR: 'bff.server.internal.error',
  BFF_UNKNOWN_API_ERROR: 'unknown.api.error',
  SESSION_EXPIRED: 'session.expired',
  CUSTOMER_SYNC_FAILED: 'customer.sync.failed',
  CODE_UNAUTHORIZED_TOKEN: 'code.unauthorized.token',
  ORDER_FORM_EMPTY: 'order.form.empty',
  ORDER_FORM_NOT_FOUND: 'order.form.not.found',
  HANDOVER_TOKEN_INVALID: 'handover.token.invalid',
  WEAK_PASSWORD: 'weak.password',
  ACCOUNT_IS_LOCKED: 'account.is.locked',
  USER_IS_DORMANT: 'user.is.dormant',
  GHOST_ACCOUNT_IS_LOCKED: 'ghost.account.is.locked',
  INCORRECT_LOGIN_DETAILS: 'incorrect.login.details',
  INCORRECT_EMAIL: 'incorrect.email',
  PAYPAL_UNAVAILABLE: 'paypal.service.unavailable',
  PAYPAL_SESSION_INTERNAL_ERROR: 'paypal.session.internal.error',
  POSTCODE_OUT_OF_AREA: 'postcode.out.of.area',
  CARD_PAYMENT_DETAILS_INCORRECT: 'credit.debit.card.payment.details.incorrect',
  CARD_3DSECURE_PAYMENT_DETAILS_INCORRECT: 'credit.debit.card.3dsecure.payment.details.incorrect',
  CARD_PAYMENT_NOT_AUTHORISED: 'credit.debit.card.payment.not.authorised',
  GIFT_CARD_PIN_INCORRECT: 'gift.card.pin.incorrect',
  GIFT_CARD_NOT_RECOGNISED: 'gift.card.not.recognised',
  DUPLICATE_GIFT_CARD: 'duplicate.gift.card',
  GIFT_CARD_EXPIRED: 'gift.card.expired',
  GIFT_CARD_NO_VALUE: 'gift.card.no.value',
  GIFT_CARD_SERVICE_UNAVAILABLE: 'gift.card.service.unavailable',
  UNKNOWN_GIFT_CARD_SERVICE_RESPONSE_CODE: 'unknown.gift.card.service.response.code',
  GIFT_CARD_REDEEM_FAILED: 'gift.card.redeem.failed',
  DUPLICATE_GIFT_VOUCHER: 'duplicate.gift.voucher',
  GIFT_VOUCHER_NOT_RECOGNISED: 'gift.voucher.not.recognised',
  SECURITY_CODE_INVALID: 'security.code.invalid',
  SERIAL_NUMBER_INVALID: 'serial.number.invalid',
  GIFT_VOUCHER_SERVICE_UNAVAILABLE: 'gift.voucher.service.unavailable',
  INSUFFICIENT_STOCK: 'insufficient.stock',
  CARD_PAYMENT_INVALID_FORMAT: 'credit.card.number.invalid.format',
  PROMO_CODE_NOT_APPLICABLE: 'promotion.code.not.applicable',
  PROMO_CODE_ALREADY_APPLIED: 'promotion.code.already.applied',
  // GENERATED ON CLIENT
  CLIENT_ROUTE_ERROR: 'client.route.error',
  CLIENT_CONNECTIVITY_ERROR: 'client.api.connectivity.error',
  CLIENT_UNKNOWN_TECHNICAL_ERROR: 'client.api.unknown.technical.error',
  CLIENT_PAYMENT_NOT_SELECTED: 'client.payment.not.selected',
  CLIENT_LOGIN_CREDS_INVALID_EMAIL: 'client.login.creds.invalid.email',
  CLIENT_LOGIN_CREDS_INVALID_PASSWORD: 'client.login.creds.invalid.password',
  CLIENT_FORM_VALIDATION_ERRORS: 'client.form.validation.errors',
  CLIENT_FIND_ADDRESS_ERROR: 'client.find.address.error'
};

var _default = exports["default"] = errorCodeConstants;

/***/ }),

/***/ 73087:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.TertiaryButton = exports.UnderlinedButton = exports.SecondaryButton = exports.PrimaryButton = void 0;

var react_1 = __importDefault(__webpack_require__(37667));

var classnames_1 = __importDefault(__webpack_require__(39232));

var button_module_scss_1 = __importDefault(__webpack_require__(60937));

var Button = function Button(_a) {
  var _b, _c, _d;

  var _e = _a.tag,
      Tag = _e === void 0 ? 'button' : _e,
      children = _a.children,
      className = _a.className,
      _f = _a.type,
      type = _f === void 0 ? 'button' : _f,
      level = _a.level,
      size = _a.size,
      _g = _a.disabled,
      disabled = _g === void 0 ? false : _g,
      _h = _a.inverted,
      inverted = _h === void 0 ? false : _h,
      _j = _a.submitting,
      submitting = _j === void 0 ? false : _j,
      inline = _a.inline,
      sale = _a.sale,
      onClick = _a.onClick,
      onKeyDown = _a.onKeyDown,
      rest = __rest(_a, ["tag", "children", "className", "type", "level", "size", "disabled", "inverted", "submitting", "inline", "sale", "onClick", "onKeyDown"]);

  var classes = (0, classnames_1["default"])(button_module_scss_1["default"]['c-button'], (_b = {}, _b[button_module_scss_1["default"]["c-button--".concat(level)]] = !!level, _b[button_module_scss_1["default"]['c-button--inverted']] = inverted, _b[button_module_scss_1["default"]['c-button--disabled']] = disabled || submitting, _b[button_module_scss_1["default"]['c-button--submitting']] = submitting && level !== 'underlined', _b[button_module_scss_1["default"]['c-button--inline']] = inline, _b[button_module_scss_1["default"]['c-button--sale']] = sale, _b[button_module_scss_1["default"]["c-button--".concat(size)]] = !!size, _b), (_c = {}, _c[button_module_scss_1["default"][className]] = !!button_module_scss_1["default"][className], _c), (_d = {}, _d[className] = !button_module_scss_1["default"][className] && !!className, _d));
  var hasDisabledButton = Tag === 'button' && (disabled || submitting);

  var handleDisabledEvent = function handleDisabledEvent(event) {
    if (event.type === 'keydown' && event.key !== 'Tab') {
      event.preventDefault();
    }
  };

  return react_1["default"].createElement(Tag, __assign({}, rest, {
    type: Tag === 'button' ? type : undefined,
    className: classes,
    "aria-disabled": hasDisabledButton,
    onClick: hasDisabledButton ? handleDisabledEvent : onClick,
    onKeyDown: hasDisabledButton ? handleDisabledEvent : onKeyDown
  }), !submitting ? children : react_1["default"].createElement("span", {
    className: "hidden"
  }, children));
};

var PrimaryButton = function PrimaryButton(_a) {
  var children = _a.children,
      rest = __rest(_a, ["children"]);

  return react_1["default"].createElement(Button, __assign({
    level: "primary"
  }, rest), children);
};

exports.PrimaryButton = PrimaryButton;

var SecondaryButton = function SecondaryButton(_a) {
  var children = _a.children,
      rest = __rest(_a, ["children"]);

  return react_1["default"].createElement(Button, __assign({
    level: "secondary"
  }, rest), children);
};

exports.SecondaryButton = SecondaryButton;

var UnderlinedButton = function UnderlinedButton(_a) {
  var children = _a.children,
      rest = __rest(_a, ["children"]);

  return react_1["default"].createElement(Button, __assign({
    level: "underlined"
  }, rest), children);
};

exports.UnderlinedButton = UnderlinedButton;

var TertiaryButton = function TertiaryButton(_a) {
  var _b;

  var children = _a.children,
      _c = _a.disabled,
      disabled = _c === void 0 ? false : _c,
      IconComponent = _a.IconComponent,
      iconPositionRight = _a.iconPositionRight,
      _d = _a.submitting,
      submitting = _d === void 0 ? false : _d,
      _e = _a.small,
      small = _e === void 0 ? false : _e,
      _f = _a.variant,
      variant = _f === void 0 ? 'tonal-dark' : _f,
      className = _a.className,
      rest = __rest(_a, ["children", "disabled", "IconComponent", "iconPositionRight", "submitting", "small", "variant", "className"]);

  var classes = (0, classnames_1["default"])((_b = {}, _b[button_module_scss_1["default"]["c-button--tertiary-icon-right"]] = iconPositionRight, _b[button_module_scss_1["default"]["c-button--tertiary-icon"]] = !!IconComponent, _b[button_module_scss_1["default"]["c-button--tertiary-no-icon"]] = !IconComponent, _b[button_module_scss_1["default"]["c-button--tertiary-submitting"]] = submitting, _b), small ? button_module_scss_1["default"]['c-button--tertiary-small'] : button_module_scss_1["default"]['c-button--tertiary-large'], button_module_scss_1["default"]["variant-".concat(variant)], className);

  var icon = function icon() {
    if (!IconComponent) return null;
    return react_1["default"].createElement("div", {
      className: button_module_scss_1["default"]['icon-container']
    }, react_1["default"].createElement("div", {
      className: (0, classnames_1["default"])(button_module_scss_1["default"]['icon'], submitting && button_module_scss_1["default"]['visually-hidden'])
    }, react_1["default"].createElement(IconComponent, null)));
  };

  return react_1["default"].createElement(Button, __assign({
    level: "tertiary",
    disabled: disabled || submitting,
    className: classes
  }, rest), icon(), react_1["default"].createElement("div", {
    className: button_module_scss_1["default"]['tertiary-content']
  }, children));
};

exports.TertiaryButton = TertiaryButton;

/***/ }),

/***/ 2909:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.IconButton = void 0;

var _classnames = _interopRequireDefault(__webpack_require__(39232));

var _logIconButtonErrors = __webpack_require__(16754);

var _iconButtonModule = _interopRequireDefault(__webpack_require__(19509));

var _jsxRuntime = __webpack_require__(85893);

var _excluded = ["className", "ariaLabel", "disabled", "IconComponent", "onClick", "onKeyDown", "size", "submitting", "type", "variant"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");

  return "symbol" == _typeof(i) ? i : i + "";
}

function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];

  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return ("string" === r ? String : Number)(t);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var IconButton = exports.IconButton = function IconButton(_ref) {
  var className = _ref.className,
      _ref$ariaLabel = _ref.ariaLabel,
      ariaLabel = _ref$ariaLabel === void 0 ? '' : _ref$ariaLabel,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      IconComponent = _ref.IconComponent,
      onClick = _ref.onClick,
      onKeyDown = _ref.onKeyDown,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      _ref$submitting = _ref.submitting,
      submitting = _ref$submitting === void 0 ? false : _ref$submitting,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'button' : _ref$type,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'tonal-dark' : _ref$variant,
      rest = _objectWithoutProperties(_ref, _excluded);

  (0, _logIconButtonErrors.logIconButtonErrors)(size, IconComponent);
  var classes = (0, _classnames["default"])(_iconButtonModule["default"].iconButton, size ? _iconButtonModule["default"][size] : _iconButtonModule["default"].medium, _defineProperty(_defineProperty({}, _iconButtonModule["default"]['disabled'], disabled), _iconButtonModule["default"]['submitting'], submitting), _iconButtonModule["default"]["variant-".concat(variant)], className);
  var hasDisabledButton = disabled || submitting;

  var handleDisabledEvent = function handleDisabledEvent(event) {
    if (event.key != 'Tab') {
      event.preventDefault();
    }
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("button", _objectSpread(_objectSpread({
      className: classes,
      "aria-disabled": hasDisabledButton,
      "aria-label": ariaLabel,
      type: type === 'submit' ? 'submit' : 'button',
      onClick: hasDisabledButton ? handleDisabledEvent : onClick,
      onKeyDown: hasDisabledButton ? handleDisabledEvent : onKeyDown
    }, rest), {}, {
      children: IconComponent ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: _iconButtonModule["default"].icon,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(IconComponent, {})
      }) : null
    }))
  });
};

/***/ }),

/***/ 16754:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.logIconButtonErrors = void 0;
/**
 * Logs errors related to IconButton.
 *
 * @param {string} size The size of the IconButton.
 * @param {object} IconComponent The IconComponent object.
 * @param {string} IconComponent.displayName The display name of the IconComponent.
 * @returns {void}
 */

var logIconButtonErrors = exports.logIconButtonErrors = function logIconButtonErrors(size, IconComponent) {
  if (!IconComponent) {
    console.error('An Icon Button was rendered with no icon.');
    return null;
  }

  var iconName = IconComponent === null || IconComponent === void 0 ? void 0 : IconComponent.displayName;

  if (size === 'small' && !(iconName !== null && iconName !== void 0 && iconName.match(/24px/i))) {
    console.error("".concat(iconName, ", was passed into a 'small' Icon Button. A small Icon Button should be rendered with a 24px icon."));
  }

  if (size === 'medium' && !(iconName !== null && iconName !== void 0 && iconName.match(/24px/i))) {
    console.error("".concat(iconName, ", was passed into a 'medium' Icon Button. A medium Icon Button should be rendered with a 24px icon."));
  }

  if (size === 'large' && !(iconName !== null && iconName !== void 0 && iconName.match(/32px/i))) {
    console.error("".concat(iconName, ", was passed into a 'large' Icon Button. A large Icon Button should be rendered with a 32px icon."));
  }
};

/***/ }),

/***/ 35119:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = exports.ChevronDown24PxOutlinedIcon = void 0;

var _react = _interopRequireDefault(__webpack_require__(37667));

var _propTypes = _interopRequireDefault(__webpack_require__(45697));

var _iconModule = _interopRequireDefault(__webpack_require__(35768));

var _classnames = _interopRequireDefault(__webpack_require__(39232));

var _jsxRuntime = __webpack_require__(85893);

var _excluded = ["title", "box", "iconState", "className"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");

  return "symbol" == _typeof(i) ? i : i + "";
}

function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];

  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return ("string" === r ? String : Number)(t);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var propTypes = {
  /** To give the icon additional context if needed */
  title: _propTypes["default"].string,

  /** To display the icon in a fixed sized box */
  box: _propTypes["default"].bool,

  /** To display the icon as white (inverse), disabled (grey) or information (blue) */
  iconState: _propTypes["default"].oneOf(['icon-invert', 'icon-disabled', 'icon-information'])
};
var defaultProps = {
  title: null,
  box: false
};
var url = 'https://www.johnlewis.com/static/ui-assets/hashed/icons-jb/chevron-down/chevron-down-24px-outlined.e35fd2be.svg';

var ChevronDown24PxOutlinedIcon = exports.ChevronDown24PxOutlinedIcon = function ChevronDown24PxOutlinedIcon(_ref) {
  var title = _ref.title,
      box = _ref.box,
      iconState = _ref.iconState,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  if (box) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _iconModule["default"].box,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", _objectSpread(_objectSpread({
        src: url,
        className: (0, _classnames["default"])(className, _defineProperty({}, _iconModule["default"][iconState], !!iconState)),
        alt: title ? title : 'Chevron Down Icon',
        width: "24",
        height: "24"
      }, props), {}, {
        "aria-hidden": title ? 'false' : 'true',
        "aria-label": title ? title : 'Chevron Down Icon'
      }))
    });
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsx)("img", _objectSpread(_objectSpread({
    src: url,
    className: (0, _classnames["default"])(className, _defineProperty({}, _iconModule["default"][iconState], !!iconState)),
    alt: title ? title : 'Chevron Down Icon',
    width: "24",
    height: "24"
  }, props), {}, {
    "aria-hidden": title ? 'false' : 'true',
    "aria-label": title ? title : 'Chevron Down Icon'
  }));
};

ChevronDown24PxOutlinedIcon.displayName = 'ChevronDown24PxOutlinedIcon';
ChevronDown24PxOutlinedIcon.propTypes = propTypes;
ChevronDown24PxOutlinedIcon.defaultProps = defaultProps;

var _default = exports["default"] = ChevronDown24PxOutlinedIcon;

/***/ }),

/***/ 20372:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = exports.ChevronDown32PxOutlinedIcon = void 0;

var _react = _interopRequireDefault(__webpack_require__(37667));

var _propTypes = _interopRequireDefault(__webpack_require__(45697));

var _iconModule = _interopRequireDefault(__webpack_require__(35768));

var _classnames = _interopRequireDefault(__webpack_require__(39232));

var _jsxRuntime = __webpack_require__(85893);

var _excluded = ["title", "box", "iconState", "className"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");

  return "symbol" == _typeof(i) ? i : i + "";
}

function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];

  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return ("string" === r ? String : Number)(t);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var propTypes = {
  /** To give the icon additional context if needed */
  title: _propTypes["default"].string,

  /** To display the icon in a fixed sized box */
  box: _propTypes["default"].bool,

  /** To display the icon as white (inverse), disabled (grey) or information (blue) */
  iconState: _propTypes["default"].oneOf(['icon-invert', 'icon-disabled', 'icon-information'])
};
var defaultProps = {
  title: null,
  box: false
};
var url = 'https://www.johnlewis.com/static/ui-assets/hashed/icons-jb/chevron-down/chevron-down-32px-outlined.8c7029b0.svg';

var ChevronDown32PxOutlinedIcon = exports.ChevronDown32PxOutlinedIcon = function ChevronDown32PxOutlinedIcon(_ref) {
  var title = _ref.title,
      box = _ref.box,
      iconState = _ref.iconState,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  if (box) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _iconModule["default"].box,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", _objectSpread(_objectSpread({
        src: url,
        className: (0, _classnames["default"])(className, _defineProperty({}, _iconModule["default"][iconState], !!iconState)),
        alt: title ? title : 'Chevron Down Icon',
        width: "32",
        height: "32"
      }, props), {}, {
        "aria-hidden": title ? 'false' : 'true',
        "aria-label": title ? title : 'Chevron Down Icon'
      }))
    });
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsx)("img", _objectSpread(_objectSpread({
    src: url,
    className: (0, _classnames["default"])(className, _defineProperty({}, _iconModule["default"][iconState], !!iconState)),
    alt: title ? title : 'Chevron Down Icon',
    width: "32",
    height: "32"
  }, props), {}, {
    "aria-hidden": title ? 'false' : 'true',
    "aria-label": title ? title : 'Chevron Down Icon'
  }));
};

ChevronDown32PxOutlinedIcon.displayName = 'ChevronDown32PxOutlinedIcon';
ChevronDown32PxOutlinedIcon.propTypes = propTypes;
ChevronDown32PxOutlinedIcon.defaultProps = defaultProps;

var _default = exports["default"] = ChevronDown32PxOutlinedIcon;

/***/ }),

/***/ 11209:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = exports.ChevronLeft24PxOutlinedIcon = void 0;

var _react = _interopRequireDefault(__webpack_require__(37667));

var _propTypes = _interopRequireDefault(__webpack_require__(45697));

var _iconModule = _interopRequireDefault(__webpack_require__(35768));

var _classnames = _interopRequireDefault(__webpack_require__(39232));

var _jsxRuntime = __webpack_require__(85893);

var _excluded = ["title", "box", "iconState", "className"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");

  return "symbol" == _typeof(i) ? i : i + "";
}

function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];

  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return ("string" === r ? String : Number)(t);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var propTypes = {
  /** To give the icon additional context if needed */
  title: _propTypes["default"].string,

  /** To display the icon in a fixed sized box */
  box: _propTypes["default"].bool,

  /** To display the icon as white (inverse), disabled (grey) or information (blue) */
  iconState: _propTypes["default"].oneOf(['icon-invert', 'icon-disabled', 'icon-information'])
};
var defaultProps = {
  title: null,
  box: false
};
var url = 'https://www.johnlewis.com/static/ui-assets/hashed/icons-jb/chevron-left/chevron-left-24px-outlined.fe51ee26.svg';

var ChevronLeft24PxOutlinedIcon = exports.ChevronLeft24PxOutlinedIcon = function ChevronLeft24PxOutlinedIcon(_ref) {
  var title = _ref.title,
      box = _ref.box,
      iconState = _ref.iconState,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  if (box) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _iconModule["default"].box,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", _objectSpread(_objectSpread({
        src: url,
        className: (0, _classnames["default"])(className, _defineProperty({}, _iconModule["default"][iconState], !!iconState)),
        alt: title ? title : 'Chevron Left Icon',
        width: "24",
        height: "24"
      }, props), {}, {
        "aria-hidden": title ? 'false' : 'true',
        "aria-label": title ? title : 'Chevron Left Icon'
      }))
    });
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsx)("img", _objectSpread(_objectSpread({
    src: url,
    className: (0, _classnames["default"])(className, _defineProperty({}, _iconModule["default"][iconState], !!iconState)),
    alt: title ? title : 'Chevron Left Icon',
    width: "24",
    height: "24"
  }, props), {}, {
    "aria-hidden": title ? 'false' : 'true',
    "aria-label": title ? title : 'Chevron Left Icon'
  }));
};

ChevronLeft24PxOutlinedIcon.displayName = 'ChevronLeft24PxOutlinedIcon';
ChevronLeft24PxOutlinedIcon.propTypes = propTypes;
ChevronLeft24PxOutlinedIcon.defaultProps = defaultProps;

var _default = exports["default"] = ChevronLeft24PxOutlinedIcon;

/***/ }),

/***/ 4279:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = exports.ChevronLeft32PxOutlinedIcon = void 0;

var _react = _interopRequireDefault(__webpack_require__(37667));

var _propTypes = _interopRequireDefault(__webpack_require__(45697));

var _iconModule = _interopRequireDefault(__webpack_require__(35768));

var _classnames = _interopRequireDefault(__webpack_require__(39232));

var _jsxRuntime = __webpack_require__(85893);

var _excluded = ["title", "box", "iconState", "className"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");

  return "symbol" == _typeof(i) ? i : i + "";
}

function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];

  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return ("string" === r ? String : Number)(t);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var propTypes = {
  /** To give the icon additional context if needed */
  title: _propTypes["default"].string,

  /** To display the icon in a fixed sized box */
  box: _propTypes["default"].bool,

  /** To display the icon as white (inverse), disabled (grey) or information (blue) */
  iconState: _propTypes["default"].oneOf(['icon-invert', 'icon-disabled', 'icon-information'])
};
var defaultProps = {
  title: null,
  box: false
};
var url = 'https://www.johnlewis.com/static/ui-assets/hashed/icons-jb/chevron-left/chevron-left-32px-outlined.a243bba5.svg';

var ChevronLeft32PxOutlinedIcon = exports.ChevronLeft32PxOutlinedIcon = function ChevronLeft32PxOutlinedIcon(_ref) {
  var title = _ref.title,
      box = _ref.box,
      iconState = _ref.iconState,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  if (box) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _iconModule["default"].box,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", _objectSpread(_objectSpread({
        src: url,
        className: (0, _classnames["default"])(className, _defineProperty({}, _iconModule["default"][iconState], !!iconState)),
        alt: title ? title : 'Chevron Left Icon',
        width: "32",
        height: "32"
      }, props), {}, {
        "aria-hidden": title ? 'false' : 'true',
        "aria-label": title ? title : 'Chevron Left Icon'
      }))
    });
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsx)("img", _objectSpread(_objectSpread({
    src: url,
    className: (0, _classnames["default"])(className, _defineProperty({}, _iconModule["default"][iconState], !!iconState)),
    alt: title ? title : 'Chevron Left Icon',
    width: "32",
    height: "32"
  }, props), {}, {
    "aria-hidden": title ? 'false' : 'true',
    "aria-label": title ? title : 'Chevron Left Icon'
  }));
};

ChevronLeft32PxOutlinedIcon.displayName = 'ChevronLeft32PxOutlinedIcon';
ChevronLeft32PxOutlinedIcon.propTypes = propTypes;
ChevronLeft32PxOutlinedIcon.defaultProps = defaultProps;

var _default = exports["default"] = ChevronLeft32PxOutlinedIcon;

/***/ }),

/***/ 35204:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

__webpack_unused_export__ = ({
  value: true
});
exports.ZP = __webpack_unused_export__ = void 0;

var _react = _interopRequireDefault(__webpack_require__(37667));

var _propTypes = _interopRequireDefault(__webpack_require__(45697));

var _iconModule = _interopRequireDefault(__webpack_require__(35768));

var _classnames = _interopRequireDefault(__webpack_require__(39232));

var _jsxRuntime = __webpack_require__(85893);

var _excluded = ["title", "box", "iconState", "className"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");

  return "symbol" == _typeof(i) ? i : i + "";
}

function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];

  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return ("string" === r ? String : Number)(t);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var propTypes = {
  /** To give the icon additional context if needed */
  title: _propTypes["default"].string,

  /** To display the icon in a fixed sized box */
  box: _propTypes["default"].bool,

  /** To display the icon as white (inverse), disabled (grey) or information (blue) */
  iconState: _propTypes["default"].oneOf(['icon-invert', 'icon-disabled', 'icon-information'])
};
var defaultProps = {
  title: null,
  box: false
};
var url = 'https://www.johnlewis.com/static/ui-assets/hashed/icons-jb/chevron-right/chevron-right-24px-outlined.d4d4d133.svg';

var ChevronRight24PxOutlinedIcon = __webpack_unused_export__ = function ChevronRight24PxOutlinedIcon(_ref) {
  var title = _ref.title,
      box = _ref.box,
      iconState = _ref.iconState,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  if (box) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _iconModule["default"].box,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", _objectSpread(_objectSpread({
        src: url,
        className: (0, _classnames["default"])(className, _defineProperty({}, _iconModule["default"][iconState], !!iconState)),
        alt: title ? title : 'Chevron Right Icon',
        width: "24",
        height: "24"
      }, props), {}, {
        "aria-hidden": title ? 'false' : 'true',
        "aria-label": title ? title : 'Chevron Right Icon'
      }))
    });
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsx)("img", _objectSpread(_objectSpread({
    src: url,
    className: (0, _classnames["default"])(className, _defineProperty({}, _iconModule["default"][iconState], !!iconState)),
    alt: title ? title : 'Chevron Right Icon',
    width: "24",
    height: "24"
  }, props), {}, {
    "aria-hidden": title ? 'false' : 'true',
    "aria-label": title ? title : 'Chevron Right Icon'
  }));
};

ChevronRight24PxOutlinedIcon.displayName = 'ChevronRight24PxOutlinedIcon';
ChevronRight24PxOutlinedIcon.propTypes = propTypes;
ChevronRight24PxOutlinedIcon.defaultProps = defaultProps;

var _default = exports.ZP = ChevronRight24PxOutlinedIcon;

/***/ }),

/***/ 18610:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = exports.ChevronRight32PxOutlinedIcon = void 0;

var _react = _interopRequireDefault(__webpack_require__(37667));

var _propTypes = _interopRequireDefault(__webpack_require__(45697));

var _iconModule = _interopRequireDefault(__webpack_require__(35768));

var _classnames = _interopRequireDefault(__webpack_require__(39232));

var _jsxRuntime = __webpack_require__(85893);

var _excluded = ["title", "box", "iconState", "className"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");

  return "symbol" == _typeof(i) ? i : i + "";
}

function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];

  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return ("string" === r ? String : Number)(t);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var propTypes = {
  /** To give the icon additional context if needed */
  title: _propTypes["default"].string,

  /** To display the icon in a fixed sized box */
  box: _propTypes["default"].bool,

  /** To display the icon as white (inverse), disabled (grey) or information (blue) */
  iconState: _propTypes["default"].oneOf(['icon-invert', 'icon-disabled', 'icon-information'])
};
var defaultProps = {
  title: null,
  box: false
};
var url = 'https://www.johnlewis.com/static/ui-assets/hashed/icons-jb/chevron-right/chevron-right-32px-outlined.e6d0a42a.svg';

var ChevronRight32PxOutlinedIcon = exports.ChevronRight32PxOutlinedIcon = function ChevronRight32PxOutlinedIcon(_ref) {
  var title = _ref.title,
      box = _ref.box,
      iconState = _ref.iconState,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  if (box) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _iconModule["default"].box,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", _objectSpread(_objectSpread({
        src: url,
        className: (0, _classnames["default"])(className, _defineProperty({}, _iconModule["default"][iconState], !!iconState)),
        alt: title ? title : 'Chevron Right Icon',
        width: "32",
        height: "32"
      }, props), {}, {
        "aria-hidden": title ? 'false' : 'true',
        "aria-label": title ? title : 'Chevron Right Icon'
      }))
    });
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsx)("img", _objectSpread(_objectSpread({
    src: url,
    className: (0, _classnames["default"])(className, _defineProperty({}, _iconModule["default"][iconState], !!iconState)),
    alt: title ? title : 'Chevron Right Icon',
    width: "32",
    height: "32"
  }, props), {}, {
    "aria-hidden": title ? 'false' : 'true',
    "aria-label": title ? title : 'Chevron Right Icon'
  }));
};

ChevronRight32PxOutlinedIcon.displayName = 'ChevronRight32PxOutlinedIcon';
ChevronRight32PxOutlinedIcon.propTypes = propTypes;
ChevronRight32PxOutlinedIcon.defaultProps = defaultProps;

var _default = exports["default"] = ChevronRight32PxOutlinedIcon;

/***/ }),

/***/ 88823:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = exports.Close24PxOutlinedIcon = void 0;

var _react = _interopRequireDefault(__webpack_require__(37667));

var _propTypes = _interopRequireDefault(__webpack_require__(45697));

var _iconModule = _interopRequireDefault(__webpack_require__(35768));

var _classnames = _interopRequireDefault(__webpack_require__(39232));

var _jsxRuntime = __webpack_require__(85893);

var _excluded = ["title", "box", "iconState", "className"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");

  return "symbol" == _typeof(i) ? i : i + "";
}

function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];

  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return ("string" === r ? String : Number)(t);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var propTypes = {
  /** To give the icon additional context if needed */
  title: _propTypes["default"].string,

  /** To display the icon in a fixed sized box */
  box: _propTypes["default"].bool,

  /** To display the icon as white (inverse), disabled (grey) or information (blue) */
  iconState: _propTypes["default"].oneOf(['icon-invert', 'icon-disabled', 'icon-information'])
};
var defaultProps = {
  title: null,
  box: false
};
var url = 'https://www.johnlewis.com/static/ui-assets/hashed/icons-jb/close/close-24px-outlined.e16f5bcf.svg';

var Close24PxOutlinedIcon = exports.Close24PxOutlinedIcon = function Close24PxOutlinedIcon(_ref) {
  var title = _ref.title,
      box = _ref.box,
      iconState = _ref.iconState,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  if (box) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _iconModule["default"].box,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", _objectSpread(_objectSpread({
        src: url,
        className: (0, _classnames["default"])(className, _defineProperty({}, _iconModule["default"][iconState], !!iconState)),
        alt: title ? title : 'Close Icon',
        width: "24",
        height: "24"
      }, props), {}, {
        "aria-hidden": title ? 'false' : 'true',
        "aria-label": title ? title : 'Close Icon'
      }))
    });
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsx)("img", _objectSpread(_objectSpread({
    src: url,
    className: (0, _classnames["default"])(className, _defineProperty({}, _iconModule["default"][iconState], !!iconState)),
    alt: title ? title : 'Close Icon',
    width: "24",
    height: "24"
  }, props), {}, {
    "aria-hidden": title ? 'false' : 'true',
    "aria-label": title ? title : 'Close Icon'
  }));
};

Close24PxOutlinedIcon.displayName = 'Close24PxOutlinedIcon';
Close24PxOutlinedIcon.propTypes = propTypes;
Close24PxOutlinedIcon.defaultProps = defaultProps;

var _default = exports["default"] = Close24PxOutlinedIcon;

/***/ }),

/***/ 94734:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = exports.Error32PxFilledIcon = void 0;

var _react = _interopRequireDefault(__webpack_require__(37667));

var _propTypes = _interopRequireDefault(__webpack_require__(45697));

var _iconModule = _interopRequireDefault(__webpack_require__(35768));

var _classnames = _interopRequireDefault(__webpack_require__(39232));

var _jsxRuntime = __webpack_require__(85893);

var _excluded = ["title", "box", "iconState", "className"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");

  return "symbol" == _typeof(i) ? i : i + "";
}

function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];

  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return ("string" === r ? String : Number)(t);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var propTypes = {
  /** To give the icon additional context if needed */
  title: _propTypes["default"].string,

  /** To display the icon in a fixed sized box */
  box: _propTypes["default"].bool,

  /** To display the icon as white (inverse), disabled (grey) or information (blue) */
  iconState: _propTypes["default"].oneOf(['icon-invert', 'icon-disabled', 'icon-information'])
};
var defaultProps = {
  title: null,
  box: false
};
var url = 'https://www.johnlewis.com/static/ui-assets/hashed/icons-jb/error/error-32px-filled.98e8e711.svg';

var Error32PxFilledIcon = exports.Error32PxFilledIcon = function Error32PxFilledIcon(_ref) {
  var title = _ref.title,
      box = _ref.box,
      iconState = _ref.iconState,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  if (box) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _iconModule["default"].box,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", _objectSpread(_objectSpread({
        src: url,
        className: (0, _classnames["default"])(className, _defineProperty({}, _iconModule["default"][iconState], !!iconState)),
        alt: title ? title : 'Error Icon',
        width: "32",
        height: "32"
      }, props), {}, {
        "aria-hidden": title ? 'false' : 'true',
        "aria-label": title ? title : 'Error Icon'
      }))
    });
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsx)("img", _objectSpread(_objectSpread({
    src: url,
    className: (0, _classnames["default"])(className, _defineProperty({}, _iconModule["default"][iconState], !!iconState)),
    alt: title ? title : 'Error Icon',
    width: "32",
    height: "32"
  }, props), {}, {
    "aria-hidden": title ? 'false' : 'true',
    "aria-label": title ? title : 'Error Icon'
  }));
};

Error32PxFilledIcon.displayName = 'Error32PxFilledIcon';
Error32PxFilledIcon.propTypes = propTypes;
Error32PxFilledIcon.defaultProps = defaultProps;

var _default = exports["default"] = Error32PxFilledIcon;

/***/ }),

/***/ 95819:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = exports.Error32PxFilledRedIcon = void 0;

var _react = _interopRequireDefault(__webpack_require__(37667));

var _propTypes = _interopRequireDefault(__webpack_require__(45697));

var _iconModule = _interopRequireDefault(__webpack_require__(35768));

var _classnames = _interopRequireDefault(__webpack_require__(39232));

var _jsxRuntime = __webpack_require__(85893);

var _excluded = ["title", "box", "iconState", "className"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");

  return "symbol" == _typeof(i) ? i : i + "";
}

function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];

  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return ("string" === r ? String : Number)(t);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var propTypes = {
  /** To give the icon additional context if needed */
  title: _propTypes["default"].string,

  /** To display the icon in a fixed sized box */
  box: _propTypes["default"].bool,

  /** To display the icon as white (inverse), disabled (grey) or information (blue) */
  iconState: _propTypes["default"].oneOf(['icon-invert', 'icon-disabled', 'icon-information'])
};
var defaultProps = {
  title: null,
  box: false
};
var url = 'https://www.johnlewis.com/static/ui-assets/hashed/icons-jb/error/error-32px-filled-red.53b4e39d.svg';

var Error32PxFilledRedIcon = exports.Error32PxFilledRedIcon = function Error32PxFilledRedIcon(_ref) {
  var title = _ref.title,
      box = _ref.box,
      iconState = _ref.iconState,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  if (box) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _iconModule["default"].box,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", _objectSpread(_objectSpread({
        src: url,
        className: (0, _classnames["default"])(className, _defineProperty({}, _iconModule["default"][iconState], !!iconState)),
        alt: title ? title : 'Error Icon',
        width: "32",
        height: "32"
      }, props), {}, {
        "aria-hidden": title ? 'false' : 'true',
        "aria-label": title ? title : 'Error Icon'
      }))
    });
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsx)("img", _objectSpread(_objectSpread({
    src: url,
    className: (0, _classnames["default"])(className, _defineProperty({}, _iconModule["default"][iconState], !!iconState)),
    alt: title ? title : 'Error Icon',
    width: "32",
    height: "32"
  }, props), {}, {
    "aria-hidden": title ? 'false' : 'true',
    "aria-label": title ? title : 'Error Icon'
  }));
};

Error32PxFilledRedIcon.displayName = 'Error32PxFilledRedIcon';
Error32PxFilledRedIcon.propTypes = propTypes;
Error32PxFilledRedIcon.defaultProps = defaultProps;

var _default = exports["default"] = Error32PxFilledRedIcon;

/***/ }),

/***/ 89165:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = exports.Info32PxFilledIcon = void 0;

var _react = _interopRequireDefault(__webpack_require__(37667));

var _propTypes = _interopRequireDefault(__webpack_require__(45697));

var _iconModule = _interopRequireDefault(__webpack_require__(35768));

var _classnames = _interopRequireDefault(__webpack_require__(39232));

var _jsxRuntime = __webpack_require__(85893);

var _excluded = ["title", "box", "iconState", "className"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");

  return "symbol" == _typeof(i) ? i : i + "";
}

function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];

  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return ("string" === r ? String : Number)(t);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var propTypes = {
  /** To give the icon additional context if needed */
  title: _propTypes["default"].string,

  /** To display the icon in a fixed sized box */
  box: _propTypes["default"].bool,

  /** To display the icon as white (inverse), disabled (grey) or information (blue) */
  iconState: _propTypes["default"].oneOf(['icon-invert', 'icon-disabled', 'icon-information'])
};
var defaultProps = {
  title: null,
  box: false
};
var url = 'https://www.johnlewis.com/static/ui-assets/hashed/icons-jb/info/info-32px-filled.bec19bf2.svg';

var Info32PxFilledIcon = exports.Info32PxFilledIcon = function Info32PxFilledIcon(_ref) {
  var title = _ref.title,
      box = _ref.box,
      iconState = _ref.iconState,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  if (box) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _iconModule["default"].box,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", _objectSpread(_objectSpread({
        src: url,
        className: (0, _classnames["default"])(className, _defineProperty({}, _iconModule["default"][iconState], !!iconState)),
        alt: title ? title : 'Info Icon',
        width: "32",
        height: "32"
      }, props), {}, {
        "aria-hidden": title ? 'false' : 'true',
        "aria-label": title ? title : 'Info Icon'
      }))
    });
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsx)("img", _objectSpread(_objectSpread({
    src: url,
    className: (0, _classnames["default"])(className, _defineProperty({}, _iconModule["default"][iconState], !!iconState)),
    alt: title ? title : 'Info Icon',
    width: "32",
    height: "32"
  }, props), {}, {
    "aria-hidden": title ? 'false' : 'true',
    "aria-label": title ? title : 'Info Icon'
  }));
};

Info32PxFilledIcon.displayName = 'Info32PxFilledIcon';
Info32PxFilledIcon.propTypes = propTypes;
Info32PxFilledIcon.defaultProps = defaultProps;

var _default = exports["default"] = Info32PxFilledIcon;

/***/ }),

/***/ 23011:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = exports.Info32PxFilledBlueIcon = void 0;

var _react = _interopRequireDefault(__webpack_require__(37667));

var _propTypes = _interopRequireDefault(__webpack_require__(45697));

var _iconModule = _interopRequireDefault(__webpack_require__(35768));

var _classnames = _interopRequireDefault(__webpack_require__(39232));

var _jsxRuntime = __webpack_require__(85893);

var _excluded = ["title", "box", "iconState", "className"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");

  return "symbol" == _typeof(i) ? i : i + "";
}

function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];

  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return ("string" === r ? String : Number)(t);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var propTypes = {
  /** To give the icon additional context if needed */
  title: _propTypes["default"].string,

  /** To display the icon in a fixed sized box */
  box: _propTypes["default"].bool,

  /** To display the icon as white (inverse), disabled (grey) or information (blue) */
  iconState: _propTypes["default"].oneOf(['icon-invert', 'icon-disabled', 'icon-information'])
};
var defaultProps = {
  title: null,
  box: false
};
var url = 'https://www.johnlewis.com/static/ui-assets/hashed/icons-jb/info/info-32px-filled-blue.8e5ba0f9.svg';

var Info32PxFilledBlueIcon = exports.Info32PxFilledBlueIcon = function Info32PxFilledBlueIcon(_ref) {
  var title = _ref.title,
      box = _ref.box,
      iconState = _ref.iconState,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  if (box) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _iconModule["default"].box,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", _objectSpread(_objectSpread({
        src: url,
        className: (0, _classnames["default"])(className, _defineProperty({}, _iconModule["default"][iconState], !!iconState)),
        alt: title ? title : 'Info Icon',
        width: "32",
        height: "32"
      }, props), {}, {
        "aria-hidden": title ? 'false' : 'true',
        "aria-label": title ? title : 'Info Icon'
      }))
    });
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsx)("img", _objectSpread(_objectSpread({
    src: url,
    className: (0, _classnames["default"])(className, _defineProperty({}, _iconModule["default"][iconState], !!iconState)),
    alt: title ? title : 'Info Icon',
    width: "32",
    height: "32"
  }, props), {}, {
    "aria-hidden": title ? 'false' : 'true',
    "aria-label": title ? title : 'Info Icon'
  }));
};

Info32PxFilledBlueIcon.displayName = 'Info32PxFilledBlueIcon';
Info32PxFilledBlueIcon.propTypes = propTypes;
Info32PxFilledBlueIcon.defaultProps = defaultProps;

var _default = exports["default"] = Info32PxFilledBlueIcon;

/***/ }),

/***/ 56703:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = exports.Info32PxOutlinedIcon = void 0;

var _react = _interopRequireDefault(__webpack_require__(37667));

var _propTypes = _interopRequireDefault(__webpack_require__(45697));

var _iconModule = _interopRequireDefault(__webpack_require__(35768));

var _classnames = _interopRequireDefault(__webpack_require__(39232));

var _jsxRuntime = __webpack_require__(85893);

var _excluded = ["title", "box", "iconState", "className"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");

  return "symbol" == _typeof(i) ? i : i + "";
}

function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];

  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return ("string" === r ? String : Number)(t);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var propTypes = {
  /** To give the icon additional context if needed */
  title: _propTypes["default"].string,

  /** To display the icon in a fixed sized box */
  box: _propTypes["default"].bool,

  /** To display the icon as white (inverse), disabled (grey) or information (blue) */
  iconState: _propTypes["default"].oneOf(['icon-invert', 'icon-disabled', 'icon-information'])
};
var defaultProps = {
  title: null,
  box: false
};
var url = 'https://www.johnlewis.com/static/ui-assets/hashed/icons-jb/info/info-32px-outlined.94cf9d32.svg';

var Info32PxOutlinedIcon = exports.Info32PxOutlinedIcon = function Info32PxOutlinedIcon(_ref) {
  var title = _ref.title,
      box = _ref.box,
      iconState = _ref.iconState,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  if (box) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _iconModule["default"].box,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", _objectSpread(_objectSpread({
        src: url,
        className: (0, _classnames["default"])(className, _defineProperty({}, _iconModule["default"][iconState], !!iconState)),
        alt: title ? title : 'Info Icon',
        width: "32",
        height: "32"
      }, props), {}, {
        "aria-hidden": title ? 'false' : 'true',
        "aria-label": title ? title : 'Info Icon'
      }))
    });
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsx)("img", _objectSpread(_objectSpread({
    src: url,
    className: (0, _classnames["default"])(className, _defineProperty({}, _iconModule["default"][iconState], !!iconState)),
    alt: title ? title : 'Info Icon',
    width: "32",
    height: "32"
  }, props), {}, {
    "aria-hidden": title ? 'false' : 'true',
    "aria-label": title ? title : 'Info Icon'
  }));
};

Info32PxOutlinedIcon.displayName = 'Info32PxOutlinedIcon';
Info32PxOutlinedIcon.propTypes = propTypes;
Info32PxOutlinedIcon.defaultProps = defaultProps;

var _default = exports["default"] = Info32PxOutlinedIcon;

/***/ }),

/***/ 89687:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = exports.Minus24PxOutlinedIcon = void 0;

var _react = _interopRequireDefault(__webpack_require__(37667));

var _propTypes = _interopRequireDefault(__webpack_require__(45697));

var _iconModule = _interopRequireDefault(__webpack_require__(35768));

var _classnames = _interopRequireDefault(__webpack_require__(39232));

var _jsxRuntime = __webpack_require__(85893);

var _excluded = ["title", "box", "iconState", "className"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");

  return "symbol" == _typeof(i) ? i : i + "";
}

function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];

  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return ("string" === r ? String : Number)(t);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var propTypes = {
  /** To give the icon additional context if needed */
  title: _propTypes["default"].string,

  /** To display the icon in a fixed sized box */
  box: _propTypes["default"].bool,

  /** To display the icon as white (inverse), disabled (grey) or information (blue) */
  iconState: _propTypes["default"].oneOf(['icon-invert', 'icon-disabled', 'icon-information'])
};
var defaultProps = {
  title: null,
  box: false
};
var url = 'https://www.johnlewis.com/static/ui-assets/hashed/icons-jb/minus/minus-24px-outlined.921eadd4.svg';

var Minus24PxOutlinedIcon = exports.Minus24PxOutlinedIcon = function Minus24PxOutlinedIcon(_ref) {
  var title = _ref.title,
      box = _ref.box,
      iconState = _ref.iconState,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  if (box) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _iconModule["default"].box,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", _objectSpread(_objectSpread({
        src: url,
        className: (0, _classnames["default"])(className, _defineProperty({}, _iconModule["default"][iconState], !!iconState)),
        alt: title ? title : 'Minus Icon',
        width: "24",
        height: "24"
      }, props), {}, {
        "aria-hidden": title ? 'false' : 'true',
        "aria-label": title ? title : 'Minus Icon'
      }))
    });
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsx)("img", _objectSpread(_objectSpread({
    src: url,
    className: (0, _classnames["default"])(className, _defineProperty({}, _iconModule["default"][iconState], !!iconState)),
    alt: title ? title : 'Minus Icon',
    width: "24",
    height: "24"
  }, props), {}, {
    "aria-hidden": title ? 'false' : 'true',
    "aria-label": title ? title : 'Minus Icon'
  }));
};

Minus24PxOutlinedIcon.displayName = 'Minus24PxOutlinedIcon';
Minus24PxOutlinedIcon.propTypes = propTypes;
Minus24PxOutlinedIcon.defaultProps = defaultProps;

var _default = exports["default"] = Minus24PxOutlinedIcon;

/***/ }),

/***/ 65649:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = exports.Plus24PxOutlinedIcon = void 0;

var _react = _interopRequireDefault(__webpack_require__(37667));

var _propTypes = _interopRequireDefault(__webpack_require__(45697));

var _iconModule = _interopRequireDefault(__webpack_require__(35768));

var _classnames = _interopRequireDefault(__webpack_require__(39232));

var _jsxRuntime = __webpack_require__(85893);

var _excluded = ["title", "box", "iconState", "className"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");

  return "symbol" == _typeof(i) ? i : i + "";
}

function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];

  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return ("string" === r ? String : Number)(t);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var propTypes = {
  /** To give the icon additional context if needed */
  title: _propTypes["default"].string,

  /** To display the icon in a fixed sized box */
  box: _propTypes["default"].bool,

  /** To display the icon as white (inverse), disabled (grey) or information (blue) */
  iconState: _propTypes["default"].oneOf(['icon-invert', 'icon-disabled', 'icon-information'])
};
var defaultProps = {
  title: null,
  box: false
};
var url = 'https://www.johnlewis.com/static/ui-assets/hashed/icons-jb/plus/plus-24px-outlined.606d8737.svg';

var Plus24PxOutlinedIcon = exports.Plus24PxOutlinedIcon = function Plus24PxOutlinedIcon(_ref) {
  var title = _ref.title,
      box = _ref.box,
      iconState = _ref.iconState,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  if (box) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _iconModule["default"].box,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", _objectSpread(_objectSpread({
        src: url,
        className: (0, _classnames["default"])(className, _defineProperty({}, _iconModule["default"][iconState], !!iconState)),
        alt: title ? title : 'Plus Icon',
        width: "24",
        height: "24"
      }, props), {}, {
        "aria-hidden": title ? 'false' : 'true',
        "aria-label": title ? title : 'Plus Icon'
      }))
    });
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsx)("img", _objectSpread(_objectSpread({
    src: url,
    className: (0, _classnames["default"])(className, _defineProperty({}, _iconModule["default"][iconState], !!iconState)),
    alt: title ? title : 'Plus Icon',
    width: "24",
    height: "24"
  }, props), {}, {
    "aria-hidden": title ? 'false' : 'true',
    "aria-label": title ? title : 'Plus Icon'
  }));
};

Plus24PxOutlinedIcon.displayName = 'Plus24PxOutlinedIcon';
Plus24PxOutlinedIcon.propTypes = propTypes;
Plus24PxOutlinedIcon.defaultProps = defaultProps;

var _default = exports["default"] = Plus24PxOutlinedIcon;

/***/ }),

/***/ 24241:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = exports.SaleTag24PxFilledRedIcon = void 0;

var _react = _interopRequireDefault(__webpack_require__(37667));

var _propTypes = _interopRequireDefault(__webpack_require__(45697));

var _iconModule = _interopRequireDefault(__webpack_require__(35768));

var _classnames = _interopRequireDefault(__webpack_require__(39232));

var _jsxRuntime = __webpack_require__(85893);

var _excluded = ["title", "box", "iconState", "className"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");

  return "symbol" == _typeof(i) ? i : i + "";
}

function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];

  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return ("string" === r ? String : Number)(t);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var propTypes = {
  /** To give the icon additional context if needed */
  title: _propTypes["default"].string,

  /** To display the icon in a fixed sized box */
  box: _propTypes["default"].bool,

  /** To display the icon as white (inverse), disabled (grey) or information (blue) */
  iconState: _propTypes["default"].oneOf(['icon-invert', 'icon-disabled', 'icon-information'])
};
var defaultProps = {
  title: null,
  box: false
};
var url = 'https://www.johnlewis.com/static/ui-assets/hashed/icons-jb/sale-tag/sale-tag-24px-filled-red.92aea36c.svg';

var SaleTag24PxFilledRedIcon = exports.SaleTag24PxFilledRedIcon = function SaleTag24PxFilledRedIcon(_ref) {
  var title = _ref.title,
      box = _ref.box,
      iconState = _ref.iconState,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  if (box) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _iconModule["default"].box,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", _objectSpread(_objectSpread({
        src: url,
        className: (0, _classnames["default"])(className, _defineProperty({}, _iconModule["default"][iconState], !!iconState)),
        alt: title ? title : 'Sale Tag Icon',
        width: "24",
        height: "24"
      }, props), {}, {
        "aria-hidden": title ? 'false' : 'true',
        "aria-label": title ? title : 'Sale Tag Icon'
      }))
    });
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsx)("img", _objectSpread(_objectSpread({
    src: url,
    className: (0, _classnames["default"])(className, _defineProperty({}, _iconModule["default"][iconState], !!iconState)),
    alt: title ? title : 'Sale Tag Icon',
    width: "24",
    height: "24"
  }, props), {}, {
    "aria-hidden": title ? 'false' : 'true',
    "aria-label": title ? title : 'Sale Tag Icon'
  }));
};

SaleTag24PxFilledRedIcon.displayName = 'SaleTag24PxFilledRedIcon';
SaleTag24PxFilledRedIcon.propTypes = propTypes;
SaleTag24PxFilledRedIcon.defaultProps = defaultProps;

var _default = exports["default"] = SaleTag24PxFilledRedIcon;

/***/ }),

/***/ 18669:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

__webpack_unused_export__ = ({
  value: true
});
exports.ZP = __webpack_unused_export__ = void 0;

var _react = _interopRequireDefault(__webpack_require__(37667));

var _propTypes = _interopRequireDefault(__webpack_require__(45697));

var _iconModule = _interopRequireDefault(__webpack_require__(35768));

var _classnames = _interopRequireDefault(__webpack_require__(39232));

var _jsxRuntime = __webpack_require__(85893);

var _excluded = ["title", "box", "iconState", "className"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");

  return "symbol" == _typeof(i) ? i : i + "";
}

function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];

  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return ("string" === r ? String : Number)(t);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var propTypes = {
  /** To give the icon additional context if needed */
  title: _propTypes["default"].string,

  /** To display the icon in a fixed sized box */
  box: _propTypes["default"].bool,

  /** To display the icon as white (inverse), disabled (grey) or information (blue) */
  iconState: _propTypes["default"].oneOf(['icon-invert', 'icon-disabled', 'icon-information'])
};
var defaultProps = {
  title: null,
  box: false
};
var url = 'https://www.johnlewis.com/static/ui-assets/hashed/icons-jb/search/search-24px-outlined.84c5d874.svg';

var Search24PxOutlinedIcon = __webpack_unused_export__ = function Search24PxOutlinedIcon(_ref) {
  var title = _ref.title,
      box = _ref.box,
      iconState = _ref.iconState,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  if (box) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _iconModule["default"].box,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", _objectSpread(_objectSpread({
        src: url,
        className: (0, _classnames["default"])(className, _defineProperty({}, _iconModule["default"][iconState], !!iconState)),
        alt: title ? title : 'Search Icon',
        width: "24",
        height: "24"
      }, props), {}, {
        "aria-hidden": title ? 'false' : 'true',
        "aria-label": title ? title : 'Search Icon'
      }))
    });
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsx)("img", _objectSpread(_objectSpread({
    src: url,
    className: (0, _classnames["default"])(className, _defineProperty({}, _iconModule["default"][iconState], !!iconState)),
    alt: title ? title : 'Search Icon',
    width: "24",
    height: "24"
  }, props), {}, {
    "aria-hidden": title ? 'false' : 'true',
    "aria-label": title ? title : 'Search Icon'
  }));
};

Search24PxOutlinedIcon.displayName = 'Search24PxOutlinedIcon';
Search24PxOutlinedIcon.propTypes = propTypes;
Search24PxOutlinedIcon.defaultProps = defaultProps;

var _default = exports.ZP = Search24PxOutlinedIcon;

/***/ }),

/***/ 77874:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = exports.Tick24PxOutlinedIcon = void 0;

var _react = _interopRequireDefault(__webpack_require__(37667));

var _propTypes = _interopRequireDefault(__webpack_require__(45697));

var _iconModule = _interopRequireDefault(__webpack_require__(35768));

var _classnames = _interopRequireDefault(__webpack_require__(39232));

var _jsxRuntime = __webpack_require__(85893);

var _excluded = ["title", "box", "iconState", "className"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");

  return "symbol" == _typeof(i) ? i : i + "";
}

function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];

  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return ("string" === r ? String : Number)(t);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var propTypes = {
  /** To give the icon additional context if needed */
  title: _propTypes["default"].string,

  /** To display the icon in a fixed sized box */
  box: _propTypes["default"].bool,

  /** To display the icon as white (inverse), disabled (grey) or information (blue) */
  iconState: _propTypes["default"].oneOf(['icon-invert', 'icon-disabled', 'icon-information'])
};
var defaultProps = {
  title: null,
  box: false
};
var url = 'https://www.johnlewis.com/static/ui-assets/hashed/icons-jb/tick/tick-24px-outlined.d0e71e98.svg';

var Tick24PxOutlinedIcon = exports.Tick24PxOutlinedIcon = function Tick24PxOutlinedIcon(_ref) {
  var title = _ref.title,
      box = _ref.box,
      iconState = _ref.iconState,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  if (box) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _iconModule["default"].box,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", _objectSpread(_objectSpread({
        src: url,
        className: (0, _classnames["default"])(className, _defineProperty({}, _iconModule["default"][iconState], !!iconState)),
        alt: title ? title : 'Tick Icon',
        width: "24",
        height: "24"
      }, props), {}, {
        "aria-hidden": title ? 'false' : 'true',
        "aria-label": title ? title : 'Tick Icon'
      }))
    });
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsx)("img", _objectSpread(_objectSpread({
    src: url,
    className: (0, _classnames["default"])(className, _defineProperty({}, _iconModule["default"][iconState], !!iconState)),
    alt: title ? title : 'Tick Icon',
    width: "24",
    height: "24"
  }, props), {}, {
    "aria-hidden": title ? 'false' : 'true',
    "aria-label": title ? title : 'Tick Icon'
  }));
};

Tick24PxOutlinedIcon.displayName = 'Tick24PxOutlinedIcon';
Tick24PxOutlinedIcon.propTypes = propTypes;
Tick24PxOutlinedIcon.defaultProps = defaultProps;

var _default = exports["default"] = Tick24PxOutlinedIcon;

/***/ }),

/***/ 76570:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = exports.TickInCircle32PxFilledIcon = void 0;

var _react = _interopRequireDefault(__webpack_require__(37667));

var _propTypes = _interopRequireDefault(__webpack_require__(45697));

var _iconModule = _interopRequireDefault(__webpack_require__(35768));

var _classnames = _interopRequireDefault(__webpack_require__(39232));

var _jsxRuntime = __webpack_require__(85893);

var _excluded = ["title", "box", "iconState", "className"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");

  return "symbol" == _typeof(i) ? i : i + "";
}

function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];

  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return ("string" === r ? String : Number)(t);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var propTypes = {
  /** To give the icon additional context if needed */
  title: _propTypes["default"].string,

  /** To display the icon in a fixed sized box */
  box: _propTypes["default"].bool,

  /** To display the icon as white (inverse), disabled (grey) or information (blue) */
  iconState: _propTypes["default"].oneOf(['icon-invert', 'icon-disabled', 'icon-information'])
};
var defaultProps = {
  title: null,
  box: false
};
var url = 'https://www.johnlewis.com/static/ui-assets/hashed/icons-jb/tick-in-circle/tick-in-circle-32px-filled.4c6fb055.svg';

var TickInCircle32PxFilledIcon = exports.TickInCircle32PxFilledIcon = function TickInCircle32PxFilledIcon(_ref) {
  var title = _ref.title,
      box = _ref.box,
      iconState = _ref.iconState,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  if (box) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _iconModule["default"].box,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", _objectSpread(_objectSpread({
        src: url,
        className: (0, _classnames["default"])(className, _defineProperty({}, _iconModule["default"][iconState], !!iconState)),
        alt: title ? title : 'Tick In Circle Icon',
        width: "32",
        height: "32"
      }, props), {}, {
        "aria-hidden": title ? 'false' : 'true',
        "aria-label": title ? title : 'Tick In Circle Icon'
      }))
    });
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsx)("img", _objectSpread(_objectSpread({
    src: url,
    className: (0, _classnames["default"])(className, _defineProperty({}, _iconModule["default"][iconState], !!iconState)),
    alt: title ? title : 'Tick In Circle Icon',
    width: "32",
    height: "32"
  }, props), {}, {
    "aria-hidden": title ? 'false' : 'true',
    "aria-label": title ? title : 'Tick In Circle Icon'
  }));
};

TickInCircle32PxFilledIcon.displayName = 'TickInCircle32PxFilledIcon';
TickInCircle32PxFilledIcon.propTypes = propTypes;
TickInCircle32PxFilledIcon.defaultProps = defaultProps;

var _default = exports["default"] = TickInCircle32PxFilledIcon;

/***/ }),

/***/ 94247:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = exports.TickInCircle32PxFilledGreenIcon = void 0;

var _react = _interopRequireDefault(__webpack_require__(37667));

var _propTypes = _interopRequireDefault(__webpack_require__(45697));

var _iconModule = _interopRequireDefault(__webpack_require__(35768));

var _classnames = _interopRequireDefault(__webpack_require__(39232));

var _jsxRuntime = __webpack_require__(85893);

var _excluded = ["title", "box", "iconState", "className"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");

  return "symbol" == _typeof(i) ? i : i + "";
}

function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];

  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return ("string" === r ? String : Number)(t);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var propTypes = {
  /** To give the icon additional context if needed */
  title: _propTypes["default"].string,

  /** To display the icon in a fixed sized box */
  box: _propTypes["default"].bool,

  /** To display the icon as white (inverse), disabled (grey) or information (blue) */
  iconState: _propTypes["default"].oneOf(['icon-invert', 'icon-disabled', 'icon-information'])
};
var defaultProps = {
  title: null,
  box: false
};
var url = 'https://www.johnlewis.com/static/ui-assets/hashed/icons-jb/tick-in-circle/tick-in-circle-32px-filled-green.9e4f1e12.svg';

var TickInCircle32PxFilledGreenIcon = exports.TickInCircle32PxFilledGreenIcon = function TickInCircle32PxFilledGreenIcon(_ref) {
  var title = _ref.title,
      box = _ref.box,
      iconState = _ref.iconState,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  if (box) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _iconModule["default"].box,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", _objectSpread(_objectSpread({
        src: url,
        className: (0, _classnames["default"])(className, _defineProperty({}, _iconModule["default"][iconState], !!iconState)),
        alt: title ? title : 'Tick In Circle Icon',
        width: "32",
        height: "32"
      }, props), {}, {
        "aria-hidden": title ? 'false' : 'true',
        "aria-label": title ? title : 'Tick In Circle Icon'
      }))
    });
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsx)("img", _objectSpread(_objectSpread({
    src: url,
    className: (0, _classnames["default"])(className, _defineProperty({}, _iconModule["default"][iconState], !!iconState)),
    alt: title ? title : 'Tick In Circle Icon',
    width: "32",
    height: "32"
  }, props), {}, {
    "aria-hidden": title ? 'false' : 'true',
    "aria-label": title ? title : 'Tick In Circle Icon'
  }));
};

TickInCircle32PxFilledGreenIcon.displayName = 'TickInCircle32PxFilledGreenIcon';
TickInCircle32PxFilledGreenIcon.propTypes = propTypes;
TickInCircle32PxFilledGreenIcon.defaultProps = defaultProps;

var _default = exports["default"] = TickInCircle32PxFilledGreenIcon;

/***/ }),

/***/ 29554:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = exports.TickInCircle32PxOutlinedIcon = void 0;

var _react = _interopRequireDefault(__webpack_require__(37667));

var _propTypes = _interopRequireDefault(__webpack_require__(45697));

var _iconModule = _interopRequireDefault(__webpack_require__(35768));

var _classnames = _interopRequireDefault(__webpack_require__(39232));

var _jsxRuntime = __webpack_require__(85893);

var _excluded = ["title", "box", "iconState", "className"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");

  return "symbol" == _typeof(i) ? i : i + "";
}

function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];

  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return ("string" === r ? String : Number)(t);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var propTypes = {
  /** To give the icon additional context if needed */
  title: _propTypes["default"].string,

  /** To display the icon in a fixed sized box */
  box: _propTypes["default"].bool,

  /** To display the icon as white (inverse), disabled (grey) or information (blue) */
  iconState: _propTypes["default"].oneOf(['icon-invert', 'icon-disabled', 'icon-information'])
};
var defaultProps = {
  title: null,
  box: false
};
var url = 'https://www.johnlewis.com/static/ui-assets/hashed/icons-jb/tick-in-circle/tick-in-circle-32px-outlined.4b48eef7.svg';

var TickInCircle32PxOutlinedIcon = exports.TickInCircle32PxOutlinedIcon = function TickInCircle32PxOutlinedIcon(_ref) {
  var title = _ref.title,
      box = _ref.box,
      iconState = _ref.iconState,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  if (box) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _iconModule["default"].box,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", _objectSpread(_objectSpread({
        src: url,
        className: (0, _classnames["default"])(className, _defineProperty({}, _iconModule["default"][iconState], !!iconState)),
        alt: title ? title : 'Tick In Circle Icon',
        width: "32",
        height: "32"
      }, props), {}, {
        "aria-hidden": title ? 'false' : 'true',
        "aria-label": title ? title : 'Tick In Circle Icon'
      }))
    });
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsx)("img", _objectSpread(_objectSpread({
    src: url,
    className: (0, _classnames["default"])(className, _defineProperty({}, _iconModule["default"][iconState], !!iconState)),
    alt: title ? title : 'Tick In Circle Icon',
    width: "32",
    height: "32"
  }, props), {}, {
    "aria-hidden": title ? 'false' : 'true',
    "aria-label": title ? title : 'Tick In Circle Icon'
  }));
};

TickInCircle32PxOutlinedIcon.displayName = 'TickInCircle32PxOutlinedIcon';
TickInCircle32PxOutlinedIcon.propTypes = propTypes;
TickInCircle32PxOutlinedIcon.defaultProps = defaultProps;

var _default = exports["default"] = TickInCircle32PxOutlinedIcon;

/***/ }),

/***/ 71227:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = exports.Visible24PxOutlinedIcon = void 0;

var _react = _interopRequireDefault(__webpack_require__(37667));

var _propTypes = _interopRequireDefault(__webpack_require__(45697));

var _iconModule = _interopRequireDefault(__webpack_require__(35768));

var _classnames = _interopRequireDefault(__webpack_require__(39232));

var _jsxRuntime = __webpack_require__(85893);

var _excluded = ["title", "box", "iconState", "className"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");

  return "symbol" == _typeof(i) ? i : i + "";
}

function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];

  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return ("string" === r ? String : Number)(t);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var propTypes = {
  /** To give the icon additional context if needed */
  title: _propTypes["default"].string,

  /** To display the icon in a fixed sized box */
  box: _propTypes["default"].bool,

  /** To display the icon as white (inverse), disabled (grey) or information (blue) */
  iconState: _propTypes["default"].oneOf(['icon-invert', 'icon-disabled', 'icon-information'])
};
var defaultProps = {
  title: null,
  box: false
};
var url = 'https://www.johnlewis.com/static/ui-assets/hashed/icons-jb/visible/visible-24px-outlined.fc91d40e.svg';

var Visible24PxOutlinedIcon = exports.Visible24PxOutlinedIcon = function Visible24PxOutlinedIcon(_ref) {
  var title = _ref.title,
      box = _ref.box,
      iconState = _ref.iconState,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  if (box) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _iconModule["default"].box,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", _objectSpread(_objectSpread({
        src: url,
        className: (0, _classnames["default"])(className, _defineProperty({}, _iconModule["default"][iconState], !!iconState)),
        alt: title ? title : 'Visible Icon',
        width: "24",
        height: "24"
      }, props), {}, {
        "aria-hidden": title ? 'false' : 'true',
        "aria-label": title ? title : 'Visible Icon'
      }))
    });
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsx)("img", _objectSpread(_objectSpread({
    src: url,
    className: (0, _classnames["default"])(className, _defineProperty({}, _iconModule["default"][iconState], !!iconState)),
    alt: title ? title : 'Visible Icon',
    width: "24",
    height: "24"
  }, props), {}, {
    "aria-hidden": title ? 'false' : 'true',
    "aria-label": title ? title : 'Visible Icon'
  }));
};

Visible24PxOutlinedIcon.displayName = 'Visible24PxOutlinedIcon';
Visible24PxOutlinedIcon.propTypes = propTypes;
Visible24PxOutlinedIcon.defaultProps = defaultProps;

var _default = exports["default"] = Visible24PxOutlinedIcon;

/***/ }),

/***/ 52572:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = exports.Warning32PxFilledIcon = void 0;

var _react = _interopRequireDefault(__webpack_require__(37667));

var _propTypes = _interopRequireDefault(__webpack_require__(45697));

var _iconModule = _interopRequireDefault(__webpack_require__(35768));

var _classnames = _interopRequireDefault(__webpack_require__(39232));

var _jsxRuntime = __webpack_require__(85893);

var _excluded = ["title", "box", "iconState", "className"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");

  return "symbol" == _typeof(i) ? i : i + "";
}

function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];

  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return ("string" === r ? String : Number)(t);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var propTypes = {
  /** To give the icon additional context if needed */
  title: _propTypes["default"].string,

  /** To display the icon in a fixed sized box */
  box: _propTypes["default"].bool,

  /** To display the icon as white (inverse), disabled (grey) or information (blue) */
  iconState: _propTypes["default"].oneOf(['icon-invert', 'icon-disabled', 'icon-information'])
};
var defaultProps = {
  title: null,
  box: false
};
var url = 'https://www.johnlewis.com/static/ui-assets/hashed/icons-jb/warning/warning-32px-filled.4a82774a.svg';

var Warning32PxFilledIcon = exports.Warning32PxFilledIcon = function Warning32PxFilledIcon(_ref) {
  var title = _ref.title,
      box = _ref.box,
      iconState = _ref.iconState,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  if (box) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _iconModule["default"].box,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", _objectSpread(_objectSpread({
        src: url,
        className: (0, _classnames["default"])(className, _defineProperty({}, _iconModule["default"][iconState], !!iconState)),
        alt: title ? title : 'Warning Icon',
        width: "32",
        height: "32"
      }, props), {}, {
        "aria-hidden": title ? 'false' : 'true',
        "aria-label": title ? title : 'Warning Icon'
      }))
    });
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsx)("img", _objectSpread(_objectSpread({
    src: url,
    className: (0, _classnames["default"])(className, _defineProperty({}, _iconModule["default"][iconState], !!iconState)),
    alt: title ? title : 'Warning Icon',
    width: "32",
    height: "32"
  }, props), {}, {
    "aria-hidden": title ? 'false' : 'true',
    "aria-label": title ? title : 'Warning Icon'
  }));
};

Warning32PxFilledIcon.displayName = 'Warning32PxFilledIcon';
Warning32PxFilledIcon.propTypes = propTypes;
Warning32PxFilledIcon.defaultProps = defaultProps;

var _default = exports["default"] = Warning32PxFilledIcon;

/***/ }),

/***/ 80089:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = exports.Warning32PxFilledYellowIcon = void 0;

var _react = _interopRequireDefault(__webpack_require__(37667));

var _propTypes = _interopRequireDefault(__webpack_require__(45697));

var _iconModule = _interopRequireDefault(__webpack_require__(35768));

var _classnames = _interopRequireDefault(__webpack_require__(39232));

var _jsxRuntime = __webpack_require__(85893);

var _excluded = ["title", "box", "iconState", "className"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");

  return "symbol" == _typeof(i) ? i : i + "";
}

function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];

  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return ("string" === r ? String : Number)(t);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var propTypes = {
  /** To give the icon additional context if needed */
  title: _propTypes["default"].string,

  /** To display the icon in a fixed sized box */
  box: _propTypes["default"].bool,

  /** To display the icon as white (inverse), disabled (grey) or information (blue) */
  iconState: _propTypes["default"].oneOf(['icon-invert', 'icon-disabled', 'icon-information'])
};
var defaultProps = {
  title: null,
  box: false
};
var url = 'https://www.johnlewis.com/static/ui-assets/hashed/icons-jb/warning/warning-32px-filled-yellow.be6f3ce4.svg';

var Warning32PxFilledYellowIcon = exports.Warning32PxFilledYellowIcon = function Warning32PxFilledYellowIcon(_ref) {
  var title = _ref.title,
      box = _ref.box,
      iconState = _ref.iconState,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  if (box) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _iconModule["default"].box,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", _objectSpread(_objectSpread({
        src: url,
        className: (0, _classnames["default"])(className, _defineProperty({}, _iconModule["default"][iconState], !!iconState)),
        alt: title ? title : 'Warning Icon',
        width: "32",
        height: "32"
      }, props), {}, {
        "aria-hidden": title ? 'false' : 'true',
        "aria-label": title ? title : 'Warning Icon'
      }))
    });
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsx)("img", _objectSpread(_objectSpread({
    src: url,
    className: (0, _classnames["default"])(className, _defineProperty({}, _iconModule["default"][iconState], !!iconState)),
    alt: title ? title : 'Warning Icon',
    width: "32",
    height: "32"
  }, props), {}, {
    "aria-hidden": title ? 'false' : 'true',
    "aria-label": title ? title : 'Warning Icon'
  }));
};

Warning32PxFilledYellowIcon.displayName = 'Warning32PxFilledYellowIcon';
Warning32PxFilledYellowIcon.propTypes = propTypes;
Warning32PxFilledYellowIcon.defaultProps = defaultProps;

var _default = exports["default"] = Warning32PxFilledYellowIcon;

/***/ }),

/***/ 41882:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = exports.Warning32PxOutlinedIcon = void 0;

var _react = _interopRequireDefault(__webpack_require__(37667));

var _propTypes = _interopRequireDefault(__webpack_require__(45697));

var _iconModule = _interopRequireDefault(__webpack_require__(35768));

var _classnames = _interopRequireDefault(__webpack_require__(39232));

var _jsxRuntime = __webpack_require__(85893);

var _excluded = ["title", "box", "iconState", "className"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");

  return "symbol" == _typeof(i) ? i : i + "";
}

function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];

  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return ("string" === r ? String : Number)(t);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var propTypes = {
  /** To give the icon additional context if needed */
  title: _propTypes["default"].string,

  /** To display the icon in a fixed sized box */
  box: _propTypes["default"].bool,

  /** To display the icon as white (inverse), disabled (grey) or information (blue) */
  iconState: _propTypes["default"].oneOf(['icon-invert', 'icon-disabled', 'icon-information'])
};
var defaultProps = {
  title: null,
  box: false
};
var url = 'https://www.johnlewis.com/static/ui-assets/hashed/icons-jb/warning/warning-32px-outlined.80a9d7ef.svg';

var Warning32PxOutlinedIcon = exports.Warning32PxOutlinedIcon = function Warning32PxOutlinedIcon(_ref) {
  var title = _ref.title,
      box = _ref.box,
      iconState = _ref.iconState,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  if (box) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _iconModule["default"].box,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", _objectSpread(_objectSpread({
        src: url,
        className: (0, _classnames["default"])(className, _defineProperty({}, _iconModule["default"][iconState], !!iconState)),
        alt: title ? title : 'Warning Icon',
        width: "32",
        height: "32"
      }, props), {}, {
        "aria-hidden": title ? 'false' : 'true',
        "aria-label": title ? title : 'Warning Icon'
      }))
    });
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsx)("img", _objectSpread(_objectSpread({
    src: url,
    className: (0, _classnames["default"])(className, _defineProperty({}, _iconModule["default"][iconState], !!iconState)),
    alt: title ? title : 'Warning Icon',
    width: "32",
    height: "32"
  }, props), {}, {
    "aria-hidden": title ? 'false' : 'true',
    "aria-label": title ? title : 'Warning Icon'
  }));
};

Warning32PxOutlinedIcon.displayName = 'Warning32PxOutlinedIcon';
Warning32PxOutlinedIcon.propTypes = propTypes;
Warning32PxOutlinedIcon.defaultProps = defaultProps;

var _default = exports["default"] = Warning32PxOutlinedIcon;

/***/ }),

/***/ 87994:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(37667));

var _propTypes = _interopRequireDefault(__webpack_require__(45697));

var _iconModule = _interopRequireDefault(__webpack_require__(35768));

var _jsxRuntime = __webpack_require__(85893);

var _excluded = ["title", "box", "sizeClass", "height", "width"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");

  return "symbol" == _typeof(i) ? i : i + "";
}

function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];

  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return ("string" === r ? String : Number)(t);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var propTypes = {
  /** To give the icon additional context if needed */
  title: _propTypes["default"].string,

  /** To display the icon in a fixed sized box */
  box: _propTypes["default"].bool
};
var defaultProps = {
  title: null,
  box: false,
  sizeClass: 'small'
};

var StarsRatingSmallDeSelectedIcon = function StarsRatingSmallDeSelectedIcon(_ref) {
  var title = _ref.title,
      box = _ref.box,
      sizeClass = _ref.sizeClass,
      height = _ref.height,
      width = _ref.width,
      props = _objectWithoutProperties(_ref, _excluded);

  var svg = /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({}, props), {}, {
    viewBox: "0 0 70 14",
    width: width ? width : 70,
    height: height ? height : 70,
    fill: "currentcolor",
    "aria-labelledby": title ? 'StarsRatingSmallDeSelectedIconTitle' : undefined,
    "aria-hidden": title ? 'false' : 'true',
    role: "img",
    children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      id: "StarsRatingSmallDeSelectedIconTitle",
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M7 0L9.16312 4.32048L14 5.0133L10.5 8.37633L11.3262 13.125L7 10.883L2.67376 13.125L3.5 8.37633L0 5.0133L4.83688 4.32048L7 0Z M21 0L23.1631 4.32048L28 5.0133L24.5 8.37633L25.3262 13.125L21 10.883L16.6738 13.125L17.5 8.37633L14 5.0133L18.8369 4.32048L21 0Z M35 0L37.1631 4.32048L42 5.0133L38.5 8.37633L39.3262 13.125L35 10.883L30.6738 13.125L31.5 8.37633L28 5.0133L32.8369 4.32048L35 0Z M49 0L51.1631 4.32048L56 5.0133L52.5 8.37633L53.3262 13.125L49 10.883L44.6738 13.125L45.5 8.37633L42 5.0133L46.8369 4.32048L49 0Z M63 0L65.1631 4.32048L70 5.0133L66.5 8.37633L67.3262 13.125L63 10.883L58.6738 13.125L59.5 8.37633L56 5.0133L60.8369 4.32048L63 0Z"
    })]
  }));

  if (box) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _iconModule["default"].box,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: _iconModule["default"][sizeClass],
        children: svg
      })
    });
  }

  ;
  return svg;
};

StarsRatingSmallDeSelectedIcon.displayName = 'StarsRatingSmallDeSelectedIcon';
StarsRatingSmallDeSelectedIcon.propTypes = propTypes;
StarsRatingSmallDeSelectedIcon.defaultProps = defaultProps;

var _default = exports["default"] = StarsRatingSmallDeSelectedIcon;

/***/ }),

/***/ 1694:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(37667));

var _propTypes = _interopRequireDefault(__webpack_require__(45697));

var _iconModule = _interopRequireDefault(__webpack_require__(35768));

var _jsxRuntime = __webpack_require__(85893);

var _excluded = ["title", "box", "sizeClass", "height", "width"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");

  return "symbol" == _typeof(i) ? i : i + "";
}

function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];

  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return ("string" === r ? String : Number)(t);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var propTypes = {
  /** To give the icon additional context if needed */
  title: _propTypes["default"].string,

  /** To display the icon in a fixed sized box */
  box: _propTypes["default"].bool
};
var defaultProps = {
  title: null,
  box: false,
  sizeClass: 'small'
};

var StarsRatingSmallSelectedIcon = function StarsRatingSmallSelectedIcon(_ref) {
  var title = _ref.title,
      box = _ref.box,
      sizeClass = _ref.sizeClass,
      height = _ref.height,
      width = _ref.width,
      props = _objectWithoutProperties(_ref, _excluded);

  var svg = /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({}, props), {}, {
    viewBox: "0 0 70 14",
    width: width ? width : 70,
    height: height ? height : 70,
    fill: "currentcolor",
    "aria-labelledby": title ? 'StarsRatingSmallSelectedIconTitle' : undefined,
    "aria-hidden": title ? 'false' : 'true',
    role: "img",
    children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      id: "StarsRatingSmallSelectedIconTitle",
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M7 0L9.16312 4.32048L14 5.0133L10.5 8.37633L11.3262 13.125L7 10.883L2.67376 13.125L3.5 8.37633L0 5.0133L4.83688 4.32048L7 0Z M21 0L23.1631 4.32048L28 5.0133L24.5 8.37633L25.3262 13.125L21 10.883L16.6738 13.125L17.5 8.37633L14 5.0133L18.8369 4.32048L21 0Z M35 0L37.1631 4.32048L42 5.0133L38.5 8.37633L39.3262 13.125L35 10.883L30.6738 13.125L31.5 8.37633L28 5.0133L32.8369 4.32048L35 0Z M49 0L51.1631 4.32048L56 5.0133L52.5 8.37633L53.3262 13.125L49 10.883L44.6738 13.125L45.5 8.37633L42 5.0133L46.8369 4.32048L49 0Z M63 0L65.1631 4.32048L70 5.0133L66.5 8.37633L67.3262 13.125L63 10.883L58.6738 13.125L59.5 8.37633L56 5.0133L60.8369 4.32048L63 0Z"
    })]
  }));

  if (box) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _iconModule["default"].box,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: _iconModule["default"][sizeClass],
        children: svg
      })
    });
  }

  ;
  return svg;
};

StarsRatingSmallSelectedIcon.displayName = 'StarsRatingSmallSelectedIcon';
StarsRatingSmallSelectedIcon.propTypes = propTypes;
StarsRatingSmallSelectedIcon.defaultProps = defaultProps;

var _default = exports["default"] = StarsRatingSmallSelectedIcon;

/***/ }),

/***/ 99556:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(37667));

var _propTypes = _interopRequireDefault(__webpack_require__(45697));

var _classnames = _interopRequireDefault(__webpack_require__(39232));

var _inputModule = _interopRequireDefault(__webpack_require__(2834));

var _jsxRuntime = __webpack_require__(85893);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
      t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}

function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };

  var t = _getRequireWildcardCache(r);

  if (t && t.has(e)) return t.get(e);
  var n = {
    __proto__: null
  },
      a = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var u in e) {
    if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }

  return n["default"] = e, t && t.set(e, n), n;
}

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}

  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");

  return "symbol" == _typeof(i) ? i : i + "";
}

function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];

  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return ("string" === r ? String : Number)(t);
}

var Input = /*#__PURE__*/function (_PureComponent) {
  function Input() {
    _classCallCheck(this, Input);

    return _callSuper(this, Input, arguments);
  }

  _inherits(Input, _PureComponent);

  return _createClass(Input, [{
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          id = _this$props.id,
          type = _this$props.type,
          className = _this$props.className,
          name = _this$props.name,
          value = _this$props.value,
          onChange = _this$props.onChange,
          onFocus = _this$props.onFocus,
          onBlur = _this$props.onBlur,
          placeholder = _this$props.placeholder,
          maxLength = _this$props.maxLength,
          autoFocus = _this$props.autoFocus,
          autoComplete = _this$props.autoComplete,
          readOnly = _this$props.readOnly,
          ariaLabel = _this$props.ariaLabel,
          ariaInvalid = _this$props.ariaInvalid,
          ariaDescribedBy = _this$props.ariaDescribedBy,
          disabled = _this$props.disabled,
          required = _this$props.required,
          defaultValue = _this$props.defaultValue,
          extensionProps = _this$props.extensionProps;
      var valueProp = defaultValue !== undefined ? {
        defaultValue: defaultValue
      } : {
        value: value
      };
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("input", _objectSpread(_objectSpread({
        id: id,
        type: type,
        className: (0, _classnames["default"])(_inputModule["default"]['c-input'], className),
        name: name
      }, valueProp), {}, {
        onChange: onChange,
        onFocus: onFocus,
        onBlur: onBlur,
        placeholder: placeholder,
        maxLength: maxLength,
        autoFocus: autoFocus // eslint-disable-line jsx-a11y/no-autofocus
        ,
        autoComplete: autoComplete,
        readOnly: readOnly,
        "aria-label": ariaLabel,
        "aria-invalid": ariaInvalid,
        "aria-describedby": ariaDescribedBy,
        disabled: disabled,
        required: required,
        ref: function ref(el) {
          _this.input = el;
        }
      }, extensionProps));
    }
  }]);
}(_react.PureComponent);

_defineProperty(Input, "propTypes", {
  /** Required: the unique id of the checkbox input */
  id: _propTypes["default"].string.isRequired,

  /** The input element's type */
  type: _propTypes["default"].string,

  /** Custom class name to be applied */
  className: _propTypes["default"].string,

  /** The name of the input element */
  name: _propTypes["default"].string.isRequired,

  /** The value of the input (if applicable) */
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /** The defaultValue of the input (if applicable) */
  defaultValue: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /** Function to be called when a change event is fired by the input */
  onChange: _propTypes["default"].func,

  /** Function to be called when the input accepts focus */
  onFocus: _propTypes["default"].func,

  /** Function to be called when the input loses focus */
  onBlur: _propTypes["default"].func,

  /** Placeholder text to appear if input is empty */
  placeholder: _propTypes["default"].string,

  /** Set maximum number of characters to be accepted */
  maxLength: _propTypes["default"].number,

  /** Focus on this input when the page loads */
  autoFocus: _propTypes["default"].bool,

  /**  */
  autoComplete: _propTypes["default"].string,

  /** Mark the textarea as readonly so it can't be edited */
  readOnly: _propTypes["default"].bool,

  /** Set the aria-label attribute */
  ariaLabel: _propTypes["default"].string,

  /** Set the aria-invalid attribute */
  ariaInvalid: _propTypes["default"].string,

  /** Set the aria-describedby attribute */
  ariaDescribedBy: _propTypes["default"].string,

  /** Disable the textarea element */
  disabled: _propTypes["default"].bool,

  /** Mark the input element as a required field */
  required: _propTypes["default"].bool,

  /**  */
  extensionProps: _propTypes["default"].objectOf(_propTypes["default"].any)
});

_defineProperty(Input, "defaultProps", {
  className: undefined,
  type: 'text',
  //
  value: '',
  onChange: function onChange() {},
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  //
  placeholder: undefined,
  maxLength: null,
  autoFocus: false,
  autoComplete: 'on',
  readOnly: false,
  ariaLabel: undefined,
  ariaInvalid: undefined,
  ariaDescribedBy: undefined,
  disabled: false,
  required: false,
  defaultValue: undefined,
  //
  extensionProps: {}
});

var _default = exports["default"] = Input;

/***/ }),

/***/ 60768:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(37667));

var _propTypes = _interopRequireDefault(__webpack_require__(45697));

var _classnames = _interopRequireDefault(__webpack_require__(39232));

var _get = _interopRequireDefault(__webpack_require__(27361));

var _staticContentPropCheck = _interopRequireDefault(__webpack_require__(85730));

var _selectModule = _interopRequireDefault(__webpack_require__(56251));

var _jsxRuntime = __webpack_require__(85893);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
      t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}

function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };

  var t = _getRequireWildcardCache(r);

  if (t && t.has(e)) return t.get(e);
  var n = {
    __proto__: null
  },
      a = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var u in e) {
    if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }

  return n["default"] = e, t && t.set(e, n), n;
}

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}

  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");

  return "symbol" == _typeof(i) ? i : i + "";
}

function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];

  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return ("string" === r ? String : Number)(t);
}

var Select = /*#__PURE__*/function (_PureComponent) {
  function Select(props) {
    var _this;

    _classCallCheck(this, Select);

    _this = _callSuper(this, Select, [props]);

    _defineProperty(_this, "onChange", function (evt) {
      var onChange = _this.props.onChange;
      var value = evt.target.value;

      _this.setState({
        value: value
      });

      onChange(evt);
    });

    _defineProperty(_this, "onFocus", function (evt) {
      var onFocus = _this.props.onFocus;
      var value = evt.target.value;

      _this.setState({
        value: value
      });

      onFocus(evt);
    });

    _defineProperty(_this, "onBlur", function (evt) {
      var onBlur = _this.props.onBlur;
      var value = evt.target.value;

      _this.setState({
        value: value
      });

      onBlur(evt);
    });

    _this.state = {
      value: _this.props.value || (0, _get["default"])(_this.props, 'options[0].value')
    };
    return _this;
  }
  /* https://gitlab.com/JohnLewisPartnership/jl-ui/jl-ui-kit/-/issues/237 */


  _inherits(Select, _PureComponent);

  return _createClass(Select, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      this.setState({
        value: nextProps.value
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          id = _this$props.id,
          className = _this$props.className,
          options = _this$props.options,
          optgroup = _this$props.optgroup,
          name = _this$props.name,
          disabled = _this$props.disabled,
          autoFocus = _this$props.autoFocus,
          required = _this$props.required,
          dataTest = _this$props['data-test'],
          ariaInvalid = _this$props.ariaInvalid,
          ariaDescribedBy = _this$props.ariaDescribedBy,
          ariaLabel = _this$props.ariaLabel;
      var noOptions = !options || options.length === 0;
      var noOptGroup = !optgroup || optgroup.length === 0;

      if (noOptGroup && noOptions) {
        return null;
      }

      var value = this.state.value;
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("select", {
        id: id,
        className: (0, _classnames["default"])(_selectModule["default"]['c-select'], className, _selectModule["default"]['joyfully-bold']),
        name: name,
        value: value,
        disabled: disabled,
        onChange: this.onChange,
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        autoFocus: autoFocus // eslint-disable-line jsx-a11y/no-autofocus
        ,
        required: required,
        "data-test": dataTest,
        "aria-invalid": ariaInvalid,
        "aria-describedby": ariaDescribedBy,
        "aria-label": ariaLabel,
        ref: function ref(el) {
          _this2.select = el;
        },
        children: [options && options.map(function (option) {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
            value: option.value,
            disabled: option.disabled,
            hidden: option.hidden,
            children: option.label
          }, option.value);
        }), optgroup && optgroup.map(function (optgroupItem) {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)("optgroup", {
            label: optgroupItem.label,
            children: optgroupItem.options.map(function (option) {
              return /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
                value: option.value,
                disabled: option.disabled,
                hidden: option.hidden,
                children: option.label
              }, option.value);
            })
          }, optgroupItem.label);
        })]
      });
    }
  }]);
}(_react.PureComponent);

_defineProperty(Select, "propTypes", {
  /** Unique ID for the select element */
  id: _propTypes["default"].string.isRequired,

  /** Custom class name to be added */
  className: _propTypes["default"].string,

  /** Array of options to be presented */
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _staticContentPropCheck["default"],
    disabled: _propTypes["default"].bool,
    hidden: _propTypes["default"].bool
  })).isRequired,

  /** Array of optgroup to be presented */
  optgroup: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _staticContentPropCheck["default"],
    options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      label: _staticContentPropCheck["default"],
      disabled: _propTypes["default"].bool,
      hidden: _propTypes["default"].bool
    }))
  })),

  /** Optional data-test attribute */
  'data-test': _propTypes["default"].string,

  /** Set the aria-invalid attribute */
  ariaInvalid: _propTypes["default"].string,

  /** Set the aria-label attribute */
  ariaLabel: _propTypes["default"].string,

  /** Set the aria-describedby attribute */
  ariaDescribedBy: _propTypes["default"].string,

  /** Name of the select element */
  name: _propTypes["default"].string.isRequired,

  /** Default value to use if none is selected - this is non-standard to HTML */
  value: _propTypes["default"].string,

  /** Disable the select element */
  disabled: _propTypes["default"].bool,

  /** Function to be called when a change event is fired by the select */
  onChange: _propTypes["default"].func,

  /** Function to be called when the select accepts focus */
  onFocus: _propTypes["default"].func,

  /** Function to be called when the select loses focus */
  onBlur: _propTypes["default"].func,

  /** Focus on this input when the page loads */
  autoFocus: _propTypes["default"].bool,

  /** Mark the select element as a required field */
  required: _propTypes["default"].bool
});

_defineProperty(Select, "defaultProps", {
  className: undefined,
  disabled: false,
  'data-test': undefined,
  ariaInvalid: undefined,
  ariaDescribedBy: undefined,
  ariaLabel: undefined,
  optgroup: undefined,
  //
  onChange: function onChange() {},
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  //
  autoFocus: false,
  required: undefined,
  value: ''
});

var _default = exports["default"] = Select;

/***/ }),

/***/ 11217:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.openMiniBasket = void 0;

var openMiniBasket = exports.openMiniBasket = function openMiniBasket(event) {
  if (window.isMinibasketLoaded) {
    event.preventDefault();
    window.dispatchEvent(new CustomEvent('jl-events.browser.showMinibasket', {
      detail: {
        source: 'page'
      }
    }));
  }
};

/***/ }),

/***/ 16088:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.isBasketPageType = void 0;

var isBasketPageType = exports.isBasketPageType = function isBasketPageType() {
  var _jlData$page;

  var jlData = window.jlData || {};
  return ((_jlData$page = jlData.page) === null || _jlData$page === void 0 || (_jlData$page = _jlData$page.pageInfo) === null || _jlData$page === void 0 ? void 0 : _jlData$page.pageType) === 'shopping basket';
};

/***/ }),

/***/ 45384:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.useCachedBasketData = exports.getDataFromCookie = exports.BASKET_QTY_UPDATED_EVENT = void 0;

var _react = __webpack_require__(37667);

var _env = _interopRequireDefault(__webpack_require__(61635));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");

  return "symbol" == _typeof(i) ? i : i + "";
}

function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];

  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return ("string" === r ? String : Number)(t);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];

  if (null != t) {
    var e,
        n,
        i,
        u,
        a = [],
        f = !0,
        o = !1;

    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) {
        ;
      }
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }

    return a;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var initialParse = false;
var basketData = {
  products: []
};
var cacheKey = 0;
var callbackCache = {};
var BASKET_COOKIE = /(?:^|; ?)cached_basket=([^;]+)/;
var BASKET_QTY_UPDATED_EVENT = exports.BASKET_QTY_UPDATED_EVENT = 'jl-events.browser.basketQuantityUpdated';

var generateCacheKey = function generateCacheKey() {
  return cacheKey++;
};

var mapServiceItems = function mapServiceItems(services) {
  var _services$split = services.split('-'),
      _services$split2 = _slicedToArray(_services$split, 5),
      productId = _services$split2[1],
      sku = _services$split2[2],
      itemPrice = _services$split2[3],
      qty = _services$split2[4];

  return {
    itemPrice: itemPrice,
    productId: productId,
    qty: qty,
    sku: sku
  };
};

var mapBasketItems = function mapBasketItems(item) {
  var _item$split = item.split('|'),
      _item$split2 = _slicedToArray(_item$split, 7),
      productId = _item$split2[1],
      sku = _item$split2[3],
      itemPrice = _item$split2[4],
      qty = _item$split2[5],
      additionalServices = _item$split2[6];

  var services = [];

  if (additionalServices) {
    // TODO: what if there are more than 1 "addons"?
    // I could only find an instance where there is 1 additional addon
    services.push.apply(services, _toConsumableArray([additionalServices].map(mapServiceItems)));
  }

  return {
    itemPrice: itemPrice,
    productId: productId,
    services: services,
    qty: qty,
    sku: sku
  };
};

var parseBasketCookie = function parseBasketCookie(basketCookie) {
  if (!basketCookie) {
    return {
      products: []
    };
  } // split all items in the cookie string


  var basket = basketCookie.split(/\|?\^/); // retrieve the totals (appear to ALAWYS be last two elements)

  var totals = basket.splice(basket.length - 2); // reduce the totals array and build an object of keys and values

  var information = totals.reduce(function (obj, info) {
    var _info$split = info.split('='),
        _info$split2 = _slicedToArray(_info$split, 2),
        key = _info$split2[0],
        value = _info$split2[1];

    return Object.assign(obj, _defineProperty({}, key, value));
  }, {});
  var products = basket.map(mapBasketItems);
  return _objectSpread({
    products: products
  }, information);
};

var getDataFromCookie = exports.getDataFromCookie = function getDataFromCookie() {
  var _ref = document.cookie.match(BASKET_COOKIE) || [],
      _ref2 = _slicedToArray(_ref, 2),
      basketCookie = _ref2[1];

  return parseBasketCookie(basketCookie);
};

var updateCachedBasketData = function updateCachedBasketData() {
  basketData = getDataFromCookie();
  Object.values(callbackCache).forEach(function (callback) {
    callback(basketData);
  });
};

var subscribeToCachedBasketData = function subscribeToCachedBasketData(key, callback) {
  callbackCache[key] = callback;

  if (!initialParse) {
    basketData = getDataFromCookie();
    initialParse = true;
  }

  callback(basketData);
};

var unSubscribeToCachedBasketData = function unSubscribeToCachedBasketData(key) {
  delete callbackCache[key];
};

if (_env["default"].isClient) {
  window.addEventListener(BASKET_QTY_UPDATED_EVENT, updateCachedBasketData);
}

var useCachedBasketData = exports.useCachedBasketData = function useCachedBasketData() {
  var _useState = (0, _react.useState)(basketData),
      _useState2 = _slicedToArray(_useState, 2),
      cachedBasketData = _useState2[0],
      setCachedBasketData = _useState2[1];

  (0, _react.useEffect)(function () {
    var key = generateCacheKey();
    subscribeToCachedBasketData(key, setCachedBasketData);
    return function () {
      unSubscribeToCachedBasketData(key);
    };
  }, []);
  return cachedBasketData;
};

/***/ }),

/***/ 70:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.isMidTierBrand = exports.isAnydayBrand = exports.getBrand = void 0;

var _anyday = _interopRequireDefault(__webpack_require__(23160));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var defaultBrandConfiguration = [{
  name: 'CHANEL',
  id: 'chanel',
  brandRegex: new RegExp(/^CHANEL/),
  titleRegex: new RegExp(/^CHANEL/)
}, {
  name: 'ANYDAY',
  id: 'anyday',
  brandRegex: new RegExp(/(^ANYDAY|^Anyday).*John.*Lewis/),
  titleRegex: new RegExp(/(^ANYDAY|^Anyday)/),
  image: _anyday["default"]
}, {
  name: 'ANYDAY',
  namePrefix: 'John Lewis ',
  id: 'anyday',
  brandRegex: new RegExp(/^anyday|^john lewis anyday/, 'i'),
  titleRegex: new RegExp(/^anyday|^john lewis anyday/, 'i'),
  image: _anyday["default"]
}, {
  name: 'John Lewis & Partners',
  id: 'john-lewis',
  brandRegex: new RegExp(/^john lewis & partners/, 'i'),
  titleRegex: new RegExp(/^john lewis & partners/, 'i')
}, {
  name: 'John Lewis',
  id: 'john-lewis',
  brandRegex: new RegExp(/^john lewis/, 'i'),
  titleRegex: new RegExp(/^john lewis/, 'i')
}];

var getBrand = exports.getBrand = function getBrand(title, customBrandConfiguration) {
  if (!title) return undefined;
  var brandConfiguration = customBrandConfiguration || defaultBrandConfiguration;
  var brandConfig = brandConfiguration.find(function (element) {
    return title.match(element.brandRegex);
  });
  return brandConfig ? {
    id: brandConfig.id,
    name: brandConfig.name,
    namePrefix: brandConfig.namePrefix,
    titleWithoutBrandName: title.replace(brandConfig.titleRegex, ''),
    image: brandConfig.image
  } : undefined;
};

var isAnydayBrand = exports.isAnydayBrand = function isAnydayBrand(brand) {
  return Boolean(brand === null || brand === void 0 ? void 0 : brand.match(new RegExp(/^anyday|^john lewis anyday/, 'i')));
};

var isMidTierBrand = exports.isMidTierBrand = function isMidTierBrand(brand) {
  return Boolean(brand === null || brand === void 0 ? void 0 : brand.match(new RegExp(/^john lewis$/, 'i')));
};

/***/ }),

/***/ 54866:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var calcNumberDisplayed = function calcNumberDisplayed() {
  var buttonWidths = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var containerWidth = arguments.length > 1 ? arguments[1] : undefined;
  var rightPadding = 16;
  var showMoreButtonWidth = 96;
  var widthAcc = 0;
  var totalDisplayedWidth = 0;
  var i = 0;
  buttonWidths.forEach(function (buttonWidth) {
    var widthWithPadding = buttonWidth + rightPadding;
    widthAcc += widthWithPadding;

    if (widthAcc <= containerWidth) {
      i++;
      totalDisplayedWidth = widthAcc;
    }
  });

  if (i < buttonWidths.length) {
    var spaceForShowMoreButton = containerWidth - totalDisplayedWidth;
    if (spaceForShowMoreButton < showMoreButtonWidth) i--;
  }

  return i;
};

var _default = exports["default"] = calcNumberDisplayed;

/***/ }),

/***/ 59467:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0; // NAMING CONVENTION FOR KEYS
// useCaseDescription
// eg:
// - formLabelEmail: 'Email',
// - formValidationEmailRequired: 'please enter an email'
// - formSubmitButtonLogin: 'Login'
// - commonLabelPhoneNumber: '03456 049 049',
// - messageInternalServerErrorTitle: 'Sorry, we’ve had a technical problem',
// - messageInternalServerErrorBody: 'Please <a href="${url}" data-action="handback">return to the homepage</a> and try again',

var defaultStaticContent = {};

var _default = exports["default"] = defaultStaticContent;

/***/ }),

/***/ 53884:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _isString = _interopRequireDefault(__webpack_require__(47037));

var _isPlainObject = _interopRequireDefault(__webpack_require__(68630));

var _replaceStringVars = _interopRequireDefault(__webpack_require__(90347));

var _defaultStaticContent = _interopRequireDefault(__webpack_require__(59467));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");

  return "symbol" == _typeof(i) ? i : i + "";
}

function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];

  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return ("string" === r ? String : Number)(t);
}
/**
 * Singleton for managing access to a static content object
 * set(source) : Content object can be set from @source object
 * get(key, vars) : Returns a value based on @key and optional @vars.
 * @key = 'aKey'
 * @vars = { varPlaceholderName: 'valueToReplacePlaceholderWith'}
 * If @key value is FALSEY the key is returned
 * If @key value is a string and @vars object is provided, the string is processed with replaceStringVars
 */


var StaticContent = /*#__PURE__*/function () {
  function StaticContent() {
    _classCallCheck(this, StaticContent);

    this.content = _defaultStaticContent["default"];
  }

  return _createClass(StaticContent, [{
    key: "set",
    value: function set() {
      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}; // console.warn('StaticContent set:', source);

      if (!(0, _isPlainObject["default"])(source)) {
        console.error('Expected object with key value pairs'); // eslint-disable-line no-console

        return;
      }

      this.content = Object.assign({}, _defaultStaticContent["default"], source);
    }
  }, {
    key: "get",
    value: function get(key, vars) {
      var hasVars = (0, _isPlainObject["default"])(vars); // if no value use the key

      var content = this.content[key];

      if (content && (0, _isString["default"])(content)) {
        // replace any string vars if supplied
        return hasVars ? (0, _replaceStringVars["default"])(content, vars) : content;
      }

      throw new Error("Static Content key cannot be found: ".concat(key));
    }
  }, {
    key: "add",
    value: function add() {
      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.content = Object.assign(this.content, source);
    }
  }, {
    key: "getContent",
    value: function getContent() {
      return this.content;
    }
  }]);
}();

var _default = exports["default"] = new StaticContent();

/***/ }),

/***/ 85730:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _staticContent = _interopRequireDefault(__webpack_require__(53884));

var _checkHTML = _interopRequireDefault(__webpack_require__(24192));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var staticContentPropCheck = function staticContentPropCheck(props, propName, componentName) {
  var propValue = props[propName];
  var valueToCheck = Array.isArray(propValue) && typeof propValue[0] === 'string' ? propValue[0] : propValue;

  if (typeof valueToCheck !== 'string') {
    return null;
  }

  if ((0, _checkHTML["default"])(valueToCheck)) {
    return new Error("String containing markup provided as prop \"".concat(propName, "\" to ").concat(componentName, ". ").concat(componentName, " will no longer parse markup. See the migration guide for more info https://gitlab.com/JohnLewisPartnership/jl-ui/jl-ui-kit/-/blob/main/migration.md#migrating-from-29-to-30"));
  }

  try {
    _staticContent["default"].get(valueToCheck);
  } catch (e) {
    return null;
  }

  return new Error("Static content key \"".concat(valueToCheck, "\" provided as prop \"").concat(propName, "\" to ").concat(componentName, ". ").concat(componentName, " will no longer convert static content keys. See the migration guide for more info https://gitlab.com/JohnLewisPartnership/jl-ui/jl-ui-kit/-/blob/main/migration.md#migrating-from-29-to-30"));
};

var requiredStaticContentPropCheck = function requiredStaticContentPropCheck(props, propName, componentName) {
  var propValue = props[propName];

  if (typeof propValue === 'undefined') {
    return new Error("Missing required \"".concat(propName, "\" prop in ").concat(componentName, " component"));
  }

  return staticContentPropCheck(props, propName, componentName);
};

staticContentPropCheck.isRequired = requiredStaticContentPropCheck;

var _default = exports["default"] = staticContentPropCheck;

/***/ }),

/***/ 61635:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");

  return "symbol" == _typeof(i) ? i : i + "";
}

function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];

  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return ("string" === r ? String : Number)(t);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
/**
 * Singleton to hold context props for the environment the app is running in
 * Note: requires window.env.ENV object to be set in the browser
 * @returns {object}
 */


var Env = /*#__PURE__*/_createClass(function Env() {
  _classCallCheck(this, Env);

  if (!Env.instance) {
    var isClient = true;
    var env = isClient && window.env && window.env.ENV || {};
    Env.instance = {
      isClient: isClient,
      isClientLocal: isClient && env === 'local',
      isClientDev: isClient && env === 'dev',
      isClientTest: isClient && env === 'test',
      isClientProd: isClient && env === 'prod',
      isClientNonProd: isClient && (env === 'local' || env === 'dev' || env === 'test')
    };
  }

  return Env.instance;
});

var _default = exports["default"] = new Env();

/***/ }),

/***/ 28464:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.useEmailConfirmed = void 0;

var _react = __webpack_require__(37667);

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];

  if (null != t) {
    var e,
        n,
        i,
        u,
        a = [],
        f = !0,
        o = !1;

    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) {
        ;
      }
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }

    return a;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var useEmailConfirmed = exports.useEmailConfirmed = function useEmailConfirmed(hasEmailMeWhenAvailableButton, id) {
  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isEmailConfirmed = _useState2[0],
      setIsEmailConfirmed = _useState2[1];

  var handleEmailMeEvent = (0, _react.useCallback)(function (event) {
    if (event.detail === id) {
      setIsEmailConfirmed(true);
    }
  }, [id]);
  (0, _react.useEffect)(function () {
    if (hasEmailMeWhenAvailableButton) {
      window.addEventListener('jl.emailMe.success', handleEmailMeEvent);
    }

    return function () {
      window.removeEventListener('jl.emailMe.success', handleEmailMeEvent);
    };
  }, [hasEmailMeWhenAvailableButton, handleEmailMeEvent]);
  return isEmailConfirmed;
};

/***/ }),

/***/ 92667:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.useWindowSize = void 0;

var _react = __webpack_require__(37667);

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];

  if (null != t) {
    var e,
        n,
        i,
        u,
        a = [],
        f = !0,
        o = !1;

    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) {
        ;
      }
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }

    return a;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var useWindowSize = exports.useWindowSize = function useWindowSize() {
  var _useState = (0, _react.useState)({
    isMaxTabletSize: false,
    isMaxMobileSize: false
  }),
      _useState2 = _slicedToArray(_useState, 2),
      windowSize = _useState2[0],
      setWindowSize = _useState2[1];

  var handleResize = function handleResize() {
    var _window$matchMedia, _window$matchMedia2;

    setWindowSize({
      isMaxMobileSize: (_window$matchMedia = window.matchMedia('(max-width: 767px)')) === null || _window$matchMedia === void 0 ? void 0 : _window$matchMedia.matches,
      isMaxTabletSize: (_window$matchMedia2 = window.matchMedia('(max-width: 1023px)')) === null || _window$matchMedia2 === void 0 ? void 0 : _window$matchMedia2.matches
    });
  };

  (0, _react.useEffect)(function () {
    handleResize();
    window.addEventListener('resize', handleResize);
    return function () {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return windowSize;
};

/***/ }),

/***/ 570:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _matchFirstNumber = _interopRequireDefault(__webpack_require__(26907));

var _formattedPrice = _interopRequireDefault(__webpack_require__(46742));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];

  if (null != t) {
    var e,
        n,
        i,
        u,
        a = [],
        f = !0,
        o = !1;

    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) {
        ;
      }
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }

    return a;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

var getPriceReduction = function getPriceReduction(priceFrom, priceTo) {
  var from = (0, _matchFirstNumber["default"])(priceFrom);
  var to = (0, _matchFirstNumber["default"])(priceTo);
  var reduction = from - to;

  if (reduction > 0) {
    // when reduction returns a float e.g. 15.04666
    // ensure that rounding is done before calling formattedPrice to return
    // expected value of 15.05 and not 15.04
    return Math.round(parseFloat(reduction) * 100) / 100;
  } else {
    return null;
  }
};

var calculatePriceReduction = function calculatePriceReduction(price) {
  var country = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en-GB';
  var currency = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GBP';
  var amountFrom = null;
  var amountTo = null; // 4 scenarios:
  // scenario 1: was (string/number) & now (string)
  // scenario 2: was (string/number) & now (object)
  // scenario 3: was (object) & now (string/number)
  // scenario 4: was (object) & now (object)

  if (!!price.was && !!price.now) {
    if (_typeof(price.was) !== 'object' && _typeof(price.now) !== 'object') {
      // scenario 1 { was: '200.00', now: '100.00' }
      var amount = getPriceReduction(price.was, price.now);
      return amount && (0, _formattedPrice["default"])(amount, country, currency);
    } else if (_typeof(price.was) !== 'object' && _typeof(price.now) === 'object') {
      // scenario 2 { was: '20.00', now: { from: '1.25', to: '8.00' } }
      amountFrom = getPriceReduction(price.was, price.now.from);
      amountTo = getPriceReduction(price.was, price.now.to);
    } else if (_typeof(price.was) === 'object' && _typeof(price.now) !== 'object') {
      // scenario 3 { was: { from: '1.25', to: '8.00' }, now: '20.00' }
      amountFrom = getPriceReduction(price.was.from, price.now);
      amountTo = getPriceReduction(price.was.to, price.now);
    } else if (_typeof(price.was) === 'object' && _typeof(price.now) === 'object') {
      // scenario 4 { was: { from: '2.50', to: '16.00' }, now: { from: '1.25', to: '8.00' } }
      amountFrom = getPriceReduction(price.was.from, price.now.from);
      amountTo = getPriceReduction(price.was.to, price.now.to);
    } // sort array and destructure


    var _sort = [amountFrom, amountTo].sort(function (a, b) {
      return a - b;
    });

    var _sort2 = _slicedToArray(_sort, 2);

    amountFrom = _sort2[0];
    amountTo = _sort2[1];

    if (!amountFrom && !amountTo) {
      return null;
    }

    var from = (0, _formattedPrice["default"])(amountFrom, country, currency);
    var to = (0, _formattedPrice["default"])(amountTo, country, currency);
    return from !== to ? "".concat(from, " \u2013 ").concat(to) : from;
  } else {
    return null;
  }
};

var _default = exports["default"] = calculatePriceReduction;

/***/ }),

/***/ 46742:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _twoDecimalPlaces = _interopRequireDefault(__webpack_require__(16243));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var formattedPrice = function formattedPrice(number) {
  var country = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en-GB';
  var currency = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GBP';
  var price = (0, _twoDecimalPlaces["default"])(number);
  return new Intl.NumberFormat(country, {
    style: 'currency',
    currency: currency
  }).format(price).replace(/\s/g, '');
};

var _default = exports["default"] = formattedPrice;

/***/ }),

/***/ 84225:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var SINGLE_QUOTE = /'/g;
var DIACRITICAL_MARKS = /[\u0300-\u036f]/g;
var INCHES = /([0-9]+)["”]/g;
var NON_ALPHA_NUMERIC = /[^A-Za-z0-9]/g;
var CONTIGUOUS_WHITESPACE = /\s+/g;

var sanitiseString = function sanitiseString(string) {
  return string.normalize('NFD').replace(SINGLE_QUOTE, '').replace(DIACRITICAL_MARKS, '').replace(INCHES, '$1 inch').replace(NON_ALPHA_NUMERIC, ' ').trim().replace(CONTIGUOUS_WHITESPACE, '-').toLowerCase();
};

var getProductUrl = function getProductUrl(title, id, selectedSwatch, adId) {
  var encodedTitle = sanitiseString(title);
  var fragmentId = adId ? "#citrusAdId=".concat(adId) : '';

  if (selectedSwatch && Object.keys(selectedSwatch).length) {
    var color = selectedSwatch.color;
    return "/".concat(encodedTitle).concat(color ? "/".concat(sanitiseString(color)) : '', "/p").concat(id).concat(fragmentId);
  }

  return "/".concat(encodedTitle, "/p").concat(id).concat(fragmentId);
};

var _default = exports["default"] = getProductUrl;

/***/ }),

/***/ 26907:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var matchFirstNumber = function matchFirstNumber(value) {
  if (!value) {
    return 0;
  }

  var valueAsString = typeof value === 'number' ? value.toString() : value; // this will match the first occurrence of a number in a string

  var matches = valueAsString.match(/[0-9,]+(?:\.\d{0,2})?/);
  return matches && parseFloat(matches[0].replace(/,/g, '')) || 0;
};

var _default = exports["default"] = matchFirstNumber;

/***/ }),

/***/ 16243:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _matchFirstNumber = _interopRequireDefault(__webpack_require__(26907));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var twoDecimalPlaces = function twoDecimalPlaces(data) {
  return (0, _matchFirstNumber["default"])(data).toFixed(2);
};

var _default = exports["default"] = twoDecimalPlaces;

/***/ }),

/***/ 29997:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.setScene7UrlQueryParams = void 0;

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];

  if (null != t) {
    var e,
        n,
        i,
        u,
        a = [],
        f = !0,
        o = !1;

    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) {
        ;
      }
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }

    return a;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var addProtocol = function addProtocol(url) {
  return url.startsWith('//') ? "https:".concat(url) : url;
};

var stripPresets = function stripPresets(url) {
  var presets = url.match(/(\$(.[^$]+)\$)/g) || [];
  return presets.reduce(function (reducedUrl, preset) {
    return reducedUrl.replace(preset, '');
  }, url);
};

var stripSrcParam = function stripSrcParam() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var srcParams = url.match(/(src=ir\(.+\))/g) || [];
  return [srcParams.length === 0 ? url : url.replace(srcParams[0], ''), srcParams[0]];
};

var getQueryPrefix = function getQueryPrefix(url) {
  if (!url.includes('?')) {
    return '?';
  } else if (url.endsWith('&')) {
    return '';
  } else return '&';
};

var setScene7UrlQueryParams = exports.setScene7UrlQueryParams = function setScene7UrlQueryParams() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var queryParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _stripSrcParam = stripSrcParam(stripPresets(url)),
      _stripSrcParam2 = _slicedToArray(_stripSrcParam, 2),
      strippedUrl = _stripSrcParam2[0],
      srcParam = _stripSrcParam2[1];

  var urlObj;

  try {
    urlObj = new URL(addProtocol(strippedUrl));
  } catch (e) {
    return "".concat(url).concat(getQueryPrefix(url)).concat(Object.entries(queryParams).map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          val = _ref2[1];

      return "".concat(key, "=").concat(val);
    }).join('&'));
  }

  Object.entries(queryParams).forEach(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        key = _ref4[0],
        val = _ref4[1];

    urlObj.searchParams.set(key, val);
  });
  var urlString = srcParam ? urlObj.toString().replace("?", "?".concat(srcParam, "&")) : urlObj.toString();
  return urlString.substring(urlString.indexOf('//'));
};

/***/ }),

/***/ 13076:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.setNoScroll = void 0;

var _noScroll = _interopRequireDefault(__webpack_require__(70743));

var _env = _interopRequireDefault(__webpack_require__(61635));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
} // Prevent the document from scrolling.  Useful if e.g. modal is
// showing and you don't want the background to be scrollable.


var setNoScroll = exports.setNoScroll = function setNoScroll(isModalOpen, disableModalAttributes) {
  if (_env["default"].isClient) {
    if (isModalOpen) {
      _noScroll["default"].on();

      if (!disableModalAttributes) {
        document.documentElement.setAttribute('data-modal', 'true');
      }
    } else {
      _noScroll["default"].off();

      if (!disableModalAttributes) {
        document.documentElement.setAttribute('data-modal', 'false');
      }
    }
  }
};

/***/ }),

/***/ 41433:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.scrollTo = scrollTo;
exports.scrollToElement = scrollToElement;

var _isFinite = _interopRequireDefault(__webpack_require__(97398));

var _isString = _interopRequireDefault(__webpack_require__(47037));

var _isElement = _interopRequireDefault(__webpack_require__(67191));

var _smoothscrollPolyfill = _interopRequireDefault(__webpack_require__(30523));

var _env = _interopRequireDefault(__webpack_require__(61635));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/**
 * Finds the position of an element for a given selector and scrolls it so that align point of the element
 * is positioned relative to the equivalent align point within the window or scrollable container
 * @selectorOrElement: {string}: the DOM selector for the element
 * @selectorOrElement: {DOM node}: a DOM element
 * @focus: {boolean}: optionally focus on the selector element
 * @focus: {string}: optionally focus on an element matching the provided selector string
 * @config: {object}: defines destination alignment and any offset, duration of scroll
 */


function scrollToElement(selectorOrElement, focus) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!_env["default"].isClient) {
    return;
  } // don't do this until we know we're not on the server


  _smoothscrollPolyfill["default"].polyfill();

  var el;

  if ((0, _isString["default"])(selectorOrElement)) {
    el = document.querySelector(selectorOrElement);
  } else if ((0, _isElement["default"])(selectorOrElement)) {
    el = selectorOrElement;
  }

  if (el) {
    setTimeout(function () {
      el.scrollIntoView({
        behavior: config.behavior || 'smooth',
        block: config.block || 'start'
      });

      if (focus) {
        var focusEl = (0, _isString["default"])(focus) ? document.querySelector(focus) : el;
        focusEl.focus();
      }
    }, 0);
  }
}

function scrollTo(scrollY) {
  if (!_env["default"].isClient) {
    return;
  }

  if ((0, _isFinite["default"])(scrollY)) {
    window.scrollTo(0, scrollY);
  }
}

/***/ }),

/***/ 24192:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _isString = _interopRequireDefault(__webpack_require__(47037));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/**
 * Check id a string contains HTML tags
 * @param string {string} : 'This is some text with some <b>HTML</b>'
 * @returns {boolean}
 */


function checkHTML() {
  var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  if (!(0, _isString["default"])(string)) {
    return false;
  }

  return string.match(/<\/?([a-z][a-z0-9]*)\b[^>]*>/gi) !== null;
}

var _default = exports["default"] = checkHTML;

/***/ }),

/***/ 57610:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.escapeRegexSpecialChars = void 0;
/**
 * Escape any regex special characters in a string so that the escaped string can be used in a regex
 * @param string {string} : 'Dr. Jart+'
 * @returns {string} : 'Dr\. Jart\+'
 */

var escapeRegexSpecialChars = exports.escapeRegexSpecialChars = function escapeRegexSpecialChars(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}; // $& means the whole matched string

/***/ }),

/***/ 90347:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _toPairs = _interopRequireDefault(__webpack_require__(93220));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];

  if (null != t) {
    var e,
        n,
        i,
        u,
        a = [],
        f = !0,
        o = !1;

    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) {
        ;
      }
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }

    return a;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
/**
 * Replace ${var} placeholders in a string with values from supplied vars object
 * @param string {string} : 'My name is ${first} ${last}'
 * @param vars {object} : {first: 'Bob', last: 'Smith'}
 * @returns {string} : 'My name is Bob Smith'
 */


function replaceStringVars() {
  var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var vars = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var text = string;
  (0, _toPairs["default"])(vars).forEach(function (entry) {
    var _entry = _slicedToArray(entry, 2),
        key = _entry[0],
        value = _entry[1];

    if (value !== undefined) {
      var keyLookup = new RegExp("\\$\\{".concat(key, "\\}"), 'g');
      text = text.replace(keyLookup, value);
    }
  });
  return text;
}

var _default = exports["default"] = replaceStringVars;

/***/ }),

/***/ 63144:
/***/ (function(module) {

"use strict";

/* globals self */ var fetch = self.fetch.bind(self);
module.exports = fetch;
module.exports["default"] = module.exports;

//# sourceMappingURL=index.js.map

/***/ }),

/***/ 26996:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"c-accordion":"accordion_c-accordion__aN_JM","c-accordion__label":"accordion_c-accordion__label__Zzit5","c-accordion__content":"accordion_c-accordion__content__6ONCo","c-accordion__label--small-size":"accordion_c-accordion__label--small-size__5XWS6","c-accordion__label--medium-size":"accordion_c-accordion__label--medium-size__j1WsB","c-accordion__label--responsive-size":"accordion_c-accordion__label--responsive-size__stzvd","c-accordion__chevron":"accordion_c-accordion__chevron____geP","c-accordion__chevron--small-size":"accordion_c-accordion__chevron--small-size__ZQg30","c-accordion__chevron--medium-size":"accordion_c-accordion__chevron--medium-size__P2HoG","c-accordion__chevron--responsive-size":"accordion_c-accordion__chevron--responsive-size__o4Z5M","c-accordion--small-size":"accordion_c-accordion--small-size__ZPm_O","c-accordion--responsive-size":"accordion_c-accordion--responsive-size___Q5Sh","c-accordion--medium-size":"accordion_c-accordion--medium-size__BOqMi","c-accordion--small-icon":"accordion_c-accordion--small-icon__Zk30V","c-accordion--large-icon":"accordion_c-accordion--large-icon__cF0zW"};

/***/ }),

/***/ 39435:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"visually-hidden":"add-to-basket-button_visually-hidden__qHLV1","c-atb-btn":"add-to-basket-button_c-atb-btn__M4U7U","c-atb-btn--joyfully-bold":"add-to-basket-button_c-atb-btn--joyfully-bold__dRLxi","c-atb-btn--roundel":"add-to-basket-button_c-atb-btn--roundel__j_1AJ","c-atb-btn--is-active":"add-to-basket-button_c-atb-btn--is-active__ikeB7","c-atb-btn--is-adding":"add-to-basket-button_c-atb-btn--is-adding__3h_1s","c-atb-btn--is-successful":"add-to-basket-button_c-atb-btn--is-successful__WybUm","joyfully-bold":"add-to-basket-button_joyfully-bold__dpKJN"};

/***/ }),

/***/ 64039:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"slider":"button-carousel_slider__aE2xg","isReady":"button-carousel_isReady__BSyMa","visibleSlider":"button-carousel_visibleSlider__5VRKl","button":"button-carousel_button__oPT_l","button--large":"button-carousel_button--large__giG63","centred":"button-carousel_centred__C0Bc5","hide":"button-carousel_hide__PUlL4"};

/***/ }),

/***/ 51753:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"carousel":"BaseCarousel_carousel__9gR6A","carousel__header-container":"BaseCarousel_carousel__header-container__s4qSZ","carousel__heading":"BaseCarousel_carousel__heading__eghPz"};

/***/ }),

/***/ 64176:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"carousel__item":"CarouselItem_carousel__item__UTVdg"};

/***/ }),

/***/ 42530:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"carousel__items-container":"CarouselList_carousel__items-container__2eU_S","carousel__page":"CarouselList_carousel__page__bglnv","carousel__page--5-items":"CarouselList_carousel__page--5-items__gCyCj","carousel__page--1-items":"CarouselList_carousel__page--1-items__j53SP","carousel__page--2-items":"CarouselList_carousel__page--2-items__MeB3e","carousel__page--3-items":"CarouselList_carousel__page--3-items__LWDG1","carousel__page--4-items":"CarouselList_carousel__page--4-items__Yla6B"};

/***/ }),

/***/ 74646:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"carousel__navigation":"CarouselNavigationButtons_carousel__navigation__LtBuF","carousel__navigation-buttons":"CarouselNavigationButtons_carousel__navigation-buttons__1X7kf","carousel__navigation-button--left":"CarouselNavigationButtons_carousel__navigation-button--left__Rz_vG"};

/***/ }),

/***/ 62503:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"product-card-carousel":"ProductCardCarousel_product-card-carousel__9iyEU","product-card-carousel--ready":"ProductCardCarousel_product-card-carousel--ready__l0HS0"};

/***/ }),

/***/ 95719:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"energy-rating":"energy-rating_energy-rating__mrYSh"};

/***/ }),

/***/ 42397:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"c-loading-spinner":"loading-spinner_c-loading-spinner__BZYDP","c-loading-spinner__spinner":"loading-spinner_c-loading-spinner__spinner__uVLXs","c-loading-spinner--centered":"loading-spinner_c-loading-spinner--centered__QiZKL"};

/***/ }),

/***/ 27527:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"c-message":"message_c-message__v6k83","c-message--inline":"message_c-message--inline__SKCH3","c-message--form-inline":"message_c-message--form-inline__kQnZC","c-message__inner":"message_c-message__inner__87u5i","c-message__inner--infoInline":"message_c-message__inner--infoInline__H9kYb","c-message__inner--error":"message_c-message__inner--error__zxW4_","c-message__copy-container":"message_c-message__copy-container___9sf6","c-message__icon":"message_c-message__icon__Km9eH","c-message__title":"message_c-message__title___Isqd","c-message__body":"message_c-message__body__MsLGP","c-message__button":"message_c-message__button__Ld_nb","c-message__button--underlined":"message_c-message__button--underlined__MRXC9","c-message__horizontalShake":"message_c-message__horizontalShake__kgcue","joyfully-bold":"message_joyfully-bold__McyHE"};

/***/ }),

/***/ 66137:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"message":"message_message__KyMOU","message--information":"message_message--information__MA_Dp","message--wide-tab":"message_message--wide-tab__oz8Rg","message__icon":"message_message__icon__cWKQO","message--error":"message_message--error__QieQn","message--success":"message_message--success__bTiIR","message--warning":"message_message--warning__bS_wZ","message--white-background":"message_message--white-background__DgfgV","message--wide-tab-border":"message_message--wide-tab-border__yOqkC","message__content":"message_message__content__0vf2M","message__content--spacing":"message_message__content--spacing__Cv_sj","message__content--centre":"message_message__content--centre__ftVzl","message__title":"message_message__title__paAp_","message__body":"message_message__body__TEtSY","message__body--spacing":"message_message__body--spacing__0RbWp","message__body-text":"message_message__body-text__O595d","message__body-object":"message_message__body-object__qKisR","message__body-link":"message_message__body-link__yFg8p"};

/***/ }),

/***/ 95582:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"buttonText":"modal_buttonText__nalw6","overlay":"modal_overlay__wLd9M","overlayAfterOpen":"modal_overlayAfterOpen__zdv77","overlayBeforeClose":"modal_overlayBeforeClose__tn0vl","modal":"modal_modal__PcfdO","content":"modal_content__7w47k","children":"modal_children__PPstT","noHeaderCloseButton":"modal_noHeaderCloseButton__wfWbx","children--has-padding":"modal_children--has-padding__XX_ZQ","forceFullHeight":"modal_forceFullHeight__cXYzR","fullscreen":"modal_fullscreen__XkdXV","modalAfterOpen":"modal_modalAfterOpen__jxDmc","modalBeforeClose":"modal_modalBeforeClose__M_IDB","large":"modal_large__nyMmQ","header":"modal_header__ldvAU","headerTitle":"modal_headerTitle__MDpLa","headerCount":"modal_headerCount__OpXbw","button":"modal_button__mw0LD","headerButton":"modal_headerButton__f6mva","headerButtonText":"modal_headerButtonText__qjWv8","headerChildren":"modal_headerChildren__k1EZK","fullWidthHeaderText":"modal_fullWidthHeaderText__pyJQu","closeButton":"modal_closeButton__M8miW","backButton":"modal_backButton__X0JJ8","actions":"modal_actions__I9cZ8","actions--inline":"modal_actions--inline__gK0E0"};

/***/ }),

/***/ 33155:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"c-option__input":"option_c-option__input__Tgsnd","c-option--is-button":"option_c-option--is-button__Qag9Z","c-option__properties":"option_c-option__properties__oPutb","c-option__label":"option_c-option__label__mvnFg","c-option__label--disabled":"option_c-option__label--disabled__F0hL7","c-option__label--unavailable":"option_c-option__label--unavailable__GQAr3","c-option__label--minimisePadding":"option_c-option__label--minimisePadding__h6Yb6","c-option__label--selected":"option_c-option__label--selected__i08G8","c-option__label--checked":"option_c-option__label--checked__6CP5x","c-option__primary-label":"option_c-option__primary-label__rs_Kq","c-option__label--with-container":"option_c-option__label--with-container__BccXa","c-option__primary-label-aside":"option_c-option__primary-label-aside__HUUPT","c-option__primary-label--with-container":"option_c-option__primary-label--with-container__7iV29","c-option__secondary-label":"option_c-option__secondary-label__cFhLs","c-option__label--is-bordered":"option_c-option__label--is-bordered__N2ysb","c-option__label--focus-on-label":"option_c-option__label--focus-on-label__VNliT","c-option__label--checkbox":"option_c-option__label--checkbox__XN3sY","c-option__input--disabled":"option_c-option__input--disabled__r1_Kk","c-option__label--radio":"option_c-option__label--radio__EnUfy"};

/***/ }),

/***/ 35594:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"u-visually-hidden":"price_u-visually-hidden__mh2yO","price":"price_price__C5Ryc","price__now":"price_price__now__3B4yM","price--reduced":"price_price--reduced__22_4g","price__prev":"price_price__prev___TXO_","price__right-padding":"price_price__right-padding__Ofyvb","price__unit-price":"price_price__unit-price__O3bxd","price__unit-price-quick-view":"price_price__unit-price-quick-view__6BhEs","price__reduction":"price_price__reduction__uqIhc","price--context-quick-view":"price_price--context-quick-view__A_qQT","price--anyday":"price_price--anyday__3XLQ_","price--context-pdp":"price_price--context-pdp__2ki1n","price__prefix":"price_price__prefix__V5cP8","price__suffix":"price_price__suffix__HIKOU","price--context-product-card":"price_price--context-product-card__Jm3n3"};

/***/ }),

/***/ 9760:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"visuallyHidden":"product-card-detailed_visuallyHidden__cUoxj","c-product-card-container":"product-card-detailed_c-product-card-container__Ox4Qs","c-product-card":"product-card-detailed_c-product-card__8pFa9","c-product-card--has-messages":"product-card-detailed_c-product-card--has-messages__oyqMd","c-product-card__link-container":"product-card-detailed_c-product-card__link-container__VXnyu","c-product-card__link":"product-card-detailed_c-product-card__link__RgkWo","c-product-card__messages-section":"product-card-detailed_c-product-card__messages-section__TNIkY","c-product-card__cta":"product-card-detailed_c-product-card__cta__1fFdT","c-product-card__sponsored-text":"product-card-detailed_c-product-card__sponsored-text__Vlg2R","c-product-card__section-divider":"product-card-detailed_c-product-card__section-divider__OmyYp","c-product-card__title-section":"product-card-detailed_c-product-card__title-section__k_Q8U","c-product-card__image-container":"product-card-detailed_c-product-card__image-container__TA3_7","c-product-card__image":"product-card-detailed_c-product-card__image__BH8gD","c-product-card__price":"product-card-detailed_c-product-card__price__a4ScH","c-product-card__rating":"product-card-detailed_c-product-card__rating__y13jw","c-product-card__divider":"product-card-detailed_c-product-card__divider__TEg__","energyRating":"product-card-detailed_energyRating__8LwEu","c-product-card__swatches":"product-card-detailed_c-product-card__swatches__vbztJ","c-product-card__promo-messages":"product-card-detailed_c-product-card__promo-messages__LRrVu","c-product-card__btn-section":"product-card-detailed_c-product-card__btn-section__i393z","c-product-card__compare":"product-card-detailed_c-product-card__compare__Tx43A"};

/***/ }),

/***/ 9066:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Carousel":"carousel_Carousel__GeZgJ","Carousel--is-active":"carousel_Carousel--is-active__F_r7J","Carousel_wrapper":"carousel_Carousel_wrapper__Tmx4A","Carousel_item":"carousel_Carousel_item__ih20r","Carousel_image":"carousel_Carousel_image__aJNyt","Carousel_button":"carousel_Carousel_button__eqxke","Carousel_button__next":"carousel_Carousel_button__next__wPCJI","Carousel_button__prev":"carousel_Carousel_button__prev__nWumq","Carousel_buttonText":"carousel_Carousel_buttonText__oXZAp"};

/***/ }),

/***/ 76267:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"additional-message":"additional-messages_additional-message__6pxbG"};

/***/ }),

/***/ 40656:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"visually-hidden":"cta-button_visually-hidden__YnfIp","cta-button":"cta-button_cta-button__dmkjf","cta-button--primary":"cta-button_cta-button--primary__rAZVM","cta-button--secondary":"cta-button_cta-button--secondary__dtcKO","cta-button--list-view":"cta-button_cta-button--list-view__6UgtU"};

/***/ }),

/***/ 60534:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"imageLink":"image_imageLink__1Znsz","image":"image_image__jhaxk","image_fadeIn__3IINu":"image_image_fadeIn__3IINu__66t9K","image--isLoading":"image_image--isLoading__kkVyo","loadingSpinner":"image_loadingSpinner__Ujxqv","altImage":"image_altImage__yDU9Y","fadeIn":"image_fadeIn__SIbvv"};

/***/ }),

/***/ 98106:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"out-of-stock":"out-of-stock_out-of-stock__zbo0a","out-of-stock--list-view":"out-of-stock_out-of-stock--list-view__gZ1cN"};

/***/ }),

/***/ 46219:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pre-order":"pre-order_pre-order__0_OBZ","pre-order--list-view":"pre-order_pre-order--list-view__9c5w8"};

/***/ }),

/***/ 33095:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"visually-hidden":"product-card_visually-hidden__iDELX","c-product-card":"product-card_c-product-card__UAdsG","c-product-card__title":"product-card_c-product-card__title__vbF7K","brand-promise-anyday":"product-card_brand-promise-anyday__r9WEN","brand-promise-mid-tier":"product-card_brand-promise-mid-tier__KlyqF","c-product-card__sponsored":"product-card_c-product-card__sponsored__s8E4j","c-product-card__section":"product-card_c-product-card__section__qvImF","c-product-card__image-container":"product-card_c-product-card__image-container__5DecW","c-product-card__image-container--hasCarousel":"product-card_c-product-card__image-container--hasCarousel__b8apz","c-product-card__image":"product-card_c-product-card__image__bO3kW","c-product-card__product-details":"product-card_c-product-card__product-details__QLyYh","c-product-card__link":"product-card_c-product-card__link__QeVVQ","c-product-card__image-loading":"product-card_c-product-card__image-loading__WHzWc","c-product-card__cta":"product-card_c-product-card__cta__nUZU3","c-product-card__range":"product-card_c-product-card__range__MnA1t","c-product-card__view-similar-button":"product-card_c-product-card__view-similar-button__XboZO","energyRating":"product-card_energyRating__A1fFp","legacy":"product-card_legacy__e8qUb","c-cta-buttons":"product-card_c-cta-buttons__Jhpwe","c-cta-buttons--quick-view":"product-card_c-cta-buttons--quick-view__hkAhV","c-cta-buttons__right":"product-card_c-cta-buttons__right__WI7rc","c-product-card__hover-drawer":"product-card_c-product-card__hover-drawer__n8Ag_","c-product-card__hover-drawer__force-open":"product-card_c-product-card__hover-drawer__force-open__yP2wj","c-product-card__hover-drawer__force-close":"product-card_c-product-card__hover-drawer__force-close__MvWnK","c-product-card__mobile-alt-img__force-space":"product-card_c-product-card__mobile-alt-img__force-space__y40z6"};

/***/ }),

/***/ 69884:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"visuallyHidden":"promo-messages_visuallyHidden__Kcyk2","promo":"promo-messages_promo__La02x","promo__modal":"promo-messages_promo__modal__G1Dfk","promo--plain":"promo-messages_promo--plain__Sbhyt","promo__modal-header":"promo-messages_promo__modal-header__SXkIl","promo__modal-title":"promo-messages_promo__modal-title__uPcRo","promo__modal-link":"promo-messages_promo__modal-link__l4lhb","promo__modal-close":"promo-messages_promo__modal-close__uncid","offers":"promo-messages_offers__9RjS9","offerTag":"promo-messages_offerTag__LZESv","underline":"promo-messages_underline__rLlYH"};

/***/ }),

/***/ 38137:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"visually-hidden":"quick-view-drawer_visually-hidden__uPp1k","qv-drawer":"quick-view-drawer_qv-drawer__iFdDb","qv-drawer__button":"quick-view-drawer_qv-drawer__button__1fnis"};

/***/ }),

/***/ 75355:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"list-view":"product-card-rating_list-view__QxMoG"};

/***/ }),

/***/ 89123:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"social-proof-message":"social-proof-message_social-proof-message__Z0NEv","social-proof-message-container":"social-proof-message_social-proof-message-container__ovDyr","social-proof-message-container__rendered-internally":"social-proof-message_social-proof-message-container__rendered-internally__uOhtt"};

/***/ }),

/***/ 86829:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sponsored-text":"sponsored_sponsored-text__2M_7U"};

/***/ }),

/***/ 66981:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"visuallyHidden":"swatches_visuallyHidden__gs6qo","swatches":"swatches_swatches__aQuwo","swatchesList":"swatches_swatchesList__mKEKI","swatchesList--padding-below":"swatches_swatchesList--padding-below__Agh2R","swatchItem":"swatches_swatchItem__f1u7B","unavailable":"swatches_unavailable__RpUoh","swatchItem--selected":"swatches_swatchItem--selected__GKmqg","moreColours":"swatches_moreColours__6rH_F","list-view":"swatches_list-view__1bZs_"};

/***/ }),

/***/ 36730:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title__visually-hidden":"title_title__visually-hidden__Hfce_","title":"title_title__H_ry2","title__desc":"title_title__desc__ZCdyp","title__desc--list-view":"title_title__desc--list-view__5WhnM","title__desc--branded":"title_title__desc--branded__8SluU","title__desc--four-lines":"title_title__desc--four-lines__7hRtk","title__desc--three-lines":"title_title__desc--three-lines__VHz1t","title__brandPrefix":"title_title__brandPrefix__BwovL","title__brand":"title_title__brand__UX8j9","title__brand--list-view":"title_title__brand--list-view__P82u5","title__brand--anyday":"title_title__brand--anyday__UAeVT","mono":"title_mono__jevdU","title__brand--chanel":"title_title__brand--chanel__d1qdW"};

/***/ }),

/***/ 74049:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"visuallyHidden":"rating_visuallyHidden__zgQQN","starOutline":"rating_starOutline__x7jED","starFilled":"rating_starFilled__ZYBCs","ratings":"rating_ratings__wt_a0","size-joyfully-bold":"rating_size-joyfully-bold__KFK3_","starRatings":"rating_starRatings__uwQfE","starRated":"rating_starRated__tfqFS","suffix":"rating_suffix__PdYl6","fontSmall":"rating_fontSmall__JCYJr","small":"rating_small__uoPnu","large":"rating_large__APaeE","joyfully-bold":"rating_joyfully-bold__Ievkk","suffix-joyfully-bold":"rating_suffix-joyfully-bold__XnIse"};

/***/ }),

/***/ 60937:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"visually-hidden":"button_visually-hidden___n6mQ","c-button":"button_c-button__V0DaS","c-button--disabled":"button_c-button--disabled__MWaJ_","c-button--primary":"button_c-button--primary__QwInn","c-button--secondary":"button_c-button--secondary__Ug9fC","c-button--inline":"button_c-button--inline__UI0w4","c-button--responsive":"button_c-button--responsive__O4YFZ","c-button--submitting":"button_c-button--submitting__76Wnf","c-button--white":"button_c-button--white__CFPrL","c-button--sale":"button_c-button--sale__pVWTs","c-button--inverted":"button_c-button--inverted__jEvpQ","c-button--tertiary":"button_c-button--tertiary__bTVBl","c-button--tertiary-icon":"button_c-button--tertiary-icon__nIJht","c-button--tertiary-icon-right":"button_c-button--tertiary-icon-right__Rp1Bz","icon-container":"button_icon-container__bMrU6","icon":"button_icon__hqsbZ","c-button--tertiary-submitting":"button_c-button--tertiary-submitting__3ZvoI","c-button--tertiary-no-icon":"button_c-button--tertiary-no-icon__rqnPJ","tertiary-content":"button_tertiary-content__4Wn0i","c-button--tertiary-small":"button_c-button--tertiary-small__1z46t","c-button--tertiary-large":"button_c-button--tertiary-large__cOZTX","c-button--small":"button_c-button--small__whwzx","c-button--medium":"button_c-button--medium__ZrQbr","c-button--large":"button_c-button--large__L531O","c-button--auto":"button_c-button--auto__SpDYt","c-button--underlined":"button_c-button--underlined__b_Gz2","c-button--underField":"button_c-button--underField__bkvtr","c-button--underFieldRight":"button_c-button--underFieldRight__36oI8","variant-clear-light":"button_variant-clear-light__7DBRI","variant-clear-dark":"button_variant-clear-dark__h1jVn","variant-clear-white":"button_variant-clear-white__EneRD","variant-tonal-light":"button_variant-tonal-light___retD","variant-tonal-dark":"button_variant-tonal-dark__PoqaX","variant-filled-light":"button_variant-filled-light__w0cSz","variant-filled-dark":"button_variant-filled-dark__Bjqat"};

/***/ }),

/***/ 19509:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"iconButton":"icon-button_iconButton__7RPlA","disabled":"icon-button_disabled__OirVo","icon":"icon-button_icon__9xypM","submitting":"icon-button_submitting__i5xrR","small":"icon-button_small__m7nTK","medium":"icon-button_medium__KObpd","large":"icon-button_large__fVL9z","variant-clear-light":"icon-button_variant-clear-light__cZoqJ","variant-clear-dark":"icon-button_variant-clear-dark__2n1xL","variant-clear-white":"icon-button_variant-clear-white__wfVZ3","variant-tonal-light":"icon-button_variant-tonal-light__xUvVN","variant-tonal-dark":"icon-button_variant-tonal-dark__dWdFv","variant-filled-light":"icon-button_variant-filled-light__fdXb0","variant-filled-dark":"icon-button_variant-filled-dark__LlB_a"};

/***/ }),

/***/ 35768:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"extralarge":"icon_extralarge__m4_d7","large":"icon_large__WTLOS","regular":"icon_regular__UDQDU","small":"icon_small__Eo1Zj","box":"icon_box__gm0eO","icon-disabled":"icon_icon-disabled__nOJBX","icon-invert":"icon_icon-invert__k3tB7","icon-information":"icon_icon-information__cUIX_"};

/***/ }),

/***/ 2834:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"c-input":"input_c-input__yUtlS"};

/***/ }),

/***/ 56251:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"c-select":"select_c-select__OuZHP","joyfully-bold":"select_joyfully-bold__3j11Y"};

/***/ }),

/***/ 5152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(73579)


/***/ }),

/***/ 41664:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(7942)


/***/ }),

/***/ 70743:
/***/ (function(module) {

(function(root) {
  var isOn = false;
  var scrollbarSize;
  var scrollTop;

  function getScrollbarSize() {
    if (typeof scrollbarSize !== 'undefined') return scrollbarSize;

    var doc = document.documentElement;
    var dummyScroller = document.createElement('div');
    dummyScroller.setAttribute('style', 'width:99px;height:99px;' + 'position:absolute;top:-9999px;overflow:scroll;');
    doc.appendChild(dummyScroller);
    scrollbarSize = dummyScroller.offsetWidth - dummyScroller.clientWidth;
    doc.removeChild(dummyScroller);
    return scrollbarSize;
  }

  function hasScrollbar() {
    return document.documentElement.scrollHeight > window.innerHeight;
  }

  function on(options) {
    if (typeof document === 'undefined' || isOn) return;
    var doc = document.documentElement;
    scrollTop = window.pageYOffset;
    if (hasScrollbar()) {
      doc.style.width = 'calc(100% - '+ getScrollbarSize() +'px)';
    } else {
      doc.style.width = '100%';
    }
    doc.style.position = 'fixed';
    doc.style.top = -scrollTop + 'px';
    doc.style.overflow = 'hidden';
    isOn = true;
  }

  function off() {
    if (typeof document === 'undefined' || !isOn) return;
    var doc = document.documentElement;
    doc.style.width = '';
    doc.style.position = '';
    doc.style.top = '';
    doc.style.overflow = '';
    window.scroll(0, scrollTop);
    isOn = false;
  }

  function toggle() {
    if (isOn) {
      off();
      return;
    }
    on();
  }

  var noScroll = {
    on: on,
    off: off,
    toggle: toggle,
  };

  if ( true && typeof module.exports !== 'undefined') {
    module.exports = noScroll;
  } else {
    root.noScroll = noScroll;
  }
})(this);


/***/ }),

/***/ 70631:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var match = String.prototype.match;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
var isEnumerable = Object.prototype.propertyIsEnumerable;

var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
    [].__proto__ === Array.prototype // eslint-disable-line no-proto
        ? function (O) {
            return O.__proto__; // eslint-disable-line no-proto
        }
        : null
);

var inspectCustom = (__webpack_require__(24654).custom);
var inspectSymbol = inspectCustom && isSymbol(inspectCustom) ? inspectCustom : null;
var toStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag !== 'undefined' ? Symbol.toStringTag : null;

module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has(opts, 'quoteStyle') && (opts.quoteStyle !== 'single' && opts.quoteStyle !== 'double')) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    }

    if (
        has(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('options "indent" must be "\\t", an integer > 0, or `null`');
    }

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        return String(obj);
    }
    if (typeof obj === 'bigint') {
        return String(obj) + 'n';
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = seen.slice();
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function') {
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + keys.join(', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? String(obj).replace(/^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + String(obj.nodeName).toLowerCase();
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + String(obj.nodeName).toLowerCase() + '>';
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + xs.join(', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + parts.join(', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function') {
            return obj[inspectSymbol]();
        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        mapForEach.call(obj, function (value, key) {
            mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
        });
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        setForEach.call(obj, function (value) {
            setParts.push(inspect(value, obj));
        });
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? toStr(obj).slice(8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + [].concat(stringTag || [], protoTag || []).join(': ') + '] ' : '');
        if (ys.length === 0) { return tag + '{}'; }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + ys.join(', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === 'double' ? '"' : "'";
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return String(s).replace(/"/g, '&quot;');
}

function isArray(obj) { return toStr(obj) === '[object Array]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isDate(obj) { return toStr(obj) === '[object Date]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isRegExp(obj) { return toStr(obj) === '[object RegExp]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isError(obj) { return toStr(obj) === '[object Error]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isString(obj) { return toStr(obj) === '[object String]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isNumber(obj) { return toStr(obj) === '[object Number]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isBoolean(obj) { return toStr(obj) === '[object Boolean]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) {
        return obj && typeof obj === 'object' && obj instanceof Symbol;
    }
    if (typeof obj === 'symbol') {
        return true;
    }
    if (!obj || typeof obj !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
        return false;
    }
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString(str.slice(0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = str.replace(/(['\\])/g, '\\$1').replace(/[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + n.toString(16).toUpperCase();
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : entries.join(', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = Array(opts.indent + 1).join(' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: Array(depth + 1).join(baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + xs.join(',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ((/[^\w$]/).test(key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}


/***/ }),

/***/ 55798:
/***/ (function(module) {

"use strict";


var replace = String.prototype.replace;
var percentTwenties = /%20/g;

var Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};

module.exports = {
    'default': Format.RFC3986,
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return String(value);
        }
    },
    RFC1738: Format.RFC1738,
    RFC3986: Format.RFC3986
};


/***/ }),

/***/ 80129:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var stringify = __webpack_require__(58261);
var parse = __webpack_require__(55235);
var formats = __webpack_require__(55798);

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};


/***/ }),

/***/ 55235:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(12769);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var defaults = {
    allowDots: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};

var interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

var parseArrayValue = function (val, options) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        return val.split(',');
    }

    return val;
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');
            val = utils.maybeMap(
                parseArrayValue(part.slice(pos + 1), options),
                function (encodedVal) {
                    return options.decoder(encodedVal, defaults.decoder, charset, 'value');
                }
            );
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(val);
        }

        if (part.indexOf('[]=') > -1) {
            val = isArray(val) ? [val] : val;
        }

        if (has.call(obj, key)) {
            obj[key] = utils.combine(obj[key], val);
        } else {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : parseArrayValue(val, options);

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            obj = [].concat(leaf);
        } else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === '') {
                obj = { 0: leaf };
            } else if (
                !isNaN(index)
                && root !== cleanRoot
                && String(index) === cleanRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else if (cleanRoot !== '__proto__') {
                obj[cleanRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options, valuesParsed);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }
    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;

    return {
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (str, opts) {
    var options = normalizeParseOptions(opts);

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = utils.merge(obj, newObj, options);
    }

    if (options.allowSparse === true) {
        return obj;
    }

    return utils.compact(obj);
};


/***/ }),

/***/ 58261:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var getSideChannel = __webpack_require__(37478);
var utils = __webpack_require__(12769);
var formats = __webpack_require__(55798);
var has = Object.prototype.hasOwnProperty;

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};

var isArray = Array.isArray;
var push = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaultFormat = formats['default'];
var defaults = {
    addQueryPrefix: false,
    allowDots: false,
    charset: 'utf-8',
    charsetSentinel: false,
    delimiter: '&',
    encode: true,
    encoder: utils.encode,
    encodeValuesOnly: false,
    format: defaultFormat,
    formatter: formats.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string'
        || typeof v === 'number'
        || typeof v === 'boolean'
        || typeof v === 'symbol'
        || typeof v === 'bigint';
};

var sentinel = {};

var stringify = function stringify(
    object,
    prefix,
    generateArrayPrefix,
    commaRoundTrip,
    strictNullHandling,
    skipNulls,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    format,
    formatter,
    encodeValuesOnly,
    charset,
    sideChannel
) {
    var obj = object;

    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while ((tmpSc = tmpSc.get(sentinel)) !== void undefined && !findFlag) {
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) {
                throw new RangeError('Cyclic object value');
            } else {
                findFlag = true; // Break while
            }
        }
        if (typeof tmpSc.get(sentinel) === 'undefined') {
            step = 0;
        }
    }

    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
        obj = utils.maybeMap(obj, function (value) {
            if (value instanceof Date) {
                return serializeDate(value);
            }
            return value;
        });
    }

    if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key', format) : prefix;
        }

        obj = '';
    }

    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key', format);
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value', format))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (generateArrayPrefix === 'comma' && isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) {
            obj = utils.maybeMap(obj, encoder);
        }
        objKeys = [{ value: obj.length > 0 ? obj.join(',') || null : void undefined }];
    } else if (isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    var adjustedPrefix = commaRoundTrip && isArray(obj) && obj.length === 1 ? prefix + '[]' : prefix;

    for (var j = 0; j < objKeys.length; ++j) {
        var key = objKeys[j];
        var value = typeof key === 'object' && typeof key.value !== 'undefined' ? key.value : obj[key];

        if (skipNulls && value === null) {
            continue;
        }

        var keyPrefix = isArray(obj)
            ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, key) : adjustedPrefix
            : adjustedPrefix + (allowDots ? '.' + key : '[' + key + ']');

        sideChannel.set(object, step);
        var valueSideChannel = getSideChannel();
        valueSideChannel.set(sentinel, sideChannel);
        pushToArray(values, stringify(
            value,
            keyPrefix,
            generateArrayPrefix,
            commaRoundTrip,
            strictNullHandling,
            skipNulls,
            generateArrayPrefix === 'comma' && encodeValuesOnly && isArray(obj) ? null : encoder,
            filter,
            sort,
            allowDots,
            serializeDate,
            format,
            formatter,
            encodeValuesOnly,
            charset,
            valueSideChannel
        ));
    }

    return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var charset = opts.charset || defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    var format = formats['default'];
    if (typeof opts.format !== 'undefined') {
        if (!has.call(formats.formatters, opts.format)) {
            throw new TypeError('Unknown format option provided.');
        }
        format = opts.format;
    }
    var formatter = formats.formatters[format];

    var filter = defaults.filter;
    if (typeof opts.filter === 'function' || isArray(opts.filter)) {
        filter = opts.filter;
    }

    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);

    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var arrayFormat;
    if (opts && opts.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = opts.arrayFormat;
    } else if (opts && 'indices' in opts) {
        arrayFormat = opts.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];
    if (opts && 'commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') {
        throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    }
    var commaRoundTrip = generateArrayPrefix === 'comma' && opts && opts.commaRoundTrip;

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (options.sort) {
        objKeys.sort(options.sort);
    }

    var sideChannel = getSideChannel();
    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (options.skipNulls && obj[key] === null) {
            continue;
        }
        pushToArray(keys, stringify(
            obj[key],
            key,
            generateArrayPrefix,
            commaRoundTrip,
            options.strictNullHandling,
            options.skipNulls,
            options.encode ? options.encoder : null,
            options.filter,
            options.sort,
            options.allowDots,
            options.serializeDate,
            options.format,
            options.formatter,
            options.encodeValuesOnly,
            options.charset,
            sideChannel
        ));
    }

    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B&';
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93&';
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};


/***/ }),

/***/ 12769:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var formats = __webpack_require__(55798);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */
    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (isArray(target)) {
            target.push(source);
        } else if (target && typeof target === 'object') {
            if ((options && (options.plainObjects || options.allowPrototypes)) || !has.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (!target || typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (isArray(target) && !isArray(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (isArray(target) && isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
                    target[i] = merge(targetItem, item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode = function (str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = str;
    if (typeof str === 'symbol') {
        string = Symbol.prototype.toString.call(str);
    } else if (typeof str !== 'string') {
        string = String(str);
    }

    if (charset === 'iso-8859-1') {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        });
    }

    var out = '';
    for (var i = 0; i < string.length; ++i) {
        var c = string.charCodeAt(i);

        if (
            c === 0x2D // -
            || c === 0x2E // .
            || c === 0x5F // _
            || c === 0x7E // ~
            || (c >= 0x30 && c <= 0x39) // 0-9
            || (c >= 0x41 && c <= 0x5A) // a-z
            || (c >= 0x61 && c <= 0x7A) // A-Z
            || (format === formats.RFC1738 && (c === 0x28 || c === 0x29)) // ( )
        ) {
            out += string.charAt(i);
            continue;
        }

        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        i += 1;
        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
        /* eslint operator-linebreak: [2, "before"] */
        out += hexTable[0xF0 | (c >> 18)]
            + hexTable[0x80 | ((c >> 12) & 0x3F)]
            + hexTable[0x80 | ((c >> 6) & 0x3F)]
            + hexTable[0x80 | (c & 0x3F)];
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b) {
    return [].concat(a, b);
};

var maybeMap = function maybeMap(val, fn) {
    if (isArray(val)) {
        var mapped = [];
        for (var i = 0; i < val.length; i += 1) {
            mapped.push(fn(val[i]));
        }
        return mapped;
    }
    return fn(val);
};

module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isRegExp: isRegExp,
    maybeMap: maybeMap,
    merge: merge
};


/***/ }),

/***/ 70131:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N7": function() { return /* binding */ observe; },
/* harmony export */   "df": function() { return /* binding */ InView; }
/* harmony export */ });
/* unused harmony export useInView */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37667);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);


function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var ObserverMap = new Map();
var RootIds = new WeakMap();
var rootId = 0;
/**
 * Generate a unique ID for the root element
 * @param root
 */

function getRootId(root) {
  if (!root) return '0';
  if (RootIds.has(root)) return RootIds.get(root);
  rootId += 1;
  RootIds.set(root, rootId.toString());
  return RootIds.get(root);
}
/**
 * Convert the options to a string Id, based on the values.
 * Ensures we can reuse the same observer when observing elements with the same options.
 * @param options
 */


function optionsToId(options) {
  return Object.keys(options).sort().filter(function (key) {
    return options[key] !== undefined;
  }).map(function (key) {
    return key + "_" + (key === 'root' ? getRootId(options.root) : options[key]);
  }).toString();
}

function createObserver(options) {
  // Create a unique ID for this observer instance, based on the root, root margin and threshold.
  var id = optionsToId(options);
  var instance = ObserverMap.get(id);

  if (!instance) {
    // Create a map of elements this observer is going to observe. Each element has a list of callbacks that should be triggered, once it comes into view.
    var elements = new Map();
    var thresholds;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var _elements$get;

        // While it would be nice if you could just look at isIntersecting to determine if the component is inside the viewport, browsers can't agree on how to use it.
        // -Firefox ignores `threshold` when considering `isIntersecting`, so it will never be false again if `threshold` is > 0
        var inView = entry.isIntersecting && thresholds.some(function (threshold) {
          return entry.intersectionRatio >= threshold;
        }); // @ts-ignore support IntersectionObserver v2

        if (options.trackVisibility && typeof entry.isVisible === 'undefined') {
          // The browser doesn't support Intersection Observer v2, falling back to v1 behavior.
          // @ts-ignore
          entry.isVisible = inView;
        }

        (_elements$get = elements.get(entry.target)) == null ? void 0 : _elements$get.forEach(function (callback) {
          callback(inView, entry);
        });
      });
    }, options); // Ensure we have a valid thresholds array. If not, use the threshold from the options

    thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [options.threshold || 0]);
    instance = {
      id: id,
      observer: observer,
      elements: elements
    };
    ObserverMap.set(id, instance);
  }

  return instance;
}
/**
 * @param element - DOM Element to observe
 * @param callback - Callback function to trigger when intersection status changes
 * @param options - Intersection Observer options
 * @return Function - Cleanup function that should be triggered to unregister the observer
 */


function observe(element, callback, options) {
  if (options === void 0) {
    options = {};
  }

  if (!element) return function () {}; // An observer with the same options can be reused, so lets use this fact

  var _createObserver = createObserver(options),
      id = _createObserver.id,
      observer = _createObserver.observer,
      elements = _createObserver.elements; // Register the callback listener for this element


  var callbacks = elements.get(element) || [];

  if (!elements.has(element)) {
    elements.set(element, callbacks);
  }

  callbacks.push(callback);
  observer.observe(element);
  return function unobserve() {
    // Remove the callback from the callback list
    callbacks.splice(callbacks.indexOf(callback), 1);

    if (callbacks.length === 0) {
      // No more callback exists for element, so destroy it
      elements["delete"](element);
      observer.unobserve(element);
    }

    if (elements.size === 0) {
      // No more elements are being observer by this instance, so destroy it
      observer.disconnect();
      ObserverMap["delete"](id);
    }
  };
}

function isPlainChildren(props) {
  return typeof props.children !== 'function';
}
/**
 ## Render props

 To use the `<InView>` component, you pass it a function. It will be called
 whenever the state changes, with the new value of `inView`. In addition to the
 `inView` prop, children also receive a `ref` that should be set on the
 containing DOM element. This is the element that the IntersectionObserver will
 monitor.

 If you need it, you can also access the
 [`IntersectionObserverEntry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry)
 on `entry`, giving you access to all the details about the current intersection
 state.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView>
 {({ inView, ref, entry }) => (
      <div ref={ref}>
        <h2>{`Header inside viewport ${inView}.`}</h2>
      </div>
    )}
 </InView>
 );

 export default Component;
 ```

 ## Plain children

 You can pass any element to the `<InView />`, and it will handle creating the
 wrapping DOM element. Add a handler to the `onChange` method, and control the
 state in your own component. Any extra props you add to `<InView>` will be
 passed to the HTML element, allowing you set the `className`, `style`, etc.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView as="div" onChange={(inView, entry) => console.log('Inview:', inView)}>
 <h2>Plain children are always rendered. Use onChange to monitor state.</h2>
 </InView>
 );

 export default Component;
 ```
 */


var InView = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(InView, _React$Component);

  function InView(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.node = null;
    _this._unobserveCb = null;

    _this.handleNode = function (node) {
      if (_this.node) {
        // Clear the old observer, before we start observing a new element
        _this.unobserve();

        if (!node && !_this.props.triggerOnce && !_this.props.skip) {
          // Reset the state if we get a new node, and we aren't ignoring updates
          _this.setState({
            inView: !!_this.props.initialInView,
            entry: undefined
          });
        }
      }

      _this.node = node ? node : null;

      _this.observeNode();
    };

    _this.handleChange = function (inView, entry) {
      if (inView && _this.props.triggerOnce) {
        // If `triggerOnce` is true, we should stop observing the element.
        _this.unobserve();
      }

      if (!isPlainChildren(_this.props)) {
        // Store the current State, so we can pass it to the children in the next render update
        // There's no reason to update the state for plain children, since it's not used in the rendering.
        _this.setState({
          inView: inView,
          entry: entry
        });
      }

      if (_this.props.onChange) {
        // If the user is actively listening for onChange, always trigger it
        _this.props.onChange(inView, entry);
      }
    };

    _this.state = {
      inView: !!props.initialInView,
      entry: undefined
    };
    return _this;
  }

  var _proto = InView.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    // If a IntersectionObserver option changed, reinit the observer
    if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
      this.unobserve();
      this.observeNode();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.unobserve();
    this.node = null;
  };

  _proto.observeNode = function observeNode() {
    if (!this.node || this.props.skip) return;
    var _this$props = this.props,
        threshold = _this$props.threshold,
        root = _this$props.root,
        rootMargin = _this$props.rootMargin,
        trackVisibility = _this$props.trackVisibility,
        delay = _this$props.delay;
    this._unobserveCb = observe(this.node, this.handleChange, {
      threshold: threshold,
      root: root,
      rootMargin: rootMargin,
      // @ts-ignore
      trackVisibility: trackVisibility,
      // @ts-ignore
      delay: delay
    });
  };

  _proto.unobserve = function unobserve() {
    if (this._unobserveCb) {
      this._unobserveCb();

      this._unobserveCb = null;
    }
  };

  _proto.render = function render() {
    if (!isPlainChildren(this.props)) {
      var _this$state = this.state,
          inView = _this$state.inView,
          entry = _this$state.entry;
      return this.props.children({
        inView: inView,
        entry: entry,
        ref: this.handleNode
      });
    }

    var _this$props2 = this.props,
        children = _this$props2.children,
        as = _this$props2.as,
        tag = _this$props2.tag,
        props = _objectWithoutPropertiesLoose(_this$props2, ["children", "as", "tag", "triggerOnce", "threshold", "root", "rootMargin", "onChange", "skip", "trackVisibility", "delay", "initialInView"]);

    return /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(as || tag || 'div', _extends({
      ref: this.handleNode
    }, props), children);
  };

  return InView;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);
InView.displayName = 'InView';
InView.defaultProps = {
  threshold: 0,
  triggerOnce: false,
  initialInView: false
};

/**
 * React Hooks make it easy to monitor the `inView` state of your components. Call
 * the `useInView` hook with the (optional) [options](#options) you need. It will
 * return an array containing a `ref`, the `inView` status and the current
 * [`entry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry).
 * Assign the `ref` to the DOM element you want to monitor, and the hook will
 * report the status.
 *
 * @example
 * ```jsx
 * import React from 'react';
 * import { useInView } from 'react-intersection-observer';
 *
 * const Component = () => {
 *   const { ref, inView, entry } = useInView({
 *       threshold: 0,
 *   });
 *
 *   return (
 *     <div ref={ref}>
 *       <h2>{`Header inside viewport ${inView}.`}</h2>
 *     </div>
 *   );
 * };
 * ```
 */

function useInView(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      threshold = _ref.threshold,
      delay = _ref.delay,
      trackVisibility = _ref.trackVisibility,
      rootMargin = _ref.rootMargin,
      root = _ref.root,
      triggerOnce = _ref.triggerOnce,
      skip = _ref.skip,
      initialInView = _ref.initialInView;

  var unobserve = useRef();

  var _React$useState = useState({
    inView: !!initialInView
  }),
      state = _React$useState[0],
      setState = _React$useState[1];

  var setRef = useCallback(function (node) {
    if (unobserve.current !== undefined) {
      unobserve.current();
      unobserve.current = undefined;
    } // Skip creating the observer


    if (skip) return;

    if (node) {
      unobserve.current = observe(node, function (inView, entry) {
        setState({
          inView: inView,
          entry: entry
        });

        if (entry.isIntersecting && triggerOnce && unobserve.current) {
          // If it should only trigger once, unobserve the element after it's inView
          unobserve.current();
          unobserve.current = undefined;
        }
      }, {
        root: root,
        rootMargin: rootMargin,
        threshold: threshold,
        // @ts-ignore
        trackVisibility: trackVisibility,
        // @ts-ignore
        delay: delay
      });
    }
  }, // We break the rule here, because we aren't including the actual `threshold` variable
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [// If the threshold is an array, convert it to a string so it won't change between renders.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  Array.isArray(threshold) ? threshold.toString() : threshold, root, rootMargin, triggerOnce, skip, trackVisibility, delay]);
  /* eslint-disable-next-line */

  useEffect(function () {
    if (!unobserve.current && state.entry && !triggerOnce && !skip) {
      // If we don't have a ref, then reset the state (unless the hook is set to only `triggerOnce` or `skip`)
      // This ensures we correctly reflect the current state - If you aren't observing anything, then nothing is inView
      setState({
        inView: !!initialInView
      });
    }
  });
  var result = [setRef, state.inView, state.entry]; // Support object destructuring, by adding the specific values.

  result.ref = result[0];
  result.inView = result[1];
  result.entry = result[2];
  return result;
}

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (InView)));

//# sourceMappingURL=react-intersection-observer.m.js.map


/***/ }),

/***/ 46871:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "polyfill": function() { return /* binding */ polyfill; }
/* harmony export */ });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),

/***/ 29983:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.bodyOpenClassName = exports.portalClassName = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(37667);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(19481);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(99545);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ModalPortal = __webpack_require__(28747);

var _ModalPortal2 = _interopRequireDefault(_ModalPortal);

var _ariaAppHider = __webpack_require__(57149);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _safeHTMLElement = __webpack_require__(51112);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

var _reactLifecyclesCompat = __webpack_require__(46871);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var portalClassName = exports.portalClassName = "ReactModalPortal";
var bodyOpenClassName = exports.bodyOpenClassName = "ReactModal__Body--open";

var isReact16 = _safeHTMLElement.canUseDOM && _reactDom2.default.createPortal !== undefined;

var createHTMLElement = function createHTMLElement(name) {
  return document.createElement(name);
};

var getCreatePortal = function getCreatePortal() {
  return isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;
};

function getParentElement(parentSelector) {
  return parentSelector();
}

var Modal = function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
      !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
      var parent = getParentElement(_this.props.parentSelector);
      if (parent && parent.contains(_this.node)) {
        parent.removeChild(_this.node);
      } else {
        // eslint-disable-next-line no-console
        console.warn('React-Modal: "parentSelector" prop did not returned any DOM ' + "element. Make sure that the parent element is unmounted to " + "avoid any memory leaks.");
      }
    }, _this.portalRef = function (ref) {
      _this.portal = ref;
    }, _this.renderPortal = function (props) {
      var createPortal = getCreatePortal();
      var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends({ defaultStyles: Modal.defaultStyles }, props)), _this.node);
      _this.portalRef(portal);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!_safeHTMLElement.canUseDOM) return;

      if (!isReact16) {
        this.node = createHTMLElement("div");
      }
      this.node.className = this.props.portalClassName;

      var parent = getParentElement(this.props.parentSelector);
      parent.appendChild(this.node);

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps) {
      var prevParent = getParentElement(prevProps.parentSelector);
      var nextParent = getParentElement(this.props.parentSelector);
      return { prevParent: prevParent, nextParent: nextParent };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, _, snapshot) {
      if (!_safeHTMLElement.canUseDOM) return;
      var _props = this.props,
          isOpen = _props.isOpen,
          portalClassName = _props.portalClassName;


      if (prevProps.portalClassName !== portalClassName) {
        this.node.className = portalClassName;
      }

      var prevParent = snapshot.prevParent,
          nextParent = snapshot.nextParent;

      if (nextParent !== prevParent) {
        prevParent.removeChild(this.node);
        nextParent.appendChild(this.node);
      }

      // Stop unnecessary renders if modal is remaining closed
      if (!prevProps.isOpen && !isOpen) return;

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!_safeHTMLElement.canUseDOM || !this.node || !this.portal) return;

      var state = this.portal.state;
      var now = Date.now();
      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);

      if (closesAt) {
        if (!state.beforeClose) {
          this.portal.closeWithTimeout();
        }

        setTimeout(this.removePortal, closesAt - now);
      } else {
        this.removePortal();
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!_safeHTMLElement.canUseDOM || !isReact16) {
        return null;
      }

      if (!this.node && isReact16) {
        this.node = createHTMLElement("div");
      }

      var createPortal = getCreatePortal();
      return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends({
        ref: this.portalRef,
        defaultStyles: Modal.defaultStyles
      }, this.props)), this.node);
    }
  }], [{
    key: "setAppElement",
    value: function setAppElement(element) {
      ariaAppHider.setElement(element);
    }

    /* eslint-disable react/no-unused-prop-types */

    /* eslint-enable react/no-unused-prop-types */

  }]);

  return Modal;
}(_react.Component);

Modal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  portalClassName: _propTypes2.default.string,
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  appElement: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_safeHTMLElement2.default), _propTypes2.default.instanceOf(_safeHTMLElement.SafeHTMLCollection), _propTypes2.default.instanceOf(_safeHTMLElement.SafeNodeList), _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_safeHTMLElement2.default))]),
  onAfterOpen: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  ariaHideApp: _propTypes2.default.bool,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  preventScroll: _propTypes2.default.bool,
  parentSelector: _propTypes2.default.func,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func,
  id: _propTypes2.default.string,
  overlayElement: _propTypes2.default.func,
  contentElement: _propTypes2.default.func
};
Modal.defaultProps = {
  isOpen: false,
  portalClassName: portalClassName,
  bodyOpenClassName: bodyOpenClassName,
  role: "dialog",
  ariaHideApp: true,
  closeTimeoutMS: 0,
  shouldFocusAfterRender: true,
  shouldCloseOnEsc: true,
  shouldCloseOnOverlayClick: true,
  shouldReturnFocusAfterClose: true,
  preventScroll: false,
  parentSelector: function parentSelector() {
    return document.body;
  },
  overlayElement: function overlayElement(props, contentEl) {
    return _react2.default.createElement(
      "div",
      props,
      contentEl
    );
  },
  contentElement: function contentElement(props, children) {
    return _react2.default.createElement(
      "div",
      props,
      children
    );
  }
};
Modal.defaultStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)"
  },
  content: {
    position: "absolute",
    top: "40px",
    left: "40px",
    right: "40px",
    bottom: "40px",
    border: "1px solid #ccc",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "4px",
    outline: "none",
    padding: "20px"
  }
};


(0, _reactLifecyclesCompat.polyfill)(Modal);

if (false) {}

exports["default"] = Modal;

/***/ }),

/***/ 28747:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(37667);

var _propTypes = __webpack_require__(99545);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _focusManager = __webpack_require__(99685);

var focusManager = _interopRequireWildcard(_focusManager);

var _scopeTab = __webpack_require__(88338);

var _scopeTab2 = _interopRequireDefault(_scopeTab);

var _ariaAppHider = __webpack_require__(57149);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _classList = __webpack_require__(32409);

var classList = _interopRequireWildcard(_classList);

var _safeHTMLElement = __webpack_require__(51112);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

var _portalOpenInstances = __webpack_require__(89623);

var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);

__webpack_require__(35063);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// so that our CSS is statically analyzable
var CLASS_NAMES = {
  overlay: "ReactModal__Overlay",
  content: "ReactModal__Content"
};

/**
 * We need to support the deprecated `KeyboardEvent.keyCode` in addition to
 * `KeyboardEvent.code` for apps that still support IE11. Can be removed when
 * `react-modal` only supports React >18 (which dropped IE support).
 */
var isTabKey = function isTabKey(event) {
  return event.code === "Tab" || event.keyCode === 9;
};
var isEscKey = function isEscKey(event) {
  return event.code === "Escape" || event.keyCode === 27;
};

var ariaHiddenInstances = 0;

var ModalPortal = function (_Component) {
  _inherits(ModalPortal, _Component);

  function ModalPortal(props) {
    _classCallCheck(this, ModalPortal);

    var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));

    _this.setOverlayRef = function (overlay) {
      _this.overlay = overlay;
      _this.props.overlayRef && _this.props.overlayRef(overlay);
    };

    _this.setContentRef = function (content) {
      _this.content = content;
      _this.props.contentRef && _this.props.contentRef(content);
    };

    _this.afterClose = function () {
      var _this$props = _this.props,
          appElement = _this$props.appElement,
          ariaHideApp = _this$props.ariaHideApp,
          htmlOpenClassName = _this$props.htmlOpenClassName,
          bodyOpenClassName = _this$props.bodyOpenClassName,
          parentSelector = _this$props.parentSelector;


      var parentDocument = parentSelector && parentSelector().ownerDocument || document;

      // Remove classes.
      bodyOpenClassName && classList.remove(parentDocument.body, bodyOpenClassName);

      htmlOpenClassName && classList.remove(parentDocument.getElementsByTagName("html")[0], htmlOpenClassName);

      // Reset aria-hidden attribute if all modals have been removed
      if (ariaHideApp && ariaHiddenInstances > 0) {
        ariaHiddenInstances -= 1;

        if (ariaHiddenInstances === 0) {
          ariaAppHider.show(appElement);
        }
      }

      if (_this.props.shouldFocusAfterRender) {
        if (_this.props.shouldReturnFocusAfterClose) {
          focusManager.returnFocus(_this.props.preventScroll);
          focusManager.teardownScopedFocus();
        } else {
          focusManager.popWithoutFocus();
        }
      }

      if (_this.props.onAfterClose) {
        _this.props.onAfterClose();
      }

      _portalOpenInstances2.default.deregister(_this);
    };

    _this.open = function () {
      _this.beforeOpen();
      if (_this.state.afterOpen && _this.state.beforeClose) {
        clearTimeout(_this.closeTimer);
        _this.setState({ beforeClose: false });
      } else {
        if (_this.props.shouldFocusAfterRender) {
          focusManager.setupScopedFocus(_this.node);
          focusManager.markForFocusLater();
        }

        _this.setState({ isOpen: true }, function () {
          _this.openAnimationFrame = requestAnimationFrame(function () {
            _this.setState({ afterOpen: true });

            if (_this.props.isOpen && _this.props.onAfterOpen) {
              _this.props.onAfterOpen({
                overlayEl: _this.overlay,
                contentEl: _this.content
              });
            }
          });
        });
      }
    };

    _this.close = function () {
      if (_this.props.closeTimeoutMS > 0) {
        _this.closeWithTimeout();
      } else {
        _this.closeWithoutTimeout();
      }
    };

    _this.focusContent = function () {
      return _this.content && !_this.contentHasFocus() && _this.content.focus({ preventScroll: true });
    };

    _this.closeWithTimeout = function () {
      var closesAt = Date.now() + _this.props.closeTimeoutMS;
      _this.setState({ beforeClose: true, closesAt: closesAt }, function () {
        _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
      });
    };

    _this.closeWithoutTimeout = function () {
      _this.setState({
        beforeClose: false,
        isOpen: false,
        afterOpen: false,
        closesAt: null
      }, _this.afterClose);
    };

    _this.handleKeyDown = function (event) {
      if (isTabKey(event)) {
        (0, _scopeTab2.default)(_this.content, event);
      }

      if (_this.props.shouldCloseOnEsc && isEscKey(event)) {
        event.stopPropagation();
        _this.requestClose(event);
      }
    };

    _this.handleOverlayOnClick = function (event) {
      if (_this.shouldClose === null) {
        _this.shouldClose = true;
      }

      if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
        if (_this.ownerHandlesClose()) {
          _this.requestClose(event);
        } else {
          _this.focusContent();
        }
      }
      _this.shouldClose = null;
    };

    _this.handleContentOnMouseUp = function () {
      _this.shouldClose = false;
    };

    _this.handleOverlayOnMouseDown = function (event) {
      if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) {
        event.preventDefault();
      }
    };

    _this.handleContentOnClick = function () {
      _this.shouldClose = false;
    };

    _this.handleContentOnMouseDown = function () {
      _this.shouldClose = false;
    };

    _this.requestClose = function (event) {
      return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
    };

    _this.ownerHandlesClose = function () {
      return _this.props.onRequestClose;
    };

    _this.shouldBeClosed = function () {
      return !_this.state.isOpen && !_this.state.beforeClose;
    };

    _this.contentHasFocus = function () {
      return document.activeElement === _this.content || _this.content.contains(document.activeElement);
    };

    _this.buildClassName = function (which, additional) {
      var classNames = (typeof additional === "undefined" ? "undefined" : _typeof(additional)) === "object" ? additional : {
        base: CLASS_NAMES[which],
        afterOpen: CLASS_NAMES[which] + "--after-open",
        beforeClose: CLASS_NAMES[which] + "--before-close"
      };
      var className = classNames.base;
      if (_this.state.afterOpen) {
        className = className + " " + classNames.afterOpen;
      }
      if (_this.state.beforeClose) {
        className = className + " " + classNames.beforeClose;
      }
      return typeof additional === "string" && additional ? className + " " + additional : className;
    };

    _this.attributesFromObject = function (prefix, items) {
      return Object.keys(items).reduce(function (acc, name) {
        acc[prefix + "-" + name] = items[name];
        return acc;
      }, {});
    };

    _this.state = {
      afterOpen: false,
      beforeClose: false
    };

    _this.shouldClose = null;
    _this.moveFromContentToOverlay = null;
    return _this;
  }

  _createClass(ModalPortal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isOpen) {
        this.open();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (false) {}

      if (this.props.isOpen && !prevProps.isOpen) {
        this.open();
      } else if (!this.props.isOpen && prevProps.isOpen) {
        this.close();
      }

      // Focus only needs to be set once when the modal is being opened
      if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) {
        this.focusContent();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.isOpen) {
        this.afterClose();
      }
      clearTimeout(this.closeTimer);
      cancelAnimationFrame(this.openAnimationFrame);
    }
  }, {
    key: "beforeOpen",
    value: function beforeOpen() {
      var _props = this.props,
          appElement = _props.appElement,
          ariaHideApp = _props.ariaHideApp,
          htmlOpenClassName = _props.htmlOpenClassName,
          bodyOpenClassName = _props.bodyOpenClassName,
          parentSelector = _props.parentSelector;


      var parentDocument = parentSelector && parentSelector().ownerDocument || document;

      // Add classes.
      bodyOpenClassName && classList.add(parentDocument.body, bodyOpenClassName);

      htmlOpenClassName && classList.add(parentDocument.getElementsByTagName("html")[0], htmlOpenClassName);

      if (ariaHideApp) {
        ariaHiddenInstances += 1;
        ariaAppHider.hide(appElement);
      }

      _portalOpenInstances2.default.register(this);
    }

    // Don't steal focus from inner elements

  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          id = _props2.id,
          className = _props2.className,
          overlayClassName = _props2.overlayClassName,
          defaultStyles = _props2.defaultStyles,
          children = _props2.children;

      var contentStyles = className ? {} : defaultStyles.content;
      var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;

      if (this.shouldBeClosed()) {
        return null;
      }

      var overlayProps = {
        ref: this.setOverlayRef,
        className: this.buildClassName("overlay", overlayClassName),
        style: _extends({}, overlayStyles, this.props.style.overlay),
        onClick: this.handleOverlayOnClick,
        onMouseDown: this.handleOverlayOnMouseDown
      };

      var contentProps = _extends({
        id: id,
        ref: this.setContentRef,
        style: _extends({}, contentStyles, this.props.style.content),
        className: this.buildClassName("content", className),
        tabIndex: "-1",
        onKeyDown: this.handleKeyDown,
        onMouseDown: this.handleContentOnMouseDown,
        onMouseUp: this.handleContentOnMouseUp,
        onClick: this.handleContentOnClick,
        role: this.props.role,
        "aria-label": this.props.contentLabel
      }, this.attributesFromObject("aria", _extends({ modal: true }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
        "data-testid": this.props.testId
      });

      var contentElement = this.props.contentElement(contentProps, children);
      return this.props.overlayElement(overlayProps, contentElement);
    }
  }]);

  return ModalPortal;
}(_react.Component);

ModalPortal.defaultProps = {
  style: {
    overlay: {},
    content: {}
  },
  defaultStyles: {}
};
ModalPortal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  defaultStyles: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  parentSelector: _propTypes2.default.func,
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  ariaHideApp: _propTypes2.default.bool,
  appElement: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_safeHTMLElement2.default), _propTypes2.default.instanceOf(_safeHTMLElement.SafeHTMLCollection), _propTypes2.default.instanceOf(_safeHTMLElement.SafeNodeList), _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_safeHTMLElement2.default))]),
  onAfterOpen: _propTypes2.default.func,
  onAfterClose: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  preventScroll: _propTypes2.default.bool,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  children: _propTypes2.default.node,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func,
  id: _propTypes2.default.string,
  overlayElement: _propTypes2.default.func,
  contentElement: _propTypes2.default.func,
  testId: _propTypes2.default.string
};
exports["default"] = ModalPortal;
module.exports = exports["default"];

/***/ }),

/***/ 57149:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.resetState = resetState;
exports.log = log;
exports.assertNodeList = assertNodeList;
exports.setElement = setElement;
exports.validateElement = validateElement;
exports.hide = hide;
exports.show = show;
exports.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;

var _warning = __webpack_require__(42473);

var _warning2 = _interopRequireDefault(_warning);

var _safeHTMLElement = __webpack_require__(51112);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var globalElement = null;

/* eslint-disable no-console */
/* istanbul ignore next */
function resetState() {
  if (globalElement) {
    if (globalElement.removeAttribute) {
      globalElement.removeAttribute("aria-hidden");
    } else if (globalElement.length != null) {
      globalElement.forEach(function (element) {
        return element.removeAttribute("aria-hidden");
      });
    } else {
      document.querySelectorAll(globalElement).forEach(function (element) {
        return element.removeAttribute("aria-hidden");
      });
    }
  }
  globalElement = null;
}

/* istanbul ignore next */
function log() {
  if (false) { var check; }
}
/* eslint-enable no-console */

function assertNodeList(nodeList, selector) {
  if (!nodeList || !nodeList.length) {
    throw new Error("react-modal: No elements were found for selector " + selector + ".");
  }
}

function setElement(element) {
  var useElement = element;
  if (typeof useElement === "string" && _safeHTMLElement.canUseDOM) {
    var el = document.querySelectorAll(useElement);
    assertNodeList(el, useElement);
    useElement = el;
  }
  globalElement = useElement || globalElement;
  return globalElement;
}

function validateElement(appElement) {
  var el = appElement || globalElement;
  if (el) {
    return Array.isArray(el) || el instanceof HTMLCollection || el instanceof NodeList ? el : [el];
  } else {
    (0, _warning2.default)(false, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" "));

    return [];
  }
}

function hide(appElement) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = validateElement(appElement)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var el = _step.value;

      el.setAttribute("aria-hidden", "true");
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}

function show(appElement) {
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = validateElement(appElement)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var el = _step2.value;

      el.removeAttribute("aria-hidden");
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }
}

function documentNotReadyOrSSRTesting() {
  globalElement = null;
}

/***/ }),

/***/ 35063:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.resetState = resetState;
exports.log = log;

var _portalOpenInstances = __webpack_require__(89623);

var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Body focus trap see Issue #742

var before = void 0,
    after = void 0,
    instances = [];

/* eslint-disable no-console */
/* istanbul ignore next */
function resetState() {
  var _arr = [before, after];

  for (var _i = 0; _i < _arr.length; _i++) {
    var item = _arr[_i];
    if (!item) continue;
    item.parentNode && item.parentNode.removeChild(item);
  }
  before = after = null;
  instances = [];
}

/* istanbul ignore next */
function log() {
  console.log("bodyTrap ----------");
  console.log(instances.length);
  var _arr2 = [before, after];
  for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
    var item = _arr2[_i2];
    var check = item || {};
    console.log(check.nodeName, check.className, check.id);
  }
  console.log("edn bodyTrap ----------");
}
/* eslint-enable no-console */

function focusContent() {
  if (instances.length === 0) {
    if (false) {}
    return;
  }
  instances[instances.length - 1].focusContent();
}

function bodyTrap(eventType, openInstances) {
  if (!before && !after) {
    before = document.createElement("div");
    before.setAttribute("data-react-modal-body-trap", "");
    before.style.position = "absolute";
    before.style.opacity = "0";
    before.setAttribute("tabindex", "0");
    before.addEventListener("focus", focusContent);
    after = before.cloneNode();
    after.addEventListener("focus", focusContent);
  }

  instances = openInstances;

  if (instances.length > 0) {
    // Add focus trap
    if (document.body.firstChild !== before) {
      document.body.insertBefore(before, document.body.firstChild);
    }
    if (document.body.lastChild !== after) {
      document.body.appendChild(after);
    }
  } else {
    // Remove focus trap
    if (before.parentElement) {
      before.parentElement.removeChild(before);
    }
    if (after.parentElement) {
      after.parentElement.removeChild(after);
    }
  }
}

_portalOpenInstances2.default.subscribe(bodyTrap);

/***/ }),

/***/ 32409:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.resetState = resetState;
exports.log = log;
var htmlClassList = {};
var docBodyClassList = {};

/* eslint-disable no-console */
/* istanbul ignore next */
function removeClass(at, cls) {
  at.classList.remove(cls);
}

/* istanbul ignore next */
function resetState() {
  var htmlElement = document.getElementsByTagName("html")[0];
  for (var cls in htmlClassList) {
    removeClass(htmlElement, htmlClassList[cls]);
  }

  var body = document.body;
  for (var _cls in docBodyClassList) {
    removeClass(body, docBodyClassList[_cls]);
  }

  htmlClassList = {};
  docBodyClassList = {};
}

/* istanbul ignore next */
function log() {
  if (false) { var _x, x, buffer, classes; }
}
/* eslint-enable no-console */

/**
 * Track the number of reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var incrementReference = function incrementReference(poll, className) {
  if (!poll[className]) {
    poll[className] = 0;
  }
  poll[className] += 1;
  return className;
};

/**
 * Drop the reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var decrementReference = function decrementReference(poll, className) {
  if (poll[className]) {
    poll[className] -= 1;
  }
  return className;
};

/**
 * Track a class and add to the given class list.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be tracked.
 */
var trackClass = function trackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    incrementReference(poll, className);
    classListRef.add(className);
  });
};

/**
 * Untrack a class and remove from the given class list if the reference
 * reaches 0.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be untracked.
 */
var untrackClass = function untrackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    decrementReference(poll, className);
    poll[className] === 0 && classListRef.remove(className);
  });
};

/**
 * Public inferface to add classes to the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var add = exports.add = function add(element, classString) {
  return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/**
 * Public inferface to remove classes from the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var remove = exports.remove = function remove(element, classString) {
  return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/***/ }),

/***/ 99685:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.resetState = resetState;
exports.log = log;
exports.handleBlur = handleBlur;
exports.handleFocus = handleFocus;
exports.markForFocusLater = markForFocusLater;
exports.returnFocus = returnFocus;
exports.popWithoutFocus = popWithoutFocus;
exports.setupScopedFocus = setupScopedFocus;
exports.teardownScopedFocus = teardownScopedFocus;

var _tabbable = __webpack_require__(37845);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var focusLaterElements = [];
var modalElement = null;
var needToFocus = false;

/* eslint-disable no-console */
/* istanbul ignore next */
function resetState() {
  focusLaterElements = [];
}

/* istanbul ignore next */
function log() {
  if (false) {}
}
/* eslint-enable no-console */

function handleBlur() {
  needToFocus = true;
}

function handleFocus() {
  if (needToFocus) {
    needToFocus = false;
    if (!modalElement) {
      return;
    }
    // need to see how jQuery shims document.on('focusin') so we don't need the
    // setTimeout, firefox doesn't support focusin, if it did, we could focus
    // the element outside of a setTimeout. Side-effect of this implementation
    // is that the document.body gets focus, and then we focus our element right
    // after, seems fine.
    setTimeout(function () {
      if (modalElement.contains(document.activeElement)) {
        return;
      }
      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
      el.focus();
    }, 0);
  }
}

function markForFocusLater() {
  focusLaterElements.push(document.activeElement);
}

/* eslint-disable no-console */
function returnFocus() {
  var preventScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var toFocus = null;
  try {
    if (focusLaterElements.length !== 0) {
      toFocus = focusLaterElements.pop();
      toFocus.focus({ preventScroll: preventScroll });
    }
    return;
  } catch (e) {
    console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
  }
}
/* eslint-enable no-console */

function popWithoutFocus() {
  focusLaterElements.length > 0 && focusLaterElements.pop();
}

function setupScopedFocus(element) {
  modalElement = element;

  if (window.addEventListener) {
    window.addEventListener("blur", handleBlur, false);
    document.addEventListener("focus", handleFocus, true);
  } else {
    window.attachEvent("onBlur", handleBlur);
    document.attachEvent("onFocus", handleFocus);
  }
}

function teardownScopedFocus() {
  modalElement = null;

  if (window.addEventListener) {
    window.removeEventListener("blur", handleBlur);
    document.removeEventListener("focus", handleFocus);
  } else {
    window.detachEvent("onBlur", handleBlur);
    document.detachEvent("onFocus", handleFocus);
  }
}

/***/ }),

/***/ 89623:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.log = log;
exports.resetState = resetState;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Tracks portals that are open and emits events to subscribers

var PortalOpenInstances = function PortalOpenInstances() {
  var _this = this;

  _classCallCheck(this, PortalOpenInstances);

  this.register = function (openInstance) {
    if (_this.openInstances.indexOf(openInstance) !== -1) {
      if (false) {}
      return;
    }
    _this.openInstances.push(openInstance);
    _this.emit("register");
  };

  this.deregister = function (openInstance) {
    var index = _this.openInstances.indexOf(openInstance);
    if (index === -1) {
      if (false) {}
      return;
    }
    _this.openInstances.splice(index, 1);
    _this.emit("deregister");
  };

  this.subscribe = function (callback) {
    _this.subscribers.push(callback);
  };

  this.emit = function (eventType) {
    _this.subscribers.forEach(function (subscriber) {
      return subscriber(eventType,
      // shallow copy to avoid accidental mutation
      _this.openInstances.slice());
    });
  };

  this.openInstances = [];
  this.subscribers = [];
};

var portalOpenInstances = new PortalOpenInstances();

/* eslint-disable no-console */
/* istanbul ignore next */
function log() {
  console.log("portalOpenInstances ----------");
  console.log(portalOpenInstances.openInstances.length);
  portalOpenInstances.openInstances.forEach(function (p) {
    return console.log(p);
  });
  console.log("end portalOpenInstances ----------");
}

/* istanbul ignore next */
function resetState() {
  portalOpenInstances = new PortalOpenInstances();
}
/* eslint-enable no-console */

exports["default"] = portalOpenInstances;

/***/ }),

/***/ 51112:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.canUseDOM = exports.SafeNodeList = exports.SafeHTMLCollection = undefined;

var _exenv = __webpack_require__(58875);

var _exenv2 = _interopRequireDefault(_exenv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EE = _exenv2.default;

var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};

var SafeHTMLCollection = exports.SafeHTMLCollection = EE.canUseDOM ? window.HTMLCollection : {};

var SafeNodeList = exports.SafeNodeList = EE.canUseDOM ? window.NodeList : {};

var canUseDOM = exports.canUseDOM = EE.canUseDOM;

exports["default"] = SafeHTMLElement;

/***/ }),

/***/ 88338:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = scopeTab;

var _tabbable = __webpack_require__(37845);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getActiveElement() {
  var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;

  return el.activeElement.shadowRoot ? getActiveElement(el.activeElement.shadowRoot) : el.activeElement;
}

function scopeTab(node, event) {
  var tabbable = (0, _tabbable2.default)(node);

  if (!tabbable.length) {
    // Do nothing, since there are no elements that can receive focus.
    event.preventDefault();
    return;
  }

  var target = void 0;

  var shiftKey = event.shiftKey;
  var head = tabbable[0];
  var tail = tabbable[tabbable.length - 1];
  var activeElement = getActiveElement();

  // proceed with default browser behavior on tab.
  // Focus on last element on shift + tab.
  if (node === activeElement) {
    if (!shiftKey) return;
    target = tail;
  }

  if (tail === activeElement && !shiftKey) {
    target = head;
  }

  if (head === activeElement && shiftKey) {
    target = tail;
  }

  if (target) {
    event.preventDefault();
    target.focus();
    return;
  }

  // Safari radio issue.
  //
  // Safari does not move the focus to the radio button,
  // so we need to force it to really walk through all elements.
  //
  // This is very error prone, since we are trying to guess
  // if it is a safari browser from the first occurence between
  // chrome or safari.
  //
  // The chrome user agent contains the first ocurrence
  // as the 'chrome/version' and later the 'safari/version'.
  var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
  var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;

  // If we are not in safari desktop, let the browser control
  // the focus
  if (!isSafariDesktop) return;

  var x = tabbable.indexOf(activeElement);

  if (x > -1) {
    x += shiftKey ? -1 : 1;
  }

  target = tabbable[x];

  // If the tabbable element does not exist,
  // focus head/tail based on shiftKey
  if (typeof target === "undefined") {
    event.preventDefault();
    target = shiftKey ? tail : head;
    target.focus();
    return;
  }

  event.preventDefault();

  target.focus();
}
module.exports = exports["default"];

/***/ }),

/***/ 37845:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = findTabbableDescendants;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */

var DISPLAY_NONE = "none";
var DISPLAY_CONTENTS = "contents";

var tabbableNode = /input|select|textarea|button|object|iframe/;

function isNotOverflowing(element, style) {
  return style.getPropertyValue("overflow") !== "visible" ||
  // if 'overflow: visible' set, check if there is actually any overflow
  element.scrollWidth <= 0 && element.scrollHeight <= 0;
}

function hidesContents(element) {
  var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;

  // If the node is empty, this is good enough
  if (zeroSize && !element.innerHTML) return true;

  try {
    // Otherwise we need to check some styles
    var style = window.getComputedStyle(element);
    var displayValue = style.getPropertyValue("display");
    return zeroSize ? displayValue !== DISPLAY_CONTENTS && isNotOverflowing(element, style) : displayValue === DISPLAY_NONE;
  } catch (exception) {
    // eslint-disable-next-line no-console
    console.warn("Failed to inspect element style");
    return false;
  }
}

function visible(element) {
  var parentElement = element;
  var rootNode = element.getRootNode && element.getRootNode();
  while (parentElement) {
    if (parentElement === document.body) break;

    // if we are not hidden yet, skip to checking outside the Web Component
    if (rootNode && parentElement === rootNode) parentElement = rootNode.host.parentNode;

    if (hidesContents(parentElement)) return false;
    parentElement = parentElement.parentNode;
  }
  return true;
}

function focusable(element, isTabIndexNotNaN) {
  var nodeName = element.nodeName.toLowerCase();
  var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
  return res && visible(element);
}

function tabbable(element) {
  var tabIndex = element.getAttribute("tabindex");
  if (tabIndex === null) tabIndex = undefined;
  var isTabIndexNaN = isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
}

function findTabbableDescendants(element) {
  var descendants = [].slice.call(element.querySelectorAll("*"), 0).reduce(function (finished, el) {
    return finished.concat(!el.shadowRoot ? [el] : findTabbableDescendants(el.shadowRoot));
  }, []);
  return descendants.filter(tabbable);
}
module.exports = exports["default"];

/***/ }),

/***/ 83253:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _Modal = __webpack_require__(29983);

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports["default"] = _Modal2.default;
module.exports = exports["default"];

/***/ }),

/***/ 61118:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(55344);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 99545:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(61118)();
}


/***/ }),

/***/ 55344:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 53200:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(54259);

var _utils2 = _interopRequireDefault(_utils);

var _smooth = __webpack_require__(89765);

var _smooth2 = _interopRequireDefault(_smooth);

var _cancelEvents = __webpack_require__(50140);

var _cancelEvents2 = _interopRequireDefault(_cancelEvents);

var _scrollEvents = __webpack_require__(64592);

var _scrollEvents2 = _interopRequireDefault(_scrollEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Gets the easing type from the smooth prop within options.
 */
var getAnimationType = function getAnimationType(options) {
  return _smooth2.default[options.smooth] || _smooth2.default.defaultEasing;
};
/*
 * Function helper
 */
var functionWrapper = function functionWrapper(value) {
  return typeof value === 'function' ? value : function () {
    return value;
  };
};
/*
 * Wraps window properties to allow server side rendering
 */
var currentWindowProperties = function currentWindowProperties() {
  if (typeof window !== 'undefined') {
    return window.requestAnimationFrame || window.webkitRequestAnimationFrame;
  }
};

/*
 * Helper function to never extend 60fps on the webpage.
 */
var requestAnimationFrameHelper = function () {
  return currentWindowProperties() || function (callback, element, delay) {
    window.setTimeout(callback, delay || 1000 / 60, new Date().getTime());
  };
}();

var makeData = function makeData() {
  return {
    currentPosition: 0,
    startPosition: 0,
    targetPosition: 0,
    progress: 0,
    duration: 0,
    cancel: false,

    target: null,
    containerElement: null,
    to: null,
    start: null,
    delta: null,
    percent: null,
    delayTimeout: null
  };
};

var currentPositionX = function currentPositionX(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return containerElement.scrollLeft;
  } else {
    var supportPageOffset = window.pageXOffset !== undefined;
    var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
    return supportPageOffset ? window.pageXOffset : isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft;
  }
};

var currentPositionY = function currentPositionY(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return containerElement.scrollTop;
  } else {
    var supportPageOffset = window.pageXOffset !== undefined;
    var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
    return supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
  }
};

var scrollContainerWidth = function scrollContainerWidth(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return containerElement.scrollWidth - containerElement.offsetWidth;
  } else {
    var body = document.body;
    var html = document.documentElement;

    return Math.max(body.scrollWidth, body.offsetWidth, html.clientWidth, html.scrollWidth, html.offsetWidth);
  }
};

var scrollContainerHeight = function scrollContainerHeight(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return containerElement.scrollHeight - containerElement.offsetHeight;
  } else {
    var body = document.body;
    var html = document.documentElement;

    return Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
  }
};

var animateScroll = function animateScroll(easing, options, timestamp) {
  var data = options.data;

  // Cancel on specific events
  if (!options.ignoreCancelEvents && data.cancel) {
    if (_scrollEvents2.default.registered['end']) {
      _scrollEvents2.default.registered['end'](data.to, data.target, data.currentPositionY);
    }
    return;
  };

  data.delta = Math.round(data.targetPosition - data.startPosition);

  if (data.start === null) {
    data.start = timestamp;
  }

  data.progress = timestamp - data.start;

  data.percent = data.progress >= data.duration ? 1 : easing(data.progress / data.duration);

  data.currentPosition = data.startPosition + Math.ceil(data.delta * data.percent);

  if (data.containerElement && data.containerElement !== document && data.containerElement !== document.body) {
    if (options.horizontal) {
      data.containerElement.scrollLeft = data.currentPosition;
    } else {
      data.containerElement.scrollTop = data.currentPosition;
    }
  } else {
    if (options.horizontal) {
      window.scrollTo(data.currentPosition, 0);
    } else {
      window.scrollTo(0, data.currentPosition);
    }
  }

  if (data.percent < 1) {
    var easedAnimate = animateScroll.bind(null, easing, options);
    requestAnimationFrameHelper.call(window, easedAnimate);
    return;
  }

  if (_scrollEvents2.default.registered['end']) {
    _scrollEvents2.default.registered['end'](data.to, data.target, data.currentPosition);
  }
};

var setContainer = function setContainer(options) {
  options.data.containerElement = !options ? null : options.containerId ? document.getElementById(options.containerId) : options.container && options.container.nodeType ? options.container : document;
};

var animateTopScroll = function animateTopScroll(scrollOffset, options, to, target) {
  options.data = options.data || makeData();

  window.clearTimeout(options.data.delayTimeout);

  _cancelEvents2.default.subscribe(function () {
    options.data.cancel = true;
  });

  setContainer(options);

  options.data.start = null;
  options.data.cancel = false;
  options.data.startPosition = options.horizontal ? currentPositionX(options) : currentPositionY(options);
  options.data.targetPosition = options.absolute ? scrollOffset : scrollOffset + options.data.startPosition;

  if (options.data.startPosition === options.data.targetPosition) {
    if (_scrollEvents2.default.registered['end']) {
      _scrollEvents2.default.registered['end'](options.data.to, options.data.target, options.data.currentPosition);
    }
    return;
  }

  options.data.delta = Math.round(options.data.targetPosition - options.data.startPosition);

  options.data.duration = functionWrapper(options.duration)(options.data.delta);
  options.data.duration = isNaN(parseFloat(options.data.duration)) ? 1000 : parseFloat(options.data.duration);
  options.data.to = to;
  options.data.target = target;

  var easing = getAnimationType(options);
  var easedAnimate = animateScroll.bind(null, easing, options);

  if (options && options.delay > 0) {
    options.data.delayTimeout = window.setTimeout(function () {
      if (_scrollEvents2.default.registered['begin']) {
        _scrollEvents2.default.registered['begin'](options.data.to, options.data.target);
      }
      requestAnimationFrameHelper.call(window, easedAnimate);
    }, options.delay);
    return;
  }

  if (_scrollEvents2.default.registered['begin']) {
    _scrollEvents2.default.registered['begin'](options.data.to, options.data.target);
  }
  requestAnimationFrameHelper.call(window, easedAnimate);
};

var proceedOptions = function proceedOptions(options) {
  options = _extends({}, options);
  options.data = options.data || makeData();
  options.absolute = true;
  return options;
};

var scrollToTop = function scrollToTop(options) {
  animateTopScroll(0, proceedOptions(options));
};

var scrollTo = function scrollTo(toPosition, options) {
  animateTopScroll(toPosition, proceedOptions(options));
};

var scrollToBottom = function scrollToBottom(options) {
  options = proceedOptions(options);
  setContainer(options);
  animateTopScroll(options.horizontal ? scrollContainerWidth(options) : scrollContainerHeight(options), options);
};

var scrollMore = function scrollMore(toPosition, options) {
  options = proceedOptions(options);
  setContainer(options);
  var currentPosition = options.horizontal ? currentPositionX(options) : currentPositionY(options);
  animateTopScroll(toPosition + currentPosition, options);
};

exports.Z = {
  animateTopScroll: animateTopScroll,
  getAnimationType: getAnimationType,
  scrollToTop: scrollToTop,
  scrollToBottom: scrollToBottom,
  scrollTo: scrollTo,
  scrollMore: scrollMore
};

/***/ }),

/***/ 50140:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _passiveEventListeners = __webpack_require__(55236);

var events = ['mousedown', 'mousewheel', 'touchmove', 'keydown'];

exports["default"] = {
  subscribe: function subscribe(cancelEvent) {
    return typeof document !== 'undefined' && events.forEach(function (event) {
      return (0, _passiveEventListeners.addPassiveEventListener)(document, event, cancelEvent);
    });
  }
};

/***/ }),

/***/ 55236:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
/*
 * Tell the browser that the event listener won't prevent a scroll.
 * Allowing the browser to continue scrolling without having to
 * to wait for the listener to return.
 */
var addPassiveEventListener = exports.addPassiveEventListener = function addPassiveEventListener(target, eventName, listener) {
  var supportsPassiveOption = function () {
    var supportsPassiveOption = false;
    try {
      var opts = Object.defineProperty({}, 'passive', {
        get: function get() {
          supportsPassiveOption = true;
        }
      });
      window.addEventListener('test', null, opts);
    } catch (e) {}
    return supportsPassiveOption;
  }();
  target.addEventListener(eventName, listener, supportsPassiveOption ? { passive: true } : false);
};

var removePassiveEventListener = exports.removePassiveEventListener = function removePassiveEventListener(target, eventName, listener) {
  target.removeEventListener(eventName, listener);
};

/***/ }),

/***/ 64592:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
	value: true
}));

var Events = {
	registered: {},
	scrollEvent: {
		register: function register(evtName, callback) {
			Events.registered[evtName] = callback;
		},
		remove: function remove(evtName) {
			Events.registered[evtName] = null;
		}
	}
};

exports["default"] = Events;

/***/ }),

/***/ 89765:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = {
  /*
   * https://github.com/oblador/angular-scroll (duScrollDefaultEasing)
   */
  defaultEasing: function defaultEasing(x) {
    if (x < 0.5) {
      return Math.pow(x * 2, 2) / 2;
    }
    return 1 - Math.pow((1 - x) * 2, 2) / 2;
  },
  /*
   * https://gist.github.com/gre/1650294
   */
  // no easing, no acceleration
  linear: function linear(x) {
    return x;
  },
  // accelerating from zero velocity
  easeInQuad: function easeInQuad(x) {
    return x * x;
  },
  // decelerating to zero velocity
  easeOutQuad: function easeOutQuad(x) {
    return x * (2 - x);
  },
  // acceleration until halfway, then deceleration
  easeInOutQuad: function easeInOutQuad(x) {
    return x < .5 ? 2 * x * x : -1 + (4 - 2 * x) * x;
  },
  // accelerating from zero velocity 
  easeInCubic: function easeInCubic(x) {
    return x * x * x;
  },
  // decelerating to zero velocity π
  easeOutCubic: function easeOutCubic(x) {
    return --x * x * x + 1;
  },
  // acceleration until halfway, then deceleration 
  easeInOutCubic: function easeInOutCubic(x) {
    return x < .5 ? 4 * x * x * x : (x - 1) * (2 * x - 2) * (2 * x - 2) + 1;
  },
  // accelerating from zero velocity 
  easeInQuart: function easeInQuart(x) {
    return x * x * x * x;
  },
  // decelerating to zero velocity 
  easeOutQuart: function easeOutQuart(x) {
    return 1 - --x * x * x * x;
  },
  // acceleration until halfway, then deceleration
  easeInOutQuart: function easeInOutQuart(x) {
    return x < .5 ? 8 * x * x * x * x : 1 - 8 * --x * x * x * x;
  },
  // accelerating from zero velocity
  easeInQuint: function easeInQuint(x) {
    return x * x * x * x * x;
  },
  // decelerating to zero velocity
  easeOutQuint: function easeOutQuint(x) {
    return 1 + --x * x * x * x * x;
  },
  // acceleration until halfway, then deceleration 
  easeInOutQuint: function easeInOutQuint(x) {
    return x < .5 ? 16 * x * x * x * x * x : 1 + 16 * --x * x * x * x * x;
  }
};

/***/ }),

/***/ 54259:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
var updateHash = function updateHash(hash, historyUpdate) {
  var hashVal = hash.indexOf("#") === 0 ? hash.substring(1) : hash;
  var hashToUpdate = hashVal ? "#" + hashVal : "";
  var curLoc = window && window.location;
  var urlToPush = hashToUpdate ? curLoc.pathname + curLoc.search + hashToUpdate : curLoc.pathname + curLoc.search;
  historyUpdate ? history.pushState(history.state, "", urlToPush) : history.replaceState(history.state, "", urlToPush);
};

var getHash = function getHash() {
  return window.location.hash.replace(/^#/, "");
};

var filterElementInContainer = function filterElementInContainer(container) {
  return function (element) {
    return container.contains ? container != element && container.contains(element) : !!(container.compareDocumentPosition(element) & 16);
  };
};

var isPositioned = function isPositioned(element) {
  return getComputedStyle(element).position !== "static";
};

var getElementOffsetInfoUntil = function getElementOffsetInfoUntil(element, predicate) {
  var offsetTop = element.offsetTop;
  var currentOffsetParent = element.offsetParent;

  while (currentOffsetParent && !predicate(currentOffsetParent)) {
    offsetTop += currentOffsetParent.offsetTop;
    currentOffsetParent = currentOffsetParent.offsetParent;
  }

  return { offsetTop: offsetTop, offsetParent: currentOffsetParent };
};

var scrollOffset = function scrollOffset(c, t, horizontal) {
  if (horizontal) {
    return c === document ? t.getBoundingClientRect().left + (window.scrollX || window.pageXOffset) : getComputedStyle(c).position !== "static" ? t.offsetLeft : t.offsetLeft - c.offsetLeft;
  } else {
    if (c === document) {
      return t.getBoundingClientRect().top + (window.scrollY || window.pageYOffset);
    }

    // The offsetParent of an element, according to MDN, is its nearest positioned
    // (an element whose position is anything other than static) ancestor. The offsetTop
    // of an element is taken with respect to its offsetParent which may not neccessarily
    // be its parentElement except the parent itself is positioned.

    // So if containerElement is positioned, then it must be an offsetParent somewhere
    // If it happens that targetElement is a descendant of the containerElement, and there
    // is not intermediate positioned element between the two of them, i.e.
    // targetElement"s offsetParent is the same as the containerElement, then the
    // distance between the two will be the offsetTop of the targetElement.
    // If, on the other hand, there are intermediate positioned elements between the
    // two entities, the distance between the targetElement and the containerElement
    // will be the accumulation of the offsetTop of the element and that of its
    // subsequent offsetParent until the containerElement is reached, since it
    // will also be an offsetParent at some point due to the fact that it is positioned.

    // If the containerElement is not positioned, then it can"t be an offsetParent,
    // which means that the offsetTop of the targetElement would not be with respect to it.
    // However, if the two of them happen to have the same offsetParent, then
    // the distance between them will be the difference between their offsetTop
    // since they are both taken with respect to the same entity.
    // The last resort would be to accumulate their offsetTop until a common
    // offsetParent is reached (usually the document) and taking the difference
    // between the accumulated offsetTops

    if (isPositioned(c)) {
      if (t.offsetParent !== c) {
        var isContainerElementOrDocument = function isContainerElementOrDocument(e) {
          return e === c || e === document;
        };

        var _getElementOffsetInfo = getElementOffsetInfoUntil(t, isContainerElementOrDocument),
            offsetTop = _getElementOffsetInfo.offsetTop,
            offsetParent = _getElementOffsetInfo.offsetParent;

        if (offsetParent !== c) {
          throw new Error("Seems containerElement is not an ancestor of the Element");
        }

        return offsetTop;
      }

      return t.offsetTop;
    }

    if (t.offsetParent === c.offsetParent) {
      return t.offsetTop - c.offsetTop;
    }

    var isDocument = function isDocument(e) {
      return e === document;
    };
    return getElementOffsetInfoUntil(t, isDocument).offsetTop - getElementOffsetInfoUntil(c, isDocument).offsetTop;
  }
};

exports["default"] = {
  updateHash: updateHash,
  getHash: getHash,
  filterElementInContainer: filterElementInContainer,
  scrollOffset: scrollOffset
};

/***/ }),

/***/ 37478:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(45388);
var callBound = __webpack_require__(21924);
var inspect = __webpack_require__(70631);

var $TypeError = GetIntrinsic('%TypeError%');
var $WeakMap = GetIntrinsic('%WeakMap%', true);
var $Map = GetIntrinsic('%Map%', true);

var $weakMapGet = callBound('WeakMap.prototype.get', true);
var $weakMapSet = callBound('WeakMap.prototype.set', true);
var $weakMapHas = callBound('WeakMap.prototype.has', true);
var $mapGet = callBound('Map.prototype.get', true);
var $mapSet = callBound('Map.prototype.set', true);
var $mapHas = callBound('Map.prototype.has', true);

/*
 * This function traverses the list returning the node corresponding to the
 * given key.
 *
 * That node is also moved to the head of the list, so that if it's accessed
 * again we don't need to traverse the whole list. By doing so, all the recently
 * used nodes can be accessed relatively quickly.
 */
var listGetNode = function (list, key) { // eslint-disable-line consistent-return
	for (var prev = list, curr; (curr = prev.next) !== null; prev = curr) {
		if (curr.key === key) {
			prev.next = curr.next;
			curr.next = list.next;
			list.next = curr; // eslint-disable-line no-param-reassign
			return curr;
		}
	}
};

var listGet = function (objects, key) {
	var node = listGetNode(objects, key);
	return node && node.value;
};
var listSet = function (objects, key, value) {
	var node = listGetNode(objects, key);
	if (node) {
		node.value = value;
	} else {
		// Prepend the new node to the beginning of the list
		objects.next = { // eslint-disable-line no-param-reassign
			key: key,
			next: objects.next,
			value: value
		};
	}
};
var listHas = function (objects, key) {
	return !!listGetNode(objects, key);
};

module.exports = function getSideChannel() {
	var $wm;
	var $m;
	var $o;
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		get: function (key) { // eslint-disable-line consistent-return
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapGet($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapGet($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listGet($o, key);
				}
			}
		},
		has: function (key) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapHas($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapHas($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listHas($o, key);
				}
			}
			return false;
		},
		set: function (key, value) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if (!$wm) {
					$wm = new $WeakMap();
				}
				$weakMapSet($wm, key, value);
			} else if ($Map) {
				if (!$m) {
					$m = new $Map();
				}
				$mapSet($m, key, value);
			} else {
				if (!$o) {
					/*
					 * Initialize the linked list as an empty node, so that we don't have
					 * to special-case handling of the first node: we can always refer to
					 * it as (previous node).next, instead of something like (list).head
					 */
					$o = { key: {}, next: null };
				}
				listSet($o, key, value);
			}
		}
	};
	return channel;
};


/***/ }),

/***/ 45388:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var undefined;

var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError = TypeError;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(19193)();

var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': RangeError,
	'%ReferenceError%': ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__(58612);
var hasOwn = __webpack_require__(17642);
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};


/***/ }),

/***/ 19193:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__(6105);

module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};


/***/ }),

/***/ 6105:
/***/ (function(module) {

"use strict";


/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),

/***/ 80044:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
__webpack_unused_export__ = void 0;
const react_1 = __webpack_require__(37667);
/**
 * A wrapper for `JSON.parse()` which supports the return value of `JSON.stringify(undefined)`
 * which returns the string `"undefined"` and this method returns the value `undefined`.
 */
function parseJSON(value) {
    return value === 'undefined'
        ? undefined
        : // JSON.parse() doesn't accept non-string values, this is why we pass empty
            // string which will throw an error which can be handled
            JSON.parse(value !== null && value !== void 0 ? value : '');
}
/**
 * Abstraction for localStorage that uses an in-memory fallback when localStorage throws an error.
 * Reasons for throwing an error:
 * - maximum quota is exceeded
 * - under Mobile Safari (since iOS 5) when the user enters private mode `localStorage.setItem()`
 *   will throw
 * - trying to access localStorage object when cookies are disabled in Safari throws
 *   "SecurityError: The operation is insecure."
 */
const data = {};
const storage = {
    get(key, defaultValue) {
        var _a;
        try {
            return (_a = data[key]) !== null && _a !== void 0 ? _a : parseJSON(localStorage.getItem(key));
        }
        catch (_b) {
            return defaultValue;
        }
    },
    set(key, value) {
        try {
            localStorage.setItem(key, JSON.stringify(value));
            data[key] = undefined;
            return true;
        }
        catch (_a) {
            data[key] = value;
            return false;
        }
    },
    remove(key) {
        data[key] = undefined;
        try {
            localStorage.removeItem(key);
        }
        catch (_a) { }
    },
};
/**
 * Used to track usages of `useLocalStorageState()` with identical `key` values. If we encounter
 * duplicates we throw an error to the user telling them to use `createLocalStorageStateHook`
 * instead.
 */
const initializedStorageKeys = new Set();
function useLocalStorageState(key, defaultValue) {
    // we don't support updating the `defaultValue` the same way `useState()` doesn't support it
    const [defaultValueState] = react_1.useState(() => {
        const isCallable = (value) => typeof value === 'function';
        return isCallable(defaultValue) ? defaultValue() : defaultValue;
    });
    const getDefaultState = react_1.useCallback(() => {
        return {
            value: storage.get(key, defaultValueState),
            isPersistent: (() => {
                /**
                 * We want to return `true` on the server. If you render a message based on `isPersistent` and the
                 * server returns `false` then the message will flicker until hydration is done:
                 * `{!isPersistent && <span>You changes aren't being persisted.</span>}`
                 */
                if (typeof window === 'undefined') {
                    return true;
                }
                try {
                    localStorage.setItem('--use-local-storage-state--', 'dummy');
                    localStorage.removeItem('--use-local-storage-state--');
                    return true;
                }
                catch (_a) {
                    return false;
                }
            })(),
        };
    }, [defaultValueState, key]);
    const [state, setState] = react_1.useState(getDefaultState);
    const updateValue = react_1.useMemo(() => {
        const fn = (newValue) => {
            const isCallable = (value) => typeof value === 'function';
            if (isCallable(newValue)) {
                setState((state) => ({
                    value: newValue(state.value),
                    isPersistent: storage.set(key, newValue(state.value)),
                }));
            }
            else {
                setState({
                    value: newValue,
                    isPersistent: storage.set(key, newValue),
                });
            }
        };
        fn.reset = () => {
            storage.remove(key);
            setState((state) => ({
                value: defaultValueState,
                isPersistent: state.isPersistent,
            }));
        };
        return fn;
    }, [key, defaultValueState]);
    /**
     * Detects incorrect usage of the library and throws an error with a suggestion how to fix it.
     */
    react_1.useEffect(() => {
        if (initializedStorageKeys.has(key)) {
            throw new Error(`Multiple instances of useLocalStorageState() has been initialized with the same key. ` +
                `Use createLocalStorageStateHook() instead. ` +
                `Example implementation: ` +
                `https://github.com/astoilkov/use-local-storage-state#create-local-storage-state-hook-example`);
        }
        else {
            initializedStorageKeys.add(key);
        }
        return () => void initializedStorageKeys.delete(key);
    }, [key]);
    /**
     * Syncs changes across tabs and iframe's.
     */
    react_1.useEffect(() => {
        const onStorage = (e) => {
            if (e.storageArea === localStorage && e.key === key) {
                setState({
                    value: storage.get(key, defaultValueState),
                    isPersistent: true,
                });
            }
        };
        window.addEventListener('storage', onStorage);
        return () => window.removeEventListener('storage', onStorage);
    }, [key, defaultValueState]);
    /**
     * Update the state when the `key` property changes.
     */
    const isFirstRender = react_1.useRef(true);
    react_1.useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        setState(getDefaultState());
    }, [getDefaultState]);
    return [state.value, updateValue, state.isPersistent];
}
exports.ZP = useLocalStorageState;
function createLocalStorageStateHook(key, defaultValue) {
    const updates = [];
    return function useLocalStorageStateHook() {
        const [value, setValue, isPersistent] = useLocalStorageState(key, defaultValue);
        const updateValue = react_1.useMemo(() => {
            const fn = (newValue) => {
                for (const update of updates) {
                    update(newValue);
                }
            };
            fn.reset = () => {
                for (const update of updates) {
                    update.reset();
                }
            };
            return fn;
        }, []);
        react_1.useEffect(() => {
            initializedStorageKeys.delete(key);
        }, []);
        react_1.useEffect(() => {
            updates.push(setValue);
            return () => void updates.splice(updates.indexOf(setValue), 1);
        }, [setValue]);
        return [value, updateValue, isPersistent];
    };
}
__webpack_unused_export__ = createLocalStorageStateHook;


/***/ }),

/***/ 42473:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),

/***/ 23160:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = __webpack_require__.p + "static/media/anyday.9f43e1a8.svg";

/***/ }),

/***/ 62631:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = __webpack_require__.p + "static/media/chanel.77389680.svg";

/***/ }),

/***/ 12511:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = __webpack_require__.p + "static/media/dior-backstage.29962175.svg";

/***/ }),

/***/ 84562:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = __webpack_require__.p + "static/media/dior.9c51de06.svg";

/***/ }),

/***/ 93967:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 78647:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "customAlphabet": function() { return /* binding */ customAlphabet; },
  "customRandom": function() { return /* binding */ customRandom; },
  "nanoid": function() { return /* binding */ nanoid; },
  "random": function() { return /* binding */ random; },
  "urlAlphabet": function() { return /* reexport */ urlAlphabet; }
});

;// CONCATENATED MODULE: ./node_modules/nanoid/url-alphabet/index.js
let urlAlphabet =
  'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict'


;// CONCATENATED MODULE: ./node_modules/nanoid/index.browser.js

let random = bytes => crypto.getRandomValues(new Uint8Array(bytes))
let customRandom = (alphabet, defaultSize, getRandom) => {
  let mask = (2 << (Math.log(alphabet.length - 1) / Math.LN2)) - 1
  let step = -~((1.6 * mask * defaultSize) / alphabet.length)
  return (size = defaultSize) => {
    let id = ''
    while (true) {
      let bytes = getRandom(step)
      let j = step
      while (j--) {
        id += alphabet[bytes[j] & mask] || ''
        if (id.length === size) return id
      }
    }
  }
}
let customAlphabet = (alphabet, size = 21) =>
  customRandom(alphabet, size, random)
let nanoid = (size = 21) =>
  crypto.getRandomValues(new Uint8Array(size)).reduce((id, byte) => {
    byte &= 63
    if (byte < 36) {
      id += byte.toString(36)
    } else if (byte < 62) {
      id += (byte - 26).toString(36).toUpperCase()
    } else if (byte > 62) {
      id += '-'
    } else {
      id += '_'
    }
    return id
  }, '')



/***/ }),

/***/ 52587:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

/***/ }),

/***/ 50029:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

/***/ }),

/***/ 4730:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ 16835:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(2937);
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || (0,unsupportedIterableToArray/* default */.Z)(arr, i) || _nonIterableRest();
}

/***/ }),

/***/ 27812:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/arrayLikeToArray.js
var arrayLikeToArray = __webpack_require__(52587);
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,arrayLikeToArray/* default */.Z)(arr);
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/iterableToArray.js
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(2937);
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || (0,unsupportedIterableToArray/* default */.Z)(arr) || _nonIterableSpread();
}

/***/ }),

/***/ 2937:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52587);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}

/***/ })

}]);